/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	
	/*
	 * 	Dropdown Module
	 * 	Requires: "/css/fitbit/app/modules/dropdown.css"
	 * 	
	 * 	If this is an AMD environment, the Dropdown class is exported.
	 * 	Otherwise, if we're in legacy land, the Dropdown class will live globally as "fitbit.modules.dropdown".
	 * 
	 * 	Note: This is an AMD-compatible module but it's also backwards compatible with legacy globals when RequireJS isn't available.
	 */
	
	(function () {
		
		// Establish CommonJS passthrough shim, for non-AMD environments.
		var define = window.define || function (f) { return f(); };
		
		define('fitbit-widget-dropdown',['require','jquery'],function(require) {
		
			var isAMD = (typeof require === "function");
			
			/*
			 * 	Imports
			 */
			
			var $ = isAMD ? require("jquery") : window.jQuery;
			
			/*
			 * 	Non-AMD initialization...
			 */
			
			if (!isAMD) {
				// Define "fitbit: namespace is it doesn't exist.
				var fitbit = window.fitbit || {};
				
				// Define "modules" namespace if it doesn't exist.
				fitbit.modules = fitbit.modules || {};
				
				// Prevent duplicate definitions.
				if ($.isFunction(fitbit.modules.dropdown)) return fitbit;
			}
			
			/**
			 * 	Dropdown
			 * 
			 * 	Description:
			 * 	This is a generic dropdown widget designed for flexibility. This widget spawns a floating layer that, by default, is positioned relative to the 
			 * 	element (catalyst) that spawned it. In other words, unless the default positioning behavior of this widget is altered, this dropdown menu will be 
			 * 	positioned just beneath and left-aligned with the element that triggered it.
			 * 
			 * 	This widget is observable via pub-sub events, and various behaviors can be altered or overwritten for whatever specific UI
			 * 	situation you're dealing with.
			 * 
			 * 	Also, this widget doesn't care where its content comes from. Use the public "render" method to write an HTML string to the content area.
			 * 
			 * 	Example Usage:
			 * 		var myButton = $("#my-button-catalyst");
			 *		var myDropdown = new Dropdown(myButton, {
			 *			className: "sean_connery", 	// optional
			 *			fadeEffectDuration: 500,	// optional
			 *			anchorPoint: "right below"	// optional
			 *		});
			 *		myDropdown.render("Hello world!");
			 * 
			 * 	@module dropdown
			 * 	@namespace fitbit.modules.dropdown (note: only applicable in legacy/non-AMD environments)
			 * 	@constructor
			 * 	@param {HTMLElement} catalyst : The catalyst element. Interacting with this element (e.g. via "click") will spawn the dropdown. Interaction is configurable.
			 * 	@param {HashMap} config : Configuration object...
			 * 		{String} anchorPoint : Change the default anchor point of the dropdown. Accepted values: "left below" (default), "right below".
			 * 		{String} className : Custom class name(s) to be applied to the root dropdown element.
			 * 		{String} catalystActiveClass : Custom class name(s) to be applied to the catalyst element whenever the dropdown is visible.
			 * 		{Integer} fadeEffectDuration : Duration of fade-in effect for show operation (in ms).
			 * 		{Integer} hideDelay : Duration to wait after a hide-trigger occurs before actually hiding the dropdown (in ms).
			 * 		{Boolean} manualShowEnabled : If TRUE, clicks on the catalyst will NOT toggle dropdown visibility. All "show" operations will need to be handled manually by you. (default: false)
			 * 		{Boolean} mouseBoundaryDetectionEnabled : If FALSE, the dropdown can only be hidden by clicks. It will ignore mouseenter/mouseleave when evaluating whether or not to hide itself. (default: true)
			 * 
			 * 	@events beforeHide, beforeShow, destroy, hide, hideAfterResize, initialize, mouseEnterDropdown, mouseLeaveDropdown, position, render, show
			 */
			var Dropdown = function (catalyst, config) {
				
				// Parse arguments.
				if (!catalyst || !catalyst.length) {
					return this._throwError("no catalyst specified");
				}
				
				// Class properties.
				this.catalyst = $(catalyst).first();
				this.catalystActiveClass				= null;			// Configurable. Optional class name to apply to the catalyst element whenever the dropdown is visible.
				this.anchorPoint						= "left below"; // Configurable. Override the default positioning of the dropdown. 
				this.elements = {
					root: null,
					content: null
				};
				this.fadeEffectDuration 				= 200;			// Configurable. Duration of fade effects for showing/hiding the dropdown.
				this.hideDelay 							= 500;			// Configurable. Time to wait (in ms) before hiding the dropdown after a mouseleave event occurs.
				this.isManualShowEnabled				= false;		// Configurable. By default, the dropdown will be shown if the user clicks on the catalyst. If TRUE, catalyst click listener will be disabled.
				this.isMouseBoundaryDetectionEnabled 	= true;			// Configurable. By default, observe mouse cursor position to determine if the dropdown needs to be hidden.
				this.isMouseCursorInsideDropdown 		= false;		// Observable. Assists with tracking mouseenter & mouseleave w.r.t. showing & hiding the dropdown.
				this.namespace = {
					css: 	"module-dd", 								// All elements will have this CSS class prefix.
					event:	"module-dropdown-" 							// Namespace for our custom events, unique to this instance. A unique suffix is appended to this value during initialization.
				};
				this.positionOffset = { x: 0, y: 0 };					// Configurable. Offset default positioning by these amounts (in pixels). Configurable via public method "setPositionOffset".
				
				// More initialization...
				this._initialize(config);
				
			};
			
			Dropdown.prototype = {
							
				/********************************************************************************************
				 * 
				 * 	Public Methods
				 * 
				 ********************************************************************************************/
				
				/**
				 * 	Cancels a pending "hide" operation.
				 * 	@method cancelHide
				 */
				cancelHide: function () {
					if (this.hideTimer) {
						clearTimeout(this.hideTimer);
						this.hideTimer = null;
					}
				},
				
				/**
				 * 	Clear the dropdown of content.
				 * 	@method clear
				 */
				clear: function () {
					$(this.elements.content).empty();
				},
				
				/**
				 * 	Destroy this instance and related DOM pollution.
				 * 	@method destroy
				 */
				destroy: function () {
					
					// Notify listeners that this instance is committing seppuku.
					this._fireCustomEvent("destroy");
					
					// Mass unsubscribe all event listeners under this namespace.
					this.catalyst.off("." + this.namespace.event);
					
					// Remove all generated DOM elements. 
					for (var el in this.elements) {
						$(el).remove();
					}
					
					// Remove data attributes from catalyst element.
					this.catalyst.removeData("module-dropdown-id");
					
					// Destroy this instance. Seppuku complete.
	                var self = this; // Closure compiler hates "delete this"
					delete self;
				},
				
				/**
				 * 	Public access to the utility method that calculates the catalyst element's current position with respect to the document.
				 * 	This information is used for calculating where to position the dropdown. It's public because this information will be helpful when 
				 * 	writing a custom "setPosition" implementation.
				 * 	@method getCatalystPosition
				 * 	@returns {HashMap} : XY coordinates of the catalyst, as well as dimensions. e.g. { x:x, y:y, w:width, h:height }
				 */
				getCatalystPosition: function () {
					return this._getCatalystPosition();
				},
				
				/**
				 * 	Returns a reference to the root element of the dropdown.
				 * 	@method getRootElement
				 * 	@returns {HTMLElement} : DOM reference to the root element of the dropdown.
				 */
				getRootElement: function () {
					return (this.elements.root && this.elements.root.length) ? this.elements.root.get(0) : null; 
				},
					
				/**
				 * 	Make the DD invisible.
				 * 	@method hide
				 */
				hide: function () {
					var rootEl = $(this.elements.root);
					if (!rootEl.is(":animated")) { // ensure we're not in the midst of a fade-out animation
						this._fireCustomEvent("beforeHide");
						this.catalyst.removeClass(this.catalystActiveClass);
						rootEl.fadeOut(this.fadeEffectDuration, $.proxy(function () {
							this._fireCustomEvent("hide");
						}, this));
					}
				},
				
				/**
				 * 	Determine whether or not the dropdown is currently visible to the user.
				 *	@method isVisible
				 *	@returns {Boolean} : Is the dropdown currently visible? 
				 */
				isVisible: function () {
					try {
						return this.elements.root.is(":visible");
					} catch (e) {
						return false;
					}
				},
				
				/**
				 * 	Given an HTML string or a DOM fragment, write/render that content inside the dropdown.
				 * 	@method render
				 * 	@param {String|HTMLElement[]} content : Content to be written to the content area of the dropdown.
				 * 	@param {Boolean} isAppend : If TRUE, existing content will be appended to. Otherwise, existing content will be overwritten with new content.
				 * 	@returns {Boolean} : Was content successfully written?
				 */
				render: function (content, isAppend) {
					if (content) {
						if (!isAppend) this.clear(); // by default, clear existing content
						$(this.elements.content).append(content);
						this._fireCustomEvent("render");
						return true;
					}
					return false;
				},
				
				/**
				 * 	Public alias for "_setPosition" method. Repositions the dropdown in its default position beneath the catalyst element.
				 * 	@method setPosition
				 */
				setPosition: function () {
					this._setPosition();
				},
				
				/**
				 * 	Alter the dropdown's default positioning with relative offset values.
				 * 	@method setPositionOffset
				 * 	@param {Integer} x : Number of pixels to offset on x-axis. Can be a negative value.
				 * 	@param {Integer} y : Number of pixels to offset on y-axis. Can be a negative value.
				 */
				setPositionOffset: function (x, y) {
					if ($.isNumeric(x)) {
						this.positionOffset.x = x;
					}
					if ($.isNumeric(y)) {
						this.positionOffset.y = y;
					}
				},
				
				/**
				 * 	Make the DD visible.
				 * 	@method show
				 */
				show: function () {
					this.setPosition();
					this._fireCustomEvent("beforeShow");
					this.catalyst.addClass(this.catalystActiveClass);
					$(this.elements.root).fadeIn(this.fadeEffectDuration, $.proxy(function () {
						this._fireCustomEvent("show");
					}, this));
				},
				
				/**
				 * 	Subscribe to custom event.
				 * 	@method subscribe
				 * 	@param {String} eventName : Name of the custom event to listen to. This event will be automatically namespaced.
				 * 	@param {Function} callback : Callback function to be executed if the event of interest occurs.
				 * 	@param {Boolean} once : If TRUE, this event can only ever be triggered once.
				 * 	@returns {Boolean} : Was this event successfully subscribed to?
				 */
				subscribe: function (eventName, callback, once) {
					if (typeof eventName === "string" && $.isFunction(callback)) {
						this.catalyst[(once === true) ? "one" : "on"](this._getEventName(eventName), callback);
						return true; // success
					}
					return false; // failure
				},
				
				/**
				 * 	Toggle show/hide of the dropdown. Delegates to the private equivalent ("_toggle").
				 * 	@method toggle
				 * 	@returns {Boolean} : If TRUE, the dropdown was just made visible. Otherwise, the dropdown was just made invisible.
				 */
				toggle: function () {
					return this._toggle();
				},
				
				/**
				 * 	Unsubscribe from custom event.
				 * 	@method unsubscribe
				 * 	@param {String} eventName : Name of the custom event to unsubscribe from.
				 * 	@param {Function} callback : The callback function supplied at subscription time. If no callback is specified, all listeners to this event will be unsubscribed. 
				 * 	@returns {Boolean} : Was this event successfully unsubscribed from?
				 */
				unsubscribe: function (eventName, callback) {
					if (typeof eventName === "string") {
						this.catalyst.off(this._getEventName(eventName), callback);
						return true; // probable success (we don't really know if the listener was removed)
					}
					return false; // probable failure
				},
				
				/********************************************************************************************
				 * 
				 * 	Private Methods (pseudo-private)
				 * 
				 ********************************************************************************************/
				
				/**
				 * 	Parse the configuration object and apply changes for this instance.
				 *  Intended to be run only once during initialization.
				 * 	@method _applyConfiguration
				 * 	@param {HashMap} config : Configuration object.
				 * 	@private
				 */
				_applyConfiguration: function (config) {
					if ($.isPlainObject(config)) {
						
						// Input validation helper.
						var isString = function (str) {
							return (typeof str === "string" && !(/^\s*$/).test(str));
						};
						
						// Change anchor point?
						if (isString(config.anchorPoint)) {
							this.anchorPoint = config.anchorPoint;
						}
						
						// Add custom class name to the dropdown root?
						if (isString(config.className)) {
							this.customClassName = config.className;
						}
						
						// Add custom class name to catalyst whenever dropdown is visible?
						if (isString(config.catalystActiveClass)) {
							this.catalystActiveClass = config.catalystActiveClass
						}
						
						// Custom duration for the "hide" timeout?
						if ($.isNumeric(config.hideDelay)) {
							this.hideDelay = config.hideDelay > 0 ? config.hideDelay : 0; 
						}
						
						// Custom fade-in duration for show operation? Overrides the default.
						if ($.isNumeric(config.fadeEffectDuration) || config.fadeEffectDuration === false) {
							this.fadeEffectDuration = config.fadeEffectDuration;
						}
						
						// Disable mouse boundary detection? If set to FALSE, this effectively makes the dropdown "click-to-hide".
						this.isMouseBoundaryDetectionEnabled = !(config.mouseBoundaryDetectionEnabled === false);
						
						// Enable manual visibility toggling? If true, this effectively disables the "_initializeCatalyst" method.
						this.isManualShowEnabled = (config.manualShowEnabled === true)
		
					}
				},
				
				/**
				 * 	Construct DOM skeleton for this dropdown. This is meant to be a one-time operation called during initialization.
				 * 	@method _buildStructure
				 * 	@private
				 */
				_buildStructure: function () {
					
					// Private utility that creates namespaced CSS class names.
					var cn = $.proxy(function (className) {
						var str = this.namespace.css;
						if (typeof className === "string") {
							str += "-" + className.replace(/\s+/, "-");
						}
						return str;
					}, this);
					
					// Construct DOM skeleton.
					var rootEl = $("<div/>").addClass(cn()).hide(); // ensure these elements are hidden
					if (this.customClassName) { // if a custom class name was specified for this instance, add it now
						rootEl.addClass(this.customClassName);
					}
					var contentEl = $("<div/>").addClass(cn("content")).appendTo(rootEl);
					rootEl.appendTo(document.body);
		
					// Cache references to important DOM elements.
					$.extend(this.elements, {
						root: 		rootEl,
						content: 	contentEl
					});
				},
				
				/**
				 * 	Define internal methods for how to position the dropdown with respect to the catalyst. The "strategy" will be chosen based on the anchor point (e.g. "left below").
				 * 	@method _defineAnchorPointStrategies
				 * 	@private
				 */
				_defineAnchorPointStrategies: function () {
					if (!this.anchorPointStrategies) {
						this.anchorPointStrategies = {
							// TO-DO: Does the "above" positioning actually work? Still untested.
							/*
							"above": 	$.proxy(function () {
											var catalystPosition = this._getCatalystPosition();
											return {
												"bottom":	parseInt($(document).height() - ((0 - this.positionOffset.y) + catalystPosition.y + catalystPosition.h), 10) + "px",
												"top": 		"auto"
											};
										}, this),
							*/
							"below": 	$.proxy(function () {
											var catalystPosition = this._getCatalystPosition();
											return {
												"top":		parseInt(this.positionOffset.y + catalystPosition.y + catalystPosition.h, 10) + "px",
												"bottom":	"auto"
											};
										}, this),
							"left": 	$.proxy(function () {
											var catalystPosition = this._getCatalystPosition();
											return {
												"left":		parseInt(this.positionOffset.x + catalystPosition.x, 10) + "px",
												"right":	"auto"
											};
										}, this),
							"right": 	$.proxy(function () {
											var catalystPosition = this._getCatalystPosition();
											return {
												"right":	parseInt($(window).width() - ((0 - this.positionOffset.x) + catalystPosition.x + catalystPosition.w), 10) + "px",
												"left":		"auto"
											};
										}, this)
						};
					}
				},
				
				/**
				 * 	Trigger/fire custom event. A reference to this instance will be supplied as an argument to the callback.
				 * 	@method _fireCustomEvent
				 * 	@param {String} eventName : Name of the event to fire.
				 * 	@private
				 */
				_fireCustomEvent: function (eventName) {
					this.catalyst.trigger(this._getEventName(eventName), this); // supply ref to this instance to the callback
				},
				
				/**
				 * 	Get catalyst element position and dimension information. Note: position is relative to the document.
				 * 	@method _getCatalystPosition
				 * 	@private
				 */
				_getCatalystPosition: function () {
					var catalyst = this.catalyst;
					var pos = catalyst.offset();
					return {
						x: Math.round(pos.left),
						y: Math.round(pos.top),
						// Explicitly supply FALSE to jQuery's "outerWidth" and "outerHeight" methods. Otherwise, these methods are prone
						// to incorrect behavior when used in a document with a mismatched/older version of jQueryUI.
						// See http://bugs.jquery.com/ticket/12491 for bug report.
						w: Math.round(catalyst.outerWidth(false)),
						h: Math.round(catalyst.outerHeight(false))
					};
				},
				
				/**
				 * 	Internal utility. Given an event name, return it with a namespace suffix (for use with jQuery event binding).
				 * 	@method _getEventName
				 * 	@param {String} eventName : Event name to be namespaced.
				 * 	@returns {String} : Event name with namespace, or NULL if bad argument supplied.
				 * 	@private
				 */
				_getEventName: function (eventName) {
					return (typeof eventName === "string" || $.isArray(eventName)) ? eventName + "." + this.namespace.event : null;
				},
				
				/**
				 * 	Internal utility. Given an array of event names, return them with namespace suffixes (for use with jQuery event binding).
				 * 	@method _getEventNames
				 * 	@param {String[]} eventNames : Event names to be namespaced.
				 * 	@returns {String[]} : Event names with namespace, or NULL if had argument supplied.
				 */
				_getEventNames: function (eventNames) {
					if (eventNames) {
						if (typeof eventNames === "string") {
							eventNames = [eventNames];
						}
						$.each(eventNames, $.proxy(function (index, eventName) {
							eventNames[index] = this._getEventName(eventName);
						}, this));
					}
					return (eventNames && eventNames.length) ? eventNames : null;
				},
				
				/**
				 * 	Given an anchor point strategy, determine the positioning of the dropdown with respect to the catalyst. 
				 * 	@method _getPositionByAnchorPoint
				 * 	@returns {HashMap} : Object containing CSS positioning information, designed to be directly applied to an element via jQuery.
				 * 	@private
				 */
				_getPositionByAnchorPoint: function () {
					
					// Transform anchor point string into an array of strings so each dimension can be processed individually.
					var strategies = this.anchorPoint.split(" ");
					if (strategies.length !== 2) {
						this._throwError("anchor point is invalid");
					}
					
					// Generate CSS positioning information based on anchor point strategy.
					var css = {};
					$.each(strategies, $.proxy(function (index, strategy) {
						$.extend(css, this.anchorPointStrategies[strategy]());
					}, this));
					
					if ($.isEmptyObject(css)) {
						this._throwError("could not determine dropdown position from anchor point");
					}
					return css;
				},
				
				/**
				 * 	@method _getUniqueId
				 * 	@private
				 */
				_getUniqueId: function () {
					if (!$.isNumeric(this.uniqueId)) {
						this.uniqueId = parseInt(Math.random().toString().replace(".", ""), 10);
					}
					return this.uniqueId;
				},
				
				/**
				 * 	Various one-time initialization.
				 * 	@method _initialize
				 * 	@param {HashMap} config : Configuration object (from the constructor arguments).
				 * 	@private
				 */
				_initialize: function (config) {
					
					// Append unique suffix to event namespace. Allows events to be (un)registered that are specific to this instance.
					var uniqueId = this._getUniqueId();
					this.namespace.event += uniqueId;
					
					// Apply configuration object to this instance.
					this._applyConfiguration(config);
					
					// Construct DOM skeleton for this dropdown.
					this._buildStructure();
					
					// Add data attributes to the catalyst and dropdown root elements, indicating which instance ID they're associated with. This is currently only used for debugging.
					$(this.catalyst).add(this.elements.root).data("module-dropdown-id", uniqueId);
					
					// Establish event listeners on the catalyst element. This functionality is the primary decider regarding visibility toggling of the dropdown.
					this._initializeCatalyst();
		
					// Initialize event listeners for hiding the dropdown based on mouse cursor position.
					this._initializeMouseBoundaryDetection();
					
					// Defines internal functions for how to position the dropdown based on an anchor point strategy (e.g. "left below").
					this._defineAnchorPointStrategies();
					
					// Browser viewport resize should hide the dropdown if it's currently visible.
					$(window).on(this._getEventName("resize"), $.proxy(function () {
						if (this.isVisible()) {
							this._fireCustomEvent("hideAfterResize"); // differentiate this "hide" event as the result of a browser viewport resize
							this.hide();
						}
					}, this));
					
					/*
					 * 	Clicks outside the dropdown should hide it. Required conditions:
					 * 		1) The dropdown is currently visible.
					 * 		2) The click did not originate from our catalyst (or any of its children).
					 * 		3) The click did not originate from the dropdown itself (or any of its children).
					 */
					$(document.body).on(this._getEventName("click"), $.proxy(function (ev) {
						var $evTarget = $(ev.target);
						if (this.isVisible() && !($evTarget.closest(this.catalyst).length || $evTarget.closest("." + this.namespace.css).length)) {
							this.hide();
						}
					}, this));
					
					// Notify any interested parties that this dropdown instance has been initialized.
					this._fireCustomEvent("initialize");
				},
				
				/**
				 * 	Establish event listeners on the catalyst for toggling visibility of the dropdown based on user interaction.
				 *	@method _initializeCatalyst 
				 *	@private
				 */
				_initializeCatalyst: function () {
					if (!this.isManualShowEnabled && !this.isMouseDelayedShowEnabled) {
						this.catalyst.on(this._getEventName("click"), $.proxy(function (ev) {
							if (ev) ev.preventDefault();
							this._toggle();
						}, this));
					}
				},
				
				/**
				 * 	@method _initializeMouseBoundaryDetection
				 * 	@private
				 */
				_initializeMouseBoundaryDetection: function () {
					
					if (this.isMouseBoundaryDetectionEnabled) {
						this.elements.root
							.on(this._getEventName("mouseenter"), $.proxy(function () {
								this._setMouseCursorInsideDropdown(true); // Record that the user has moused-into the dropdown.
							}, this))
							.on(this._getEventName("mouseleave"), $.proxy(function () {
								// Record that the user has moused-out of the dropdown.
								// This is important when dealing with delayed hiding of the dropdown. If the user quickly cycles between mouseleave
								// and mouseenter within a certain timeframe (this.hideDelay), we want to keep the dropdown visible. 
								this._setMouseCursorInsideDropdown(false);
								
								// If there isn't already an active timeout and the dropdown is currently visible, wait a little bit before hiding the dropdown...
								if (!this.hideTimer && this.isVisible()) {
									this.hideTimer = setTimeout($.proxy(function () {
										if (!this.isMouseCursorInsideDropdown) { // ensure user has not moused back into the dropdown
											this.hide();
										}
										this.cancelHide();
									}, this), this.hideDelay);
								}
							}, this));
					}
					
				},
				
				/**
				 * 	Sets the "isMouseCursorInsideDropdown" property and notifies subscribers of the change.
				 * 	@method _setMouseCursorInsideDropdown
				 * 	@param {Boolean} isInside : Is the mouse cursor currently inside the dropdown wrapper?
				 * 	@private
				 */
				_setMouseCursorInsideDropdown: function (isInside) {
					if (isInside) {
						this.isMouseCursorInsideDropdown = true;
						this._fireCustomEvent("mouseEnterDropdown");
					} else {
						this.isMouseCursorInsideDropdown = false;
						this._fireCustomEvent("mouseLeaveDropdown");
					}
				},
				
				/**
				 * 	Sets the position of the dropdown with respect to the catalyst element.
				 * 	@method _setPosition
				 * 	@private
				 */
				_setPosition: function () {
					this.elements.root.css(this._getPositionByAnchorPoint());
					this._fireCustomEvent("position");
				},
				
				/**
				 * 	Custom error handling.
				 * 	@method _throwError
				 * 	@param {String} message : Error message to show.
				 * 	@private
				 */
				_throwError: function (message) {
					console.log("Fitbit Dropdown Widget : " + (message || "unknown error"));
				},
				
				/**
				 * 	Toggle show/hide of the dropdown.
				 * 	@method _toggle
				 * 	@returns {Boolean} : If TRUE, the dropdown was just made visible. Otherwise, the dropdown was just made invisible.
				 * 	@private
				 */
				_toggle: function () {
					if (this.isVisible()) {
						this.hide();
						return false;
					} else {
						this.show();
						return true;
					}
				}
					
			};
			
			/*
			 * 	Exports
			 */
			if (isAMD) {
				return Dropdown;
			} else {
				fitbit.modules.dropdown = Dropdown;
				return fitbit;
			}
			
		});
	
	}());
	
	/**
	 * @license 
	 * jQuery Tools @VERSION Overlay - Overlay base. Extend it.
	 * 
	 * NO COPYRIGHTS OR LICENSES. DO WHAT YOU LIKE.
	 * 
	 * http://flowplayer.org/tools/overlay/
	 *
	 * Since: March 2008
	 * Date: @DATE 
	 */
	(function($) { 
	
		// static constructs
		$.tools = $.tools || {version: '@VERSION'};
		
		$.tools.overlay = {
			
			addEffect: function(name, loadFn, closeFn) {
				effects[name] = [loadFn, closeFn];	
			},
		
			conf: {  
				close: null,	
				closeOnClick: true,
				closeOnEsc: true,			
				closeSpeed: 'fast',
				effect: 'default',
				
				// since 1.2. fixed positioning not supported by IE6
				fixed:true,
				
				left: 'center',		
				load: false, // 1.2
				mask: null,  
				oneInstance: true,
				speed: 'normal',
				target: null, // target element to be overlayed. by default taken from [rel]
				top: '10%'
			}
		};
	
		
		var instances = [], effects = {};
			
		// the default effect. nice and easy!
		$.tools.overlay.addEffect('default', 
			
			/* 
				onLoad/onClose functions must be called otherwise none of the 
				user supplied callback methods won't be called
			*/
			function(pos, onLoad) {
				
				var conf = this.getConf(),
					 w = $(window);				 
					
				if (!conf.fixed)  {
					pos.top += w.scrollTop();
					pos.left += w.scrollLeft();
				} 
					
				pos.position = conf.fixed ? 'fixed' : 'absolute';
				this.getOverlay().css(pos).fadeIn(conf.speed, onLoad); 
				
			}, function(onClose) {
				this.getOverlay().fadeOut(this.getConf().closeSpeed, onClose); 			
			}		
		);		
	
		
		function Overlay(trigger, conf) {		
			
			// private variables
			var self = this,
				 fire = trigger.add(self),
				 w = $(window), 
				 closers,            
				 overlay,
				 opened,
				 maskConf = $.tools.expose && (conf.mask || conf.expose),
				 uid = Math.random().toString().slice(10);		
			
				 
			// mask configuration
			if (maskConf) {			
				if (typeof maskConf == 'string') { maskConf = {color: maskConf}; }
				maskConf.closeOnClick = maskConf.closeOnEsc = false;
			}			 
			 
			// get overlay and triggerr
			var jq = conf.target || trigger.attr("rel");
			overlay = jq ? $(jq) : null || trigger;	
			
			// overlay not found. cannot continue
			if (!overlay.length) { throw "Could not find Overlay: " + jq; }
			
			// trigger's click event
			if (trigger && trigger.index(overlay) == -1) {
				trigger.click(function(e) {				
					self.load(e);
					return e.preventDefault();
				});
			}   			
			
			// API methods  
			$.extend(self, {
	
				load: function(e) {
	
					// can be opened only once
					if (self.isOpened()) { return self; }
					
					// find the effect
			 		var eff = effects[conf.effect];
			 		if (!eff) { throw "Overlay: cannot find effect : \"" + conf.effect + "\""; }
					
					// close other instances?
					if (conf.oneInstance) {
						$.each(instances, function() {
							this.close(e);
						});
					}
					
					// onBeforeLoad
					e = e || $.Event();
					e.type = "onBeforeLoad";
					fire.trigger(e);				
					if (e.isDefaultPrevented()) { return self; }				
	
					// opened
					opened = true;
					
					// possible mask effect
					if (maskConf) { $(overlay).expose(maskConf); }				
					
					// position & dimensions 
					var top = conf.top,					
						 left = conf.left,
						 oWidth = overlay.outerWidth(true),
						 oHeight = overlay.outerHeight(true);
	
					if (typeof top == 'string')  {
						top = top == 'center' ? Math.max((w.height() - oHeight) / 2, 0) :
							parseInt(top, 10) / 100 * w.height();
					}				
					
					if (left == 'center') { left = Math.max((w.width() - oWidth) / 2, 0); }
	
					
			 		// load effect  		 		
					eff[0].call(self, {top: top, left: left}, function() {					
						if (opened) {
							e.type = "onLoad";
							fire.trigger(e);
						}
					}); 				
	
					// mask.click closes overlay
					if (maskConf && conf.closeOnClick) {
						$.mask.getMask().one("click", self.close); 
					}
					
					// when window is clicked outside overlay, we close
					if (conf.closeOnClick) {
						$(document).bind("click." + uid, function(e) { 
							if (!$(e.target).parents(overlay).length) { 
								self.close(e); 
							}
						});						
					}						
				
					// keyboard::escape
					if (conf.closeOnEsc) { 
	
						// one callback is enough if multiple instances are loaded simultaneously
						$(document).bind("keydown." + uid, function(e) {
							if (e.keyCode == 27) { 
								self.close(e);	 
							}
						});			
					}
	
					
					return self; 
				}, 
				
				close: function(e) {
	
					if (!self.isOpened()) { return self; }
					
					e = e || $.Event();
					e.type = "onBeforeClose";
					fire.trigger(e);				
					if (e.isDefaultPrevented()) { return; }				
					
					opened = false;
					
					// close effect
					effects[conf.effect][1].call(self, function() {
						e.type = "onClose";
						fire.trigger(e); 
					});
					
					// unbind the keyboard / clicking actions
					$(document).unbind("click." + uid).unbind("keydown." + uid);		  
					
					if (maskConf) {
						$.mask.close();		
					}
					 
					return self;
				}, 
				
				getOverlay: function() {
					return overlay;	
				},
				
				getTrigger: function() {
					return trigger;	
				},
				
				getClosers: function() {
					return closers;	
				},			
	
				isOpened: function()  {
					return opened;
				},
				
				// manipulate start, finish and speeds
				getConf: function() {
					return conf;	
				}			
				
			});
			
			// callbacks	
			$.each("onBeforeLoad,onStart,onLoad,onBeforeClose,onClose".split(","), function(i, name) {
					
				// configuration
				if ($.isFunction(conf[name])) { 
					$(self).bind(name, conf[name]); 
				}
	
				// API
				self[name] = function(fn) {
					if (fn) { $(self).bind(name, fn); }
					return self;
				};
			});
			
			// close button
			closers = overlay.find(conf.close || ".close");		
			
			if (!closers.length && !conf.close) {
				closers = $('<a class="close"></a>');
				overlay.prepend(closers);	
			}		
			
			closers.click(function(e) { 
				self.close(e);  
			});	
			
			// autoload
			if (conf.load) { self.load(); }
			
		}
		
		// jQuery plugin initialization
		$.fn.overlay = function(conf) {   
			
			// already constructed --> return API
			var el = this.data("overlay");
			if (el) { return el; }	  		 
			
			if ($.isFunction(conf)) {
				conf = {onBeforeLoad: conf};	
			}
	
			conf = $.extend(true, {}, $.tools.overlay.conf, conf);
			
			this.each(function() {		
				el = new Overlay($(this), conf);
				instances.push(el);
				$(this).data("overlay", el);	
			});
			
			return conf.api ? el: this;		
		}; 
		
	})(jQuery);
	
	
	define("jqtools-overlay", function(){});
	
	/**
	 * @license 
	 * jQuery Tools @VERSION / Expose - Dim the lights
	 * 
	 * NO COPYRIGHTS OR LICENSES. DO WHAT YOU LIKE.
	 * 
	 * http://flowplayer.org/tools/toolbox/expose.html
	 *
	 * Since: Mar 2010
	 * Date: @DATE 
	 */
	(function($) { 	
	
		// static constructs
		$.tools = $.tools || {version: '@VERSION'};
		
		var tool;
		
		tool = $.tools.expose = {
			
			conf: {	
				maskId: 'exposeMask',
				loadSpeed: 'slow',
				closeSpeed: 'fast',
				closeOnClick: true,
				closeOnEsc: true,
				
				// css settings
				zIndex: 9998,
				opacity: 0.8,
				startOpacity: 0,
				color: '#fff',
				
				// callbacks
				onLoad: null,
				onClose: null
			}
		};
	
		/* one of the greatest headaches in the tool. finally made it */
		function viewport() {
					
			// the horror case
			if ($.browser.msie) {
				
				// if there are no scrollbars then use window.height
				var d = $(document).height(), w = $(window).height();
				
				return [
					window.innerWidth || 							// ie7+
					document.documentElement.clientWidth || 	// ie6  
					document.body.clientWidth, 					// ie6 quirks mode
					d - w < 20 ? w : d
				];
			} 
			
			// other well behaving browsers
			return [$(document).width(), $(document).height()]; 
		} 
		
		function call(fn) {
			if (fn) { return fn.call($.mask); }
		}
		
		var mask, exposed, loaded, config, overlayIndex;		
		
		
		$.mask = {
			
			load: function(conf, els) {
				
				// already loaded ?
				if (loaded) { return this; }			
				
				// configuration
				if (typeof conf == 'string') {
					conf = {color: conf};	
				}
				
				// use latest config
				conf = conf || config;
				
				config = conf = $.extend($.extend({}, tool.conf), conf);
	
				// get the mask
				mask = $("#" + conf.maskId);
					
				// or create it
				if (!mask.length) {
					mask = $('<div/>').attr("id", conf.maskId);
					$("body").append(mask);
				}
				
				// set position and dimensions 			
				var size = viewport();
					
				mask.css({				
					position:'absolute', 
					top: 0, 
					left: 0,
					width: size[0],
					height: size[1],
					display: 'none',
					opacity: conf.startOpacity,					 		
					zIndex: conf.zIndex 
				});
				
				if (conf.color) {
					mask.css("backgroundColor", conf.color);	
				}			
				
				// onBeforeLoad
				if (call(conf.onBeforeLoad) === false) {
					return this;
				}
				
				// esc button
				if (conf.closeOnEsc) {						
					$(document).bind("keydown.mask", function(e) {							
						if (e.keyCode == 27) {
							$.mask.close(e);	
						}		
					});			
				}
				
				// mask click closes
				if (conf.closeOnClick) {
					mask.bind("click.mask", function(e)  {
						$.mask.close(e);		
					});					
				}			
				
				// resize mask when window is resized
				$(window).bind("resize.mask", function() {
					$.mask.fit();
				});
				
				// exposed elements
				if (els && els.length) {
					
					overlayIndex = els.eq(0).css("zIndex");
	
					// make sure element is positioned absolutely or relatively
					$.each(els, function() {
						var el = $(this);
						if (!/relative|absolute|fixed/i.test(el.css("position"))) {
							el.css("position", "relative");		
						}					
					});
				 
					// make elements sit on top of the mask
					exposed = els.css({ zIndex: Math.max(conf.zIndex + 1, overlayIndex == 'auto' ? 0 : overlayIndex)});			
				}	
				
				// reveal mask
				mask.css({display: 'block'}).fadeTo(conf.loadSpeed, conf.opacity, function() {
					$.mask.fit(); 
					call(conf.onLoad);
					loaded = "full";
				});
				
				loaded = true;			
				return this;				
			},
			
			close: function() {
				if (loaded) {
					
					// onBeforeClose
					if (call(config.onBeforeClose) === false) { return this; }
						
					mask.fadeOut(config.closeSpeed, function()  {					
						call(config.onClose);					
						if (exposed) {
							exposed.css({zIndex: overlayIndex});						
						}				
						loaded = false;
					});				
					
					// unbind various event listeners
					$(document).unbind("keydown.mask");
					mask.unbind("click.mask");
					$(window).unbind("resize.mask");  
				}
				
				return this; 
			},
			
			fit: function() {
				if (loaded) {
					var size = viewport();				
					mask.css({width: size[0], height: size[1]});
				}				
			},
			
			getMask: function() {
				return mask;	
			},
			
			isLoaded: function(fully) {
				return fully ? loaded == 'full' : loaded;	
			}, 
			
			getConf: function() {
				return config;	
			},
			
			getExposed: function() {
				return exposed;	
			}		
		};
		
		$.fn.mask = function(conf) {
			$.mask.load(conf);
			return this;		
		};			
		
		$.fn.expose = function(conf) {
			$.mask.load(conf, this);
			return this;			
		};
	
	
	})(jQuery);
	
	define("jqtools-toolbox-expose", function(){});
	
	//     Underscore.js 1.7.0
	//     http://underscorejs.org
	//     (c) 2009-2014 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    concat           = ArrayProto.concat,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind;
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (typeof exports !== 'undefined') {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.7.0';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var createCallback = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  _.iteratee = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return createCallback(value, context, argCount);
	    if (_.isObject(value)) return _.matches(value);
	    return _.property(value);
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    if (obj == null) return obj;
	    iteratee = createCallback(iteratee, context);
	    var i, length = obj.length;
	    if (length === +length) {
	      for (i = 0; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    if (obj == null) return [];
	    iteratee = _.iteratee(iteratee, context);
	    var keys = obj.length !== +obj.length && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length),
	        currentKey;
	    for (var index = 0; index < length; index++) {
	      currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  var reduceError = 'Reduce of empty array with no initial value';
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = function(obj, iteratee, memo, context) {
	    if (obj == null) obj = [];
	    iteratee = createCallback(iteratee, context, 4);
	    var keys = obj.length !== +obj.length && _.keys(obj),
	        length = (keys || obj).length,
	        index = 0, currentKey;
	    if (arguments.length < 3) {
	      if (!length) throw new TypeError(reduceError);
	      memo = obj[keys ? keys[index++] : index++];
	    }
	    for (; index < length; index++) {
	      currentKey = keys ? keys[index] : index;
	      memo = iteratee(memo, obj[currentKey], currentKey, obj);
	    }
	    return memo;
	  };
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = function(obj, iteratee, memo, context) {
	    if (obj == null) obj = [];
	    iteratee = createCallback(iteratee, context, 4);
	    var keys = obj.length !== + obj.length && _.keys(obj),
	        index = (keys || obj).length,
	        currentKey;
	    if (arguments.length < 3) {
	      if (!index) throw new TypeError(reduceError);
	      memo = obj[keys ? keys[--index] : --index];
	    }
	    while (index--) {
	      currentKey = keys ? keys[index] : index;
	      memo = iteratee(memo, obj[currentKey], currentKey, obj);
	    }
	    return memo;
	  };
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var result;
	    predicate = _.iteratee(predicate, context);
	    _.some(obj, function(value, index, list) {
	      if (predicate(value, index, list)) {
	        result = value;
	        return true;
	      }
	    });
	    return result;
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    if (obj == null) return results;
	    predicate = _.iteratee(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(_.iteratee(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    if (obj == null) return true;
	    predicate = _.iteratee(predicate, context);
	    var keys = obj.length !== +obj.length && _.keys(obj),
	        length = (keys || obj).length,
	        index, currentKey;
	    for (index = 0; index < length; index++) {
	      currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    if (obj == null) return false;
	    predicate = _.iteratee(predicate, context);
	    var keys = obj.length !== +obj.length && _.keys(obj),
	        length = (keys || obj).length,
	        index, currentKey;
	    for (index = 0; index < length; index++) {
	      currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given value (using `===`).
	  // Aliased as `include`.
	  _.contains = _.include = function(obj, target) {
	    if (obj == null) return false;
	    if (obj.length !== +obj.length) obj = _.values(obj);
	    return _.indexOf(obj, target) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      return (isFunc ? method : value[method]).apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matches(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matches(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = obj.length === +obj.length ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = _.iteratee(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = obj.length === +obj.length ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = _.iteratee(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = obj && obj.length === +obj.length ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (obj.length !== +obj.length) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = _.iteratee(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = _.iteratee(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = _.iteratee(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = array.length;
	    while (low < high) {
	      var mid = low + high >>> 1;
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (obj.length === +obj.length) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return obj.length === +obj.length ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = _.iteratee(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    if (n < 0) return [];
	    return slice.call(array, 0, n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N. The **guard** check allows it to work with
	  // `_.map`.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array. The **guard** check allows it to work with `_.map`.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return slice.call(array, Math.max(array.length - n, 0));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array. The **guard**
	  // check allows it to work with `_.map`.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, output) {
	    if (shallow && _.every(input, _.isArray)) {
	      return concat.apply(output, input);
	    }
	    for (var i = 0, length = input.length; i < length; i++) {
	      var value = input[i];
	      if (!_.isArray(value) && !_.isArguments(value)) {
	        if (!strict) output.push(value);
	      } else if (shallow) {
	        push.apply(output, value);
	      } else {
	        flatten(value, shallow, strict, output);
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false, []);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (array == null) return [];
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = _.iteratee(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = array.length; i < length; i++) {
	      var value = array[i];
	      if (isSorted) {
	        if (!i || seen !== value) result.push(value);
	        seen = value;
	      } else if (iteratee) {
	        var computed = iteratee(value, i, array);
	        if (_.indexOf(seen, computed) < 0) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (_.indexOf(result, value) < 0) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true, []));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    if (array == null) return [];
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = array.length; i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(slice.call(arguments, 1), true, true, []);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function(array) {
	    if (array == null) return [];
	    var length = _.max(arguments, 'length').length;
	    var results = Array(length);
	    for (var i = 0; i < length; i++) {
	      results[i] = _.pluck(arguments, i);
	    }
	    return results;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    if (list == null) return {};
	    var result = {};
	    for (var i = 0, length = list.length; i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = function(array, item, isSorted) {
	    if (array == null) return -1;
	    var i = 0, length = array.length;
	    if (isSorted) {
	      if (typeof isSorted == 'number') {
	        i = isSorted < 0 ? Math.max(0, length + isSorted) : isSorted;
	      } else {
	        i = _.sortedIndex(array, item);
	        return array[i] === item ? i : -1;
	      }
	    }
	    for (; i < length; i++) if (array[i] === item) return i;
	    return -1;
	  };
	
	  _.lastIndexOf = function(array, item, from) {
	    if (array == null) return -1;
	    var idx = array.length;
	    if (typeof from == 'number') {
	      idx = from < 0 ? idx + from + 1 : Math.min(idx, from + 1);
	    }
	    while (--idx >= 0) if (array[idx] === item) return idx;
	    return -1;
	  };
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (arguments.length <= 1) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Reusable constructor function for prototype setting.
	  var Ctor = function(){};
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    var args, bound;
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    args = slice.call(arguments, 2);
	    bound = function() {
	      if (!(this instanceof bound)) return func.apply(context, args.concat(slice.call(arguments)));
	      Ctor.prototype = func.prototype;
	      var self = new Ctor;
	      Ctor.prototype = null;
	      var result = func.apply(self, args.concat(slice.call(arguments)));
	      if (_.isObject(result)) return result;
	      return self;
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    return function() {
	      var position = 0;
	      var args = boundArgs.slice();
	      for (var i = 0, length = args.length; i < length; i++) {
	        if (args[i] === _) args[i] = arguments[position++];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return func.apply(this, args);
	    };
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = hasher ? hasher.apply(this, arguments) : key;
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = function(func) {
	    return _.delay.apply(_, [func, 1].concat(slice.call(arguments, 1)));
	  };
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        clearTimeout(timeout);
	        timeout = null;
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last > 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed after being called N times.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed before being called N times.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      } else {
	        func = null;
	      }
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Retrieve the names of an object's properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    var source, prop;
	    for (var i = 1, length = arguments.length; i < length; i++) {
	      source = arguments[i];
	      for (prop in source) {
	        if (hasOwnProperty.call(source, prop)) {
	            obj[prop] = source[prop];
	        }
	      }
	    }
	    return obj;
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(obj, iteratee, context) {
	    var result = {}, key;
	    if (obj == null) return result;
	    if (_.isFunction(iteratee)) {
	      iteratee = createCallback(iteratee, context);
	      for (key in obj) {
	        var value = obj[key];
	        if (iteratee(value, key, obj)) result[key] = value;
	      }
	    } else {
	      var keys = concat.apply([], slice.call(arguments, 1));
	      obj = new Object(obj);
	      for (var i = 0, length = keys.length; i < length; i++) {
	        key = keys[i];
	        if (key in obj) result[key] = obj[key];
	      }
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(concat.apply([], slice.call(arguments, 1)), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    for (var i = 1, length = arguments.length; i < length; i++) {
	      var source = arguments[i];
	      for (var prop in source) {
	        if (obj[prop] === void 0) obj[prop] = source[prop];
	      }
	    }
	    return obj;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	    if (typeof a != 'object' || typeof b != 'object') return false;
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	    // Objects with different constructors are not equivalent, but `Object`s
	    // from different frames are.
	    var aCtor = a.constructor, bCtor = b.constructor;
	    if (
	      aCtor !== bCtor &&
	      // Handle Object.create(x) cases
	      'constructor' in a && 'constructor' in b &&
	      !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	        _.isFunction(bCtor) && bCtor instanceof bCtor)
	    ) {
	      return false;
	    }
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	    var size, result;
	    // Recursively compare objects and arrays.
	    if (className === '[object Array]') {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      size = a.length;
	      result = size === b.length;
	      if (result) {
	        // Deep compare the contents, ignoring non-numeric properties.
	        while (size--) {
	          if (!(result = eq(a[size], b[size], aStack, bStack))) break;
	        }
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      size = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      result = _.keys(b).length === size;
	      if (result) {
	        while (size--) {
	          // Deep compare each member
	          key = keys[size];
	          if (!(result = _.has(b, key) && eq(a[key], b[key], aStack, bStack))) break;
	        }
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return result;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b, [], []);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (_.isArray(obj) || _.isString(obj) || _.isArguments(obj)) return obj.length === 0;
	    for (var key in obj) if (_.has(obj, key)) return false;
	    return true;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around an IE 11 bug.
	  if (typeof /./ !== 'function') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = function(key) {
	    return function(obj) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of `key:value` pairs.
	  _.matches = function(attrs) {
	    var pairs = _.pairs(attrs), length = pairs.length;
	    return function(obj) {
	      if (obj == null) return !length;
	      obj = new Object(obj);
	      for (var i = 0; i < length; i++) {
	        var pair = pairs[i], key = pair[0];
	        if (pair[1] !== obj[key] || !(key in obj)) return false;
	      }
	      return true;
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = createCallback(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property) {
	    if (object == null) return void 0;
	    var value = object[property];
	    return _.isFunction(value) ? object[property]() : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(obj) {
	    return this._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result.call(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result.call(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result.call(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (typeof define === 'function' && define.amd) {
	    define('underscore', [], function() {
	      return _;
	    });
	  }
	}.call(this));
	
	/**
	 * messageformat.js
	 *
	 * ICU PluralFormat + SelectFormat for JavaScript
	 *
	 * @author Alex Sexton - @SlexAxton
	 * @version 0.1.1
	 * @license WTFPL
	 * @contributor_license Dojo CLA
	*/
	(function ( root ) {
	
	  if(root['MessageFormat']) {
	    return;
	  }
	
	  // Create the contructor function
	  function MessageFormat ( locale, pluralFunc ) {
	
	    if ( locale && pluralFunc ) {
	      MessageFormat.locale[ locale ] = pluralFunc;
	    }
	
	    // Defaults
	    locale = locale || "en";
	    pluralFunc = pluralFunc || MessageFormat.locale[ locale ];
	
	    // Let's just be friends.
	    if ( ! pluralFunc ) {
	      throw new Error( "Plural Function not found for locale: " + locale );
	    }
	
	
	    // Own Properties
	    this.pluralFunc = pluralFunc;
	    this.locale = locale;
	  }
	
	  // Set up the locales object. Add in english by default
	  MessageFormat.locale = {
	    "en" : function ( n ) {
	      if ( n === 1 ) {
	        return "one";
	      }
	      return "other";
	    },
	    "en_us" : function () {
	      return this.en.apply( this, arguments );
	    }
	  };
	
	  // Build out our basic SafeString type
	  // more or less stolen from Handlebars by @wycats
	  MessageFormat.SafeString = function( string ) {
	    this.string = string;
	  };
	
	  MessageFormat.SafeString.prototype.toString = function () {
	    return this.string.toString();
	  };
	
	  MessageFormat.Utils = {
	    numSub : function ( string, key, depth ) {
	      // make sure that it's not an escaped octothorpe
	      return string.replace( /^#|[^\\]#/g, function (m) {
	        var prefix = m && m.length === 2 ? m.charAt(0) : '';
	        return prefix + '" + (function(){ var x = ' +
	        key+';\nif( isNaN(x) ){\nthrow new Error("MessageFormat: `"+lastkey_'+depth+'+"` isnt a number.");\n}\nreturn x;\n})() + "'
	      });
	    },
	    escapeExpression : function (string) {
	      var escape = {
	            "\n": "\\n"
	          },
	          badChars = /(\n)|[\n]/g,
	          possible = /[\n]/,
	          escapeChar = function(chr) {
	            return escape[chr] || "&amp;";
	          };
	
	      // Don't escape SafeStrings, since they're already safe
	      if ( string instanceof MessageFormat.SafeString ) {
	        return string.toString();
	      }
	      else if ( string === null || string === false ) {
	        return "";
	      }
	
	      if ( ! possible.test( string ) ) {
	        return string;
	      }
	      return string.replace( badChars, escapeChar );
	    }
	  };
	
	  // This is generated and pulled in for browsers.
	  var mparser = (function(){
	    /* Generated by PEG.js 0.6.2 (http://pegjs.majda.cz/). */
	
	    var result = {
	      /*
	      * Parses the input with a generated parser. If the parsing is successfull,
	      * returns a value explicitly or implicitly specified by the grammar from
	      * which the parser was generated (see |PEG.buildParser|). If the parsing is
	      * unsuccessful, throws |PEG.parser.SyntaxError| describing the error.
	      */
	      parse: function(input, startRule) {
	        var parseFunctions = {
	          "_": parse__,
	          "char": parse_char,
	          "chars": parse_chars,
	          "digits": parse_digits,
	          "elementFormat": parse_elementFormat,
	          "hexDigit": parse_hexDigit,
	          "id": parse_id,
	          "messageFormatElement": parse_messageFormatElement,
	          "messageFormatPattern": parse_messageFormatPattern,
	          "messageFormatPatternRight": parse_messageFormatPatternRight,
	          "offsetPattern": parse_offsetPattern,
	          "pluralFormatPattern": parse_pluralFormatPattern,
	          "pluralForms": parse_pluralForms,
	          "pluralStyle": parse_pluralStyle,
	          "selectFormatPattern": parse_selectFormatPattern,
	          "selectStyle": parse_selectStyle,
	          "start": parse_start,
	          "string": parse_string,
	          "stringKey": parse_stringKey,
	          "whitespace": parse_whitespace
	        };
	
	        if (startRule !== undefined) {
	          if (parseFunctions[startRule] === undefined) {
	            throw new Error("Invalid rule name: " + quote(startRule) + ".");
	          }
	        } else {
	          startRule = "start";
	        }
	
	        var pos = 0;
	        var reportMatchFailures = true;
	        var rightmostMatchFailuresPos = 0;
	        var rightmostMatchFailuresExpected = [];
	        var cache = {};
	
	        function padLeft(input, padding, length) {
	          var result = input;
	
	          var padLength = length - input.length;
	          for (var i = 0; i < padLength; i++) {
	            result = padding + result;
	          }
	
	          return result;
	        }
	
	        function escape(ch) {
	          var charCode = ch.charCodeAt(0);
	
	          if (charCode <= 0xFF) {
	            var escapeChar = 'x';
	            var length = 2;
	          } else {
	            var escapeChar = 'u';
	            var length = 4;
	          }
	
	          return '\\' + escapeChar + padLeft(charCode.toString(16).toUpperCase(), '0', length);
	        }
	
	        function quote(s) {
	          /*
	          * ECMA-262, 5th ed., 7.8.4: All characters may appear literally in a
	          * string literal except for the closing quote character, backslash,
	          * carriage return, line separator, paragraph separator, and line feed.
	          * Any character may appear in the form of an escape sequence.
	          */
	          return '"' + s
	          .replace(/\\/g, '\\\\')            // backslash
	          .replace(/"/g, '\\"')              // closing quote character
	          .replace(/\r/g, '\\r')             // carriage return
	          .replace(/\n/g, '\\n')             // line feed
	          .replace(/[\x80-\uFFFF]/g, escape) // non-ASCII characters
	          + '"';
	        }
	
	        function matchFailed(failure) {
	          if (pos < rightmostMatchFailuresPos) {
	            return;
	          }
	
	          if (pos > rightmostMatchFailuresPos) {
	            rightmostMatchFailuresPos = pos;
	            rightmostMatchFailuresExpected = [];
	          }
	
	          rightmostMatchFailuresExpected.push(failure);
	        }
	
	        function parse_start() {
	          var cacheKey = 'start@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var result1 = parse_messageFormatPattern();
	          var result2 = result1 !== null
	          ? (function(messageFormatPattern) { return { type: "program", program: messageFormatPattern }; })(result1)
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_messageFormatPattern() {
	          var cacheKey = 'messageFormatPattern@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var savedPos1 = pos;
	          var result3 = parse_string();
	          if (result3 !== null) {
	            var result4 = [];
	            var result5 = parse_messageFormatPatternRight();
	            while (result5 !== null) {
	              result4.push(result5);
	              var result5 = parse_messageFormatPatternRight();
	            }
	            if (result4 !== null) {
	              var result1 = [result3, result4];
	            } else {
	              var result1 = null;
	              pos = savedPos1;
	            }
	          } else {
	            var result1 = null;
	            pos = savedPos1;
	          }
	          var result2 = result1 !== null
	          ? (function(s1, inner) {
	            var st = [];
	            if ( s1 && s1.val ) {
	              st.push( s1 );
	            }
	            for( var i in inner ){
	              if ( inner.hasOwnProperty( i ) ) {
	                st.push( inner[ i ] );
	              }
	            }
	            return { type: 'messageFormatPattern', statements: st };
	          })(result1[0], result1[1])
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_messageFormatPatternRight() {
	          var cacheKey = 'messageFormatPatternRight@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var savedPos1 = pos;
	          if (input.substr(pos, 1) === "{") {
	            var result3 = "{";
	              pos += 1;
	            } else {
	              var result3 = null;
	              if (reportMatchFailures) {
	                matchFailed("\"{\"");
	                }
	              }
	              if (result3 !== null) {
	                var result4 = parse__();
	                if (result4 !== null) {
	                  var result5 = parse_messageFormatElement();
	                  if (result5 !== null) {
	                    var result6 = parse__();
	                    if (result6 !== null) {
	                      if (input.substr(pos, 1) === "}") {
	                        var result7 = "}";
	                        pos += 1;
	                  } else {
	                    var result7 = null;
	                    if (reportMatchFailures) {
	                      matchFailed("\"}\"");
	                  }
	                }
	                if (result7 !== null) {
	                  var result8 = parse_string();
	                  if (result8 !== null) {
	                    var result1 = [result3, result4, result5, result6, result7, result8];
	                  } else {
	                    var result1 = null;
	                    pos = savedPos1;
	                  }
	                } else {
	                  var result1 = null;
	                  pos = savedPos1;
	                }
	              } else {
	                var result1 = null;
	                pos = savedPos1;
	              }
	            } else {
	              var result1 = null;
	              pos = savedPos1;
	            }
	          } else {
	            var result1 = null;
	            pos = savedPos1;
	          }
	          } else {
	            var result1 = null;
	            pos = savedPos1;
	          }
	          var result2 = result1 !== null
	          ? (function(mfe, s1) {
	            var res = [];
	            if ( mfe ) {
	              res.push(mfe);
	            }
	            if ( s1 && s1.val ) {
	              res.push( s1 );
	            }
	            return { type: "messageFormatPatternRight", statements : res };
	          })(result1[2], result1[5])
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_messageFormatElement() {
	          var cacheKey = 'messageFormatElement@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var savedPos1 = pos;
	          var result3 = parse_id();
	          if (result3 !== null) {
	            var savedPos2 = pos;
	            if (input.substr(pos, 1) === ",") {
	              var result6 = ",";
	              pos += 1;
	            } else {
	              var result6 = null;
	              if (reportMatchFailures) {
	                matchFailed("\",\"");
	              }
	            }
	            if (result6 !== null) {
	              var result7 = parse_elementFormat();
	              if (result7 !== null) {
	                var result5 = [result6, result7];
	              } else {
	                var result5 = null;
	                pos = savedPos2;
	              }
	            } else {
	              var result5 = null;
	              pos = savedPos2;
	            }
	            var result4 = result5 !== null ? result5 : '';
	            if (result4 !== null) {
	              var result1 = [result3, result4];
	            } else {
	              var result1 = null;
	              pos = savedPos1;
	            }
	          } else {
	            var result1 = null;
	            pos = savedPos1;
	          }
	          var result2 = result1 !== null
	          ? (function(argIdx, efmt) {
	            var res = {
	              type: "messageFormatElement",
	              argumentIndex: argIdx
	            };
	            if ( efmt && efmt.length ) {
	              res.elementFormat = efmt[1];
	            }
	            else {
	              res.output = true;
	            }
	            return res;
	          })(result1[0], result1[1])
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_elementFormat() {
	          var cacheKey = 'elementFormat@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos2 = pos;
	          var savedPos3 = pos;
	          var result14 = parse__();
	          if (result14 !== null) {
	            if (input.substr(pos, 6) === "plural") {
	              var result15 = "plural";
	              pos += 6;
	            } else {
	              var result15 = null;
	              if (reportMatchFailures) {
	                matchFailed("\"plural\"");
	              }
	            }
	            if (result15 !== null) {
	              var result16 = parse__();
	              if (result16 !== null) {
	                if (input.substr(pos, 1) === ",") {
	                  var result17 = ",";
	                  pos += 1;
	                } else {
	                  var result17 = null;
	                  if (reportMatchFailures) {
	                    matchFailed("\",\"");
	                  }
	                }
	                if (result17 !== null) {
	                  var result18 = parse__();
	                  if (result18 !== null) {
	                    var result19 = parse_pluralStyle();
	                    if (result19 !== null) {
	                      var result20 = parse__();
	                      if (result20 !== null) {
	                        var result12 = [result14, result15, result16, result17, result18, result19, result20];
	                      } else {
	                        var result12 = null;
	                        pos = savedPos3;
	                      }
	                    } else {
	                      var result12 = null;
	                      pos = savedPos3;
	                    }
	                  } else {
	                    var result12 = null;
	                    pos = savedPos3;
	                  }
	                } else {
	                  var result12 = null;
	                  pos = savedPos3;
	                }
	              } else {
	                var result12 = null;
	                pos = savedPos3;
	              }
	            } else {
	              var result12 = null;
	              pos = savedPos3;
	            }
	          } else {
	            var result12 = null;
	            pos = savedPos3;
	          }
	          var result13 = result12 !== null
	          ? (function(t, s) {
	            return {
	              type : "elementFormat",
	              key  : t,
	              val  : s.val
	            };
	          })(result12[1], result12[5])
	          : null;
	          if (result13 !== null) {
	            var result11 = result13;
	          } else {
	            var result11 = null;
	            pos = savedPos2;
	          }
	          if (result11 !== null) {
	            var result0 = result11;
	          } else {
	            var savedPos0 = pos;
	            var savedPos1 = pos;
	            var result4 = parse__();
	            if (result4 !== null) {
	              if (input.substr(pos, 6) === "select") {
	                var result5 = "select";
	                pos += 6;
	              } else {
	                var result5 = null;
	                if (reportMatchFailures) {
	                  matchFailed("\"select\"");
	                }
	              }
	              if (result5 !== null) {
	                var result6 = parse__();
	                if (result6 !== null) {
	                  if (input.substr(pos, 1) === ",") {
	                    var result7 = ",";
	                    pos += 1;
	                  } else {
	                    var result7 = null;
	                    if (reportMatchFailures) {
	                      matchFailed("\",\"");
	                    }
	                  }
	                  if (result7 !== null) {
	                    var result8 = parse__();
	                    if (result8 !== null) {
	                      var result9 = parse_selectStyle();
	                      if (result9 !== null) {
	                        var result10 = parse__();
	                        if (result10 !== null) {
	                          var result2 = [result4, result5, result6, result7, result8, result9, result10];
	                        } else {
	                          var result2 = null;
	                          pos = savedPos1;
	                        }
	                      } else {
	                        var result2 = null;
	                        pos = savedPos1;
	                      }
	                    } else {
	                      var result2 = null;
	                      pos = savedPos1;
	                    }
	                  } else {
	                    var result2 = null;
	                    pos = savedPos1;
	                  }
	                } else {
	                  var result2 = null;
	                  pos = savedPos1;
	                }
	              } else {
	                var result2 = null;
	                pos = savedPos1;
	              }
	            } else {
	              var result2 = null;
	              pos = savedPos1;
	            }
	            var result3 = result2 !== null
	            ? (function(t, s) {
	              return {
	                type : "elementFormat",
	                key  : t,
	                val  : s.val
	              };
	            })(result2[1], result2[5])
	            : null;
	            if (result3 !== null) {
	              var result1 = result3;
	            } else {
	              var result1 = null;
	              pos = savedPos0;
	            }
	            if (result1 !== null) {
	              var result0 = result1;
	            } else {
	              var result0 = null;;
	            };
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_pluralStyle() {
	          var cacheKey = 'pluralStyle@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var result1 = parse_pluralFormatPattern();
	          var result2 = result1 !== null
	          ? (function(pfp) {
	            return { type: "pluralStyle", val: pfp };
	          })(result1)
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_selectStyle() {
	          var cacheKey = 'selectStyle@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var result1 = parse_selectFormatPattern();
	          var result2 = result1 !== null
	          ? (function(sfp) {
	            return { type: "selectStyle", val: sfp };
	          })(result1)
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_pluralFormatPattern() {
	          var cacheKey = 'pluralFormatPattern@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var savedPos1 = pos;
	          var result6 = parse_offsetPattern();
	          var result3 = result6 !== null ? result6 : '';
	          if (result3 !== null) {
	            var result4 = [];
	            var result5 = parse_pluralForms();
	            while (result5 !== null) {
	              result4.push(result5);
	              var result5 = parse_pluralForms();
	            }
	            if (result4 !== null) {
	              var result1 = [result3, result4];
	            } else {
	              var result1 = null;
	              pos = savedPos1;
	            }
	          } else {
	            var result1 = null;
	            pos = savedPos1;
	          }
	          var result2 = result1 !== null
	          ? (function(op, pf) {
	            var res = {
	              type: "pluralFormatPattern",
	              pluralForms: pf
	            };
	            if ( op ) {
	              res.offset = op;
	            }
	            else {
	              res.offset = 0;
	            }
	            return res;
	          })(result1[0], result1[1])
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_offsetPattern() {
	          var cacheKey = 'offsetPattern@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var savedPos1 = pos;
	          var result3 = parse__();
	          if (result3 !== null) {
	            if (input.substr(pos, 6) === "offset") {
	              var result4 = "offset";
	              pos += 6;
	            } else {
	              var result4 = null;
	              if (reportMatchFailures) {
	                matchFailed("\"offset\"");
	              }
	            }
	            if (result4 !== null) {
	              var result5 = parse__();
	              if (result5 !== null) {
	                if (input.substr(pos, 1) === ":") {
	                  var result6 = ":";
	                  pos += 1;
	                } else {
	                  var result6 = null;
	                  if (reportMatchFailures) {
	                    matchFailed("\":\"");
	                  }
	                }
	                if (result6 !== null) {
	                  var result7 = parse__();
	                  if (result7 !== null) {
	                    var result8 = parse_digits();
	                    if (result8 !== null) {
	                      var result9 = parse__();
	                      if (result9 !== null) {
	                        var result1 = [result3, result4, result5, result6, result7, result8, result9];
	                      } else {
	                        var result1 = null;
	                        pos = savedPos1;
	                      }
	                    } else {
	                      var result1 = null;
	                      pos = savedPos1;
	                    }
	                  } else {
	                    var result1 = null;
	                    pos = savedPos1;
	                  }
	                } else {
	                  var result1 = null;
	                  pos = savedPos1;
	                }
	              } else {
	                var result1 = null;
	                pos = savedPos1;
	              }
	            } else {
	              var result1 = null;
	              pos = savedPos1;
	            }
	          } else {
	            var result1 = null;
	            pos = savedPos1;
	          }
	          var result2 = result1 !== null
	          ? (function(d) {
	            return d;
	          })(result1[5])
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_selectFormatPattern() {
	          var cacheKey = 'selectFormatPattern@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var result1 = [];
	          var result3 = parse_pluralForms();
	          while (result3 !== null) {
	            result1.push(result3);
	            var result3 = parse_pluralForms();
	          }
	          var result2 = result1 !== null
	          ? (function(pf) {
	            return {
	              type: "selectFormatPattern",
	              pluralForms: pf
	            };
	          })(result1)
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_pluralForms() {
	          var cacheKey = 'pluralForms@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var savedPos1 = pos;
	          var result3 = parse__();
	          if (result3 !== null) {
	            var result4 = parse_stringKey();
	            if (result4 !== null) {
	              var result5 = parse__();
	              if (result5 !== null) {
	                if (input.substr(pos, 1) === "{") {
	                  var result6 = "{";
	                    pos += 1;
	                  } else {
	                    var result6 = null;
	                    if (reportMatchFailures) {
	                      matchFailed("\"{\"");
	                      }
	                    }
	                    if (result6 !== null) {
	                      var result7 = parse__();
	                      if (result7 !== null) {
	                        var result8 = parse_messageFormatPattern();
	                        if (result8 !== null) {
	                          var result9 = parse__();
	                          if (result9 !== null) {
	                            if (input.substr(pos, 1) === "}") {
	                              var result10 = "}";
	                              pos += 1;
	                        } else {
	                          var result10 = null;
	                          if (reportMatchFailures) {
	                            matchFailed("\"}\"");
	                        }
	                      }
	                      if (result10 !== null) {
	                        var result1 = [result3, result4, result5, result6, result7, result8, result9, result10];
	                      } else {
	                        var result1 = null;
	                        pos = savedPos1;
	                      }
	                    } else {
	                      var result1 = null;
	                      pos = savedPos1;
	                    }
	                  } else {
	                    var result1 = null;
	                    pos = savedPos1;
	                  }
	                } else {
	                  var result1 = null;
	                  pos = savedPos1;
	                }
	                } else {
	                  var result1 = null;
	                  pos = savedPos1;
	                }
	              } else {
	                var result1 = null;
	                pos = savedPos1;
	              }
	            } else {
	              var result1 = null;
	              pos = savedPos1;
	            }
	          } else {
	            var result1 = null;
	            pos = savedPos1;
	          }
	          var result2 = result1 !== null
	          ? (function(k, mfp) {
	            return {
	              type: "pluralForms",
	              key: k,
	              val: mfp
	            };
	          })(result1[1], result1[5])
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_stringKey() {
	          var cacheKey = 'stringKey@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos2 = pos;
	          var result7 = parse_id();
	          var result8 = result7 !== null
	          ? (function(i) {
	            return i;
	          })(result7)
	          : null;
	          if (result8 !== null) {
	            var result6 = result8;
	          } else {
	            var result6 = null;
	            pos = savedPos2;
	          }
	          if (result6 !== null) {
	            var result0 = result6;
	          } else {
	            var savedPos0 = pos;
	            var savedPos1 = pos;
	            if (input.substr(pos, 1) === "=") {
	              var result4 = "=";
	              pos += 1;
	            } else {
	              var result4 = null;
	              if (reportMatchFailures) {
	                matchFailed("\"=\"");
	              }
	            }
	            if (result4 !== null) {
	              var result5 = parse_digits();
	              if (result5 !== null) {
	                var result2 = [result4, result5];
	              } else {
	                var result2 = null;
	                pos = savedPos1;
	              }
	            } else {
	              var result2 = null;
	              pos = savedPos1;
	            }
	            var result3 = result2 !== null
	            ? (function(d) {
	              return d;
	            })(result2[1])
	            : null;
	            if (result3 !== null) {
	              var result1 = result3;
	            } else {
	              var result1 = null;
	              pos = savedPos0;
	            }
	            if (result1 !== null) {
	              var result0 = result1;
	            } else {
	              var result0 = null;;
	            };
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_string() {
	          var cacheKey = 'string@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var savedPos1 = pos;
	          var result3 = parse__();
	          if (result3 !== null) {
	            var result4 = [];
	            var savedPos2 = pos;
	            var result6 = parse__();
	            if (result6 !== null) {
	              var result7 = parse_chars();
	              if (result7 !== null) {
	                var result8 = parse__();
	                if (result8 !== null) {
	                  var result5 = [result6, result7, result8];
	                } else {
	                  var result5 = null;
	                  pos = savedPos2;
	                }
	              } else {
	                var result5 = null;
	                pos = savedPos2;
	              }
	            } else {
	              var result5 = null;
	              pos = savedPos2;
	            }
	            while (result5 !== null) {
	              result4.push(result5);
	              var savedPos2 = pos;
	              var result6 = parse__();
	              if (result6 !== null) {
	                var result7 = parse_chars();
	                if (result7 !== null) {
	                  var result8 = parse__();
	                  if (result8 !== null) {
	                    var result5 = [result6, result7, result8];
	                  } else {
	                    var result5 = null;
	                    pos = savedPos2;
	                  }
	                } else {
	                  var result5 = null;
	                  pos = savedPos2;
	                }
	              } else {
	                var result5 = null;
	                pos = savedPos2;
	              }
	            }
	            if (result4 !== null) {
	              var result1 = [result3, result4];
	            } else {
	              var result1 = null;
	              pos = savedPos1;
	            }
	          } else {
	            var result1 = null;
	            pos = savedPos1;
	          }
	          var result2 = result1 !== null
	          ? (function(ws, s) {
	            var tmp = [];
	            for( var i = 0; i < s.length; ++i ) {
	              for( var j = 0; j < s[ i ].length; ++j ) {
	                tmp.push(s[i][j]);
	              }
	            }
	            return {
	              type: "string",
	              val: ws + tmp.join('')
	            };
	          })(result1[0], result1[1])
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_id() {
	          var cacheKey = 'id@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var savedPos1 = pos;
	          var result3 = parse__();
	          if (result3 !== null) {
	            if (input.substr(pos).match(/^[a-zA-Z$_]/) !== null) {
	              var result4 = input.charAt(pos);
	              pos++;
	            } else {
	              var result4 = null;
	              if (reportMatchFailures) {
	                matchFailed("[a-zA-Z$_]");
	              }
	            }
	            if (result4 !== null) {
	              var result5 = [];
	              if (input.substr(pos).match(/^[^ 	\n\r,.+={}]/) !== null) {
	                var result7 = input.charAt(pos);
	                pos++;
	              } else {
	                var result7 = null;
	                if (reportMatchFailures) {
	                  matchFailed("[^ 	\\n\\r,.+={}]");
	                }
	              }
	              while (result7 !== null) {
	                result5.push(result7);
	                if (input.substr(pos).match(/^[^ 	\n\r,.+={}]/) !== null) {
	                  var result7 = input.charAt(pos);
	                  pos++;
	                } else {
	                  var result7 = null;
	                  if (reportMatchFailures) {
	                    matchFailed("[^ 	\\n\\r,.+={}]");
	                  }
	                }
	              }
	              if (result5 !== null) {
	                var result6 = parse__();
	                if (result6 !== null) {
	                  var result1 = [result3, result4, result5, result6];
	                } else {
	                  var result1 = null;
	                  pos = savedPos1;
	                }
	              } else {
	                var result1 = null;
	                pos = savedPos1;
	              }
	            } else {
	              var result1 = null;
	              pos = savedPos1;
	            }
	          } else {
	            var result1 = null;
	            pos = savedPos1;
	          }
	          var result2 = result1 !== null
	          ? (function(s1, s2) {
	            return s1 + (s2 ? s2.join('') : '');
	          })(result1[1], result1[2])
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_chars() {
	          var cacheKey = 'chars@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var result3 = parse_char();
	          if (result3 !== null) {
	            var result1 = [];
	            while (result3 !== null) {
	              result1.push(result3);
	              var result3 = parse_char();
	            }
	          } else {
	            var result1 = null;
	          }
	          var result2 = result1 !== null
	          ? (function(chars) { return chars.join(''); })(result1)
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_char() {
	          var cacheKey = 'char@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos5 = pos;
	          if (input.substr(pos).match(/^[^{}\\\0- 	\n\r]/) !== null) {
	            var result19 = input.charAt(pos);
	            pos++;
	          } else {
	            var result19 = null;
	            if (reportMatchFailures) {
	              matchFailed("[^{}\\\\\\0- 	\\n\\r]");
	            }
	          }
	          var result20 = result19 !== null
	          ? (function(x) {
	            return x;
	          })(result19)
	          : null;
	          if (result20 !== null) {
	            var result18 = result20;
	          } else {
	            var result18 = null;
	            pos = savedPos5;
	          }
	          if (result18 !== null) {
	            var result0 = result18;
	          } else {
	            var savedPos4 = pos;
	            if (input.substr(pos, 2) === "\\#") {
	              var result16 = "\\#";
	              pos += 2;
	            } else {
	              var result16 = null;
	              if (reportMatchFailures) {
	                matchFailed("\"\\\\#\"");
	              }
	            }
	            var result17 = result16 !== null
	            ? (function() {
	              return "\\#";
	            })()
	            : null;
	            if (result17 !== null) {
	              var result15 = result17;
	            } else {
	              var result15 = null;
	              pos = savedPos4;
	            }
	            if (result15 !== null) {
	              var result0 = result15;
	            } else {
	              var savedPos3 = pos;
	              if (input.substr(pos, 2) === "\\{") {
	                var result13 = "\\{";
	                  pos += 2;
	                } else {
	                  var result13 = null;
	                  if (reportMatchFailures) {
	                    matchFailed("\"\\\\{\"");
	                    }
	                  }
	                  var result14 = result13 !== null
	                  ? (function() {
	                    return "\u007B";
	                  })()
	                  : null;
	                  if (result14 !== null) {
	                    var result12 = result14;
	                  } else {
	                    var result12 = null;
	                    pos = savedPos3;
	                  }
	                  if (result12 !== null) {
	                    var result0 = result12;
	                  } else {
	                    var savedPos2 = pos;
	                    if (input.substr(pos, 2) === "\\}") {
	                      var result10 = "\\}";
	                      pos += 2;
	                } else {
	                  var result10 = null;
	                  if (reportMatchFailures) {
	                    matchFailed("\"\\\\}\"");
	                }
	              }
	              var result11 = result10 !== null
	              ? (function() {
	                return "\u007D";
	              })()
	              : null;
	              if (result11 !== null) {
	                var result9 = result11;
	              } else {
	                var result9 = null;
	                pos = savedPos2;
	              }
	              if (result9 !== null) {
	                var result0 = result9;
	              } else {
	                var savedPos0 = pos;
	                var savedPos1 = pos;
	                if (input.substr(pos, 2) === "\\u") {
	                  var result4 = "\\u";
	                  pos += 2;
	                } else {
	                  var result4 = null;
	                  if (reportMatchFailures) {
	                    matchFailed("\"\\\\u\"");
	                  }
	                }
	                if (result4 !== null) {
	                  var result5 = parse_hexDigit();
	                  if (result5 !== null) {
	                    var result6 = parse_hexDigit();
	                    if (result6 !== null) {
	                      var result7 = parse_hexDigit();
	                      if (result7 !== null) {
	                        var result8 = parse_hexDigit();
	                        if (result8 !== null) {
	                          var result2 = [result4, result5, result6, result7, result8];
	                        } else {
	                          var result2 = null;
	                          pos = savedPos1;
	                        }
	                      } else {
	                        var result2 = null;
	                        pos = savedPos1;
	                      }
	                    } else {
	                      var result2 = null;
	                      pos = savedPos1;
	                    }
	                  } else {
	                    var result2 = null;
	                    pos = savedPos1;
	                  }
	                } else {
	                  var result2 = null;
	                  pos = savedPos1;
	                }
	                var result3 = result2 !== null
	                ? (function(h1, h2, h3, h4) {
	                  return String.fromCharCode(parseInt("0x" + h1 + h2 + h3 + h4));
	                })(result2[1], result2[2], result2[3], result2[4])
	                : null;
	                if (result3 !== null) {
	                  var result1 = result3;
	                } else {
	                  var result1 = null;
	                  pos = savedPos0;
	                }
	                if (result1 !== null) {
	                  var result0 = result1;
	                } else {
	                  var result0 = null;;
	                };
	              };
	              };
	            };
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_digits() {
	          var cacheKey = 'digits@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          if (input.substr(pos).match(/^[0-9]/) !== null) {
	            var result3 = input.charAt(pos);
	            pos++;
	          } else {
	            var result3 = null;
	            if (reportMatchFailures) {
	              matchFailed("[0-9]");
	            }
	          }
	          if (result3 !== null) {
	            var result1 = [];
	            while (result3 !== null) {
	              result1.push(result3);
	              if (input.substr(pos).match(/^[0-9]/) !== null) {
	                var result3 = input.charAt(pos);
	                pos++;
	              } else {
	                var result3 = null;
	                if (reportMatchFailures) {
	                  matchFailed("[0-9]");
	                }
	              }
	            }
	          } else {
	            var result1 = null;
	          }
	          var result2 = result1 !== null
	          ? (function(ds) {
	            return parseInt((ds.join('')), 10);
	          })(result1)
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_hexDigit() {
	          var cacheKey = 'hexDigit@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          if (input.substr(pos).match(/^[0-9a-fA-F]/) !== null) {
	            var result0 = input.charAt(pos);
	            pos++;
	          } else {
	            var result0 = null;
	            if (reportMatchFailures) {
	              matchFailed("[0-9a-fA-F]");
	            }
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse__() {
	          var cacheKey = '_@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	          var savedReportMatchFailures = reportMatchFailures;
	          reportMatchFailures = false;
	          var savedPos0 = pos;
	          var result1 = [];
	          var result3 = parse_whitespace();
	          while (result3 !== null) {
	            result1.push(result3);
	            var result3 = parse_whitespace();
	          }
	          var result2 = result1 !== null
	          ? (function(w) { return w.join(''); })(result1)
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	          reportMatchFailures = savedReportMatchFailures;
	          if (reportMatchFailures && result0 === null) {
	            matchFailed("whitespace");
	          }
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_whitespace() {
	          var cacheKey = 'whitespace@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          if (input.substr(pos).match(/^[ 	\n\r]/) !== null) {
	            var result0 = input.charAt(pos);
	            pos++;
	          } else {
	            var result0 = null;
	            if (reportMatchFailures) {
	              matchFailed("[ 	\\n\\r]");
	            }
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function buildErrorMessage() {
	          function buildExpected(failuresExpected) {
	            failuresExpected.sort();
	
	            var lastFailure = null;
	            var failuresExpectedUnique = [];
	            for (var i = 0; i < failuresExpected.length; i++) {
	              if (failuresExpected[i] !== lastFailure) {
	                failuresExpectedUnique.push(failuresExpected[i]);
	                lastFailure = failuresExpected[i];
	              }
	            }
	
	            switch (failuresExpectedUnique.length) {
	              case 0:
	                return 'end of input';
	              case 1:
	                return failuresExpectedUnique[0];
	              default:
	                return failuresExpectedUnique.slice(0, failuresExpectedUnique.length - 1).join(', ')
	              + ' or '
	              + failuresExpectedUnique[failuresExpectedUnique.length - 1];
	            }
	          }
	
	          var expected = buildExpected(rightmostMatchFailuresExpected);
	          var actualPos = Math.max(pos, rightmostMatchFailuresPos);
	          var actual = actualPos < input.length
	          ? quote(input.charAt(actualPos))
	          : 'end of input';
	
	          return 'Expected ' + expected + ' but ' + actual + ' found.';
	        }
	
	        function computeErrorPosition() {
	          /*
	          * The first idea was to use |String.split| to break the input up to the
	          * error position along newlines and derive the line and column from
	          * there. However IE's |split| implementation is so broken that it was
	          * enough to prevent it.
	          */
	
	          var line = 1;
	          var column = 1;
	          var seenCR = false;
	
	          for (var i = 0; i <  rightmostMatchFailuresPos; i++) {
	            var ch = input.charAt(i);
	            if (ch === '\n') {
	              if (!seenCR) { line++; }
	              column = 1;
	              seenCR = false;
	            } else if (ch === '\r' | ch === '\u2028' || ch === '\u2029') {
	              line++;
	              column = 1;
	              seenCR = true;
	            } else {
	              column++;
	              seenCR = false;
	            }
	          }
	
	          return { line: line, column: column };
	        }
	
	
	
	        var result = parseFunctions[startRule]();
	
	        /*
	        * The parser is now in one of the following three states:
	        *
	        * 1. The parser successfully parsed the whole input.
	        *
	        *    - |result !== null|
	        *    - |pos === input.length|
	        *    - |rightmostMatchFailuresExpected| may or may not contain something
	        *
	        * 2. The parser successfully parsed only a part of the input.
	        *
	        *    - |result !== null|
	        *    - |pos < input.length|
	        *    - |rightmostMatchFailuresExpected| may or may not contain something
	        *
	        * 3. The parser did not successfully parse any part of the input.
	        *
	        *   - |result === null|
	        *   - |pos === 0|
	        *   - |rightmostMatchFailuresExpected| contains at least one failure
	        *
	        * All code following this comment (including called functions) must
	        * handle these states.
	        */
	        if (result === null || pos !== input.length) {
	          var errorPosition = computeErrorPosition();
	          throw new this.SyntaxError(
	            buildErrorMessage(),
	            errorPosition.line,
	            errorPosition.column
	          );
	        }
	
	        return result;
	      },
	
	      /* Returns the parser source code. */
	      toSource: function() { return this._source; }
	    };
	
	    /* Thrown when a parser encounters a syntax error. */
	
	    result.SyntaxError = function(message, line, column) {
	      this.name = 'SyntaxError';
	      this.message = message;
	      this.line = line;
	      this.column = column;
	    };
	
	    result.SyntaxError.prototype = Error.prototype;
	
	    return result;
	  })();
	
	  MessageFormat.prototype.parse = function () {
	    // Bind to itself so error handling works
	    return mparser.parse.apply( mparser, arguments );
	  };
	
	  MessageFormat.prototype.precompile = function ( ast ) {
	    var self = this,
	        needOther = false,
	        fp = {
	      begin: 'function(d){\nvar r = "";\n',
	      end  : "return r;\n}"
	    };
	
	    function interpMFP ( ast, data ) {
	      // Set some default data
	      data = data || {};
	      var s = '', i, tmp, lastkeyname;
	
	      switch ( ast.type ) {
	        case 'program':
	          return interpMFP( ast.program );
	        case 'messageFormatPattern':
	          for ( i = 0; i < ast.statements.length; ++i ) {
	            s += interpMFP( ast.statements[i], data );
	          }
	          return fp.begin + s + fp.end;
	        case 'messageFormatPatternRight':
	          for ( i = 0; i < ast.statements.length; ++i ) {
	            s += interpMFP( ast.statements[i], data );
	          }
	          return s;
	        case 'messageFormatElement':
	          data.pf_count = data.pf_count || 0;
	          s += 'if(!d){\nthrow new Error("MessageFormat: No data passed to function.");\n}\n';
	          if ( ast.output ) {
	            s += 'r += d["' + ast.argumentIndex + '"];\n';
	          }
	          else {
	            lastkeyname = 'lastkey_'+(data.pf_count+1);
	            s += 'var '+lastkeyname+' = "'+ast.argumentIndex+'";\n';
	            s += 'var k_'+(data.pf_count+1)+'=d['+lastkeyname+'];\n';
	            s += interpMFP( ast.elementFormat, data );
	          }
	          return s;
	        case 'elementFormat':
	          if ( ast.key === 'select' ) {
	            s += interpMFP( ast.val, data );
	            s += 'r += (pf_' +
	                 data.pf_count +
	                 '[ k_' + (data.pf_count+1) + ' ] || pf_'+data.pf_count+'[ "other" ])( d );\n';
	          }
	          else if ( ast.key === 'plural' ) {
	            s += interpMFP( ast.val, data );
	            s += 'if ( pf_'+(data.pf_count)+'[ k_'+(data.pf_count+1)+' + "" ] ) {\n';
	            s += 'r += pf_'+data.pf_count+'[ k_'+(data.pf_count+1)+' + "" ]( d ); \n';
	            s += '}\nelse {\n';
	            s += 'r += (pf_' +
	                 data.pf_count +
	                 '[ MessageFormat.locale["' +
	                 self.locale +
	                 '"]( k_'+(data.pf_count+1)+' - off_'+(data.pf_count)+' ) ] || pf_'+data.pf_count+'[ "other" ] )( d );\n';
	            s += '}\n';
	          }
	          return s;
	        /* // Unreachable cases.
	        case 'pluralStyle':
	        case 'selectStyle':*/
	        case 'pluralFormatPattern':
	          data.pf_count = data.pf_count || 0;
	          s += 'var off_'+data.pf_count+' = '+ast.offset+';\n';
	          s += 'var pf_' + data.pf_count + ' = { \n';
	          needOther = true;
	          // We're going to simultaneously check to make sure we hit the required 'other' option.
	
	          for ( i = 0; i < ast.pluralForms.length; ++i ) {
	            if ( ast.pluralForms[ i ].key === 'other' ) {
	              needOther = false;
	            }
	            if ( tmp ) {
	              s += ',\n';
	            }
	            else{
	              tmp = 1;
	            }
	            s += '"' + ast.pluralForms[ i ].key + '" : ' + interpMFP( ast.pluralForms[ i ].val,
	          (function(){ var res = JSON.parse(JSON.stringify(data)); res.pf_count++; return res; })() );
	          }
	          s += '\n};\n';
	          if ( needOther ) {
	            throw new Error("No 'other' form found in pluralFormatPattern " + data.pf_count);
	          }
	          return s;
	        case 'selectFormatPattern':
	
	          data.pf_count = data.pf_count || 0;
	          s += 'var off_'+data.pf_count+' = 0;\n';
	          s += 'var pf_' + data.pf_count + ' = { \n';
	          needOther = true;
	
	          for ( i = 0; i < ast.pluralForms.length; ++i ) {
	            if ( ast.pluralForms[ i ].key === 'other' ) {
	              needOther = false;
	            }
	            if ( tmp ) {
	              s += ',\n';
	            }
	            else{
	              tmp = 1;
	            }
	            s += '"' + ast.pluralForms[ i ].key + '" : ' + interpMFP( ast.pluralForms[ i ].val,
	              (function(){
	                var res = JSON.parse( JSON.stringify( data ) );
	                res.pf_count++;
	                return res;
	              })()
	            );
	          }
	          s += '\n};\n';
	          if ( needOther ) {
	            throw new Error("No 'other' form found in selectFormatPattern " + data.pf_count);
	          }
	          return s;
	        /* // Unreachable
	        case 'pluralForms':
	        */
	        case 'string':
	          return 'r += "' + MessageFormat.Utils.numSub(
	            MessageFormat.Utils.escapeExpression( ast.val ),
	            'k_' + data.pf_count + ' - off_' + ( data.pf_count - 1 ),
	            data.pf_count
	          ) + '";\n';
	        default:
	          throw new Error( 'Bad AST type: ' + ast.type );
	      }
	    }
	    return interpMFP( ast );
	  };
	
	  MessageFormat.prototype.compile = function ( message ) {
	    return (new Function( 'MessageFormat',
	      'return ' +
	        this.precompile(
	          this.parse( message )
	        )
	    ))(MessageFormat);
	  };
	
	   root['MessageFormat'] = MessageFormat;
	}(this));
	
	define("messageformat/messageformat", (function (global) {
	    return function () {
	        var ret, fn;
	        return ret || global.MessageFormat;
	    };
	}(this)));
	
	MessageFormat.locale.en = function ( n ) {
	  if ( n === 1 ) {
	    return "one";
	  }
	  return "other";
	};
	
	define("messageformat/locale/en", function(){});
	
	MessageFormat.locale.ja = function ( n ) {
	    if ( n === 1 ) {
	        return "one";
	    }
	    return "other";
	};
	
	define("messageformat/locale/ja", function(){});
	
	MessageFormat.locale.zh = function ( n ) {
	  return "other";
	};
	
	define("messageformat/locale/zh", function(){});
	
	MessageFormat.locale.ko = function ( n ) {
	  return "other";
	};
	
	define("messageformat/locale/ko", function(){});
	
	MessageFormat.locale.fr = function (n) {
	  if (n >= 0 && n < 2) {
	    return 'one';
	  }
	  return 'other';
	};
	
	define("messageformat/locale/fr", function(){});
	
	MessageFormat.locale.de = function ( n ) {
	  if ( n === 1 ) {
	    return "one";
	  }
	  return "other";
	};
	
	define("messageformat/locale/de", function(){});
	
	MessageFormat.locale.es = function ( n ) {
	  if ( n === 1 ) {
	    return "one";
	  }
	  return "other";
	};
	
	define("messageformat/locale/es", function(){});
	
	MessageFormat.locale.it = function ( n ) {
	  if ( n === 1 ) {
	    return "one";
	  }
	  return "other";
	};
	
	define("messageformat/locale/it", function(){});
	
	MessageFormat.locale.tr = function(n) {
	  return 'other';
	};
	
	define("messageformat/locale/tr", function(){});
	
	MessageFormat.locale.ru = function (n) {
	  if ((n % 10) == 1 && (n % 100) != 11) {
	    return 'one';
	  }
	  if ((n % 10) >= 2 && (n % 10) <= 4 &&
	      ((n % 100) < 12 || (n % 100) > 14) && n == Math.floor(n)) {
	    return 'few';
	  }
	  if ((n % 10) === 0 || ((n % 10) >= 5 && (n % 10) <= 9) ||
	      ((n % 100) >= 11 && (n % 100) <= 14) && n == Math.floor(n)) {
	    return 'many';
	  }
	  return 'other';
	};
	
	define("messageformat/locale/ru", function(){});
	
	MessageFormat.locale.pt = function ( n ) {
	  if ( n === 1 ) {
	    return "one";
	  }
	  return "other";
	};
	
	define("messageformat/locale/pt", function(){});
	
	MessageFormat.locale.no = function ( n ) {
	  if ( n === 1 ) {
	    return "one";
	  }
	  return "other";
	};
	
	define("messageformat/locale/no", function(){});
	
	MessageFormat.locale.sv = function ( n ) {
	  if ( n === 1 ) {
	    return "one";
	  }
	  return "other";
	};
	
	define("messageformat/locale/sv", function(){});
	
	MessageFormat.locale.nl = function ( n ) {
	  if ( n === 1 ) {
	    return "one";
	  }
	  return "other";
	};
	
	define("messageformat/locale/nl", function(){});
	
	MessageFormat.locale.pl = function (n) {
	  if (n == 1) {
	    return 'one';
	  }
	  if ((n % 10) >= 2 && (n % 10) <= 4 &&
	      ((n % 100) < 12 || (n % 100) > 14) && n == Math.floor(n)) {
	    return 'few';
	  }
	  if ((n % 10) === 0 || n != 1 && (n % 10) == 1 ||
	      ((n % 10) >= 5 && (n % 10) <= 9 || (n % 100) >= 12 && (n % 100) <= 14) &&
	      n == Math.floor(n)) {
	    return 'many';
	  }
	  return 'other';
	};
	
	define("messageformat/locale/pl", function(){});
	
	MessageFormat.locale.cs = function (n) {
	  if (n == 1) {
	    return 'one';
	  }
	  if (n == 2 || n == 3 || n == 4) {
	    return 'few';
	  }
	  return 'other';
	};
	
	define("messageformat/locale/cs", function(){});
	
	MessageFormat.locale.ro = function (n) {
	  if (n == 1) {
	    return 'one';
	  }
	  if (n === 0 || n != 1 && (n % 100) >= 1 &&
	      (n % 100) <= 19 && n == Math.floor(n)) {
	    return 'few';
	  }
	  return 'other';
	};
	
	define("messageformat/locale/ro", function(){});
	
	MessageFormat.locale["in"] = function(n) {
	  return 'other';
	};
	
	define("messageformat/locale/in", function(){});
	
	define('i18n/locale',['require'],function(require) {
	    if(typeof global_page_viewer === 'object' && global_page_viewer.locale) {
	        return global_page_viewer.locale;
	    } else if(typeof fitbit === 'object' && typeof fitbit.i18n === 'object' && fitbit.i18n.locale) {
	        return fitbit.i18n.locale;
	    } else {
	        var body = document.getElementsByTagName("body");
	        if(body && body[0]) {
	            var res = /locale-([a-z]{2}_[A-Z]{2})/.exec(body[0].className);
	            if(res && res[1]) {
	                return res[1];
	            }
	        }
	        return 'en_US';
	    }
	});
	
	define('i18n/i18n',['require','exports','module','underscore','messageformat/messageformat','messageformat/locale/en','messageformat/locale/ja','messageformat/locale/zh','messageformat/locale/ko','messageformat/locale/fr','messageformat/locale/de','messageformat/locale/es','messageformat/locale/it','messageformat/locale/tr','messageformat/locale/ru','messageformat/locale/pt','messageformat/locale/no','messageformat/locale/sv','messageformat/locale/nl','messageformat/locale/pl','messageformat/locale/cs','messageformat/locale/ro','messageformat/locale/in','i18n/locale'],function(require, exports, module) {
	    var _ = require('underscore');
	    var Messageformat = require('messageformat/messageformat');
	
	    // todo: don't do this, load the correct message format in a way that is more fundamentally connected to what locale is loaded
	    require('messageformat/locale/en');
	    require('messageformat/locale/ja');
	    require('messageformat/locale/zh');
	    require('messageformat/locale/ko');
	    require('messageformat/locale/fr');
	    require('messageformat/locale/de');
	    require('messageformat/locale/es');
	    require('messageformat/locale/it');
	    require('messageformat/locale/tr');
	    require('messageformat/locale/ru');
	    require('messageformat/locale/pt');
	    require('messageformat/locale/no');
	    require('messageformat/locale/sv');
	    require('messageformat/locale/nl');
	    require('messageformat/locale/pl');
	    require('messageformat/locale/cs');
	    require('messageformat/locale/ro');
	    require('messageformat/locale/in');
	
	    Messageformat.locale.nb = MessageFormat.locale.no;
	
	    var format = new Messageformat(require('i18n/locale').slice(0,2));
	    var masterConfig = (module.config && module.config()) || {};
	
	    // bootstrap is an array of our i18n hashes
	    // the i18n hashes generally look like:
	    // {
	    //   namespace: "com.fitbit.blah.blah",
	    //   translations: {
	    //      'somekey': 'some translation of some key',
	    //      ...
	    //   }
	    // }
	    return function i18nConstructor(bootstrap) {
	        var namespaces = [];
	
	        function i18n(key) {
	            var args = _.toArray(arguments).slice(1);
	
	            var namespace = i18n._getNamespace(key);
	
	            if (!namespace) {
	                return i18n._handleError(key);
	            }
	
	            var value;
	
	            if (args.length) {
	                value = i18n._ensureMessageFormat(namespace, key).apply(i18n, args);
	            } else {
	                value = namespace.translations[key];
	            }
	
	            return value;
	        }
	
	        i18n._ensureMessageFormat = function _ensureMessageFormat(namespaceObject, key, overrideValue) {
	            var formatted = namespaceObject.formatted[key];
	
	            if(!formatted) {
	                var value = overrideValue || namespaceObject.translations[key];
	                formatted = namespaceObject.formatted[key] = format.compile(value);
	            }
	
	            return formatted;
	        };
	
	        i18n._getNamespace = function _getNamespace(key) {
	            return _.find(namespaces, function (namespace) {
	                return namespace.translations[key];
	            });
	        };
	
	        i18n._handleError = function _handleError(key) {
	            if (masterConfig.strict) {
	                var namespaceNames = _.pluck(i18n.getNamespaces(), 'namespace');
	                throw new Error('missing translation for: "' + key + '" with loaded namespaces: ' + JSON.stringify(namespaceNames));
	            }
	            return key;
	        };
	
	        i18n._handleReserveError = function _handleReserveError(namespace) {
	            if (masterConfig.strict) {
	                var namespaceNames = _.pluck(i18n.getNamespaces(), 'namespace');
	                throw new Error('missing namespace for: "' + namespace + '" with loaded namespaces: ' + JSON.stringify(namespaceNames));
	            }
	        };
	
	        // deprecated: just use normal message formatting
	        i18n.plural = function plural(key) {
	            var namespace = i18n._getNamespace(key);
	
	            if (!namespace) {
	                var errorFallback = i18n._handleError(key);
	                return function() {
	                    return errorFallback;
	                };
	            }
	
	            return function(results) {
	                return i18n._ensureMessageFormat(namespace, key, '{NUM_RESULTS, plural, ' + namespace.translations[key] + '}')({
	                    NUM_RESULTS: results
	                });
	            };
	        };
	
	        // takes an arbitrary amount of objects of the type
	        // {
	        //   namespace: "com.fitbit.blah.blah",
	        //   translations: {
	        //      'somekey': 'some translation of some key',
	        //      ...
	        //   }
	        // }
	        i18n.namespace = function namespace() {
	            _.each(arguments, function(namespaceObject) {
	                if (!namespaceObject) {
	                    return;
	                }
	                // would leak, do we care?
	                namespaceObject.formatted = namespaceObject.formatted || {};
	                namespaces.unshift(namespaceObject);
	            });
	
	            return this;
	        };
	
	        i18n.getNamespaces = function getNamespaces() {
	            return namespaces;
	        };
	
	        i18n.inNamespace = function inNamespace(namespace) {
	            var found = _.find(i18n.getNamespaces(), function (namespaceObject) {
	                return namespaceObject.namespace === namespace;
	            });
	            if(!found) {
	                i18n._handleReserveError(namespace);
	
	                return i18n;
	            }
	            return new i18nConstructor([found]);
	        };
	
	        if(bootstrap) {
	            i18n.namespace.apply(i18n, bootstrap);
	        }
	
	        return i18n;
	    };
	});
	
	define('i18n/locales',[],function() {
	    return [
	        'en_US', 'en_CA', 'en_AU', 'en_GB', 'en_IE', 'en_NL', 'en_NO', 'en_SE', 'en_BE', 'en_DK', 'en_FI', 'en_PL', 'en_NZ', 'en_HK', 'en_SG', 'en_ZA', 'en_IL', 'en_TH', 'en_MY', 'en_PH', 'en_ID', 'en_VN', 'en_IN',
	        'ja_JP',
	        'zh_CN', 'zh_TW',
	        'ko_KR',
	        'fr_FR', 'fr_CH', 'fr_CA', 'fr_BE',
	        'de_DE', 'de_AT', 'de_CH',
	        'es_ES', 'es_MX', 'es_CO', 'es_CL', 'es_EC', 'es_VE', 'es_AR', 'es_PE', 'es_PY', 'es_CR', 'es_PA', 'es_PR', 'es_GT',
	        'it_IT', 'it_CH',
	        'nl_NL',
	        'no_NO',
	        'sv_SE',
	        'tr_TR',
	        'ru',
	        'pt_BR',
	        'en_EU'
	    ];
	});
	
	define('i18n/properties/parse',['require','exports','module'],function (require, exports, module) {
	
	var hex = function (c){
	  switch (c){
	    case "0": return 0;
	    case "1": return 1;
	    case "2": return 2;
	    case "3": return 3;
	    case "4": return 4;
	    case "5": return 5;
	    case "6": return 6;
	    case "7": return 7;
	    case "8": return 8;
	    case "9": return 9;
	    case "a": case "A": return 10;
	    case "b": case "B": return 11;
	    case "c": case "C": return 12;
	    case "d": case "D": return 13;
	    case "e": case "E": return 14;
	    case "f": case "F": return 15;
	  }
	};
	
	module.exports = function (data, options, handlers, control){
	  var c;
	  var code;
	  var escape;
	  var skipSpace = true;
	  var isCommentLine;
	  var isSectionLine;
	  var newLine = true;
	  var multiLine;
	  var isKey = true;
	  var key = "";
	  var value = "";
	  var section;
	  var unicode;
	  var unicodeRemaining;
	  var escapingUnicode;
	  var keySpace;
	  var sep;
	  var ignoreLine;
	  
	  var line = function (){
	    if (key || value || sep){
	      handlers.line (key, value);
	      key = "";
	      value = "";
	      sep = false;
	    }
	  };
	  
	  var escapeString = function (key, c, code){
	    if (escapingUnicode && unicodeRemaining){
	      unicode = (unicode << 4) + hex (c);
	      if (--unicodeRemaining) return key;
	      escape = false;
	      escapingUnicode = false;
	      return key + String.fromCharCode (unicode);
	    }
	    
	    //code 117: u
	    if (code === 117){
	      unicode = 0;
	      escapingUnicode = true;
	      unicodeRemaining = 4;
	      return key;
	    }
	    
	    escape = false;
	    
	    //code 116: t
	    //code 114: r
	    //code 110: n
	    //code 102: f
	    if (code === 116) return key + "\t";
	    else if (code === 114) return key + "\r";
	    else if (code === 110) return key + "\n";
	    else if (code === 102) return key + "\f";
	    
	    return key + c;
	  };
	  
	  var isComment;
	  var isSeparator;
	  
	  if (options._strict){
	    isComment = function (c, code, options){
	      return options._comments[c];
	    };
	
	    isSeparator = function (c, code, options){
	      return options._separators[c];
	    };
	  }else{
	    isComment = function (c, code, options){
	      //code 35: #
	      //code 33: !
	      return code === 35 || code === 33 || options._comments[c];
	    };
	
	    isSeparator = function (c, code, options){
	      //code 61: =
	      //code 58: :
	      return code === 61 || code === 58 || options._separators[c];
	    };
	  }
	  
	  for (var i=~~control.resume; i<data.length; i++){
	    if (control.abort) return;
	    if (control.pause){
	      //The next index is always the start of a new line, it's a like a fresh
	      //start, there's no need to save the current state
	      control.resume = i;
	      return;
	    }
	    
	    c = data[i];
	    code = data.charCodeAt (i);
	    
	    //code 13: \r
	    if (code === 13) continue;
	    
	    if (isCommentLine){
	      //code 10: \n
	      if (code === 10){
	        isCommentLine = false;
	        newLine = true;
	        skipSpace = true;
	      }
	      continue;
	    }
	    
	    //code 93: ]
	    if (isSectionLine && code === 93){
	      handlers.section (section);
	      //Ignore chars after the section in the same line
	      ignoreLine = true;
	      continue;
	    }
	    
	    if (skipSpace){
	      //code 32: " " (space)
	      //code 9: \t
	      //code 12: \f
	      if (code === 32 || code === 9 || code === 12){
	        continue;
	      }
	      //code 10: \n
	      if (!multiLine && code === 10){
	        //Empty line or key w/ separator and w/o value
	        isKey = true;
	        keySpace = false;
	        newLine = true;
	        line ();
	        continue;
	      }
	      skipSpace = false;
	      multiLine = false;
	    }
	    
	    if (newLine){
	      newLine = false;
	      if (isComment (c, code, options)){
	        isCommentLine = true;
	        continue;
	      }
	      //code 91: [
	      if (options.sections && code === 91){
	        section = "";
	        isSectionLine = true;
	        control.skipSection = false;
	        continue;
	      }
	    }
	    
	    //code 10: \n
	    if (code !== 10){
	      if (control.skipSection || ignoreLine) continue;
	      
	      if (!isSectionLine){
	        if (!escape && isKey && isSeparator (c, code, options)){
	          //sep is needed to detect empty key and empty value with a
	          //non-whitespace separator
	          sep = true;
	          isKey = false;
	          keySpace = false;
	          //Skip whitespace between separator and value
	          skipSpace = true;
	          continue;
	        }
	      }
	      
	      //code 92: "\" (backslash)
	      if (code === 92){
	        if (escape){
	          if (escapingUnicode) continue;
	          
	          if (keySpace){
	            //Line with whitespace separator
	            keySpace = false;
	            isKey = false;
	          }
	        
	          if (isSectionLine) section += "\\";
	          else if (isKey) key += "\\";
	          else value += "\\";
	        }
	        escape = !escape;
	      }else{
	        if (keySpace){
	          //Line with whitespace separator
	          keySpace = false;
	          isKey = false;
	        }
	        
	        if (isSectionLine){
	          if (escape) section = escapeString (section, c, code);
	          else section += c;
	        }else if (isKey){
	          if (escape){
	            key = escapeString (key, c, code);
	          }else{
	            //code 32: " " (space)
	            //code 9: \t
	            //code 12: \f
	            if (code === 32 || code === 9 || code === 12){
	              keySpace = true;
	              //Skip whitespace between key and separator
	              skipSpace = true;
	              continue;
	            }
	            key += c;
	          }
	        }else{
	          if (escape) value = escapeString (value, c, code);
	          else value += c;
	        }
	      }
	    }else{
	      if (escape){
	        if (!escapingUnicode){
	          escape = false;
	        }
	        skipSpace = true;
	        multiLine = true;
	      }else{
	        if (isSectionLine){
	          isSectionLine = false;
	          if (!ignoreLine){
	            //The section doesn't end with ], it's a key
	            control.error = new Error ("The section line \"" + section +
	                "\" must end with \"]\"");
	            return;
	          }
	          ignoreLine = false;
	        }
	        newLine = true;
	        skipSpace = true;
	        isKey = true;
	        
	        line ();
	      }
	    }
	  }
	  
	  control.parsed = true;
	  
	  if (isSectionLine && !ignoreLine){
	    //The section doesn't end with ], it's a key
	    control.error = new Error ("The section line \"" + section + "\" must end" +
	        "with \"]\"");
	    return;
	  }
	  line ();
	};
	});
	
	define('properties',['require','exports','module','i18n/properties/parse'],function (require, exports, module) {
	
	var parse = require('i18n/properties/parse');
	
	var cast = function (value){
	    if (value === null || value === "null") return null;
	    if (value === "undefined") return undefined;
	    if (value === "true") return true;
	    if (value === "false") return false;
	    var v = Number (value);
	    return isNaN (v) ? value : v;
	};
	
	var searchValue = function (o, chain, section){
	    var n = chain.split (".");
	    var str;
	
	    for (var i=0; i<n.length-1; i++){
	        str = n[i];
	        if (o[str] === undefined) return;
	        o = o[str];
	    }
	
	    var v = o[n[n.length - 1]];
	    if (section){
	        if (typeof v !== "object") return;
	        return v;
	    }else{
	        if (typeof v === "object") return;
	        return v;
	    }
	};
	
	var namespaceKey = function (o, key, value){
	    var n = key.split (".");
	    var str;
	
	    for (var i=0; i<n.length-1; i++){
	        str = n[i];
	        if (o[str] === undefined){
	            o[str] = {};
	        }else if (typeof o[str] !== "object"){
	            throw new Error ("Invalid namespace chain in the property name '" +
	                             key + "' ('" + str + "' has already a value)");
	        }
	        o = o[str];
	    }
	
	    o[n[n.length - 1]] = value;
	};
	
	var namespaceSection = function (o, section){
	    var n = section.split (".");
	    var str;
	
	    for (var i=0; i<n.length; i++){
	        str = n[i];
	        if (o[str] === undefined){
	            o[str] = {};
	        }else if (typeof o[str] !== "object"){
	            throw new Error ("Invalid namespace chain in the section name '" +
	                             section + "' ('" + str + "' has already a value)");
	        }
	        o = o[str];
	    }
	
	    return o;
	};
	
	var merge = function (o1, o2){
	    for (var p in o2){
	        try{
	            if (o1[p].constructor === Object){
	                o1[p] = merge (o1[p], o2[p]);
	            }else{
	                o1[p] = o2[p];
	            }
	        }catch (e){
	            o1[p] = o2[p];
	        }
	    }
	    return o1;
	};
	
	var expand = function  (o, str, options, cb){
	    if (!options.variables || !str) return cb (null, str);
	
	    var stack = [];
	    var c;
	    var cp;
	    var key = "";
	    var section = null;
	    var v;
	    var holder;
	    var t;
	    var n;
	
	    for (var i=0; i<str.length; i++){
	        c = str[i];
	
	        if (cp === "$" && c === "{"){
	            key = key.substring (0, key.length - 1);
	            stack.push ({
	                key: key,
	                section: section
	            });
	            key = "";
	            section = null;
	            continue;
	        }else if (stack.length){
	            if (options.sections && c === "|"){
	                section = key;
	                key = "";
	                continue;
	            }else if (c === "}"){
	                holder = section !== null ? searchValue (o, section, true) : o;
	                if (!holder){
	                    return cb (new Error ("The section \"" + section + "\" does not " +
	                                          "exist"));
	                }
	
	                v = options.namespaces ? searchValue (holder, key) : holder[key];
	                if (v === undefined){
	                    //Read the external vars
	                    v = options.namespaces ? searchValue (options._vars, key) : options._vars[key];
	
	                        if (v === undefined){
	                            return cb (new Error ("The property \"" + key + "\" does not " +
	                                                  "exist"));
	                        }
	                }
	
	                t = stack.pop ();
	                section = t.section;
	                key = t.key + (v === null ? "" : v);
	                continue;
	            }
	        }
	
	        cp = c;
	        key += c;
	    }
	
	    if (stack.length !== 0){
	        return cb (new Error ("Malformed variable: " + str));
	    }
	
	    cb (null, key);
	};
	
	var build = function (data, options, dirname, cb){
	    var o = {};
	    var n;
	
	    if (options.namespaces){
	        n = {};
	    }
	
	    var control = {
	        abort: false,
	        skipSection: false
	    };
	
	    if (!data){
	        if (cb) return cb (null, o);
	        return o;
	    }
	
	    var currentSection = null;
	    var currentSectionStr = null;
	
	    var abort = function (error){
	        control.abort = true;
	        if (cb) return cb (error);
	        throw error;
	    };
	
	    var handlers = {};
	    var reviver = {
	        assert: function (){
	            return this.isProperty ? reviverLine.value : true;
	        }
	    };
	    var reviverLine = {};
	
	    //Line handler
	    //For speed reasons, if "namespaces" is enabled, the old object is still
	    //populated, e.g.: ${a.b} reads the "a.b" property from { "a.b": 1 }, instead
	    //of having a unique object { a: { b: 1 } } which is slower to search for
	    //the "a.b" value
	    //If "a.b" is not found, then the external vars are read. If "namespaces" is
	    //enabled, the var "a.b" is split and it searches the a.b value. If it is not
	    //enabled, then the var "a.b" searches the "a.b" value
	
	    var line;
	    var error;
	
	    if (options.reviver){
	        if (options.sections){
	            line = function (key, value){
	                reviverLine.value = value;
	                reviver.isProperty = true;
	                reviver.isSection = false;
	
	                value = options.reviver.call (reviver, key, value, currentSectionStr);
	                if (value !== undefined){
	                    if (options.namespaces){
	                        try{
	                            namespaceKey (currentSection === null ? n : currentSection,
	                                          key, value);
	                        }catch (error){
	                            abort (error);
	                        }
	                    }else{
	                        if (currentSection === null) o[key] = value;
	                        else currentSection[key] = value;
	                    }
	                }
	            };
	        }else{
	            line = function (key, value){
	
	                reviverLine.value = value;
	                reviver.isProperty = true;
	                reviver.isSection = false;
	
	                value = options.reviver.call (reviver, key, value);
	                if (value !== undefined){
	                    if (options.namespaces){
	                        try{
	                            namespaceKey (n, key, value);
	                        }catch (error){
	                            abort (error);
	                        }
	                    }else{
	                        o[key] = value;
	                    }
	                }
	            };
	        }
	    }else{
	        if (options.sections){
	            line = function (key, value){
	                if (options.namespaces){
	                    try{
	                        namespaceKey (currentSection === null ? n : currentSection, key,
	                                      value);
	                    }catch (error){
	                        abort (error);
	                    }
	                }else{
	                    if (currentSection === null) o[key] = value;
	                    else currentSection[key] = value;
	                }
	            };
	        }else{
	            line = function (key, value){
	                if (options.namespaces){
	                    try{
	                        namespaceKey (n, key, value);
	                    }catch (error){
	                        abort (error);
	                    }
	                }else{
	                    o[key] = value;
	                }
	            };
	        }
	    }
	
	    //Section handler
	    var section;
	    if (options.sections){
	        if (options.reviver){
	            section = function (section){
	                currentSectionStr = section;
	                reviverLine.section = section;
	                reviver.isProperty = false;
	                reviver.isSection = true;
	
	                var add = options.reviver.call (reviver, null, null, section);
	                if (add){
	                    if (options.namespaces){
	                        try{
	                            currentSection = namespaceSection (n, section);
	                        }catch (error){
	                            abort (error);
	                        }
	                    }else{
	                        currentSection = o[section] = {};
	                    }
	                }else{
	                    control.skipSection = true;
	                }
	            };
	        }else{
	            section = function (section){
	                currentSectionStr = section;
	                if (options.namespaces){
	                    try{
	                        currentSection = namespaceSection (n, section);
	                    }catch (error){
	                        abort (error);
	                    }
	                }else{
	                    currentSection = o[section] = {};
	                }
	            };
	        }
	    }
	
	    //Variables
	    if (options.variables){
	        handlers.line = function (key, value){
	            expand(options.namespaces ? n : o, key, options, function (error, key){
	                if (error) return abort (error);
	
	                expand(options.namespaces ? n : o, value, options,
	                        function (error, value){
	                            if (error) return abort (error);
	
	                            line (key, cast (value || null));
	                        });
	            });
	        };
	
	        if (options.sections){
	            handlers.section = function (s){
	                expand(options.namespaces ? n : o, s, options, function (error, s){
	                    if (error) return abort (error);
	
	                    section (s);
	                });
	            };
	        }
	    }else{
	        handlers.line = function (key, value){
	            line (key, cast (value || null));
	        };
	
	        if (options.sections){
	            handlers.section = section;
	        }
	    }
	
	    parse (data, options, handlers, control);
	    if (control.error) return abort (control.error);
	
	    if (control.abort || control.pause) return;
	
	    if (cb) return cb (null, options.namespaces ? n : o);
	    return options.namespaces ? n : o;
	
	};
	
	var preParse = function (data, options, cb) {
	    if (typeof options === "function"){
	        cb = options;
	        options = {};
	    }
	
	    var code;
	
	    options = options || {};
	    options._strict = options.strict && (options.comments || options.separators);
	    options._vars = options.vars || {};
	
	    var comments = options.comments || [];
	    if (!Array.isArray (comments)) comments = [comments];
	    var c = {};
	    comments.forEach (function (comment){
	        code = comment.charCodeAt (0);
	        if (comment.length > 1 || code < 33 || code > 126){
	            throw new Error ("The comment token must be a single printable ASCII " +
	                             "character");
	        }
	        c[comment] = true;
	    });
	    options._comments = c;
	
	    var separators = options.separators || [];
	    if (!Array.isArray (separators)) separators = [separators];
	    var s = {};
	    separators.forEach (function (separator){
	        code = separator.charCodeAt (0);
	        if (separator.length > 1 || code < 33 || code > 126){
	            throw new Error ("The separator token must be a single printable ASCII " +
	                             "character");
	        }
	        s[separator] = true;
	    });
	    options._separators = s;
	
	    return build(data, options, ".", cb);
	};
	
	module.exports = {
	  parse: preParse
	};
	});
	
	/**
	 * @license RequireJS text 2.0.14 Copyright (c) 2010-2014, The Dojo Foundation All Rights Reserved.
	 * Available via the MIT or new BSD license.
	 * see: http://github.com/requirejs/text for details
	 */
	/*jslint regexp: true */
	/*global require, XMLHttpRequest, ActiveXObject,
	 define, window, process, Packages,
	 java, location, Components, FileUtils */
	
	define('text',['module'], function (module) {
	    
	
	    var text, fs, Cc, Ci, xpcIsWindows,
	        progIds = ['Msxml2.XMLHTTP', 'Microsoft.XMLHTTP', 'Msxml2.XMLHTTP.4.0'],
	        xmlRegExp = /^\s*<\?xml(\s)+version=[\'\"](\d)*.(\d)*[\'\"](\s)*\?>/im,
	        bodyRegExp = /<body[^>]*>\s*([\s\S]+)\s*<\/body>/im,
	        hasLocation = typeof location !== 'undefined' && location.href,
	        defaultProtocol = hasLocation && location.protocol && location.protocol.replace(/\:/, ''),
	        defaultHostName = hasLocation && location.hostname,
	        defaultPort = hasLocation && (location.port || undefined),
	        buildMap = {},
	        masterConfig = (module.config && module.config()) || {};
	
	    text = {
	        version: '2.0.14',
	
	        strip: function (content) {
	            //Strips <?xml ...?> declarations so that external SVG and XML
	            //documents can be added to a document without worry. Also, if the string
	            //is an HTML document, only the part inside the body tag is returned.
	            if (content) {
	                content = content.replace(xmlRegExp, "");
	                var matches = content.match(bodyRegExp);
	                if (matches) {
	                    content = matches[1];
	                }
	            } else {
	                content = "";
	            }
	            return content;
	        },
	
	        jsEscape: function (content) {
	            return content.replace(/(['\\])/g, '\\$1')
	                .replace(/[\f]/g, "\\f")
	                .replace(/[\b]/g, "\\b")
	                .replace(/[\n]/g, "\\n")
	                .replace(/[\t]/g, "\\t")
	                .replace(/[\r]/g, "\\r")
	                .replace(/[\u2028]/g, "\\u2028")
	                .replace(/[\u2029]/g, "\\u2029");
	        },
	
	        createXhr: masterConfig.createXhr || function () {
	            //Would love to dump the ActiveX crap in here. Need IE 6 to die first.
	            var xhr, i, progId;
	            if (typeof XMLHttpRequest !== "undefined") {
	                return new XMLHttpRequest();
	            } else if (typeof ActiveXObject !== "undefined") {
	                for (i = 0; i < 3; i += 1) {
	                    progId = progIds[i];
	                    try {
	                        xhr = new ActiveXObject(progId);
	                    } catch (e) {}
	
	                    if (xhr) {
	                        progIds = [progId];  // so faster next time
	                        break;
	                    }
	                }
	            }
	
	            return xhr;
	        },
	
	        /**
	         * Parses a resource name into its component parts. Resource names
	         * look like: module/name.ext!strip, where the !strip part is
	         * optional.
	         * @param {String} name the resource name
	         * @returns {Object} with properties "moduleName", "ext" and "strip"
	         * where strip is a boolean.
	         */
	        parseName: function (name) {
	            var modName, ext, temp,
	                strip = false,
	                index = name.lastIndexOf("."),
	                isRelative = name.indexOf('./') === 0 ||
	                    name.indexOf('../') === 0;
	
	            if (index !== -1 && (!isRelative || index > 1)) {
	                modName = name.substring(0, index);
	                ext = name.substring(index + 1);
	            } else {
	                modName = name;
	            }
	
	            temp = ext || modName;
	            index = temp.indexOf("!");
	            if (index !== -1) {
	                //Pull off the strip arg.
	                strip = temp.substring(index + 1) === "strip";
	                temp = temp.substring(0, index);
	                if (ext) {
	                    ext = temp;
	                } else {
	                    modName = temp;
	                }
	            }
	
	            return {
	                moduleName: modName,
	                ext: ext,
	                strip: strip
	            };
	        },
	
	        xdRegExp: /^((\w+)\:)?\/\/([^\/\\]+)/,
	
	        /**
	         * Is an URL on another domain. Only works for browser use, returns
	         * false in non-browser environments. Only used to know if an
	         * optimized .js version of a text resource should be loaded
	         * instead.
	         * @param {String} url
	         * @returns Boolean
	         */
	        useXhr: function (url, protocol, hostname, port) {
	            var uProtocol, uHostName, uPort,
	                match = text.xdRegExp.exec(url);
	            if (!match) {
	                return true;
	            }
	            uProtocol = match[2];
	            uHostName = match[3];
	
	            uHostName = uHostName.split(':');
	            uPort = uHostName[1];
	            uHostName = uHostName[0];
	
	            return (!uProtocol || uProtocol === protocol) &&
	                (!uHostName || uHostName.toLowerCase() === hostname.toLowerCase()) &&
	                ((!uPort && !uHostName) || uPort === port);
	        },
	
	        finishLoad: function (name, strip, content, onLoad) {
	            content = strip ? text.strip(content) : content;
	            if (masterConfig.isBuild) {
	                buildMap[name] = content;
	            }
	            onLoad(content);
	        },
	
	        load: function (name, req, onLoad, config) {
	            //Name has format: some.module.filext!strip
	            //The strip part is optional.
	            //if strip is present, then that means only get the string contents
	            //inside a body tag in an HTML string. For XML/SVG content it means
	            //removing the <?xml ...?> declarations so the content can be inserted
	            //into the current doc without problems.
	
	            // Do not bother with the work if a build and text will
	            // not be inlined.
	            if (config && config.isBuild && !config.inlineText) {
	                onLoad();
	                return;
	            }
	
	            masterConfig.isBuild = config && config.isBuild;
	
	            var parsed = text.parseName(name),
	                nonStripName = parsed.moduleName +
	                    (parsed.ext ? '.' + parsed.ext : ''),
	                url = req.toUrl(nonStripName),
	                useXhr = (masterConfig.useXhr) ||
	                    text.useXhr;
	
	            // Do not load if it is an empty: url
	            if (url.indexOf('empty:') === 0) {
	                onLoad();
	                return;
	            }
	
	            //Load the text. Use XHR if possible and in a browser.
	            if (!hasLocation || useXhr(url, defaultProtocol, defaultHostName, defaultPort)) {
	                text.get(url, function (content) {
	                    text.finishLoad(name, parsed.strip, content, onLoad);
	                }, function (err) {
	                    if (onLoad.error) {
	                        onLoad.error(err);
	                    }
	                });
	            } else {
	                //Need to fetch the resource across domains. Assume
	                //the resource has been optimized into a JS module. Fetch
	                //by the module name + extension, but do not include the
	                //!strip part to avoid file system issues.
	                req([nonStripName], function (content) {
	                    text.finishLoad(parsed.moduleName + '.' + parsed.ext,
	                        parsed.strip, content, onLoad);
	                });
	            }
	        },
	
	        write: function (pluginName, moduleName, write, config) {
	            if (buildMap.hasOwnProperty(moduleName)) {
	                var content = text.jsEscape(buildMap[moduleName]);
	                write.asModule(pluginName + "!" + moduleName,
	                    "define(function () { return '" +
	                    content +
	                    "';});\n");
	            }
	        },
	
	        writeFile: function (pluginName, moduleName, req, write, config) {
	            var parsed = text.parseName(moduleName),
	                extPart = parsed.ext ? '.' + parsed.ext : '',
	                nonStripName = parsed.moduleName + extPart,
	            //Use a '.js' file name so that it indicates it is a
	            //script that can be loaded across domains.
	                fileName = req.toUrl(parsed.moduleName + extPart) + '.js';
	
	            //Leverage own load() method to load plugin value, but only
	            //write out values that do not have the strip argument,
	            //to avoid any potential issues with ! in file names.
	            text.load(nonStripName, req, function (value) {
	                //Use own write() method to construct full module value.
	                //But need to create shell that translates writeFile's
	                //write() to the right interface.
	                var textWrite = function (contents) {
	                    return write(fileName, contents);
	                };
	                textWrite.asModule = function (moduleName, contents) {
	                    return write.asModule(moduleName, fileName, contents);
	                };
	
	                text.write(pluginName, nonStripName, textWrite, config);
	            }, config);
	        }
	    };
	
	    if (masterConfig.env === 'node' || (!masterConfig.env &&
	        typeof process !== "undefined" &&
	        process.versions &&
	        !!process.versions.node &&
	        !process.versions['node-webkit'] &&
	        !process.versions['atom-shell'])) {
	        //Using special require.nodeRequire, something added by r.js.
	        fs = require.nodeRequire('fs');
	
	        text.get = function (url, callback, errback) {
	            try {
	                var file = fs.readFileSync(url, 'utf8');
	                //Remove BOM (Byte Mark Order) from utf8 files if it is there.
	                if (file[0] === '\uFEFF') {
	                    file = file.substring(1);
	                }
	                callback(file);
	            } catch (e) {
	                if (errback) {
	                    errback(e);
	                }
	            }
	        };
	    } else if (masterConfig.env === 'xhr' || (!masterConfig.env &&
	        text.createXhr())) {
	        text.get = function (url, callback, errback, headers) {
	            var xhr = text.createXhr(), header;
	            xhr.open('GET', url, true);
	
	            //Allow plugins direct access to xhr headers
	            if (headers) {
	                for (header in headers) {
	                    if (headers.hasOwnProperty(header)) {
	                        xhr.setRequestHeader(header.toLowerCase(), headers[header]);
	                    }
	                }
	            }
	
	            //Allow overrides specified in config
	            if (masterConfig.onXhr) {
	                masterConfig.onXhr(xhr, url);
	            }
	
	            xhr.onreadystatechange = function (evt) {
	                var status, err;
	                //Do not explicitly handle errors, those should be
	                //visible via console output in the browser.
	                if (xhr.readyState === 4) {
	                    status = xhr.status || 0;
	                    if (status > 399 && status < 600) {
	                        //An http 4xx or 5xx error. Signal an error.
	                        err = new Error(url + ' HTTP status: ' + status);
	                        err.xhr = xhr;
	                        if (errback) {
	                            errback(err);
	                        }
	                    } else {
	                        callback(xhr.responseText);
	                    }
	
	                    if (masterConfig.onXhrComplete) {
	                        masterConfig.onXhrComplete(xhr, url);
	                    }
	                }
	            };
	            xhr.send(null);
	        };
	    } else if (masterConfig.env === 'rhino' || (!masterConfig.env &&
	        typeof Packages !== 'undefined' && typeof java !== 'undefined')) {
	        //Why Java, why is this so awkward?
	        text.get = function (url, callback) {
	            var stringBuffer, line,
	                encoding = "utf-8",
	                file = new java.io.File(url),
	                lineSeparator = java.lang.System.getProperty("line.separator"),
	                input = new java.io.BufferedReader(new java.io.InputStreamReader(new java.io.FileInputStream(file), encoding)),
	                content = '';
	            try {
	                stringBuffer = new java.lang.StringBuffer();
	                line = input.readLine();
	
	                // Byte Order Mark (BOM) - The Unicode Standard, version 3.0, page 324
	                // http://www.unicode.org/faq/utf_bom.html
	
	                // Note that when we use utf-8, the BOM should appear as "EF BB BF", but it doesn't due to this bug in the JDK:
	                // http://bugs.sun.com/bugdatabase/view_bug.do?bug_id=4508058
	                if (line && line.length() && line.charAt(0) === 0xfeff) {
	                    // Eat the BOM, since we've already found the encoding on this file,
	                    // and we plan to concatenating this buffer with others; the BOM should
	                    // only appear at the top of a file.
	                    line = line.substring(1);
	                }
	
	                if (line !== null) {
	                    stringBuffer.append(line);
	                }
	
	                while ((line = input.readLine()) !== null) {
	                    stringBuffer.append(lineSeparator);
	                    stringBuffer.append(line);
	                }
	                //Make sure we return a JavaScript string and not a Java string.
	                content = String(stringBuffer.toString()); //String
	            } finally {
	                input.close();
	            }
	            callback(content);
	        };
	    } else if (masterConfig.env === 'xpconnect' || (!masterConfig.env &&
	        typeof Components !== 'undefined' && Components.classes &&
	        Components.interfaces)) {
	        //Avert your gaze!
	        Cc = Components.classes;
	        Ci = Components.interfaces;
	        Components.utils['import']('resource://gre/modules/FileUtils.jsm');
	        xpcIsWindows = ('@mozilla.org/windows-registry-key;1' in Cc);
	
	        text.get = function (url, callback) {
	            var inStream, convertStream, fileObj,
	                readData = {};
	
	            if (xpcIsWindows) {
	                url = url.replace(/\//g, '\\');
	            }
	
	            fileObj = new FileUtils.File(url);
	
	            //XPCOM, you so crazy
	            try {
	                inStream = Cc['@mozilla.org/network/file-input-stream;1']
	                    .createInstance(Ci.nsIFileInputStream);
	                inStream.init(fileObj, 1, 0, false);
	
	                convertStream = Cc['@mozilla.org/intl/converter-input-stream;1']
	                    .createInstance(Ci.nsIConverterInputStream);
	                convertStream.init(inStream, "utf-8", inStream.available(),
	                    Ci.nsIConverterInputStream.DEFAULT_REPLACEMENT_CHARACTER);
	
	                convertStream.readString(inStream.available(), readData);
	                convertStream.close();
	                inStream.close();
	                callback(readData.value);
	            } catch (e) {
	                throw new Error((fileObj && fileObj.path || '') + ': ' + e);
	            }
	        };
	    }
	    return text;
	});
	define('props',['module', 'properties', 'text'], function(module, properties, text) {
	    var buildMap = {};
	
	    function writeOutput(moduleName, content) {
	        return 'define(\'' + moduleName + '\', ' +
	            JSON.stringify(content) +
	            ');'
	    }
	
	    return {
	        load: function load(name, req, onload) {
	            if(buildMap[name]) {
	                onload(buildMap[name]);
	            } else {
	                this.get(req.toUrl(name), function (result) {
	                    buildMap[name] = result;
	                    onload(result);
	                }, function (err) {
	                    if (onload.error) {
	                        onload.error(err);
	                    }
	                });
	            }
	        },
	        write: function write(pluginName, moduleName, write) {
	            write(writeOutput(pluginName, moduleName, buildMap[moduleName]));
	        },
	        get: function get(url, callback, errback) {
	            text.get(url, function (result) {
	                return callback(properties.parse(result));
	            }, errback);
	        },
	        writeOutput: writeOutput
	    }
	});
	
	define('i18n-load',['module', 'i18n/locales', 'underscore'
	        ], function(module, locales, _
	        ) {
	
	    var masterConfig = (module.config && module.config()) || {};
	
	    function findFallbacks(locale) {
	        // base en_US version is always a fallback
	        var output = ['en_US'];
	
	        _.each(masterConfig.fallbacks, function(fallback) {
	            if(fallback.test.test(locale) && output.indexOf(fallback.fallback) === -1) {
	                output.push(fallback.fallback);
	            }
	        });
	
	        if(locales.indexOf(locale) !== -1 && output.indexOf(locale) === -1) {
	            output.push(locale);
	        }
	
	        return output;
	    }
	
	    
	    function localizeName(name, locale) {
	        return name + '.' + _.last(findFallbacks(locale));
	    }
	
	    return {
	        load: function load(name, parentRequire, onload, config) {
	            if (!config.isBuild) {
	                parentRequire(['i18n/locale'], function(locale) {
	                    var built = true;
	                                        if(built) {
	                        var localizedName = localizeName(name, locale);
	                        parentRequire([localizedName], function(result) {
	                            onload(result);
	                        });
	                    }
	                });
	            }
	                    }
	    }
	});
	
	/*
	 * 	Vanilla implementation of message variable replacement.
	 * 	e.g. "My message is {0} and {1}." -> "My message is A and B."
	 */
	define('substitute',['require'],function(require) {
	    return function (str) {
	        if (typeof str !== "string") return "";
	        if (arguments.length > 1) {
	            for (var i=0, len = arguments.length; i < len; i++) {
	                str = str.replace("{" + i + "}", arguments[i+1] + "");
	            }
	        }
		    return str;
		};
	});
	
	/*
	 * 	Characters Remaining (plus maxlength enforcement for textareas)
	 * 	jQuery Plugin
	 * 	
	 * 	Notes:
	 * 		- This is an AMD-compatible module but it's also backwards compatible with legacy globals when RequireJS isn't available.
	 * 		- This module does not export anything. It simply defines a jQuery plugin.
	 */
	
	(function () {
		
		// Establish CommonJS passthrough shim, for non-AMD environments.
		var define = window.define || function (f) { return f(); };
		
		define('fitbit-jquery-charsRemaining',['require','jquery','i18n/i18n','i18n-load!com/fitbit/app/modules/message','substitute'],function(require) {
		
			var isAMD = (typeof require === "function");
			var isLayoutBaseLean = document.getElementById("requirejs");
			
			/*
			 * 	Imports
			 */
			 
			var $ = isAMD ? require("jquery") : window.jQuery;
			
			/*
			 * 	i18n
			 */
			var messages;
	
			if (isAMD && !isLayoutBaseLean) {
				var i18n = require('i18n/i18n')();
	
				i18n.namespace(require('i18n-load!com/fitbit/app/modules/message'));
				var getResource = require("substitute");
	
				messages = {
					singular: 	i18n("chars_remaining_primary_singular"),
					plural:		i18n("chars_remaining_primary_plural")
				};
			} else {
				var i18n = function(key){return key;};
				var getResource = fitbit.i18n.getResource;
	
				messages = {
					singular: 	i18n("com.fitbit.app.modules.message.chars_remaining_primary_singular"),
					plural:		i18n("com.fitbit.app.modules.message.chars_remaining_primary_plural")
				};
			}
			
			/*
			 * 	Constants
			 */
			
			var namespace = {
				css: 		"module-chars-remaining",
				plugin: 	"chars_remaining"
			};
			
			/*
			 * 	Default configuration properties
			 */
			
			var defaultConfig = {
				maxlength:			140,
				warningThreshold: 	20,
				warningClass: 		"warning",
				errorClass: 		"exceeded",
				tagName:			"span"
			};
			
			/*
			 * 	Private Methods
			 */
			
			/**
			 * 	Retrieve original configuration object from catalyst data.
			 * 	@method _getConfig
			 * 	@param {HTMLElement} catalyst : The catalyst field that we're interested in.
			 * 	@returns {HashMap} : Configuration object that was supplied at initialization.
			 */
			function _getConfig(catalyst) {
				return $(catalyst).data(namespace.plugin).config;
			}
			
			/**
			 * 	Retrieve localized message string containing the number of characters remaining.
			 * 	@method _getMessage
			 * 	@param {Integer} numRemaining : The number of characters remaining.
			 * 	@returns {String} : Localized message.
			 * 	@private
			 */
			function _getMessage(numRemaining) {
				var messageType = (numRemaining === 1 ? "singular" : "plural");
				return getResource(messages[messageType], numRemaining);
			}
			
			/**
			 * 	Given a catalyst field, get its message element.
			 * 	@method _getMessageElement
			 * 	@param {HTMLElement} catalyst : The catalyst field that we're interested in.
			 * 	@returns {HTMLElement[]} : jQuery-wrapped element reference to the message container associated with this catalyst.
			 */
			function _getMessageElement(catalyst) {
				return $(catalyst).data(namespace.plugin).messageEl;
			}
			
			/**
			 * 	Recalculate the message based on catalyst's current value.
			 * 	@method _refresh
			 * 	@param {HTMLElement} catalyst : The catalyst field that we're interested in.
			 * 	@private
			 */
			function _refresh(catalyst) {
				// Update message.
				catalyst = $(catalyst);
				var config = _getConfig(catalyst);
				var length = catalyst.val().length;
				var maxlength = config.maxlength;
				var messageEl = _getMessageElement(catalyst);
				messageEl.text(_getMessage(maxlength - length));
				
				// Apply appropriate CSS class to the message element based on catalyst field's current value length.
				if (length >= maxlength) { // at limit or exceeded
					if (!messageEl.hasClass(config.errorClass)) {
						messageEl.removeClass(config.warningClass).addClass(config.errorClass);
						_triggerCustomEvent(catalyst, "lengthError");
					}
					
				} else if (length >= (maxlength - config.warningThreshold)) { // warning
					if (!messageEl.hasClass(config.warningClass)) {
						messageEl.removeClass(config.errorClass).addClass(config.warningClass);
						_triggerCustomEvent(catalyst, "lengthWarning");
					}
					
				} else { // no problemo
					if (messageEl.hasClass(config.errorClass)) {
						messageEl.removeClass(config.errorClass);
						_triggerCustomEvent(catalyst, "lengthOkay");
					}
					if (messageEl.hasClass(config.warningClass)) {
						messageEl.removeClass(config.warningClass);
					}
				}
			}
			
			/**	
			 * 	Throws a "soft" error that doesn't disrupt execution. Basically just a formatted message to console.log().
			 * 	@method _throwError
			 * 	@param {String} msg : Error message to be shown in the console.
			 * 	@private
			 */
			function _throwError(msg) {
				console.log(namespace.plugin + " : " + msg);
			}
			
			/**
			 * 	@method _triggerCustomEvent
			 * 	@param {HTMLElement} catalyst : The catalyst field that we're interested in.
			 * 	@param {String} eventName : The name of the event to trigger. All subscribers to this event will be notified.
			 * 	@private
			 */
			function _triggerCustomEvent(catalyst, eventName) {
				$(catalyst).trigger(eventName);
			}
			
			/*
			 * 	Public Methods
			 */
			
			var methods = {
				
				/**
				 * 	@method init
				 * 	@param {HashMap} options : Configuration object.
				 */
				init: function (options) {
					
					// Create configuration object.
					var config = $.extend(defaultConfig, options);
					
					// Construct message to be displayed. The count is wrapped with a span for easy future manipulation.
					var displayText = _getMessage(config.maxlength);
					if (!displayText || (/^\s*$/).test(displayText)) {
						_throwError("error initializing, message keys not found");
					}
					
					// Initialize each element in the collection.
					return this.each(function () {
						var catalyst = $(this);
						
						// Ensure the catalyst element is appropriate.
						if (catalyst.is("input[type='text'], input[type='password'], textarea")) {
							
							// Has this particular element already been initialized by this plugin?
							var data = catalyst.data(namespace.plugin);
							if (!data) {
								
								// Add message element to the DOM.
								var messageEl =
									$("<" + config.tagName + "/>")
										.addClass(namespace.css)
										.html(displayText)
										.insertAfter(catalyst);
								
								// Establish persistent plugin state.
								catalyst.data(namespace.plugin, {
									target: 	catalyst,
									messageEl:	messageEl,
									config:		config
								});
								
								// Establish event listeners for modifying the message based on catalyst field's value.
								catalyst.on("paste." + namespace.plugin + " keyup." + namespace.plugin, function () {
									setTimeout(function () { // cooperative multitasking, allows paste events to be captured
										_refresh(catalyst);
									}, 0);
								});
							}
						}
					});
				},
				
				/**
				 * 	Clears catalyst field value and resets the message.
				 * 	@method reset
				 */
				reset: function () {
					return this.each(function () {
						var catalyst = $(this);
						catalyst.val("");
						_refresh(catalyst);
					});
				},
				
				/**
				 * 	Destroys this plugin instance for the given catalyst field.
				 * 	@method destroy
				 */
				destroy: function () {
					return this.each(function () {
						var catalyst = $(this);
						_getMessageElement(catalyst).remove();
						catalyst
							.off("." + namespace.plugin)
							.removeData(namespace.plugin);
					});
				}
			};
			
			/*
			 * 	Public Interface
			 */
			
			$.fn.charsRemaining = function (method) {
				
				if ($.isFunction(methods[method])) {
					return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
					
				} else if ($.isPlainObject(method) || !method) {
					return methods.init.apply(this, arguments);
					
				} else {
					_throwError("\"" + method + "\" does not exist");
					return this;
				}
				
			};
			
		});
		
	}());
	/*
	 * 	Peer Message Modal
	 *
	 * 	Notes:
	 * 		- This is an AMD-compatible module but it's also backwards compatible with legacy globals when RequireJS isn't available.
	 * 		- This module does not export anything. It simply defines a jQuery plugin.
	 */
	
	(function () {
	
	    // Establish CommonJS passthrough shim, for non-AMD environments.
	    var define = window.define || function (f) { return f(); };
	
	    define('fitbit-jquery-peerMessageModal',['require','jquery','jqtools-overlay','jqtools-toolbox-expose','fitbit-jquery-charsRemaining'],function(require) {
	
	        /*
	         * 	Imports
	         */
	
	        if (typeof require === "function") {
	            var $ = require("jquery");
	            require("jqtools-overlay");
	            require("jqtools-toolbox-expose");
	            require("fitbit-jquery-charsRemaining");
	
	        } else {
	            var $ = window.jQuery;
	            window.curvyCornersNoAutoScan = true; // Disable curvy corners script. (not sure why we're doing this)
	        }
	
	        // Prevent duplicate initialization
	        if ($.isFunction($.fn.peerMessageModal)) return;
	
	        /*
	         * 	jQuery Plugin
	         */
	
	        var isInitialized = false;
	        var theForm;
	        var textarea;
	        var successMessage;
	
	        $.fn.peerMessageModal = function (options) {
	
	            var $self = $(this),
	                messageMaxLength = 180,
	                opts = $.extend({}, $.fn.peerMessageModal.defaults, options),
	                init = function() {
	                    // starting point
	                    mm.launchModal();
	                },
	                pluginConfig = {
	                    overlay: {
	                        top: "center",
	                        left: "center",
	                        mask: {
	                            color: "#000",
	                            opacity: 0.6
	                        },
	                        close: ".closeModal, .cancel",
	                        zIndex: 199999,
	                        onLoad: function () {
	
	                            // One-time initialization of modal content.
	                            _initModalContent();
	
	                            // Give focus to the textarea (every time).
	                            textarea.get(0).focus();
	                        },
	                        onClose: function() {
	
	                            // Reset form.
	                            theForm.each(function (index, el) {
	                                el.reset();
	                            });
	
	                            // unbind submit event on close
	                            $self.find("form").unbind("submit");
	
	                            // Reset character counter.
	                            textarea.charsRemaining("reset");
	
	                            // Ensure the success message is hidden before the next show.
	                            successMessage.hide();
	                        }
	                    }
	                },
	                mm = {
	                    launchModal: function() {
	                        mm.addData();
	                        $self.overlay(pluginConfig.overlay);
	                        mm.overlay = $self.data("overlay");
	                        mm.overlay.load();
	                    }
	                };
	
	
	            mm.addData = function() {
	                var thumbUrl;
	                // Populate modal header section with recipient user details.
	                if (opts.userThumb) {
	                    thumbUrl = opts.userThumb.replace(/\\"/g, '"');
	                } else {
	                    thumbUrl = "/images/profile/defaultProfile_32_male.png";
	                }
	
	                var modalHeader = $self.find(".modal-header");
	                modalHeader
	                    .find(".name").text(opts.userName).end()
	                    .find(".photo")
	                    .empty()
	                    .append(
	                        $("<img/>").attr({
	                            src: thumbUrl,
	                            width: 40,
	                            height: 40,
	                            alt: ""
	                        })
	                    );
	            };
	
	            init();
	
	            $self.find("form").submit(function (ev) {
	                ev.preventDefault();
	
	                // If form validation passes, submit form asynchronously.
	                if (_validateForm()) {
	                    $.ajax({
	                        type: "POST",
	                        url: "/leaderboard/message",
	                        data: {
	                            apiFormat               : "JSON",
	                            sendMessage             : "on",
	                            recipientEncodedUserId  : opts.userId,
	                            msgToSend               : textarea.val(),
	                            statType                : opts.statType,
	                            periodType              : opts.periodType,
	                            networkType             : opts.networkType,
	                            networkId               : opts.networkId,
	                            dataType                : opts.dataType,
	                            csrfToken               : window.fitbitCsrfToken
	                        },
	                        dataType: "json",
	                        success: function (json) {
	
	                            // Show success message to user;
	                            successMessage.fadeIn(200);
	
	                            // After a brief delay, close the modal entirely.
	                            setTimeout(function () {
	                                mm.overlay.close();
	                            }, 2000);
	                        }
	                    });
	                }
	            });
	
	            // One-time initialization of modal content.
	            function _initModalContent() {
	                if (isInitialized) return;
	
	                isInitialized = true;
	                var formDisabledClass = "failure";
	
	                // Cache references to important elements as local-globals.
	                theForm = $self.find(".wrapper-form");
	                textarea = theForm.find("textarea").first();
	                successMessage = $self.find(".message-success");
	
	                // Initialize character counter on textarea.
	                textarea
	                    .charsRemaining({ maxlength: messageMaxLength })
	                    // Establish event listeners for toggling "active"/"disabled" state of the form based on the textarea's value.
	                    .on("paste keyup", function () {
	                        setTimeout(function () { // cooperative multitasking, allows paste events to be captured
	                            theForm.toggleClass(formDisabledClass, !_validateForm());
	                        }, 0);
	                    });
	            }
	
	            // Private method for validating the form.
	            function _validateForm() {
	                var messageValue = textarea.val();
	                return (messageValue.length <= messageMaxLength) && !(/^\s*$/).test(messageValue);
	            }
	
	        };
	
	    });
	
	}());
	
	/*
	 * 	Notification Dropdown (for Fitbit Site Header)
	 * 	Requires: "/css/fitbitui/notificationDropdown.css"
	 * 	Notes:
	 * 		- This is an AMD-compatible module but it's also backwards compatible with legacy globals when RequireJS isn't available.
	 * 		- This module does not export anything.
	 */
	
	(function () {
		
		// Establish CommonJS passthrough shim, for non-AMD environments.
		var define = window.define || function (f) { return f(); };
		define('fitbit-header-notificationDropdown',['require','jquery','fitbit-widget-dropdown','fitbit-jquery-peerMessageModal','i18n/i18n','i18n-load!com/fitbit/app/user/friends/label'],function(require) {
		
			var isAMD = (typeof require === "function");
			var isLayoutBaseLean = document.getElementById("requirejs");
	
			/*
			 * 	Imports
			 */
			
			if (isAMD) { // is AMD environment
				var $ = require("jquery");
				var DD = require("fitbit-widget-dropdown");
				require("fitbit-jquery-peerMessageModal");
				//JSON2 is also imported via a shim defined in our config file
				
			} else { // non-AMD
				var $ = window.jQuery;
				var DD = $.isFunction(fitbit.modules.dropdown) && fitbit.modules.dropdown;
			}
			
			/*
			 * 	i18n
			 */
			
			if (isAMD && !isLayoutBaseLean) {
				var i18n = require('i18n/i18n')();
	
				i18n.namespace(require('i18n-load!com/fitbit/app/user/friends/label'));
	
			    var _localMessageBundle = {
			    		
			    	// Notification User Calls-To-Action
					"badges"					: i18n("badges"),
					"friend_rankings"			: i18n("friend_rankings"),
					"reply"						: i18n("reply"),
					"send_message"				: i18n("send_message"),
					"view_request"				: i18n("view_request"),
					
					// Loading Messages
					"loading_notifications" 	: i18n("loading_notifications"),
					"empty_state_notifications" : i18n("empty_state_notifications")
					
		    	};
			    var _getMessage = function (key) {
			    	return _localMessageBundle[key] ? _localMessageBundle[key] : "";
			    };
			    
			} else {
				var _getMessage = function (key) {
		            return fitbit.i18n.getResource("com.fitbit.app.user.friends.label." + key);
			    }
			}
			
			/*
			 * 	Prevent duplicate initialization.
			 */
			var FLAG_INIT = "isNotificationDropdownInitialized";
			var $CATALYST = $("#catalyst-notify");
			if ($CATALYST.data(FLAG_INIT)) return;
		
			/*
			 * 	Notification Dropdown Module definition.
			 */
			var API_VERSION = 1;
	
			var notificationDropdown = (function () {
				
			    // attached to jquery obj for global accessibility
			    $.firstNotifRequest = true;
			    
			    var nDropdown = {
			            notifications: {},
			            subsequentNotifications: {}
			        },
			        firstTimeDropdown = true,
			        listElem = "notifyList",
			        $triggerElem = $CATALYST,
			        notifActionMap = {
			            "friendReq"         : [_getMessage("view_request"),     "/user/"],
			            "messageSingle"     : [_getMessage("reply"),            "#umm"],
			            "cheer"             : [_getMessage("reply"),            "#umm"],
			            "taunt"             : [_getMessage("reply"),            "#umm"],
			            "passSingle"        : [_getMessage("send_message"),     "#umm"],
			            "passedBySingle"    : [_getMessage("send_message"),		"#umm"],
			            "passMultiple"      : [_getMessage("friend_rankings"),  "/friends/leaders"],
			            "badge"             : [_getMessage("badges"),           "/badges/all"],
			            "messageCorporate"  : ["",                              ""]
			        };
			
				/* * * * * * * * * * * * * * * * * * * * * * * * * * * * *
				                       _
				 _                    | |      _
				| |_  ____ ____  ____ | | ____| |_  ____  ___
				|  _)/ _  )    \|  _ \| |/ _  |  _)/ _  )/___)
				| |_( (/ /| | | | | | | ( ( | | |_( (/ /|___ |
				 \___)____)_|_|_| ||_/|_|\_||_|\___)____|___/
				                |_|
				* * * * * * * * * * * * * * * * * * * * * * * * * * * * */
			
	            function fillTemplate(data) {
	                var ret = $("<ul>").addClass("listCont");
	                $.isArray(data.result) && $.each(data.result, function() {
	
			            var that = this,
			                linkAction = {},
			                linkText = "",
							thumbDiv,
							timeAction;
			            
			            $.each(notifActionMap, function(key, value) {
			                /*if (that.notifType == "noAction") {
	                            linkAction = null;
	                            return;
	                        }*/
	                        if (key == that.notifType) {
			                    linkText = value[0];
	
			                    // this adds the action value to data-action attr
			                    // click behavior is in bind events section
			                    linkAction.link = value[1];
			                    
			                    // For tracking purposes, include the notification type so it can be passed into the universal messaging modal.
			                    linkAction.actionType = that.notifType;
			                }
			            });
			
			            // add in the rest of the meta data
			            if ($.isPlainObject(this.msgMetaData)){
			                linkAction.dataType          = this.msgMetaData.dataType;
			                linkAction.statType          = this.msgMetaData.statType;
			                linkAction.periodType        = this.msgMetaData.periodType;
			                linkAction.networkType       = this.msgMetaData.networkType;
			                linkAction.networkId         = this.msgMetaData.networkId;
			            }
						linkAction.userId            = this.thumbUsrEncId;
						linkAction.userName          = this.thumbUsrDisplayName;
			            linkAction.userThumb         = this.thumbImage;
	
	                    if(linkAction.actionType == "messageCorporate") {
	                        linkAction = null;
	                    }
	
						thumbDiv = fillThumbDiv(this, linkAction);
	
						timeAction = $("<div>").addClass("timeAction")
							.append($("<span>").text(this.notifTimeLabel));
						if (linkText.length) {
							timeAction.append($("<span>").addClass("link").text(linkText));
						}
	
	                    $("<li>").addClass("clearfix").addClass(this.hasBeenRead).data('action', linkAction)
	                        .append(timeAction,
	                                thumbDiv,
	                                $("<div>").addClass("icon").addClass(this.notifType).addClass(this.hasBeenRead),
	                                $("<div>").addClass("meat").append(
	                                    $("<h6>").text(this.notifSysGenMsg),
	                                    (this.notifSysGenHeader ? $("<h3>").text(this.notifSysGenHeader) : ""),
	                                    (this.notifType === "messageCorporate" ? $("<span>").html(this.notifUsrGenMsg) : $("<span>").text(this.notifUsrGenMsg))
	                                )).appendTo(ret);
	                });
	                ret = ret.add($("<div>").addClass("paginate").addClass(!isNaN(data.result.length) && data.result.length < 15 ? "hide" : "").append(
	                        $("<span>").text($("#notificationDropdownTemplate").html())
	                    ));
	                return ret;
	            }
	
				function fillThumbDiv(notification, linkAction) {
					var thumbDiv = $("<div>").addClass("thumb");
					var thumbLink = $("<a>").addClass("thumbLink");
					var thumbImage = $("<img>").addClass("photo").attr("src", notification.thumbImage);
	
					if (notification.thumbMetaData) {
						thumbDiv.addClass("thumb-badge").append(
							thumbLink.attr("href", "/user/" + linkAction.userId).append(
								thumbImage.attr("alt", "")
							),
							$("<span>").addClass("num").text(notification.thumbMetaData.badgeValue),
							$("<span>").addClass("unit").text(notification.thumbMetaData.badgeUnit)
						);
					} else if (notification.notifType === "messageCorporate") {
						thumbDiv.append(
							thumbImage.addClass("programLogo").attr('alt', notification.thumbUsrDisplayName || "")
						);
					} else if (notification.notifType === "badge") {
						thumbDiv.append(
							thumbLink.attr("href", linkAction.link).append(
								thumbImage.attr('alt', notification.thumbUsrDisplayName || "")
							)
						);
					}else {
						if (linkAction && linkAction.userId) {
							thumbDiv.append(
								thumbLink.attr("href", "/user/" + linkAction.userId).append(
									thumbImage.attr('alt', notification.thumbUsrDisplayName || "")
								)
							);
						} else {
							thumbDiv.append(
								thumbImage.attr('alt', notification.thumbUsrDisplayName || "")
							);
						}
					}
					return thumbDiv;
				}
	
			    nDropdown.generateTemplateHTML = function(loadMore) {
			        var source = $("#notificationDropdownTemplate").html(),
			            initialList = !$.isEmptyObject(nDropdown.notifications) ? nDropdown.notifications : false,
			            subsequentList = !$.isEmptyObject(nDropdown.subsequentNotifications) ? nDropdown.subsequentNotifications : false,
			            listHtml = {};
			        
			        if (subsequentList && loadMore) {
			            // use the subsequent json data
			            listHtml = fillTemplate(nDropdown.subsequentNotifications);
			        } else if (initialList) {
			            // use the initial json data
			            listHtml = fillTemplate(nDropdown.notifications);
			        } else {
			            return false;
			        }
			        return listHtml;
			    }
			
			    nDropdown.showLoader = function() {
			        // render the dropdown unit with external html fragment
			        NotifDD.render("<div class=\"initialLoading\">" + _getMessage("loading_notifications") + "</div>");
			        
			        // Toggle dropdown visibility.
			        if (firstTimeDropdown) {
			        	if (!NotifDD.isVisible()) { // prevent double-show during initialization
			        		NotifDD.show();
			        	}
			        } else {
			        	NotifDD.toggle();
			        }
			    };
			
			    // now that we have the html, make it show up on the page
			    nDropdown.displayNotifList = function(listHtml, isAppend) {
			        var initialListLength = !$.isEmptyObject(nDropdown.notifications) ? nDropdown.notifications.result.length : 0;
			
			        // render the dropdown unit with external html fragment
			        NotifDD.render(listHtml, isAppend);
			
			        // Some last minute CSS just before showing the list
			        // mark as read for re-opening of notifDD
			        if (!firstTimeDropdown && !isAppend) {
			            nDropdown.markAsRead();
			        }
			        
			        // Toggle dropdown visibility.
			        if (firstTimeDropdown || isAppend) {
			        	if (!NotifDD.isVisible()) { // prevent double-show during initialization
			        		NotifDD.show();
			        	}
			        } else {
			        	NotifDD.toggle();
			        }
			        
			        // After the dropdown becomes visible and its content is completely rendered, notify the server of the most recent item seen by the user.
			        // Also switch the notification menu's catalyst icon to its "read" visual state. Only do this when we're NOT dealing with 
			        // append/pagination operations.
			        if (!isAppend) {
				        recordMostRecentlySeen();
				        clearNotificationMenuIconState();
			        }
			    }
			
				/* * * * * * * * *
				 _       _
				(_)     (_)_
				 _ ____  _| |_
				| |  _ \| |  _)
				| | | | | | |__
				|_|_| |_|_|\___)
				
				* * * * * * * * */
			
			    nDropdown.init = function(loadingMode) {
	
			        if (firstTimeDropdown) {
			            nDropdown.bindEvents();
			        }
			
			        nDropdown.displayNotifList( nDropdown.generateTemplateHTML() );
			
			        firstTimeDropdown = false;
			    };
			
				/* * * * * * * * * * * * * * * * * * *
				                        _
				  ____ _   _ ____ ____ | |_   ___
				 / _  ) | | / _  )  _ \|  _) /___)
				( (/ / \ V ( (/ /| | | | |__|___ |
				 \____) \_/ \____)_| |_|\___|___/
				
				* * * * * * * * * * * * * * * * * * */
			
			    nDropdown.bindEvents = function() {
			
			        // XHR: LOAD MORE -- when user clicks 'Load more'
			        $("." + listElem).on("click", ".paginate", function() {
			            var that = this;
			            // show spinner
			            $(that).addClass("spinner");
			
			            $.ajax({
			                type: "GET",
			                url: "/notifications/view",
			                data: {
			                    apiFormat           : "JSON",
			                    lowEventId          : minMaxNotifId(false)
			                },
			                dataType: "json",
			                success: function (json) {
								if (json.result.length > 0) {
									// stash the json
									notificationDropdown.saveJSON(json);
	
									// displays the notification list
									// second param for appending to existing list
									nDropdown.displayNotifList(nDropdown.generateTemplateHTML(true), true);
									nDropdown.notifications.result = nDropdown.notifications.result.concat(nDropdown.subsequentNotifications.result);
									nDropdown.subsequentNotifications.result = [];
								}
								// hide the spinner after new stuff comes in
								$(that).html("").removeClass("spinner, paginate").addClass("divider");
			                }
			            });
			
			        });
			
			        // notification list row click event
					$("." + listElem).on("click", ".link", function() {
			            var actionObj = $(this).closest("li").data("action");
			
			            // Spawn universal messaging modal and quit.
			            if (/^#umm/.test(actionObj.link)) {
			                nDropdown.notificationMessageModal(actionObj);
			                return;
			            }
			            
			            // If we're dealing with an action that forwards the user to a profile page, construct a proper profile page URL first.
			            if (/^\/user\/$/.test(actionObj.link)) {
			            	actionObj.link += actionObj.userId;
			            }
			            
			            // Navigate the user to whatever URL is associated with this action.
			            nDropdown.notificationLink(actionObj);
			        });
			    }
			
			    // Handles links to other pages
			    nDropdown.notificationLink = function (actionObj) {
			    	// Navigate browser to new destination.
			        window.location = actionObj.link;
			
			    };
	
	            nDropdown.showPeerMessageModal = function(actionObj) {
	                $("#peerMessageModal").peerMessageModal($.extend(actionObj, {}));
	            };
	
	            nDropdown.showFriendBlockedModal = function(actionObj) {
	                require([
	                    'fitbit-jquery-friendBlockedModal',
	                    'fitbit-jquery-friendRequestModal'
	                ], function() {
	                    $('#friendBlockedModal').friendBlockedModal({
	                        userId: actionObj.userId,
	                        userName: actionObj.userName,
	                        callback: function() {
	                            nDropdown.sendSingleInvitation(actionObj);
	                        },
	                        closeBeforeCallback: false
	                    });
	                });
	            };
	
	            nDropdown.sendSingleInvitation = function(actionObj) {
	                require([
	                    'shared/scripts/modules/api-client'
	                ], function(apiClient) {
	                    var url = apiClient.makeFullUrl('/' + API_VERSION + '/user/-/friends/invitations.json');
	                    var params = {
	                        invitedUserId: actionObj.userId
	                    };
	
	                    apiClient.ajax({
	                        url: url,
	                        type: "POST",
	                        data: params,
	                        dataType: 'json',
	                        success: function(data, textStatus, xhr) {
	                            $('#friendRequestContent').hide();
	                            $('#friendRequestSuccess').show();
	                            $('#friendRequestError').hide();
	                            setTimeout(function() {
	                                $('#friendRequestModal').data("overlay").close();
	                            }, 1000);
	                        },
	                        error: function(jqXHR, textStatus, errorThrown) {
	                            $('#friendRequestContent').hide();
	                            $('#friendRequestSuccess').hide();
	                            $('#friendRequestError').show();
	                            setTimeout(function() {
	                                $('#friendRequestModal').data("overlay").close();
	                            }, 1000);
	                        }
	                    });
	                });
	            };
	
	            nDropdown.showNonfriendMessageModal = function(actionObj) {
	                require([
	                    'fitbit-jquery-nonfriendMessageModal'
	                ], function() {
	                    $("#nonfriendMessageModal").nonfriendMessageModal();
	                });
	            };
	
			    // Handles launch of peerMessageModal
			    nDropdown.notificationMessageModal = function (actionObj) {
	                var encodedId = actionObj.userId;
	
	                require(['relationshipStatus'], function(relationshipStatus) {
	                   relationshipStatus.determine(encodedId, function(status) {
	                       if (status === 'blocked') {
	                           nDropdown.showFriendBlockedModal(actionObj);
	                           return;
	                       }
	
	                       // Hide the dropdown (only if it's currently visible).
	                       if (NotifDD.isVisible()) {
	                           NotifDD.hide();
	                       }
	                       if (status === 'friend') {
	                           nDropdown.showPeerMessageModal(actionObj);
	                       } else { // status === 'nonfriend'
	                           nDropdown.showNonfriendMessageModal(actionObj);
	                       }
	                   });
	                });
			    };
			
			    // Stash JSON return
			    nDropdown.saveJSON = function(json) {
			        if (json && firstTimeDropdown && json.result.length > 0) {
			            $.extend(nDropdown.notifications, json);
			        } else if (json && json.result.length > 0) {
			            $.extend(nDropdown.subsequentNotifications, json);
			        }
			    };
			
			    // Clear all notifications of visual unread status
			    nDropdown.markAsRead = function() {
			        // css remove spinner, mark all as read
			        $("." + listElem).find("li").addClass("read").end()
			            .find(".icon").addClass("read").end()
			            .find(".paginate").removeClass("spinner");
			    };
			
			    // Instantiates the dropdown
			    nDropdown.newDropdown = function() {
			    	if ($triggerElem.length) {
				        NotifDD = new DD($triggerElem, {
				            className : listElem + " subnav subnav-app",
				            anchorPoint: "below right",
							manualShowEnabled: true,
				            catalystActiveClass: "active",
				            mouseBoundaryDetectionEnabled: false
				        });
				        NotifDD.setPositionOffset(-51, 0);
			    	}
			    };
			
				/* * * * * * * * * * * * * * * * * * * *
				 _           _
				| |         | |
				| | _   ____| |____   ____  ____ ___
				| || \ / _  ) |  _ \ / _  )/ ___)___)
				| | | ( (/ /| | | | ( (/ /| |  |___ |
				|_| |_|\____)_| ||_/ \____)_|  (___/
				              |_|
				
				* * * * * * * * * * * * * * * * * * * */
			    
			    /**
			     * 	Updates the notification dropdown's catalyst UI to reflect that all items within it have been read.
			     * 	@method clearNotificationMenuIconState
			     * 	@private
			     */
			    function clearNotificationMenuIconState() {
			    	$CATALYST.find(".icon-notify").removeClass("unread");
			    }
			    
			    /**
			     * 	Update UI when notifications are read by the user.
			     * 	Also inform the back-end of most recent notification seen by the user.
			     * 	@method recordMostRecentlySeen
			     * 	@param {Boolean} doQuickRequest : If TRUE, notify the back-end via non-XHR means (because speed is of the essence and we don't care about the response).
			     * 	@private
			     */
			    function recordMostRecentlySeen(doQuickRequest) {
			        var fetchedId = minMaxNotifId(true);
			        if (fetchedId) {
			        	$.ajax({
			                type: "GET",
			                url: "/notifications/view",
			                data: {
			                    apiFormat           : "JSON",
			                    updateLastViewed   	: "on",
			                    highEventId         : fetchedId
			                },
			                dataType: "json",
			                success: function (json) {
			                    //log("max notifId "+ fetchedId +" successfully sent to db");
			                }
			            });
			        }
			    }
			    
			
			    // @method minMaxNotifId : return the highest/lowest notification id
			    // @param {Boolean} max : if TRUE returns highest notifId, otherwise lowest
			    // @return (Integer or Boolean} : the notifId number value or FALSE if nothing to sort
			    function minMaxNotifId(max) {
			        var initialResult = nDropdown.notifications.result ? nDropdown.notifications.result : null,
			            subsequentResult = nDropdown.subsequentNotifications.result ? nDropdown.subsequentNotifications.result : null,
			            notifArr = [],
			            notifIdArr =[];
			
			        if ($.isArray(initialResult)  && $.isArray(subsequentResult)) {
						notifArr = initialResult.concat(subsequentResult);
			        } else if ($.isArray(initialResult)) {
						notifArr = [].concat(initialResult);
			        } else {
			            return false;
			        }
			
			        $.each(notifArr, function(index, value) {
			            notifIdArr.push( parseInt(value.notifId) );
			        });
			
		            return Math[max ? "max" : "min"].apply(null, notifIdArr);
			    }
	
			    return nDropdown;
			
			})();
			
			/*
			 * 	Instantiate and initialize the notification dropdown. This is a one-time operation.
			 */
			
			$(function() {
				
			    // instantiate the dropdown
			    notificationDropdown.newDropdown();
			    $CATALYST.addClass("hasdropdown");
			    
			    // Set a flag on catalyst element, indicating that it has been initialized (to prevent accidental double-initializations). 
			    $CATALYST.data(FLAG_INIT, true);
			
			    $CATALYST.on("mousedown", function() {
			        // get empty state string
			        var noData = _getMessage("empty_state_notifications");
			
			        if ($.firstNotifRequest) {
			            notificationDropdown.showLoader();
			            $.firstNotifRequest = false;
			
			            $.ajax({
			                type: "GET",
			                url: "/notifications/view",
			                data: { apiFormat:"JSON" },
			                dataType: "json",
			                success: function(json) {
			                    if (json.result.length > 0) {
			                        notificationDropdown.saveJSON(json);
			                        notificationDropdown.init();
			                    } else {
			                        $(".initialLoading").addClass("empty").html(noData);
			                    }
			                }
			            });
			        } else {
			            notificationDropdown.init();
			        }
			    });
			
			});
		
		});
		
	}());
	
	/*
	---
	MooTools: the javascript framework
	
	web build:
	 - http://mootools.net/core/c1f223b3ac0d92e4d6f976c65e2dbc3a
	
	packager build:
	 - packager build Core/Core Core/Array Core/String Core/Number Core/Function Core/Event Core/Class Core/Class.Extras Core/JSON
	
	...
	*/
	
	/*
	---
	
	name: Core
	
	description: The heart of MooTools.
	
	license: MIT-style license.
	
	copyright: Copyright (c) 2006-2012 [Valerio Proietti](http://mad4milk.net/).
	
	authors: The MooTools production team (http://mootools.net/developers/)
	
	inspiration:
	  - Class implementation inspired by [Base.js](http://dean.edwards.name/weblog/2006/03/base/) Copyright (c) 2006 Dean Edwards, [GNU Lesser General Public License](http://opensource.org/licenses/lgpl-license.php)
	  - Some functionality inspired by [Prototype.js](http://prototypejs.org) Copyright (c) 2005-2007 Sam Stephenson, [MIT License](http://opensource.org/licenses/mit-license.php)
	
	provides: [Core, MooTools, Type, typeOf, instanceOf, Native]
	
	...
	*/
	
	(function(){
	
	this.MooTools = {
	    version: '1.4.5',
	    build: 'ab8ea8824dc3b24b6666867a2c4ed58ebb762cf0'
	};
	
	// typeOf, instanceOf
	
	var typeOf = this.typeOf = function(item){
	    if (item == null) return 'null';
	    if (item.$family != null) return item.$family();
	
	    if (item.nodeName){
	        if (item.nodeType == 1) return 'element';
	        if (item.nodeType == 3) return (/\S/).test(item.nodeValue) ? 'textnode' : 'whitespace';
	    } else if (typeof item.length == 'number'){
	        if (item.callee) return 'arguments';
	        if ('item' in item) return 'collection';
	    }
	
	    return typeof item;
	};
	
	var instanceOf = this.instanceOf = function(item, object){
	    if (item == null) return false;
	    var constructor = item.$constructor || item.constructor;
	    while (constructor){
	        if (constructor === object) return true;
	        constructor = constructor.parent;
	    }
	    /*<ltIE8>*/
	    if (!item.hasOwnProperty) return false;
	    /*</ltIE8>*/
	    return item instanceof object;
	};
	
	// Function overloading
	
	var Function = this.Function;
	
	var enumerables = true;
	for (var i in {toString: 1}) enumerables = null;
	if (enumerables) enumerables = ['hasOwnProperty', 'valueOf', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'constructor'];
	
	Function.prototype.overloadSetter = function(usePlural){
	    var self = this;
	    return function(a, b){
	        if (a == null) return this;
	        if (usePlural || typeof a != 'string'){
	            for (var k in a) self.call(this, k, a[k]);
	            if (enumerables) for (var i = enumerables.length; i--;){
	                k = enumerables[i];
	                if (a.hasOwnProperty(k)) self.call(this, k, a[k]);
	            }
	        } else {
	            self.call(this, a, b);
	        }
	        return this;
	    };
	};
	
	Function.prototype.overloadGetter = function(usePlural){
	    var self = this;
	    return function(a){
	        var args, result;
	        if (typeof a != 'string') args = a;
	        else if (arguments.length > 1) args = arguments;
	        else if (usePlural) args = [a];
	        if (args){
	            result = {};
	            for (var i = 0; i < args.length; i++) result[args[i]] = self.call(this, args[i]);
	        } else {
	            result = self.call(this, a);
	        }
	        return result;
	    };
	};
	
	Function.prototype.extend = function(key, value){
	    this[key] = value;
	}.overloadSetter();
	
	Function.prototype.implement = function(key, value){
	    this.prototype[key] = value;
	}.overloadSetter();
	
	// From
	
	var slice = Array.prototype.slice;
	
	Function.from = function(item){
	    return (typeOf(item) == 'function') ? item : function(){
	        return item;
	    };
	};
	
	Array.from = function(item){
	    if (item == null) return [];
	    return (Type.isEnumerable(item) && typeof item != 'string') ? (typeOf(item) == 'array') ? item : slice.call(item) : [item];
	};
	
	Number.from = function(item){
	    var number = parseFloat(item);
	    return isFinite(number) ? number : null;
	};
	
	String.from = function(item){
	    return item + '';
	};
	
	// hide, protect
	
	Function.implement({
	
	    hide: function(){
	        this.$hidden = true;
	        return this;
	    },
	
	    protect: function(){
	        this.$protected = true;
	        return this;
	    }
	
	});
	
	// Type
	
	var Type = this.Type = function(name, object){
	    if (name){
	        var lower = name.toLowerCase();
	        var typeCheck = function(item){
	            return (typeOf(item) == lower);
	        };
	
	        Type['is' + name] = typeCheck;
	        if (object != null){
	            object.prototype.$family = (function(){
	                return lower;
	            }).hide();
	            
	        }
	    }
	
	    if (object == null) return null;
	
	    object.extend(this);
	    object.$constructor = Type;
	    object.prototype.$constructor = object;
	
	    return object;
	};
	
	var toString = Object.prototype.toString;
	
	Type.isEnumerable = function(item){
	    return (item != null && typeof item.length == 'number' && toString.call(item) != '[object Function]' );
	};
	
	var hooks = {};
	
	var hooksOf = function(object){
	    var type = typeOf(object.prototype);
	    return hooks[type] || (hooks[type] = []);
	};
	
	var implement = function(name, method){
	    if (method && method.$hidden) return;
	
	    var hooks = hooksOf(this);
	
	    for (var i = 0; i < hooks.length; i++){
	        var hook = hooks[i];
	        if (typeOf(hook) == 'type') implement.call(hook, name, method);
	        else hook.call(this, name, method);
	    }
	
	    var previous = this.prototype[name];
	    if (previous == null || !previous.$protected) this.prototype[name] = method;
	
	    if (this[name] == null && typeOf(method) == 'function') extend.call(this, name, function(item){
	        return method.apply(item, slice.call(arguments, 1));
	    });
	};
	
	var extend = function(name, method){
	    if (method && method.$hidden) return;
	    var previous = this[name];
	    if (previous == null || !previous.$protected) this[name] = method;
	};
	
	Type.implement({
	
	    implement: implement.overloadSetter(),
	
	    extend: extend.overloadSetter(),
	
	    alias: function(name, existing){
	        implement.call(this, name, this.prototype[existing]);
	    }.overloadSetter(),
	
	    mirror: function(hook){
	        hooksOf(this).push(hook);
	        return this;
	    }
	
	});
	
	new Type('Type', Type);
	
	// Default Types
	
	var force = function(name, object, methods){
	    var isType = (object != Object),
	        prototype = object.prototype;
	
	    if (isType) object = new Type(name, object);
	
	    for (var i = 0, l = methods.length; i < l; i++){
	        var key = methods[i],
	            generic = object[key],
	            proto = prototype[key];
	
	        if (generic) generic.protect();
	        if (isType && proto) object.implement(key, proto.protect());
	    }
	
	    if (isType){
	        var methodsEnumerable = prototype.propertyIsEnumerable(methods[0]);
	        object.forEachMethod = function(fn){
	            if (!methodsEnumerable) for (var i = 0, l = methods.length; i < l; i++){
	                fn.call(prototype, prototype[methods[i]], methods[i]);
	            }
	            for (var key in prototype) fn.call(prototype, prototype[key], key)
	        };
	    }
	
	    return force;
	};
	
	force('String', String, [
	    'charAt', 'charCodeAt', 'concat', 'indexOf', 'lastIndexOf', 'match', 'quote', 'replace', 'search',
	    'slice', 'split', 'substr', 'substring', 'trim', 'toLowerCase', 'toUpperCase'
	])('Array', Array, [
	    'pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift', 'concat', 'join', 'slice',
	    'indexOf', 'lastIndexOf', 'filter', 'forEach', 'every', 'map', 'some', 'reduce', 'reduceRight'
	])('Number', Number, [
	    'toExponential', 'toFixed', 'toLocaleString', 'toPrecision'
	])('Function', Function, [
	    'apply', 'call', 'bind'
	])('RegExp', RegExp, [
	    'exec', 'test'
	])('Object', Object, [
	    'create', 'defineProperty', 'defineProperties', 'keys',
	    'getPrototypeOf', 'getOwnPropertyDescriptor', 'getOwnPropertyNames',
	    'preventExtensions', 'isExtensible', 'seal', 'isSealed', 'freeze', 'isFrozen'
	])('Date', Date, ['now']);
	
	Object.extend = extend.overloadSetter();
	
	Date.extend('now', function(){
	    return +(new Date);
	});
	
	new Type('Boolean', Boolean);
	
	// fixes NaN returning as Number
	
	Number.prototype.$family = function(){
	    return isFinite(this) ? 'number' : 'null';
	}.hide();
	
	// Number.random
	
	Number.extend('random', function(min, max){
	    return Math.floor(Math.random() * (max - min + 1) + min);
	});
	
	// forEach, each
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	Object.extend('forEach', function(object, fn, bind){
	    for (var key in object){
	        if (hasOwnProperty.call(object, key)) fn.call(bind, object[key], key, object);
	    }
	});
	
	Object.each = Object.forEach;
	
	Array.implement({
	
	    forEach: function(fn, bind){
	        for (var i = 0, l = this.length; i < l; i++){
	            if (i in this) fn.call(bind, this[i], i, this);
	        }
	    },
	
	    each: function(fn, bind){
	        Array.forEach(this, fn, bind);
	        return this;
	    }
	
	});
	
	// Array & Object cloning, Object merging and appending
	
	var cloneOf = function(item){
	    switch (typeOf(item)){
	        case 'array': return item.clone();
	        case 'object': return Object.clone(item);
	        default: return item;
	    }
	};
	
	Array.implement('clone', function(){
	    var i = this.length, clone = new Array(i);
	    while (i--) clone[i] = cloneOf(this[i]);
	    return clone;
	});
	
	var mergeOne = function(source, key, current){
	    switch (typeOf(current)){
	        case 'object':
	            if (typeOf(source[key]) == 'object') Object.merge(source[key], current);
	            else source[key] = Object.clone(current);
	        break;
	        case 'array': source[key] = current.clone(); break;
	        default: source[key] = current;
	    }
	    return source;
	};
	
	Object.extend({
	
	    merge: function(source, k, v){
	        if (typeOf(k) == 'string') return mergeOne(source, k, v);
	        for (var i = 1, l = arguments.length; i < l; i++){
	            var object = arguments[i];
	            for (var key in object) mergeOne(source, key, object[key]);
	        }
	        return source;
	    },
	
	    clone: function(object){
	        var clone = {};
	        for (var key in object) clone[key] = cloneOf(object[key]);
	        return clone;
	    },
	
	    append: function(original){
	        for (var i = 1, l = arguments.length; i < l; i++){
	            var extended = arguments[i] || {};
	            for (var key in extended) original[key] = extended[key];
	        }
	        return original;
	    }
	
	});
	
	// Object-less types
	
	['Object', 'WhiteSpace', 'TextNode', 'Collection', 'Arguments'].each(function(name){
	    new Type(name);
	});
	
	// Unique ID
	
	var UID = Date.now();
	
	String.extend('uniqueID', function(){
	    return (UID++).toString(36);
	});
	
	
	
	})();
	
	
	/*
	---
	
	name: Array
	
	description: Contains Array Prototypes like each, contains, and erase.
	
	license: MIT-style license.
	
	requires: Type
	
	provides: Array
	
	...
	*/
	
	Array.implement({
	
	    /*<!ES5>*/
	    every: function(fn, bind){
	        for (var i = 0, l = this.length >>> 0; i < l; i++){
	            if ((i in this) && !fn.call(bind, this[i], i, this)) return false;
	        }
	        return true;
	    },
	
	    filter: function(fn, bind){
	        var results = [];
	        for (var value, i = 0, l = this.length >>> 0; i < l; i++) if (i in this){
	            value = this[i];
	            if (fn.call(bind, value, i, this)) results.push(value);
	        }
	        return results;
	    },
	
	    indexOf: function(item, from){
	        var length = this.length >>> 0;
	        for (var i = (from < 0) ? Math.max(0, length + from) : from || 0; i < length; i++){
	            if (this[i] === item) return i;
	        }
	        return -1;
	    },
	
	    map: function(fn, bind){
	        var length = this.length >>> 0, results = Array(length);
	        for (var i = 0; i < length; i++){
	            if (i in this) results[i] = fn.call(bind, this[i], i, this);
	        }
	        return results;
	    },
	
	    some: function(fn, bind){
	        for (var i = 0, l = this.length >>> 0; i < l; i++){
	            if ((i in this) && fn.call(bind, this[i], i, this)) return true;
	        }
	        return false;
	    },
	    /*</!ES5>*/
	
	    clean: function(){
	        return this.filter(function(item){
	            return item != null;
	        });
	    },
	
	    invoke: function(methodName){
	        var args = Array.slice(arguments, 1);
	        return this.map(function(item){
	            return item[methodName].apply(item, args);
	        });
	    },
	
	    associate: function(keys){
	        var obj = {}, length = Math.min(this.length, keys.length);
	        for (var i = 0; i < length; i++) obj[keys[i]] = this[i];
	        return obj;
	    },
	
	    link: function(object){
	        var result = {};
	        for (var i = 0, l = this.length; i < l; i++){
	            for (var key in object){
	                if (object[key](this[i])){
	                    result[key] = this[i];
	                    delete object[key];
	                    break;
	                }
	            }
	        }
	        return result;
	    },
	
	    contains: function(item, from){
	        return this.indexOf(item, from) != -1;
	    },
	
	    append: function(array){
	        this.push.apply(this, array);
	        return this;
	    },
	
	    getLast: function(){
	        return (this.length) ? this[this.length - 1] : null;
	    },
	
	    getRandom: function(){
	        return (this.length) ? this[Number.random(0, this.length - 1)] : null;
	    },
	
	    include: function(item){
	        if (!this.contains(item)) this.push(item);
	        return this;
	    },
	
	    combine: function(array){
	        for (var i = 0, l = array.length; i < l; i++) this.include(array[i]);
	        return this;
	    },
	
	    erase: function(item){
	        for (var i = this.length; i--;){
	            if (this[i] === item) this.splice(i, 1);
	        }
	        return this;
	    },
	
	    empty: function(){
	        this.length = 0;
	        return this;
	    },
	
	    flatten: function(){
	        var array = [];
	        for (var i = 0, l = this.length; i < l; i++){
	            var type = typeOf(this[i]);
	            if (type == 'null') continue;
	            array = array.concat((type == 'array' || type == 'collection' || type == 'arguments' || instanceOf(this[i], Array)) ? Array.flatten(this[i]) : this[i]);
	        }
	        return array;
	    },
	
	    pick: function(){
	        for (var i = 0, l = this.length; i < l; i++){
	            if (this[i] != null) return this[i];
	        }
	        return null;
	    },
	
	    hexToRgb: function(array){
	        if (this.length != 3) return null;
	        var rgb = this.map(function(value){
	            if (value.length == 1) value += value;
	            return value.toInt(16);
	        });
	        return (array) ? rgb : 'rgb(' + rgb + ')';
	    },
	
	    rgbToHex: function(array){
	        if (this.length < 3) return null;
	        if (this.length == 4 && this[3] == 0 && !array) return 'transparent';
	        var hex = [];
	        for (var i = 0; i < 3; i++){
	            var bit = (this[i] - 0).toString(16);
	            hex.push((bit.length == 1) ? '0' + bit : bit);
	        }
	        return (array) ? hex : '#' + hex.join('');
	    }
	
	});
	
	
	
	
	/*
	---
	
	name: String
	
	description: Contains String Prototypes like camelCase, capitalize, test, and toInt.
	
	license: MIT-style license.
	
	requires: Type
	
	provides: String
	
	...
	*/
	
	String.implement({
	
	    test: function(regex, params){
	        return ((typeOf(regex) == 'regexp') ? regex : new RegExp('' + regex, params)).test(this);
	    },
	
	    contains: function(string, separator){
	        return (separator) ? (separator + this + separator).indexOf(separator + string + separator) > -1 : String(this).indexOf(string) > -1;
	    },
	
	    trim: function(){
	        return String(this).replace(/^\s+|\s+$/g, '');
	    },
	
	    clean: function(){
	        return String(this).replace(/\s+/g, ' ').trim();
	    },
	
	    camelCase: function(){
	        return String(this).replace(/-\D/g, function(match){
	            return match.charAt(1).toUpperCase();
	        });
	    },
	
	    hyphenate: function(){
	        return String(this).replace(/[A-Z]/g, function(match){
	            return ('-' + match.charAt(0).toLowerCase());
	        });
	    },
	
	    capitalize: function(){
	        return String(this).replace(/\b[a-z]/g, function(match){
	            return match.toUpperCase();
	        });
	    },
	
	    escapeRegExp: function(){
	        return String(this).replace(/([-.*+?^{$}()|[\]\/\\])/g, '\\$1');
	    },
	
	    toInt: function(base){
	        return parseInt(this, base || 10);
	    },
	
	    toFloat: function(){
	        return parseFloat(this);
	    },
	
	    hexToRgb: function(array){
	        var hex = String(this).match(/^#?(\w{1,2})(\w{1,2})(\w{1,2})$/);
	        return (hex) ? hex.slice(1).hexToRgb(array) : null;
	    },
	
	    rgbToHex: function(array){
	        var rgb = String(this).match(/\d{1,3}/g);
	        return (rgb) ? rgb.rgbToHex(array) : null;
	    },
	
	    substitute: function(object, regexp){
	        return String(this).replace(regexp || (/\\?\{([^{}]+)\}/g), function(match, name){
	            if (match.charAt(0) == '\\') return match.slice(1);
	            return (object[name] != null) ? object[name] : '';
	        });
	    }
	
	});
	
	
	/*
	---
	
	name: Number
	
	description: Contains Number Prototypes like limit, round, times, and ceil.
	
	license: MIT-style license.
	
	requires: Type
	
	provides: Number
	
	...
	*/
	
	Number.implement({
	
	    limit: function(min, max){
	        return Math.min(max, Math.max(min, this));
	    },
	
	    round: function(precision){
	        precision = Math.pow(10, precision || 0).toFixed(precision < 0 ? -precision : 0);
	        return Math.round(this * precision) / precision;
	    },
	
	    times: function(fn, bind){
	        for (var i = 0; i < this; i++) fn.call(bind, i, this);
	    },
	
	    toFloat: function(){
	        return parseFloat(this);
	    },
	
	    toInt: function(base){
	        return parseInt(this, base || 10);
	    }
	
	});
	
	Number.alias('each', 'times');
	
	(function(math){
	    var methods = {};
	    math.each(function(name){
	        if (!Number[name]) methods[name] = function(){
	            return Math[name].apply(null, [this].concat(Array.from(arguments)));
	        };
	    });
	    Number.implement(methods);
	})(['abs', 'acos', 'asin', 'atan', 'atan2', 'ceil', 'cos', 'exp', 'floor', 'log', 'max', 'min', 'pow', 'sin', 'sqrt', 'tan']);
	
	
	/*
	---
	
	name: Function
	
	description: Contains Function Prototypes like create, bind, pass, and delay.
	
	license: MIT-style license.
	
	requires: Type
	
	provides: Function
	
	...
	*/
	
	Function.extend({
	
	    attempt: function(){
	        for (var i = 0, l = arguments.length; i < l; i++){
	            try {
	                return arguments[i]();
	            } catch (e){}
	        }
	        return null;
	    }
	
	});
	
	Function.implement({
	
	    attempt: function(args, bind){
	        try {
	            return this.apply(bind, Array.from(args));
	        } catch (e){}
	
	        return null;
	    },
	
	    /*<!ES5-bind>*/
	    bind: function(that){
	        var self = this,
	            args = arguments.length > 1 ? Array.slice(arguments, 1) : null,
	            F = function(){};
	
	        var bound = function(){
	            var context = that, length = arguments.length;
	            if (this instanceof bound){
	                F.prototype = self.prototype;
	                context = new F;
	            }
	            var result = (!args && !length)
	                ? self.call(context)
	                : self.apply(context, args && length ? args.concat(Array.slice(arguments)) : args || arguments);
	            return context == that ? result : context;
	        };
	        return bound;
	    },
	    /*</!ES5-bind>*/
	
	    pass: function(args, bind){
	        var self = this;
	        if (args != null) args = Array.from(args);
	        return function(){
	            return self.apply(bind, args || arguments);
	        };
	    },
	
	    delay: function(delay, bind, args){
	        return setTimeout(this.pass((args == null ? [] : args), bind), delay);
	    },
	
	    periodical: function(periodical, bind, args){
	        return setInterval(this.pass((args == null ? [] : args), bind), periodical);
	    }
	
	});
	
	
	
	
	/*
	---
	
	name: Browser
	
	description: The Browser Object. Contains Browser initialization, Window and Document, and the Browser Hash.
	
	license: MIT-style license.
	
	requires: [Array, Function, Number, String]
	
	provides: [Browser, Window, Document]
	
	...
	*/
	
	(function(){
	
	var document = this.document;
	var window = document.window = this;
	
	var ua = navigator.userAgent.toLowerCase(),
	    platform = navigator.platform.toLowerCase(),
	    UA = ua.match(/(opera|ie|firefox|chrome|version)[\s\/:]([\w\d\.]+)?.*?(safari|version[\s\/:]([\w\d\.]+)|$)/) || [null, 'unknown', 0],
	    mode = UA[1] == 'ie' && document.documentMode;
	
	var Browser = this.Browser = {
	
	    extend: Function.prototype.extend,
	
	    name: (UA[1] == 'version') ? UA[3] : UA[1],
	
	    version: mode || parseFloat((UA[1] == 'opera' && UA[4]) ? UA[4] : UA[2]),
	
	    Platform: {
	        name: ua.match(/ip(?:ad|od|hone)/) ? 'ios' : (ua.match(/(?:webos|android)/) || platform.match(/mac|win|linux/) || ['other'])[0]
	    },
	
	    Features: {
	        xpath: !!(document.evaluate),
	        air: !!(window.runtime),
	        query: !!(document.querySelector),
	        json: !!(window.JSON)
	    },
	
	    Plugins: {}
	
	};
	
	Browser[Browser.name] = true;
	Browser[Browser.name + parseInt(Browser.version, 10)] = true;
	Browser.Platform[Browser.Platform.name] = true;
	
	// Request
	
	Browser.Request = (function(){
	
	    var XMLHTTP = function(){
	        return new XMLHttpRequest();
	    };
	
	    var MSXML2 = function(){
	        return new ActiveXObject('MSXML2.XMLHTTP');
	    };
	
	    var MSXML = function(){
	        return new ActiveXObject('Microsoft.XMLHTTP');
	    };
	
	    return Function.attempt(function(){
	        XMLHTTP();
	        return XMLHTTP;
	    }, function(){
	        MSXML2();
	        return MSXML2;
	    }, function(){
	        MSXML();
	        return MSXML;
	    });
	
	})();
	
	Browser.Features.xhr = !!(Browser.Request);
	
	// Flash detection
	
	var version = (Function.attempt(function(){
	    return navigator.plugins['Shockwave Flash'].description;
	}, function(){
	    return new ActiveXObject('ShockwaveFlash.ShockwaveFlash').GetVariable('$version');
	}) || '0 r0').match(/\d+/g);
	
	Browser.Plugins.Flash = {
	    version: Number(version[0] || '0.' + version[1]) || 0,
	    build: Number(version[2]) || 0
	};
	
	// String scripts
	
	Browser.exec = function(text){
	    if (!text) return text;
	    if (window.execScript){
	        window.execScript(text);
	    } else {
	        var script = document.createElement('script');
	        script.setAttribute('type', 'text/javascript');
	        script.text = text;
	        document.head.appendChild(script);
	        document.head.removeChild(script);
	    }
	    return text;
	};
	
	String.implement('stripScripts', function(exec){
	    var scripts = '';
	    var text = this.replace(/<script[^>]*>([\s\S]*?)<\/script>/gi, function(all, code){
	        scripts += code + '\n';
	        return '';
	    });
	    if (exec === true) Browser.exec(scripts);
	    else if (typeOf(exec) == 'function') exec(scripts, text);
	    return text;
	});
	
	// Window, Document
	
	Browser.extend({
	    Document: this.Document,
	    Window: this.Window,
	    Element: this.Element,
	    Event: this.Event
	});
	
	this.Window = this.$constructor = new Type('Window', function(){});
	
	this.$family = Function.from('window').hide();
	
	Window.mirror(function(name, method){
	    window[name] = method;
	});
	
	this.Document = document.$constructor = new Type('Document', function(){});
	
	document.$family = Function.from('document').hide();
	
	Document.mirror(function(name, method){
	    document[name] = method;
	});
	
	document.html = document.documentElement;
	if (!document.head) document.head = document.getElementsByTagName('head')[0];
	
	if (document.execCommand) try {
	    document.execCommand("BackgroundImageCache", false, true);
	} catch (e){}
	
	/*<ltIE9>*/
	if (this.attachEvent && !this.addEventListener){
	    var unloadEvent = function(){
	        this.detachEvent('onunload', unloadEvent);
	        document.head = document.html = document.window = null;
	    };
	    this.attachEvent('onunload', unloadEvent);
	}
	
	// IE fails on collections and <select>.options (refers to <select>)
	var arrayFrom = Array.from;
	try {
	    arrayFrom(document.html.childNodes);
	} catch(e){
	    Array.from = function(item){
	        if (typeof item != 'string' && Type.isEnumerable(item) && typeOf(item) != 'array'){
	            var i = item.length, array = new Array(i);
	            while (i--) array[i] = item[i];
	            return array;
	        }
	        return arrayFrom(item);
	    };
	
	    var prototype = Array.prototype,
	        slice = prototype.slice;
	    ['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift', 'concat', 'join', 'slice'].each(function(name){
	        var method = prototype[name];
	        Array[name] = function(item){
	            return method.apply(Array.from(item), slice.call(arguments, 1));
	        };
	    });
	}
	/*</ltIE9>*/
	
	
	
	})();
	
	
	/*
	---
	
	name: Object
	
	description: Object generic methods
	
	license: MIT-style license.
	
	requires: Type
	
	provides: [Object, Hash]
	
	...
	*/
	
	(function(){
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	Object.extend({
	
	    subset: function(object, keys){
	        var results = {};
	        for (var i = 0, l = keys.length; i < l; i++){
	            var k = keys[i];
	            if (k in object) results[k] = object[k];
	        }
	        return results;
	    },
	
	    map: function(object, fn, bind){
	        var results = {};
	        for (var key in object){
	            if (hasOwnProperty.call(object, key)) results[key] = fn.call(bind, object[key], key, object);
	        }
	        return results;
	    },
	
	    filter: function(object, fn, bind){
	        var results = {};
	        for (var key in object){
	            var value = object[key];
	            if (hasOwnProperty.call(object, key) && fn.call(bind, value, key, object)) results[key] = value;
	        }
	        return results;
	    },
	
	    every: function(object, fn, bind){
	        for (var key in object){
	            if (hasOwnProperty.call(object, key) && !fn.call(bind, object[key], key)) return false;
	        }
	        return true;
	    },
	
	    some: function(object, fn, bind){
	        for (var key in object){
	            if (hasOwnProperty.call(object, key) && fn.call(bind, object[key], key)) return true;
	        }
	        return false;
	    },
	
	    keys: function(object){
	        var keys = [];
	        for (var key in object){
	            if (hasOwnProperty.call(object, key)) keys.push(key);
	        }
	        return keys;
	    },
	
	    values: function(object){
	        var values = [];
	        for (var key in object){
	            if (hasOwnProperty.call(object, key)) values.push(object[key]);
	        }
	        return values;
	    },
	
	    getLength: function(object){
	        return Object.keys(object).length;
	    },
	
	    keyOf: function(object, value){
	        for (var key in object){
	            if (hasOwnProperty.call(object, key) && object[key] === value) return key;
	        }
	        return null;
	    },
	
	    contains: function(object, value){
	        return Object.keyOf(object, value) != null;
	    },
	
	    toQueryString: function(object, base){
	        var queryString = [];
	
	        Object.each(object, function(value, key){
	            if (base) key = base + '[' + key + ']';
	            var result;
	            switch (typeOf(value)){
	                case 'object': result = Object.toQueryString(value, key); break;
	                case 'array':
	                    var qs = {};
	                    value.each(function(val, i){
	                        qs[i] = val;
	                    });
	                    result = Object.toQueryString(qs, key);
	                break;
	                default: result = key + '=' + encodeURIComponent(value);
	            }
	            if (value != null) queryString.push(result);
	        });
	
	        return queryString.join('&');
	    }
	
	});
	
	})();
	
	
	
	
	/*
	---
	
	name: Event
	
	description: Contains the Event Type, to make the event object cross-browser.
	
	license: MIT-style license.
	
	requires: [Window, Document, Array, Function, String, Object]
	
	provides: Event
	
	...
	*/
	
	(function() {
	
	var _keys = {};
	
	var DOMEvent = this.DOMEvent = new Type('DOMEvent', function(event, win){
	    if (!win) win = window;
	    event = event || win.event;
	    if (event.$extended) return event;
	    this.event = event;
	    this.$extended = true;
	    this.shift = event.shiftKey;
	    this.control = event.ctrlKey;
	    this.alt = event.altKey;
	    this.meta = event.metaKey;
	    var type = this.type = event.type;
	    var target = event.target || event.srcElement;
	    while (target && target.nodeType == 3) target = target.parentNode;
	    this.target = document.id(target);
	
	    if (type.indexOf('key') == 0){
	        var code = this.code = (event.which || event.keyCode);
	        this.key = _keys[code];
	        if (type == 'keydown'){
	            if (code > 111 && code < 124) this.key = 'f' + (code - 111);
	            else if (code > 95 && code < 106) this.key = code - 96;
	        }
	        if (this.key == null) this.key = String.fromCharCode(code).toLowerCase();
	    } else if (type == 'click' || type == 'dblclick' || type == 'contextmenu' || type == 'DOMMouseScroll' || type.indexOf('mouse') == 0){
	        var doc = win.document;
	        doc = (!doc.compatMode || doc.compatMode == 'CSS1Compat') ? doc.html : doc.body;
	        this.page = {
	            x: (event.pageX != null) ? event.pageX : event.clientX + doc.scrollLeft,
	            y: (event.pageY != null) ? event.pageY : event.clientY + doc.scrollTop
	        };
	        this.client = {
	            x: (event.pageX != null) ? event.pageX - win.pageXOffset : event.clientX,
	            y: (event.pageY != null) ? event.pageY - win.pageYOffset : event.clientY
	        };
	        if (type == 'DOMMouseScroll' || type == 'mousewheel')
	            this.wheel = (event.wheelDelta) ? event.wheelDelta / 120 : -(event.detail || 0) / 3;
	
	        this.rightClick = (event.which == 3 || event.button == 2);
	        if (type == 'mouseover' || type == 'mouseout'){
	            var related = event.relatedTarget || event[(type == 'mouseover' ? 'from' : 'to') + 'Element'];
	            while (related && related.nodeType == 3) related = related.parentNode;
	            this.relatedTarget = document.id(related);
	        }
	    } else if (type.indexOf('touch') == 0 || type.indexOf('gesture') == 0){
	        this.rotation = event.rotation;
	        this.scale = event.scale;
	        this.targetTouches = event.targetTouches;
	        this.changedTouches = event.changedTouches;
	        var touches = this.touches = event.touches;
	        if (touches && touches[0]){
	            var touch = touches[0];
	            this.page = {x: touch.pageX, y: touch.pageY};
	            this.client = {x: touch.clientX, y: touch.clientY};
	        }
	    }
	
	    if (!this.client) this.client = {};
	    if (!this.page) this.page = {};
	});
	
	DOMEvent.implement({
	
	    stop: function(){
	        return this.preventDefault().stopPropagation();
	    },
	
	    stopPropagation: function(){
	        if (this.event.stopPropagation) this.event.stopPropagation();
	        else this.event.cancelBubble = true;
	        return this;
	    },
	
	    preventDefault: function(){
	        if (this.event.preventDefault) this.event.preventDefault();
	        else this.event.returnValue = false;
	        return this;
	    }
	
	});
	
	DOMEvent.defineKey = function(code, key){
	    _keys[code] = key;
	    return this;
	};
	
	DOMEvent.defineKeys = DOMEvent.defineKey.overloadSetter(true);
	
	DOMEvent.defineKeys({
	    '38': 'up', '40': 'down', '37': 'left', '39': 'right',
	    '27': 'esc', '32': 'space', '8': 'backspace', '9': 'tab',
	    '46': 'delete', '13': 'enter'
	});
	
	})();
	
	
	
	
	
	
	/*
	---
	
	name: Class
	
	description: Contains the Class Function for easily creating, extending, and implementing reusable Classes.
	
	license: MIT-style license.
	
	requires: [Array, String, Function, Number]
	
	provides: Class
	
	...
	*/
	
	(function(){
	
	var Class = this.Class = new Type('Class', function(params){
	    if (instanceOf(params, Function)) params = {initialize: params};
	
	    var newClass = function(){
	        reset(this);
	        if (newClass.$prototyping) return this;
	        this.$caller = null;
	        var value = (this.initialize) ? this.initialize.apply(this, arguments) : this;
	        this.$caller = this.caller = null;
	        return value;
	    }.extend(this).implement(params);
	
	    newClass.$constructor = Class;
	    newClass.prototype.$constructor = newClass;
	    newClass.prototype.parent = parent;
	
	    return newClass;
	});
	
	var parent = function(){
	    if (!this.$caller) throw new Error('The method "parent" cannot be called.');
	    var name = this.$caller.$name,
	        parent = this.$caller.$owner.parent,
	        previous = (parent) ? parent.prototype[name] : null;
	    if (!previous) throw new Error('The method "' + name + '" has no parent.');
	    return previous.apply(this, arguments);
	};
	
	var reset = function(object){
	    for (var key in object){
	        var value = object[key];
	        switch (typeOf(value)){
	            case 'object':
	                var F = function(){};
	                F.prototype = value;
	                object[key] = reset(new F);
	            break;
	            case 'array': object[key] = value.clone(); break;
	        }
	    }
	    return object;
	};
	
	var wrap = function(self, key, method){
	    if (method.$origin) method = method.$origin;
	    var wrapper = function(){
	        if (method.$protected && this.$caller == null) throw new Error('The method "' + key + '" cannot be called.');
	        var caller = this.caller, current = this.$caller;
	        this.caller = current; this.$caller = wrapper;
	        var result = method.apply(this, arguments);
	        this.$caller = current; this.caller = caller;
	        return result;
	    }.extend({$owner: self, $origin: method, $name: key});
	    return wrapper;
	};
	
	var implement = function(key, value, retain){
	    if (Class.Mutators.hasOwnProperty(key)){
	        value = Class.Mutators[key].call(this, value);
	        if (value == null) return this;
	    }
	
	    if (typeOf(value) == 'function'){
	        if (value.$hidden) return this;
	        this.prototype[key] = (retain) ? value : wrap(this, key, value);
	    } else {
	        Object.merge(this.prototype, key, value);
	    }
	
	    return this;
	};
	
	var getInstance = function(klass){
	    klass.$prototyping = true;
	    var proto = new klass;
	    delete klass.$prototyping;
	    return proto;
	};
	
	Class.implement('implement', implement.overloadSetter());
	
	Class.Mutators = {
	
	    Extends: function(parent){
	        this.parent = parent;
	        this.prototype = getInstance(parent);
	    },
	
	    Implements: function(items){
	        Array.from(items).each(function(item){
	            var instance = new item;
	            for (var key in instance) implement.call(this, key, instance[key], true);
	        }, this);
	    }
	};
	
	})();
	
	
	/*
	---
	
	name: Class.Extras
	
	description: Contains Utility Classes that can be implemented into your own Classes to ease the execution of many common tasks.
	
	license: MIT-style license.
	
	requires: Class
	
	provides: [Class.Extras, Chain, Events, Options]
	
	...
	*/
	
	(function(){
	
	this.Chain = new Class({
	
	    $chain: [],
	
	    chain: function(){
	        this.$chain.append(Array.flatten(arguments));
	        return this;
	    },
	
	    callChain: function(){
	        return (this.$chain.length) ? this.$chain.shift().apply(this, arguments) : false;
	    },
	
	    clearChain: function(){
	        this.$chain.empty();
	        return this;
	    }
	
	});
	
	var removeOn = function(string){
	    return string.replace(/^on([A-Z])/, function(full, first){
	        return first.toLowerCase();
	    });
	};
	
	this.Events = new Class({
	
	    $events: {},
	
	    addEvent: function(type, fn, internal){
	        type = removeOn(type);
	
	        
	
	        this.$events[type] = (this.$events[type] || []).include(fn);
	        if (internal) fn.internal = true;
	        return this;
	    },
	
	    addEvents: function(events){
	        for (var type in events) this.addEvent(type, events[type]);
	        return this;
	    },
	
	    fireEvent: function(type, args, delay){
	        type = removeOn(type);
	        var events = this.$events[type];
	        if (!events) return this;
	        args = Array.from(args);
	        events.each(function(fn){
	            if (delay) fn.delay(delay, this, args);
	            else fn.apply(this, args);
	        }, this);
	        return this;
	    },
	
	    removeEvent: function(type, fn){
	        type = removeOn(type);
	        var events = this.$events[type];
	        if (events && !fn.internal){
	            var index =  events.indexOf(fn);
	            if (index != -1) delete events[index];
	        }
	        return this;
	    },
	
	    removeEvents: function(events){
	        var type;
	        if (typeOf(events) == 'object'){
	            for (type in events) this.removeEvent(type, events[type]);
	            return this;
	        }
	        if (events) events = removeOn(events);
	        for (type in this.$events){
	            if (events && events != type) continue;
	            var fns = this.$events[type];
	            for (var i = fns.length; i--;) if (i in fns){
	                this.removeEvent(type, fns[i]);
	            }
	        }
	        return this;
	    }
	
	});
	
	this.Options = new Class({
	
	    setOptions: function(){
	        var options = this.options = Object.merge.apply(null, [{}, this.options].append(arguments));
	        if (this.addEvent) for (var option in options){
	            if (typeOf(options[option]) != 'function' || !(/^on[A-Z]/).test(option)) continue;
	            this.addEvent(option, options[option]);
	            delete options[option];
	        }
	        return this;
	    }
	
	});
	
	})();
	
	
	/*
	---
	
	name: JSON
	
	description: JSON encoder and decoder.
	
	license: MIT-style license.
	
	SeeAlso: <http://www.json.org/>
	
	requires: [Array, String, Number, Function]
	
	provides: JSON
	
	...
	*/
	
	if (typeof JSON == 'undefined') this.JSON = {};
	
	
	
	(function(){
	
	var special = {'\b': '\\b', '\t': '\\t', '\n': '\\n', '\f': '\\f', '\r': '\\r', '"' : '\\"', '\\': '\\\\'};
	
	var escape = function(chr){
	    return special[chr] || '\\u' + ('0000' + chr.charCodeAt(0).toString(16)).slice(-4);
	};
	
	JSON.validate = function(string){
	    string = string.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, '@').
	                    replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
	                    replace(/(?:^|:|,)(?:\s*\[)+/g, '');
	
	    return (/^[\],:{}\s]*$/).test(string);
	};
	
	JSON.encode = JSON.stringify ? function(obj){
	    return JSON.stringify(obj);
	} : function(obj){
	    if (obj && obj.toJSON) obj = obj.toJSON();
	
	    switch (typeOf(obj)){
	        case 'string':
	            return '"' + obj.replace(/[\x00-\x1f\\"]/g, escape) + '"';
	        case 'array':
	            return '[' + obj.map(JSON.encode).clean() + ']';
	        case 'object': case 'hash':
	            var string = [];
	            Object.each(obj, function(value, key){
	                var json = JSON.encode(value);
	                if (json) string.push(JSON.encode(key) + ':' + json);
	            });
	            return '{' + string + '}';
	        case 'number': case 'boolean': return '' + obj;
	        case 'null': return 'null';
	    }
	
	    return null;
	};
	
	JSON.decode = function(string, secure){
	    if (!string || typeOf(string) != 'string') return null;
	
	    if (secure || JSON.secure){
	        if (JSON.parse) return JSON.parse(string);
	        if (!JSON.validate(string)) throw new Error('JSON could not decode the input; security is enabled and the value is not secure.');
	    }
	
	    return eval('(' + string + ')');
	};
	
	})();
	
	
	define("mootools", function(){});
	
	define('galileo/prototype/array',['require','mootools'],function(require) {
	    require('mootools')
	
	    Array.implement({
	        reindex: function(indices) {
	            var ret = [];
	            for(var ii = 0; ii < indices.length; ii++) {
	                ret[ii] = this[indices[ii]];
	            }
	            return ret;
	        },
	
	        sortBy: function(picker) {
	            this.sort(function(x,y) {
	                var px = picker(x), py = picker(y);
	                return px < py ? -1 : (px > py ? 1 : 0);
	            });
	            return this;
	        },
	
	        group: function(n) {
	            if(this.length < n) return [];
	            var ret = this.slice(1).group(n);
	            ret.unshift(this.slice(0,n));
	            return ret;
	        },
	
	        zipWith: function(that, fn) {
	            var len = Math.min(this.length, that.length), ret = [];
	            for(var ii = 0; ii < len; ii++) {
	                ret.push(fn(this[ii], that[ii], ii));
	            }
	            return ret;
	        },
	
	        shuffle: function() {
	            for (var i = this.length - 1; i > 0; i--) {
	                var j = Math.floor(Math.random() * (i + 1));
	                var tmp = this[i];
	                this[i] = this[j];
	                this[j] = tmp;
	            }
	            return this;
	        },
	
	        find: function(testFunction) {
	            for (var i = 0; i < this.length; i++) {
	                if(testFunction(this[i]) === true) {
	                    return this[i];
	                }
	            }
	            return null;
	        }
	
	    });
	});
	
	define('galileo/prototype/function',['require','mootools'],function(require) {
	
	    require("mootools");
	
	    Function.extend({
	        id: function (x) {
	            return x;
	        },
	
	        takeKey: function() {
	            var args = Array.from(arguments);
	            return function(o) {
	                var myArgs = args.slice(0);
	                while(myArgs.length) o = o[ myArgs.shift() ];
	                return o;
	            }
	        },
	
	        join: function() {
	            var fns = Array.from(arguments),
	                k = fns.pop(),
	                results = [],
	                ctxt = this,
	                taken = 0;
	            fns.map(function(fn, ii) { 
	                fn(function(result) {
	                    if(!(ii in results)) taken++; 
	                    results[ii] = result; 
	                    if(taken == fns.length) k.apply(ctxt, results);
	                }); 
	            });
	        }
	    });
	});
	
	
	define('galileo/util/dateUtil',['require','i18n/i18n','substitute','jquery','galileo/prototype/array','galileo/prototype/function','i18n-load!com/fitbit/util/relativedateutil','i18n-load!core/com/fitbit/util/dateformat'],function(require) {
	    
	
	    var i18n = require('i18n/i18n')(),
	        substituteUtil = require('substitute'),
	        $ = require('jquery');
	
	    require('galileo/prototype/array');
	    require('galileo/prototype/function');
	
	    i18n.namespace(require('i18n-load!com/fitbit/util/relativedateutil'));
	    i18n.namespace(require('i18n-load!core/com/fitbit/util/dateformat'));
	
	    var dateFormatI18n = i18n.inNamespace('com.fitbit.util.dateformat');
	
	    // Private helper to get localized strings, or English defaults for development.
	    function _getStrings(str, defaultList) {
	        var ret = str.split(',').map(function(x) {
	            return x.trim();
	        });
	
	        return ret.length <= 1 ? defaultList : ret;
	    }
	
	    var relativeDateMessageBundle = {
	            'just_now': i18n('just_now'),
	            'seconds': i18n('seconds'),
	            'minute': i18n('minute'),
	            'minutes': i18n('minutes'),
	            'hour': i18n('hour'),
	            'hours': i18n('hours'),
	            'day': i18n('day'),
	            'days': i18n('days'),
	            'week': i18n('week'),
	            'weeks': i18n('weeks'),
	            'months': i18n.inNamespace('com.fitbit.util.relativedateutil')('months'),
	            'years': i18n('years')
	        },
	        localeFormats = {
	            // Conveniently support our commonly used date formats, without explicitly using i18n keys.
	            'EEE, MMM d': i18n('weekday_month_date_medium'), // Tue, Feb 14
	            'EEE, M/d': i18n('weekday_month_date_short'), // Mon, 2/14
	            'M/dd/yyyy': i18n('month_date_year_short'), // 2/27/12
	            'MMMM dd, yyyy': i18n('month_date_year_long'), // February 14, 2012
	            'MMM dd, yyyy': i18n('month_date_year_medium'), // Feb 14, 2012
	            'MMM': dateFormatI18n('month'), // Feb
	            'MMM dd': i18n('month_date'), // Feb 14
	            'MMMM dd': i18n('month_date_long'), // February 04
	            'MMMM d': i18n('month_long_date_short'), // February 4
	            'MMM yyyy': i18n('month_year_medium'), // Feb 2012
	            'MMMM yyyy': i18n('month_year'), // February 2012
	            'EEE': i18n('weekday'), // Mon Tue Wed Thu Fri Sat Sun
	            'EEEE, MMMM dd': i18n('weekday_month_date_long'), // Monday, February 06
	            'EEE, MMM d, yyyy': i18n('weekday_month_date_year'), // Mon, Feb 3, 2012
	            'MMM d, hh:mm a': i18n('month_date_time'), // Feb 6 10:22 AM
	            'MMM d, HH:mm': i18n('month_date_time_24'), // Feb 6 20:22
	
	            // This seems to be universal?
	            'hh:mm a': i18n('dash_time_12'),
	            'hh:mm:ss': 'hh:mm:ss',
	            'HH:mm': i18n('dash_time_24'),
	            'HH:mm:ss': 'HH:mm:ss',
	            'hh:mm': 'hh:mm',
	            'hha': 'hha'
	        },
	        amPm = _getStrings(dateFormatI18n('am_pm'), ['AM','PM']),
	        weekdays = _getStrings(dateFormatI18n('weekdays'), ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']),
	        shortWeekdays = _getStrings(dateFormatI18n('short_weekdays'), ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']),
	        extraminWeekdays = _getStrings(dateFormatI18n('extramin_weekdays'), ['S', 'M', 'T', 'W', 'T', 'F', 'S']),
	        months = _getStrings(dateFormatI18n('months'),
	                                 ['January', 'February', 'March', 'April', 'May',
	                                  'June', 'July', 'August', 'September', 'October', 'November', 'December']),
	        shortMonths = _getStrings(dateFormatI18n('short_months'),
	                                      ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']),
	        subRE;
	
	    /**
	     *  Formats a date object into a readable format.
	     *  @method _localeFormat
	     *  @param {Date} A JavaScript date object.
	     *  @param {String} The desired output format.
	     *  @param {Object} A custom localization bundle. (Optional)
	     *  @returns {String} A formatted, localized string like 'Mon, Nov 17'.
	     */
	    function _localeFormat(date, fmt, formatMapping) {
	        var yy = date.getFullYear() % 100,
	            substitutions = {
	                'yyyy': date.getFullYear(),
	                'yy': yy > 9 ? '' + yy : '0' + yy,
	                'MMMM': months[date.getMonth()],
	                'MMM': shortMonths[date.getMonth()],
	                'MM': date.getMonth() >= 9 ? '' + (date.getMonth() + 1) : '0' + (date.getMonth() + 1),
	                'M': '' + (date.getMonth() + 1),
	                'dd': date.getDate() > 9 ? '' + date.getDate() : '0' + date.getDate(),
	                'd': '' + date.getDate(),
	                'EEEE': weekdays[date.getDay()],
	                'EEE': shortWeekdays[date.getDay()],
	                'E': extraminWeekdays[date.getDay()],
	                'HH': date.getHours() > 9 ? '' + date.getHours() : '0' + date.getHours(),
	                'hh': '' + (date.getHours() % 12 || 12),
	                'mm': date.getMinutes() > 9 ? '' + date.getMinutes() : '0' + date.getMinutes(),
	                'ss': date.getSeconds() > 9 ? '' + date.getSeconds() : '0' + date.getSeconds(),
	                'H': '' + date.getHours(),
	                'h': '' + (date.getHours() % 12 || 12),
	                'm': '' + date.getMinutes(),
	                's': '' + date.getSeconds(),
	                'a': date.getHours() >= 12 ? amPm[1] : amPm[0]
	            };
	
	        formatMapping = formatMapping ? formatMapping : localeFormats;
	
	        if (!formatMapping[fmt] && !substitutions[fmt]) {
	            throw 'Unsupported localized date format: ' + fmt;
	        }
	
	        if (substitutions[fmt]) {
	            return substitutions[fmt];
	        }
	
	        // Just construct the regex once - (yyyy|yy|MMMM|MMM|...)
	        subRE = subRE || new RegExp('(' + Object.keys(substitutions).sortBy(Function.takeKey('length')).reverse().join('|') + ')', 'g');
	        return formatMapping[fmt].replace(subRE, function(match) { return substitutions[match]; });
	    }
	
	    /**
	     *  A function for deriving relative date strings.
	     *  @method _getRelativeDate
	     *  @param {String} Any string that can be parsed by Date().
	     *  @param {Boolean} Assume the date string is in ISO8601 format and convert it.
	     *  @param {Object} A custom localization bundle. (Optional)
	     *  @returns {String} A relative date string like '1 hour ago', '2 weeks ago'. These messages are pulled from localized message bundles.
	     */
	    function _getRelativeDate(dateTime, isDateFormatISO, formatMapping) {
	        var delta,
	            relativeDate = '',
	            minute = 60,
	            hour = minute * 60,
	            day = hour * 24,
	            week = day * 7,
	            month = week * 4,
	            year = month * 12,
	            getMessage = function(key, num) {
	                // Returns a localized relative date based on the partial message key supplied.
	                return formatMapping[key] ? substituteUtil(formatMapping[key], num) : '';
	            };
	
	            formatMapping = formatMapping ? formatMapping : relativeDateMessageBundle;
	
	        // Attempt to parse an ISO8601 date string.
	        if (isDateFormatISO) {
	            try {
	                dateTime = _getDateFromISO8601(dateTime, (dateTime.charAt(dateTime.length - 1) === 'Z')); // If the last character is a 'Z', the date string is already UTC.
	            } catch (e) {
	                if (console) {
	                    console.log('_getRelativeDate: improperly formatted ISO8601 date string');
	                }
	                return '';
	            }
	        }
	
	        // Compute delta between right now and the specified date, in seconds.
	        delta = Math.floor((new Date().getTime() - new Date(dateTime).getTime()) / 1000);
	
	        // Derive a relative date string based on the delta between right now and the time specified.
	        if ($.isNumeric(delta)) {
	            if (delta < 30) {
	                relativeDate = getMessage('just_now', delta);
	            } else if (delta < minute) {
	                relativeDate = getMessage('seconds', delta);
	            } else if (delta < minute * 2) {
	                relativeDate = getMessage('minute', '1');
	            } else if (delta < hour) {
	                relativeDate = getMessage('minutes', Math.floor(delta / minute));
	            } else if (delta < hour * 2) {
	                relativeDate = getMessage('hour', '1');
	            } else if (delta < day) {
	                relativeDate = getMessage('hours', Math.floor(delta / hour));
	            } else if (delta < day * 2) {
	                relativeDate = getMessage('day', '1');
	            } else if (delta < week) {
	                relativeDate = getMessage('days', Math.floor(delta / day));
	            } else if (delta < week * 2) {
	                relativeDate = getMessage('week', '1');
	            } else if (delta < month * 3) {
	                relativeDate = getMessage('weeks', Math.floor(delta / week));
	            } else if (delta < year * 2) {
	                relativeDate = getMessage('months', Math.floor(delta / month));
	            } else {
	                relativeDate = getMessage('years', Math.floor(delta / year));
	            }
	        }
	
	        return relativeDate;
	    }
	
	    /**
	     *  Given an ISO8601 date string (e.g. '2012-11-12T18:17:00.000Z'), return a proper Date instance.
	     *  @method _getDateFromISO8601
	     *  @param {String} The ISO8601 date string to be parsed.
	     *  @param {Boolean} Convert the result to UTC.
	     *  @returns {Date} The converted date object.
	     */
	    function _getDateFromISO8601(dateString, doConversionToUTC) {
	        var dateParts = dateString.match(/([0-9]{4})(-([0-9]{2})(-([0-9]{2})(T([0-9]{2}):([0-9]{2})(:([0-9]{2})(\.([0-9]+))?)?(Z|(([-+])([0-9]{2}):([0-9]{2})))?)?)?)?/),
	            offset = 0,
	            date = new Date(dateParts[1], 0, 1),
	            convertedDate;
	
	        if (dateParts[3]) { date.setMonth(dateParts[3] - 1); }
	        if (dateParts[5]) { date.setDate(dateParts[5]); }
	        if (dateParts[7]) { date.setHours(dateParts[7]); }
	        if (dateParts[8]) { date.setMinutes(dateParts[8]); }
	        if (dateParts[10]) { date.setSeconds(dateParts[10]); }
	        if (dateParts[12]) { date.setMilliseconds(Number('0.' + dateParts[12]) * 1000); }
	        if (dateParts[14]) {
	            offset = (Number(dateParts[16]) * 60) + Number(dateParts[17]);
	            offset *= ((dateParts[15] === '-') ? 1 : -1);
	        }
	
	        if (!doConversionToUTC) {
	            offset -= date.getTimezoneOffset();
	        }
	
	        convertedDate = new Date();
	        convertedDate.setTime(Number(Number(date) + (offset * 60 * 1000)));
	
	        return convertedDate;
	    }
	
	    /**
	     *  Given a Date object, return a string in the YY-mm-dd format commonly used for AJAX requests.
	     *  @method _ajaxEncode
	     *  @param {Date} A JavaScript Date object.
	     *  @returns {String} The date in the hyphen delimited format.
	     */
	    function _ajaxEncode(date) {
	        var pad = function(n) {
	            if (('' + n).length === 1) {
	                return '0' + n;
	            }
	
	            return '' + n;
	        };
	
	        return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
	    }
	
	    /**
	     *  Given a String the YY-mm-dd format commonly used for AJAX requests, return a Date object.
	     *  @method _ajaxDecode
	     *  @param {String} A String in the YY-mm-dd format commonly used for AJAX requests.
	     *  @returns {Date} The created Date object.
	     */
	    function _ajaxDecode(dateString) {
	        var parts     = dateString.split(' '),
	            dateParts = parts[0].split('-');
	
	        // Date and time
	        if (parts.length > 1) {
	            var timeParts = parts[1].split(':');
	            return new Date(dateParts[0], dateParts[1] - 1, dateParts[2], timeParts[0], timeParts[1], timeParts[2]);
	        }
	
	        // Just date
	        return new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
	    }
	
	    /**
	     *  Given a String in a time format hh:mm:ss, return a Date object. Seconds are ignored.
	     *  @method _forTime
	     *  @param {String} A String in the hh:mm:ss format.
	     *  @returns {Date} The created Date object.
	     */
	    function _forTime(time) {
	        var parts = time.split(':'),
	            ret = new Date();
	
	        ret.setHours(parts[0]);
	        ret.setMinutes(parts[1]);
	        ret.setSeconds(0);
	        ret.setMilliseconds(0);
	
	        return ret;
	    }
	
	    // Private helper for date computations.
	    function _compute(type, fn) {
	        return function(date, n) {
	            var copy = new Date(date.getTime());
	
	            copy['set' + type](copy['get' + type]() + fn(n));
	
	            return copy;
	        };
	    }
	
	    return {
	        getRelativeDate     : _getRelativeDate,
	        getDateFromISO8601  : _getDateFromISO8601,
	        ajaxEncode          : _ajaxEncode,
	        ajaxDecode          : _ajaxDecode,
	        forTime             : _forTime,
	
	        plusMinutes         : _compute('Time', function(n) { return n * 60 * 1000; }),
	        minusMinutes        : _compute('Time', function(n) { return -(n * 60 * 1000); }),
	        plusDays            : _compute('Date', function(n) { return n; }),
	        minusDays           : _compute('Date', function(n) { return -n; }),
	        plusWeeks           : _compute('Date', function(n) { return n * 7; }),
	        minusWeeks          : _compute('Date', function(n) { return -n * 7; }),
	        plusMonths          : _compute('Month', function(n) { return n; }),
	        minusMonths         : _compute('Month', function(n) { return -n; }),
	        plusYears           : _compute('FullYear', function(n) { return n; }),
	        minusYears          : _compute('FullYear', function(n) { return -n; }),
	
	        localeFormat        : _localeFormat,
	
	        diff: function(date1, date2) {
	            return date1.getTime() - date2.getTime();
	        },
	
	        diffInSeconds: function(date1, date2, doNotFloor) {
	            var diff = this.diff(date1, date2) / 1000;
	            return doNotFloor ? diff : (Math.abs(diff) !== diff ? Math.ceil(diff) : Math.floor(diff));
	        },
	
	        diffInMinutes: function(date1, date2, doNotFloor) {
	            var diff = this.diffInSeconds(date1, date2, true) / 60;
	            return doNotFloor ? diff : (Math.abs(diff) !== diff ? Math.ceil(diff) : Math.floor(diff));
	        },
	
	        diffInHours: function(date1, date2, doNotFloor) {
	            var diff = this.diffInMinutes(date1, date2, true) / 60;
	            return doNotFloor ? diff : (Math.abs(diff) !== diff ? Math.ceil(diff) : Math.floor(diff));
	        },
	
	        diffInDays: function(date1, date2) {
	            return this.diffInHours(new Date(date1.toDateString()), new Date(date2.toDateString())) / 24;
	        },
	
	        getMonthNames: function() {
	            return months;
	        },
	
	        getShortMonthNames: function() {
	            return shortMonths;
	        },
	
	        getWeekdayNames: function() {
	            return weekdays;
	        },
	
	        getShortWeekdayNames: function() {
	            return shortWeekdays;
	        },
	
	        isToday: function(date) {
	            if(!date) {
	                return false;
	            }
	            return this.diffInDays(new Date(), date) === 0;
	        },
	
	        isYesterday: function(date) {
	            if(!date) {
	                return false;
	            }
	            return this.diffInDays(new Date(), date) === 1;
	        },
	
	        isBefore: function(before, after) {
	            return this.diff(before, after) < 0;
	        }
	    };
	});
	
	
	define('messages-deviceNames',['require','i18n/i18n','i18n-load!com/fitbit/app/device/message'],function(require) {
	
	    var i18n = require('i18n/i18n')();
	
	    i18n.namespace(require('i18n-load!com/fitbit/app/device/message'));
	
	    return {
	    	"FLOJO": {
	    		"name"			: i18n("device_name_FLOJO"),
	    		"displayName"	: i18n("device_displayName_FLOJO")
	    	},
	    	"KEPLER": {
	    		"name"			: i18n("device_name_KEPLER"),
	    		"displayName"	: i18n("device_displayName_KEPLER")
	    	},
	        "VIRTUAL_KEPLER": {
	            "name"			: i18n("device_name_KEPLER"),
	            "displayName"	: i18n("device_displayName_KEPLER")
	        },
	    	"TYCHO": {
	    		"name"			: i18n("device_name_TYCHO"),
	    		"displayName"	: i18n("device_displayName_TYCHO")
	    	},
	    	"GALILEO": {
	    		"name"			: i18n("device_name_GALILEO"),
	    		"displayName"	: i18n("device_displayName_GALILEO")
	    	},
	    	"HADRON": {
	    		"name"			: i18n("device_name_HADRON"),
	    		"displayName"	: i18n("device_displayName_HADRON")
	    	},
	    	"QUARK": {
	    		"name"			: i18n("device_name_QUARK"),
	    		"displayName"	: i18n("device_displayName_QUARK")
	    	},
	        "NEUTRINO": {
	            "name"          : i18n("device_name_NEUTRINO"),
	            "displayName"   : i18n("device_displayName_NEUTRINO")
	        },
	        "GRAVITON": {
	            "name"          : i18n("device_name_GRAVITON"),
	            "displayName"   : i18n("device_displayName_GRAVITON")
	        },
	        "TAU": {
	            "name"          : i18n("device_name_TAU"),
	            "displayName"   : i18n("device_displayName_TAU")
	        },
	        "PROTON": {
	            "name"          : i18n("device_name_PROTON"),
	            "displayName"   : i18n("device_displayName_PROTON")
	        },
	        "ELECTRON": {
	            "name"          : i18n("device_name_ELECTRON"),
	            "displayName"   : i18n("device_displayName_ELECTRON")
	        },
	        "LEPTON": {
	            "name"          : i18n("device_name_LEPTON"),
	            "displayName"   : i18n("device_displayName_LEPTON")
	        }
	    };
	    
	});
	
	define('messages-batteryLevels',['require','i18n/i18n','i18n-load!com/fitbit/app/device/message'],function(require) {
	
	    var i18n = require('i18n/i18n')();
	
		i18n.namespace(require('i18n-load!com/fitbit/app/device/message'));
	
	    return {
	    	"empty"		: i18n("battery_empty"),
	    	"low"		: i18n("battery_low"),
	    	"medium"	: i18n("battery_medium"),
	    	"high"		: i18n("battery_high"),
	    	"full"		: i18n("battery_full"),
	    	"unknown"	: i18n("battery_unknown")
	    };
	
	});
	define('galileo/builder/text',['require','jquery'],function(require) {
	    require("jquery");
	
	    // Create span from shorthand string specifying font properties.
	    // Similar to "font" property from CSS but more flexible.
	    return function(str, text) {
	        var keywords = {
	            italic: {'font-style': 'italic'},
	            bold: {'font-weight': 'bold'},
	            uppercase: {'text-transform': 'uppercase'},
	            underline: {'text-decoration': 'underline'},
	            nounderline: {'text-decoration': 'none'}
	        };
	        var parts = str.split(/(?:\s|\/)+/), style = {};
	        
	        while(parts.length && parts[0] in keywords) {
	            Object.merge(style, keywords[ parts.shift() ]);
	        }
	        var fontRE = /\d+(\.\d*)?(px|em|%|pt|en)/;
	        if(parts.length && parts[0].match(fontRE)) {
	            Object.merge(style, {'font-size': parts.shift()});
	        }
	        if(parts.length && parts[0].match(fontRE)) {
	            Object.merge(style, {'line-height': parts.shift()});
	        }
	
	        if(parts.getLast() && parts.getLast().indexOf("#") == 0) {
	            Object.merge(style, {color: parts.pop()});
	        }
	
	
	        // By now we've got keywords, font size and line height, and color if these are mentioned. Everything left goes in font-family.
	        var fontFamily = parts.join(" ").trim();
	        if(fontFamily != "") {
	            Object.merge(style, {fontFamily: fontFamily});
	        }
	        return $("<span>").css(style).text(text);
	    }
	});
	
	define('galileo/builder/util',['require','./text'],function(require) {
	
	    // Small DOM construction utilities used in a few modules.
	
	    var Text = require("./text");
	
	    function legend(color, text) {
	        return $("<span>").append(
	            $("<span>").css('display', 'inline-block').width(10).height(10).css('backgroundColor', color),
	            hspace(10),
	            Text("uppercase 12px #666", text)
	        );
	    }
	
	    function hspace(n) {
	        return $("<span>").css('display', 'inline-block').width(n);
	    }
	    
	    function vspace(n) {
	        return $("<p>").html("&nbsp").height(n);
	    }
	
	    function vline(width, height, color) {
	        return hspace(width).css('height', height).css('background-color', color);
	    }
	
	    return {
	        hspace: hspace,
	        vspace: vspace,
	        vline: vline,
	        legend: legend
	    }
	    
	});
	
	define('galileo/prototype/number',['require','mootools'],function(require) {
	    require("mootools");
	
	    Number.withDigits = function(x, n) {
	        return Math.round(x * Math.pow(10, n)) / Math.pow(10,n);
	    };
	
	    Number.implement({
	        //Javascript modulo operator does not work
	        //correctly with negative numbers
	        mod:function(n) {
	           return ((this%n)+n)%n;
	        }
	    });
	});
	
	define('galileo/prototype/all',['require','./function','./array','./number'],function(require) {
	    require("./function");
	    require("./array");
	    require("./number");
	});
	
	define('galileo/widget/tabs',['require','galileo/prototype/all'],function(require) {
	    require("galileo/prototype/all");
	
	    return function(tabs, defaultStyle, selectedStyle, initialSelection) {
	        var list = $("<ul>").css('listStyle', 'none'), tabElems = {}, selected = null, unselect = null;
	        tabs.each(function(tabRecord) {
	            var tabName = tabRecord[0];
	            tabElems[tabName] = $("<li>").css('display', 'inline-block').text(tabName).click(function(){ 
	                selectTab(tabName);
	            }).css(defaultStyle).appendTo(list);
	            if(!unselect) {
	                unselect = {};
	                Object.keys(selectedStyle).each(function(styleName) { 
	                    unselect[styleName] = tabElems[tabName].css(styleName); 
	                });
	            }
	        });
	        selectTab(initialSelection || tabs[0][0]);
	        
	        return list;
	        function selectTab(tabName) {
	            if(selected === tabName) return;
	            selected = tabName;
	
	            tabs.each(function(tab) { if(tab[0] == tabName) { tab[1](); } });
	
	            Object.each(tabElems, function(elem, name) {
	                if(name == tabName) {
	                    elem.css(selectedStyle);
	                } else {
	                    elem.css(unselect);
	                }
	            });
	        }
	    };
	});
	
	define('shared/scripts/modal',['require','jquery'],function(require) {
	    var $ = require("jquery"), win, doc;
	
	    return function(fn) {
	        win = win || $(window);
	        doc = doc || $(document);
	
	        // Adding styles inline so that modals such as flex101 can be used on other pages.
	        var overlay = $('<div>').addClass('backdrop').css({
	            position: 'absolute', left: 0, top: 0, right: 0, bottom: 0, zIndex: 1000
	        });
	
	        $('<div>').addClass('overlay').css({
	            position: 'absolute', left: 0, top: 0, right: 0, bottom: 0, opacity: .5,
	            backgroundColor: '#000'
	        }).appendTo(overlay).on('click', function(ev){ if(this == ev.target) close(); });
	
	        overlay.appendTo($("body").css({position: 'relative'})).fadeIn(250);
	
	        var onCloseCallback = function() { };
	
	        var dialog = fn(close);
	
	        dialog.appendTo(overlay);
	
	        dialog.find('.close').on('click', close);
	
	        doc.on('keydown', docClose);
	
	        // Figure out the dialog's width and height after injecting into the overlay.
	
	
	        // Position the dialog
	        position();
	
	        // Make sure that the dialog is positioned properly if the user resizes the window
	        win.on('resize', position);
	
	        return {
	            dialog: dialog,
	            close: close,
	            onClose: function(cb) {
	                onCloseCallback = cb;
	            },
	            position: position,
	            overlay: overlay
	        };
	
	        function position () {
	            var width = win.width(),
	                height = win.height(),
	
	                dialogWidth = dialog.outerWidth(false),
	                dialogHeight = dialog.outerHeight(false),
	
	                styles = {};
	
	            var indentLeft = 0;
	            var indentTop = 0;
	
	            if (dialog.css('position').toLowerCase() != 'fixed') {
	                indentLeft = doc.scrollLeft();
	                indentTop = doc.scrollTop();
	            }
	
	            // if the width of the window is greater than the dialogs width.. compute!
	            styles.left = width >= dialogWidth ? (computeCenter(width, dialogWidth) + indentLeft) : indentLeft;
	
	            // if the height of the window is greater than the dialogs height.. compute!
	            styles.top = height >= dialogHeight ? (computeCenter(height, dialogHeight) + indentTop) : indentTop;
	
	            dialog.css(styles);
	        }
	
	        function computeCenter(a, b) {
	            return ((a - b) / 2);
	        }
	
	        function close() {
	            overlay.animate({
	                'opacity': 0
	            }, {
	                duration: 250,
	                complete: function(){
	                    overlay.detach();
	                }
	            });
	
	            win.off('resize', position);
	            doc.off('keydown', docClose);
	            onCloseCallback();
	        }
	
	        function docClose(e) {
	            e.keyCode == 27 && close();
	        }
	    };
	});
	
	
	// jshint ignore: start
	define('galileo/modal/flex101',['require','jquery','galileo/builder/util','galileo/builder/text','i18n/i18n','galileo/widget/tabs','i18n-load!com/fitbit/app/ngd/flex101','i18n-load!com/fitbit/mktg/crosssell','shared/scripts/modal'],function(require) {
	    var $ = require('jquery');
	    var B = require("galileo/builder/util");
	    var Text = require("galileo/builder/text");
	    var i18n = require('i18n/i18n')();
	    var Tabs = require("galileo/widget/tabs");
	
	    i18n.namespace(require('i18n-load!com/fitbit/app/ngd/flex101'));
	    i18n.namespace(require('i18n-load!com/fitbit/mktg/crosssell'));
	
	    var flex101PackedImages;
	    
	    var allTexts = [
	        // BASICS
	        txt(i18n("charging"),
	            i18n("your_tracker_battery_lasts")),
	        txt(i18n("syncing"),
	            i18n("when_your_flex_is_within").substitute(
	                [link(i18n("supported_devices"), "/devices"), 
	                 link(i18n("syncing"), i18n("syncing_href"))])),
	        txt(i18n("wearing"),
	            i18n("your_flex_tracker_should_be_placed")),
	        // GOALS
	        goals(),
	        txt(i18n("goal_progress"),
	            i18n("each_light_on_your_flex")),
	        txt(i18n("changing_goals"),
	            i18n("to_choose_which_goal_is_shown").substitute([link(i18n("device_settings"), "/settings/device")])),
	        // SLEEP
	        txt(i18n("tracking_sleep"),
	            i18n("sleep_tracking_can_be_turned_on")),
	        txt(i18n("forgot_to_turn_on"),
	            i18n("you_can_add_a_sleep_log").substitute([link(i18n("learn_more"), i18n("forgot_to_turn_on_href"))])),
	        txt(i18n("silent_alarms"),
	            i18n("set_a_silent_alarm").substitute([link(i18n("devices_area"), "/settings/alarms")]))
	    ];
	
	    return function() {
	        return $.ajax({
	            dataType: "json",
	            url: '/lab/galileo/flex101'
	        }).then(function(data) {
	            flex101PackedImages = data;
	            return require("shared/scripts/modal")(function(close) {
	                var container = $("<div>");
	                return $("<div>").css({padding: 31, backgroundColor: 'white', width: 500, position: 'fixed'}).append(
	                    Tabs(
	                        [[i18n("nav_basics"), function(){ container.empty().append(flex101([img('11'), img('12'), img('13')], allTexts.slice(0,3))); }],
	                         [i18n("nav_goals"), function(){ container.empty().append(flex101([img('21'), img('22'), img('23')], allTexts.slice(3,6))); }],
	                         [i18n("nav_sleep"), function(){ container.empty().append(flex101([img('31'), img('32'), img('33')], allTexts.slice(6,9))); }]],
	                        {
	                            fontSize: '12px',
	                            fontWeight: 'bold',
	                            color: "#999",
	                            cursor: 'pointer',
	                            lineHeight: '23px',
	                            textTransform: 'uppercase',
	                            padding: '0px 12px',
	                            //margin: '0px 8px',
	                            borderBottom: '2px solid #999'
	                        },
	                        {color: '#333', borderBottom: '2px solid #55c2c2', cursor: 'default'},
	                        i18n("nav_basics")).css('float', 'right'),
	                    Text("bold 25px #55c2c2", i18n("title")),
	                    $('body').attr('class').match(/locale-([a-z]{2}_[A-Z]{2})/)[1] === 'zh_TW' ?
	                        $("<div>").text(i18n('status_not_available')).css({position: 'absolute', padding: '3px 5px 3px',
	                                                                           backgroundColor: '#ef3d6f', borderRadius: '3px',
	                                                                           color: '#fff', letterSpacing: '1px',
	                                                                           fontFamily: '"Proxima Nova Bold",Arial,Helvetica,sans-serif',
	                                                                           fontWeight: 700, top: 60})
	                        : $("<br>"),
	                    B.vspace(61),
	                    container,
	                    B.vspace(20),
	                    Text("bold 18px/30px #fff", "x").css({position: 'absolute', right: -30, top: 0, width: 30, 
	                                                          backgroundColor: 'black', textAlign: 'center', cursor: 'pointer'}).click(close)
	                );
	            });
	        });
	    };
	
	    function txt(header, content) {
	        var ret = $("<div>").append(
	            Text("bold 16px/22px #333", header),
	            $("<br>"),
	            Text("14px/17px #333", "").html(content)
	        );
	        ret.find("a").css({color: '#ff4588'});
	        return ret;
	    }
	    
	    function link(text, href) {
	        return "<a href='" + href + "'>" + text + "</a>";
	    }
	
	    function goals() {
	        return $("<div>").append(
	            Text("bold 16px/22px #333", i18n("goals")),
	            $("<br>"),
	            Text("14px/17px #333", i18n("on_the_dashboard")),
	            $("<br>"), $("<br>"),
	            $("<div>").css({width: 200, display: 'inline-block'}).append(
	                Text("14px/17px #333", "\u2022 " + i18n("steps")),
	                $("<br>"),
	                Text("14px/17px #333", "\u2022 " + i18n("calories_burned"))
	            ),
	            $("<div>").css({width: 200, display: 'inline-block'}).append(
	                Text("14px/17px #333", "\u2022 " + i18n("distance")),
	                $("<br>"),
	                Text("14px/17px #333", "\u2022 " + i18n("very_active_minutes"))
	            )
	        );
	    }
	
	    function img(x) {
	        return $("<img>").attr('src', flex101PackedImages[x]);
	    }
	
	    function flex101(ims,texts) {
	        return $("<div>").append(
	            line(ims[0], texts[0]),
	            hline(),
	            line(ims[1], texts[1]),
	            hline(),
	            line(ims[2], texts[2])
	        );
	    }
	
	    function hline() {
	        return $("<div>").html("&nbsp").css({
	            height: 1, backgroundColor: '#ccc'
	        });
	    }
	
	    function line(im, text) {
	        return $("<div>").append(
	            B.vspace(23),
	            B.hspace(15), im, B.hspace(27), $("<div>").css({
	                width: 407, display: 'inline-block'
	            }).append(text),
	            B.vspace(23)
	        );
	    }
	
	});
	
	(function () {
	    /*
	
	     Copyright (C) 2011 by Yehuda Katz
	
	     Permission is hereby granted, free of charge, to any person obtaining a copy
	     of this software and associated documentation files (the "Software"), to deal
	     in the Software without restriction, including without limitation the rights
	     to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	     copies of the Software, and to permit persons to whom the Software is
	     furnished to do so, subject to the following conditions:
	
	     The above copyright notice and this permission notice shall be included in
	     all copies or substantial portions of the Software.
	
	     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	     IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	     FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	     AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	     LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	     OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	     THE SOFTWARE.
	
	     */
	
	// lib/handlebars/browser-prefix.js
	    var Handlebars = {};
	
	    (function(Handlebars, undefined) {
	        ;
	// lib/handlebars/base.js
	
	        Handlebars.VERSION = "1.0.0-rc.3";
	        Handlebars.COMPILER_REVISION = 2;
	
	        Handlebars.REVISION_CHANGES = {
	            1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
	            2: '>= 1.0.0-rc.3'
	        };
	
	        Handlebars.helpers  = {};
	        Handlebars.partials = {};
	
	        Handlebars.registerHelper = function(name, fn, inverse) {
	            if(inverse) { fn.not = inverse; }
	            this.helpers[name] = fn;
	        };
	
	        Handlebars.registerPartial = function(name, str) {
	            this.partials[name] = str;
	        };
	
	        Handlebars.registerHelper('helperMissing', function(arg) {
	            if(arguments.length === 2) {
	                return undefined;
	            } else {
	                throw new Error("Could not find property '" + arg + "'");
	            }
	        });
	
	        var toString = Object.prototype.toString, functionType = "[object Function]";
	
	        Handlebars.registerHelper('blockHelperMissing', function(context, options) {
	            var inverse = options.inverse || function() {}, fn = options.fn;
	
	            var type = toString.call(context);
	
	            if(type === functionType) { context = context.call(this); }
	
	            if(context === true) {
	                return fn(this);
	            } else if(context === false || context == null) {
	                return inverse(this);
	            } else if(type === "[object Array]") {
	                if(context.length > 0) {
	                    return Handlebars.helpers.each(context, options);
	                } else {
	                    return inverse(this);
	                }
	            } else {
	                return fn(context);
	            }
	        });
	
	        Handlebars.K = function() {};
	
	        Handlebars.createFrame = Object.create || function(object) {
	            Handlebars.K.prototype = object;
	            var obj = new Handlebars.K();
	            Handlebars.K.prototype = null;
	            return obj;
	        };
	
	        Handlebars.logger = {
	            DEBUG: 0, INFO: 1, WARN: 2, ERROR: 3, level: 3,
	
	            methodMap: {0: 'debug', 1: 'info', 2: 'warn', 3: 'error'},
	
	            // can be overridden in the host environment
	            log: function(level, obj) {
	                if (Handlebars.logger.level <= level) {
	                    var method = Handlebars.logger.methodMap[level];
	                    if (typeof console !== 'undefined' && console[method]) {
	                        console[method].call(console, obj);
	                    }
	                }
	            }
	        };
	
	        Handlebars.log = function(level, obj) { Handlebars.logger.log(level, obj); };
	
	        Handlebars.registerHelper('each', function(context, options) {
	            var fn = options.fn, inverse = options.inverse;
	            var i = 0, ret = "", data;
	
	            if (options.data) {
	                data = Handlebars.createFrame(options.data);
	            }
	
	            if(context && typeof context === 'object') {
	                if(context instanceof Array){
	                    for(var j = context.length; i<j; i++) {
	                        if (data) { data.index = i; }
	                        ret = ret + fn(context[i], { data: data });
	                    }
	                } else {
	                    for(var key in context) {
	                        if(context.hasOwnProperty(key)) {
	                            if(data) { data.key = key; }
	                            ret = ret + fn(context[key], {data: data});
	                            i++;
	                        }
	                    }
	                }
	            }
	
	            if(i === 0){
	                ret = inverse(this);
	            }
	
	            return ret;
	        });
	
	        Handlebars.registerHelper('if', function(context, options) {
	            var type = toString.call(context);
	            if(type === functionType) { context = context.call(this); }
	
	            if(!context || Handlebars.Utils.isEmpty(context)) {
	                return options.inverse(this);
	            } else {
	                return options.fn(this);
	            }
	        });
	
	        Handlebars.registerHelper('unless', function(context, options) {
	            return Handlebars.helpers['if'].call(this, context, {fn: options.inverse, inverse: options.fn});
	        });
	
	        Handlebars.registerHelper('with', function(context, options) {
	            return options.fn(context);
	        });
	
	        Handlebars.registerHelper('log', function(context, options) {
	            var level = options.data && options.data.level != null ? parseInt(options.data.level, 10) : 1;
	            Handlebars.log(level, context);
	        });
	        ;
	    }(Handlebars));
	    ;
	// lib/handlebars/compiler/parser.js
	    /* Jison generated parser */
	    var handlebars = (function(){
	        var parser = {trace: function trace() { },
	            yy: {},
	            symbols_: {"error":2,"root":3,"program":4,"EOF":5,"simpleInverse":6,"statements":7,"statement":8,"openInverse":9,"closeBlock":10,"openBlock":11,"mustache":12,"partial":13,"CONTENT":14,"COMMENT":15,"OPEN_BLOCK":16,"inMustache":17,"CLOSE":18,"OPEN_INVERSE":19,"OPEN_ENDBLOCK":20,"path":21,"OPEN":22,"OPEN_UNESCAPED":23,"OPEN_PARTIAL":24,"partialName":25,"params":26,"hash":27,"DATA":28,"param":29,"STRING":30,"INTEGER":31,"BOOLEAN":32,"hashSegments":33,"hashSegment":34,"ID":35,"EQUALS":36,"PARTIAL_NAME":37,"pathSegments":38,"SEP":39,"$accept":0,"$end":1},
	            terminals_: {2:"error",5:"EOF",14:"CONTENT",15:"COMMENT",16:"OPEN_BLOCK",18:"CLOSE",19:"OPEN_INVERSE",20:"OPEN_ENDBLOCK",22:"OPEN",23:"OPEN_UNESCAPED",24:"OPEN_PARTIAL",28:"DATA",30:"STRING",31:"INTEGER",32:"BOOLEAN",35:"ID",36:"EQUALS",37:"PARTIAL_NAME",39:"SEP"},
	            productions_: [0,[3,2],[4,2],[4,3],[4,2],[4,1],[4,1],[4,0],[7,1],[7,2],[8,3],[8,3],[8,1],[8,1],[8,1],[8,1],[11,3],[9,3],[10,3],[12,3],[12,3],[13,3],[13,4],[6,2],[17,3],[17,2],[17,2],[17,1],[17,1],[26,2],[26,1],[29,1],[29,1],[29,1],[29,1],[29,1],[27,1],[33,2],[33,1],[34,3],[34,3],[34,3],[34,3],[34,3],[25,1],[21,1],[38,3],[38,1]],
	            performAction: function anonymous(yytext,yyleng,yylineno,yy,yystate,$$,_$) {
	
	                var $0 = $$.length - 1;
	                switch (yystate) {
	                    case 1: return $$[$0-1];
	                        break;
	                    case 2: this.$ = new yy.ProgramNode([], $$[$0]);
	                        break;
	                    case 3: this.$ = new yy.ProgramNode($$[$0-2], $$[$0]);
	                        break;
	                    case 4: this.$ = new yy.ProgramNode($$[$0-1], []);
	                        break;
	                    case 5: this.$ = new yy.ProgramNode($$[$0]);
	                        break;
	                    case 6: this.$ = new yy.ProgramNode([], []);
	                        break;
	                    case 7: this.$ = new yy.ProgramNode([]);
	                        break;
	                    case 8: this.$ = [$$[$0]];
	                        break;
	                    case 9: $$[$0-1].push($$[$0]); this.$ = $$[$0-1];
	                        break;
	                    case 10: this.$ = new yy.BlockNode($$[$0-2], $$[$0-1].inverse, $$[$0-1], $$[$0]);
	                        break;
	                    case 11: this.$ = new yy.BlockNode($$[$0-2], $$[$0-1], $$[$0-1].inverse, $$[$0]);
	                        break;
	                    case 12: this.$ = $$[$0];
	                        break;
	                    case 13: this.$ = $$[$0];
	                        break;
	                    case 14: this.$ = new yy.ContentNode($$[$0]);
	                        break;
	                    case 15: this.$ = new yy.CommentNode($$[$0]);
	                        break;
	                    case 16: this.$ = new yy.MustacheNode($$[$0-1][0], $$[$0-1][1]);
	                        break;
	                    case 17: this.$ = new yy.MustacheNode($$[$0-1][0], $$[$0-1][1]);
	                        break;
	                    case 18: this.$ = $$[$0-1];
	                        break;
	                    case 19: this.$ = new yy.MustacheNode($$[$0-1][0], $$[$0-1][1]);
	                        break;
	                    case 20: this.$ = new yy.MustacheNode($$[$0-1][0], $$[$0-1][1], true);
	                        break;
	                    case 21: this.$ = new yy.PartialNode($$[$0-1]);
	                        break;
	                    case 22: this.$ = new yy.PartialNode($$[$0-2], $$[$0-1]);
	                        break;
	                    case 23:
	                        break;
	                    case 24: this.$ = [[$$[$0-2]].concat($$[$0-1]), $$[$0]];
	                        break;
	                    case 25: this.$ = [[$$[$0-1]].concat($$[$0]), null];
	                        break;
	                    case 26: this.$ = [[$$[$0-1]], $$[$0]];
	                        break;
	                    case 27: this.$ = [[$$[$0]], null];
	                        break;
	                    case 28: this.$ = [[new yy.DataNode($$[$0])], null];
	                        break;
	                    case 29: $$[$0-1].push($$[$0]); this.$ = $$[$0-1];
	                        break;
	                    case 30: this.$ = [$$[$0]];
	                        break;
	                    case 31: this.$ = $$[$0];
	                        break;
	                    case 32: this.$ = new yy.StringNode($$[$0]);
	                        break;
	                    case 33: this.$ = new yy.IntegerNode($$[$0]);
	                        break;
	                    case 34: this.$ = new yy.BooleanNode($$[$0]);
	                        break;
	                    case 35: this.$ = new yy.DataNode($$[$0]);
	                        break;
	                    case 36: this.$ = new yy.HashNode($$[$0]);
	                        break;
	                    case 37: $$[$0-1].push($$[$0]); this.$ = $$[$0-1];
	                        break;
	                    case 38: this.$ = [$$[$0]];
	                        break;
	                    case 39: this.$ = [$$[$0-2], $$[$0]];
	                        break;
	                    case 40: this.$ = [$$[$0-2], new yy.StringNode($$[$0])];
	                        break;
	                    case 41: this.$ = [$$[$0-2], new yy.IntegerNode($$[$0])];
	                        break;
	                    case 42: this.$ = [$$[$0-2], new yy.BooleanNode($$[$0])];
	                        break;
	                    case 43: this.$ = [$$[$0-2], new yy.DataNode($$[$0])];
	                        break;
	                    case 44: this.$ = new yy.PartialNameNode($$[$0]);
	                        break;
	                    case 45: this.$ = new yy.IdNode($$[$0]);
	                        break;
	                    case 46: $$[$0-2].push($$[$0]); this.$ = $$[$0-2];
	                        break;
	                    case 47: this.$ = [$$[$0]];
	                        break;
	                }
	            },
	            table: [{3:1,4:2,5:[2,7],6:3,7:4,8:6,9:7,11:8,12:9,13:10,14:[1,11],15:[1,12],16:[1,13],19:[1,5],22:[1,14],23:[1,15],24:[1,16]},{1:[3]},{5:[1,17]},{5:[2,6],7:18,8:6,9:7,11:8,12:9,13:10,14:[1,11],15:[1,12],16:[1,13],19:[1,19],20:[2,6],22:[1,14],23:[1,15],24:[1,16]},{5:[2,5],6:20,8:21,9:7,11:8,12:9,13:10,14:[1,11],15:[1,12],16:[1,13],19:[1,5],20:[2,5],22:[1,14],23:[1,15],24:[1,16]},{17:23,18:[1,22],21:24,28:[1,25],35:[1,27],38:26},{5:[2,8],14:[2,8],15:[2,8],16:[2,8],19:[2,8],20:[2,8],22:[2,8],23:[2,8],24:[2,8]},{4:28,6:3,7:4,8:6,9:7,11:8,12:9,13:10,14:[1,11],15:[1,12],16:[1,13],19:[1,5],20:[2,7],22:[1,14],23:[1,15],24:[1,16]},{4:29,6:3,7:4,8:6,9:7,11:8,12:9,13:10,14:[1,11],15:[1,12],16:[1,13],19:[1,5],20:[2,7],22:[1,14],23:[1,15],24:[1,16]},{5:[2,12],14:[2,12],15:[2,12],16:[2,12],19:[2,12],20:[2,12],22:[2,12],23:[2,12],24:[2,12]},{5:[2,13],14:[2,13],15:[2,13],16:[2,13],19:[2,13],20:[2,13],22:[2,13],23:[2,13],24:[2,13]},{5:[2,14],14:[2,14],15:[2,14],16:[2,14],19:[2,14],20:[2,14],22:[2,14],23:[2,14],24:[2,14]},{5:[2,15],14:[2,15],15:[2,15],16:[2,15],19:[2,15],20:[2,15],22:[2,15],23:[2,15],24:[2,15]},{17:30,21:24,28:[1,25],35:[1,27],38:26},{17:31,21:24,28:[1,25],35:[1,27],38:26},{17:32,21:24,28:[1,25],35:[1,27],38:26},{25:33,37:[1,34]},{1:[2,1]},{5:[2,2],8:21,9:7,11:8,12:9,13:10,14:[1,11],15:[1,12],16:[1,13],19:[1,19],20:[2,2],22:[1,14],23:[1,15],24:[1,16]},{17:23,21:24,28:[1,25],35:[1,27],38:26},{5:[2,4],7:35,8:6,9:7,11:8,12:9,13:10,14:[1,11],15:[1,12],16:[1,13],19:[1,19],20:[2,4],22:[1,14],23:[1,15],24:[1,16]},{5:[2,9],14:[2,9],15:[2,9],16:[2,9],19:[2,9],20:[2,9],22:[2,9],23:[2,9],24:[2,9]},{5:[2,23],14:[2,23],15:[2,23],16:[2,23],19:[2,23],20:[2,23],22:[2,23],23:[2,23],24:[2,23]},{18:[1,36]},{18:[2,27],21:41,26:37,27:38,28:[1,45],29:39,30:[1,42],31:[1,43],32:[1,44],33:40,34:46,35:[1,47],38:26},{18:[2,28]},{18:[2,45],28:[2,45],30:[2,45],31:[2,45],32:[2,45],35:[2,45],39:[1,48]},{18:[2,47],28:[2,47],30:[2,47],31:[2,47],32:[2,47],35:[2,47],39:[2,47]},{10:49,20:[1,50]},{10:51,20:[1,50]},{18:[1,52]},{18:[1,53]},{18:[1,54]},{18:[1,55],21:56,35:[1,27],38:26},{18:[2,44],35:[2,44]},{5:[2,3],8:21,9:7,11:8,12:9,13:10,14:[1,11],15:[1,12],16:[1,13],19:[1,19],20:[2,3],22:[1,14],23:[1,15],24:[1,16]},{14:[2,17],15:[2,17],16:[2,17],19:[2,17],20:[2,17],22:[2,17],23:[2,17],24:[2,17]},{18:[2,25],21:41,27:57,28:[1,45],29:58,30:[1,42],31:[1,43],32:[1,44],33:40,34:46,35:[1,47],38:26},{18:[2,26]},{18:[2,30],28:[2,30],30:[2,30],31:[2,30],32:[2,30],35:[2,30]},{18:[2,36],34:59,35:[1,60]},{18:[2,31],28:[2,31],30:[2,31],31:[2,31],32:[2,31],35:[2,31]},{18:[2,32],28:[2,32],30:[2,32],31:[2,32],32:[2,32],35:[2,32]},{18:[2,33],28:[2,33],30:[2,33],31:[2,33],32:[2,33],35:[2,33]},{18:[2,34],28:[2,34],30:[2,34],31:[2,34],32:[2,34],35:[2,34]},{18:[2,35],28:[2,35],30:[2,35],31:[2,35],32:[2,35],35:[2,35]},{18:[2,38],35:[2,38]},{18:[2,47],28:[2,47],30:[2,47],31:[2,47],32:[2,47],35:[2,47],36:[1,61],39:[2,47]},{35:[1,62]},{5:[2,10],14:[2,10],15:[2,10],16:[2,10],19:[2,10],20:[2,10],22:[2,10],23:[2,10],24:[2,10]},{21:63,35:[1,27],38:26},{5:[2,11],14:[2,11],15:[2,11],16:[2,11],19:[2,11],20:[2,11],22:[2,11],23:[2,11],24:[2,11]},{14:[2,16],15:[2,16],16:[2,16],19:[2,16],20:[2,16],22:[2,16],23:[2,16],24:[2,16]},{5:[2,19],14:[2,19],15:[2,19],16:[2,19],19:[2,19],20:[2,19],22:[2,19],23:[2,19],24:[2,19]},{5:[2,20],14:[2,20],15:[2,20],16:[2,20],19:[2,20],20:[2,20],22:[2,20],23:[2,20],24:[2,20]},{5:[2,21],14:[2,21],15:[2,21],16:[2,21],19:[2,21],20:[2,21],22:[2,21],23:[2,21],24:[2,21]},{18:[1,64]},{18:[2,24]},{18:[2,29],28:[2,29],30:[2,29],31:[2,29],32:[2,29],35:[2,29]},{18:[2,37],35:[2,37]},{36:[1,61]},{21:65,28:[1,69],30:[1,66],31:[1,67],32:[1,68],35:[1,27],38:26},{18:[2,46],28:[2,46],30:[2,46],31:[2,46],32:[2,46],35:[2,46],39:[2,46]},{18:[1,70]},{5:[2,22],14:[2,22],15:[2,22],16:[2,22],19:[2,22],20:[2,22],22:[2,22],23:[2,22],24:[2,22]},{18:[2,39],35:[2,39]},{18:[2,40],35:[2,40]},{18:[2,41],35:[2,41]},{18:[2,42],35:[2,42]},{18:[2,43],35:[2,43]},{5:[2,18],14:[2,18],15:[2,18],16:[2,18],19:[2,18],20:[2,18],22:[2,18],23:[2,18],24:[2,18]}],
	            defaultActions: {17:[2,1],25:[2,28],38:[2,26],57:[2,24]},
	            parseError: function parseError(str, hash) {
	                throw new Error(str);
	            },
	            parse: function parse(input) {
	                var self = this, stack = [0], vstack = [null], lstack = [], table = this.table, yytext = "", yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
	                this.lexer.setInput(input);
	                this.lexer.yy = this.yy;
	                this.yy.lexer = this.lexer;
	                this.yy.parser = this;
	                if (typeof this.lexer.yylloc == "undefined")
	                    this.lexer.yylloc = {};
	                var yyloc = this.lexer.yylloc;
	                lstack.push(yyloc);
	                var ranges = this.lexer.options && this.lexer.options.ranges;
	                if (typeof this.yy.parseError === "function")
	                    this.parseError = this.yy.parseError;
	                function popStack(n) {
	                    stack.length = stack.length - 2 * n;
	                    vstack.length = vstack.length - n;
	                    lstack.length = lstack.length - n;
	                }
	                function lex() {
	                    var token;
	                    token = self.lexer.lex() || 1;
	                    if (typeof token !== "number") {
	                        token = self.symbols_[token] || token;
	                    }
	                    return token;
	                }
	                var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
	                while (true) {
	                    state = stack[stack.length - 1];
	                    if (this.defaultActions[state]) {
	                        action = this.defaultActions[state];
	                    } else {
	                        if (symbol === null || typeof symbol == "undefined") {
	                            symbol = lex();
	                        }
	                        action = table[state] && table[state][symbol];
	                    }
	                    if (typeof action === "undefined" || !action.length || !action[0]) {
	                        var errStr = "";
	                        if (!recovering) {
	                            expected = [];
	                            for (p in table[state])
	                                if (this.terminals_[p] && p > 2) {
	                                    expected.push("'" + this.terminals_[p] + "'");
	                                }
	                            if (this.lexer.showPosition) {
	                                errStr = "Parse error on line " + (yylineno + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
	                            } else {
	                                errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == 1?"end of input":"'" + (this.terminals_[symbol] || symbol) + "'");
	                            }
	                            this.parseError(errStr, {text: this.lexer.match, token: this.terminals_[symbol] || symbol, line: this.lexer.yylineno, loc: yyloc, expected: expected});
	                        }
	                    }
	                    if (action[0] instanceof Array && action.length > 1) {
	                        throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
	                    }
	                    switch (action[0]) {
	                        case 1:
	                            stack.push(symbol);
	                            vstack.push(this.lexer.yytext);
	                            lstack.push(this.lexer.yylloc);
	                            stack.push(action[1]);
	                            symbol = null;
	                            if (!preErrorSymbol) {
	                                yyleng = this.lexer.yyleng;
	                                yytext = this.lexer.yytext;
	                                yylineno = this.lexer.yylineno;
	                                yyloc = this.lexer.yylloc;
	                                if (recovering > 0)
	                                    recovering--;
	                            } else {
	                                symbol = preErrorSymbol;
	                                preErrorSymbol = null;
	                            }
	                            break;
	                        case 2:
	                            len = this.productions_[action[1]][1];
	                            yyval.$ = vstack[vstack.length - len];
	                            yyval._$ = {first_line: lstack[lstack.length - (len || 1)].first_line, last_line: lstack[lstack.length - 1].last_line, first_column: lstack[lstack.length - (len || 1)].first_column, last_column: lstack[lstack.length - 1].last_column};
	                            if (ranges) {
	                                yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
	                            }
	                            r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);
	                            if (typeof r !== "undefined") {
	                                return r;
	                            }
	                            if (len) {
	                                stack = stack.slice(0, -1 * len * 2);
	                                vstack = vstack.slice(0, -1 * len);
	                                lstack = lstack.slice(0, -1 * len);
	                            }
	                            stack.push(this.productions_[action[1]][0]);
	                            vstack.push(yyval.$);
	                            lstack.push(yyval._$);
	                            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
	                            stack.push(newState);
	                            break;
	                        case 3:
	                            return true;
	                    }
	                }
	                return true;
	            }
	        };
	        /* Jison generated lexer */
	        var lexer = (function(){
	            var lexer = ({EOF:1,
	                parseError:function parseError(str, hash) {
	                    if (this.yy.parser) {
	                        this.yy.parser.parseError(str, hash);
	                    } else {
	                        throw new Error(str);
	                    }
	                },
	                setInput:function (input) {
	                    this._input = input;
	                    this._more = this._less = this.done = false;
	                    this.yylineno = this.yyleng = 0;
	                    this.yytext = this.matched = this.match = '';
	                    this.conditionStack = ['INITIAL'];
	                    this.yylloc = {first_line:1,first_column:0,last_line:1,last_column:0};
	                    if (this.options.ranges) this.yylloc.range = [0,0];
	                    this.offset = 0;
	                    return this;
	                },
	                input:function () {
	                    var ch = this._input[0];
	                    this.yytext += ch;
	                    this.yyleng++;
	                    this.offset++;
	                    this.match += ch;
	                    this.matched += ch;
	                    var lines = ch.match(/(?:\r\n?|\n).*/g);
	                    if (lines) {
	                        this.yylineno++;
	                        this.yylloc.last_line++;
	                    } else {
	                        this.yylloc.last_column++;
	                    }
	                    if (this.options.ranges) this.yylloc.range[1]++;
	
	                    this._input = this._input.slice(1);
	                    return ch;
	                },
	                unput:function (ch) {
	                    var len = ch.length;
	                    var lines = ch.split(/(?:\r\n?|\n)/g);
	
	                    this._input = ch + this._input;
	                    this.yytext = this.yytext.substr(0, this.yytext.length-len-1);
	                    //this.yyleng -= len;
	                    this.offset -= len;
	                    var oldLines = this.match.split(/(?:\r\n?|\n)/g);
	                    this.match = this.match.substr(0, this.match.length-1);
	                    this.matched = this.matched.substr(0, this.matched.length-1);
	
	                    if (lines.length-1) this.yylineno -= lines.length-1;
	                    var r = this.yylloc.range;
	
	                    this.yylloc = {first_line: this.yylloc.first_line,
	                        last_line: this.yylineno+1,
	                        first_column: this.yylloc.first_column,
	                        last_column: lines ?
	                            (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length:
	                            this.yylloc.first_column - len
	                    };
	
	                    if (this.options.ranges) {
	                        this.yylloc.range = [r[0], r[0] + this.yyleng - len];
	                    }
	                    return this;
	                },
	                more:function () {
	                    this._more = true;
	                    return this;
	                },
	                less:function (n) {
	                    this.unput(this.match.slice(n));
	                },
	                pastInput:function () {
	                    var past = this.matched.substr(0, this.matched.length - this.match.length);
	                    return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
	                },
	                upcomingInput:function () {
	                    var next = this.match;
	                    if (next.length < 20) {
	                        next += this._input.substr(0, 20-next.length);
	                    }
	                    return (next.substr(0,20)+(next.length > 20 ? '...':'')).replace(/\n/g, "");
	                },
	                showPosition:function () {
	                    var pre = this.pastInput();
	                    var c = new Array(pre.length + 1).join("-");
	                    return pre + this.upcomingInput() + "\n" + c+"^";
	                },
	                next:function () {
	                    if (this.done) {
	                        return this.EOF;
	                    }
	                    if (!this._input) this.done = true;
	
	                    var token,
	                        match,
	                        tempMatch,
	                        index,
	                        col,
	                        lines;
	                    if (!this._more) {
	                        this.yytext = '';
	                        this.match = '';
	                    }
	                    var rules = this._currentRules();
	                    for (var i=0;i < rules.length; i++) {
	                        tempMatch = this._input.match(this.rules[rules[i]]);
	                        if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
	                            match = tempMatch;
	                            index = i;
	                            if (!this.options.flex) break;
	                        }
	                    }
	                    if (match) {
	                        lines = match[0].match(/(?:\r\n?|\n).*/g);
	                        if (lines) this.yylineno += lines.length;
	                        this.yylloc = {first_line: this.yylloc.last_line,
	                            last_line: this.yylineno+1,
	                            first_column: this.yylloc.last_column,
	                            last_column: lines ? lines[lines.length-1].length-lines[lines.length-1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length};
	                        this.yytext += match[0];
	                        this.match += match[0];
	                        this.matches = match;
	                        this.yyleng = this.yytext.length;
	                        if (this.options.ranges) {
	                            this.yylloc.range = [this.offset, this.offset += this.yyleng];
	                        }
	                        this._more = false;
	                        this._input = this._input.slice(match[0].length);
	                        this.matched += match[0];
	                        token = this.performAction.call(this, this.yy, this, rules[index],this.conditionStack[this.conditionStack.length-1]);
	                        if (this.done && this._input) this.done = false;
	                        if (token) return token;
	                        else return;
	                    }
	                    if (this._input === "") {
	                        return this.EOF;
	                    } else {
	                        return this.parseError('Lexical error on line '+(this.yylineno+1)+'. Unrecognized text.\n'+this.showPosition(),
	                            {text: "", token: null, line: this.yylineno});
	                    }
	                },
	                lex:function lex() {
	                    var r = this.next();
	                    if (typeof r !== 'undefined') {
	                        return r;
	                    } else {
	                        return this.lex();
	                    }
	                },
	                begin:function begin(condition) {
	                    this.conditionStack.push(condition);
	                },
	                popState:function popState() {
	                    return this.conditionStack.pop();
	                },
	                _currentRules:function _currentRules() {
	                    return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules;
	                },
	                topState:function () {
	                    return this.conditionStack[this.conditionStack.length-2];
	                },
	                pushState:function begin(condition) {
	                    this.begin(condition);
	                }});
	            lexer.options = {};
	            lexer.performAction = function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
	
	                var YYSTATE=YY_START
	                switch($avoiding_name_collisions) {
	                    case 0:
	                        if(yy_.yytext.slice(-1) !== "\\") this.begin("mu");
	                        if(yy_.yytext.slice(-1) === "\\") yy_.yytext = yy_.yytext.substr(0,yy_.yyleng-1), this.begin("emu");
	                        if(yy_.yytext) return 14;
	
	                        break;
	                    case 1: return 14;
	                        break;
	                    case 2:
	                        if(yy_.yytext.slice(-1) !== "\\") this.popState();
	                        if(yy_.yytext.slice(-1) === "\\") yy_.yytext = yy_.yytext.substr(0,yy_.yyleng-1);
	                        return 14;
	
	                        break;
	                    case 3: yy_.yytext = yy_.yytext.substr(0, yy_.yyleng-4); this.popState(); return 15;
	                        break;
	                    case 4: this.begin("par"); return 24;
	                        break;
	                    case 5: return 16;
	                        break;
	                    case 6: return 20;
	                        break;
	                    case 7: return 19;
	                        break;
	                    case 8: return 19;
	                        break;
	                    case 9: return 23;
	                        break;
	                    case 10: return 23;
	                        break;
	                    case 11: this.popState(); this.begin('com');
	                        break;
	                    case 12: yy_.yytext = yy_.yytext.substr(3,yy_.yyleng-5); this.popState(); return 15;
	                        break;
	                    case 13: return 22;
	                        break;
	                    case 14: return 36;
	                        break;
	                    case 15: return 35;
	                        break;
	                    case 16: return 35;
	                        break;
	                    case 17: return 39;
	                        break;
	                    case 18: /*ignore whitespace*/
	                        break;
	                    case 19: this.popState(); return 18;
	                        break;
	                    case 20: this.popState(); return 18;
	                        break;
	                    case 21: yy_.yytext = yy_.yytext.substr(1,yy_.yyleng-2).replace(/\\"/g,'"'); return 30;
	                        break;
	                    case 22: yy_.yytext = yy_.yytext.substr(1,yy_.yyleng-2).replace(/\\'/g,"'"); return 30;
	                        break;
	                    case 23: yy_.yytext = yy_.yytext.substr(1); return 28;
	                        break;
	                    case 24: return 32;
	                        break;
	                    case 25: return 32;
	                        break;
	                    case 26: return 31;
	                        break;
	                    case 27: return 35;
	                        break;
	                    case 28: yy_.yytext = yy_.yytext.substr(1, yy_.yyleng-2); return 35;
	                        break;
	                    case 29: return 'INVALID';
	                        break;
	                    case 30: /*ignore whitespace*/
	                        break;
	                    case 31: this.popState(); return 37;
	                        break;
	                    case 32: return 5;
	                        break;
	                }
	            };
	            lexer.rules = [/^(?:[^\x00]*?(?=(\{\{)))/,/^(?:[^\x00]+)/,/^(?:[^\x00]{2,}?(?=(\{\{|$)))/,/^(?:[\s\S]*?--\}\})/,/^(?:\{\{>)/,/^(?:\{\{#)/,/^(?:\{\{\/)/,/^(?:\{\{\^)/,/^(?:\{\{\s*else\b)/,/^(?:\{\{\{)/,/^(?:\{\{&)/,/^(?:\{\{!--)/,/^(?:\{\{![\s\S]*?\}\})/,/^(?:\{\{)/,/^(?:=)/,/^(?:\.(?=[} ]))/,/^(?:\.\.)/,/^(?:[\/.])/,/^(?:\s+)/,/^(?:\}\}\})/,/^(?:\}\})/,/^(?:"(\\["]|[^"])*")/,/^(?:'(\\[']|[^'])*')/,/^(?:@[a-zA-Z]+)/,/^(?:true(?=[}\s]))/,/^(?:false(?=[}\s]))/,/^(?:-?[0-9]+(?=[}\s]))/,/^(?:[a-zA-Z0-9_$-]+(?=[=}\s\/.]))/,/^(?:\[[^\]]*\])/,/^(?:.)/,/^(?:\s+)/,/^(?:[a-zA-Z0-9_$-/]+)/,/^(?:$)/];
	            lexer.conditions = {"mu":{"rules":[4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,32],"inclusive":false},"emu":{"rules":[2],"inclusive":false},"com":{"rules":[3],"inclusive":false},"par":{"rules":[30,31],"inclusive":false},"INITIAL":{"rules":[0,1,32],"inclusive":true}};
	            return lexer;})()
	        parser.lexer = lexer;
	        function Parser () { this.yy = {}; }Parser.prototype = parser;parser.Parser = Parser;
	        return new Parser;
	    })();
	    ;
	// lib/handlebars/compiler/base.js
	
	    Handlebars.Parser = handlebars;
	
	    Handlebars.parse = function(input) {
	
	        // Just return if an already-compile AST was passed in.
	        if(input.constructor === Handlebars.AST.ProgramNode) { return input; }
	
	        Handlebars.Parser.yy = Handlebars.AST;
	        return Handlebars.Parser.parse(input);
	    };
	    ;
	// lib/handlebars/compiler/ast.js
	    (function() {
	        Handlebars.AST = {};
	
	        Handlebars.AST.ProgramNode = function(statements, inverse) {
	            this.type = "program";
	            this.statements = statements;
	            if(inverse) { this.inverse = new Handlebars.AST.ProgramNode(inverse); }
	        };
	
	        Handlebars.AST.MustacheNode = function(rawParams, hash, unescaped) {
	            this.type = "mustache";
	            this.escaped = !unescaped;
	            this.hash = hash;
	
	            var id = this.id = rawParams[0];
	            var params = this.params = rawParams.slice(1);
	
	            // a mustache is an eligible helper if:
	            // * its id is simple (a single part, not `this` or `..`)
	            var eligibleHelper = this.eligibleHelper = id.isSimple;
	
	            // a mustache is definitely a helper if:
	            // * it is an eligible helper, and
	            // * it has at least one parameter or hash segment
	            this.isHelper = eligibleHelper && (params.length || hash);
	
	            // if a mustache is an eligible helper but not a definite
	            // helper, it is ambiguous, and will be resolved in a later
	            // pass or at runtime.
	        };
	
	        Handlebars.AST.PartialNode = function(partialName, context) {
	            this.type         = "partial";
	            this.partialName  = partialName;
	            this.context      = context;
	        };
	
	        Handlebars.AST.BlockNode = function(mustache, program, inverse, close) {
	            var verifyMatch = function(open, close) {
	                if(open.original !== close.original) {
	                    throw new Handlebars.Exception(open.original + " doesn't match " + close.original);
	                }
	            };
	
	            verifyMatch(mustache.id, close);
	            this.type = "block";
	            this.mustache = mustache;
	            this.program  = program;
	            this.inverse  = inverse;
	
	            if (this.inverse && !this.program) {
	                this.isInverse = true;
	            }
	        };
	
	        Handlebars.AST.ContentNode = function(string) {
	            this.type = "content";
	            this.string = string;
	        };
	
	        Handlebars.AST.HashNode = function(pairs) {
	            this.type = "hash";
	            this.pairs = pairs;
	        };
	
	        Handlebars.AST.IdNode = function(parts) {
	            this.type = "ID";
	            this.original = parts.join(".");
	
	            var dig = [], depth = 0;
	
	            for(var i=0,l=parts.length; i<l; i++) {
	                var part = parts[i];
	
	                if (part === ".." || part === "." || part === "this") {
	                    if (dig.length > 0) { throw new Handlebars.Exception("Invalid path: " + this.original); }
	                    else if (part === "..") { depth++; }
	                    else { this.isScoped = true; }
	                }
	                else { dig.push(part); }
	            }
	
	            this.parts    = dig;
	            this.string   = dig.join('.');
	            this.depth    = depth;
	
	            // an ID is simple if it only has one part, and that part is not
	            // `..` or `this`.
	            this.isSimple = parts.length === 1 && !this.isScoped && depth === 0;
	
	            this.stringModeValue = this.string;
	        };
	
	        Handlebars.AST.PartialNameNode = function(name) {
	            this.type = "PARTIAL_NAME";
	            this.name = name;
	        };
	
	        Handlebars.AST.DataNode = function(id) {
	            this.type = "DATA";
	            this.id = id;
	        };
	
	        Handlebars.AST.StringNode = function(string) {
	            this.type = "STRING";
	            this.string = string;
	            this.stringModeValue = string;
	        };
	
	        Handlebars.AST.IntegerNode = function(integer) {
	            this.type = "INTEGER";
	            this.integer = integer;
	            this.stringModeValue = Number(integer);
	        };
	
	        Handlebars.AST.BooleanNode = function(bool) {
	            this.type = "BOOLEAN";
	            this.bool = bool;
	            this.stringModeValue = bool === "true";
	        };
	
	        Handlebars.AST.CommentNode = function(comment) {
	            this.type = "comment";
	            this.comment = comment;
	        };
	        ;
	    })();;
	// lib/handlebars/utils.js
	
	    var errorProps = ['description', 'fileName', 'lineNumber', 'message', 'name', 'number', 'stack'];
	
	    Handlebars.Exception = function(message) {
	        var tmp = Error.prototype.constructor.apply(this, arguments);
	
	        // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
	        for (var idx = 0; idx < errorProps.length; idx++) {
	            this[errorProps[idx]] = tmp[errorProps[idx]];
	        }
	    };
	    Handlebars.Exception.prototype = new Error();
	
	// Build out our basic SafeString type
	    Handlebars.SafeString = function(string) {
	        this.string = string;
	    };
	    Handlebars.SafeString.prototype.toString = function() {
	        return this.string.toString();
	    };
	
	    (function() {
	        var escape = {
	            "&": "&amp;",
	            "<": "&lt;",
	            ">": "&gt;",
	            '"': "&quot;",
	            "'": "&#x27;",
	            "`": "&#x60;"
	        };
	
	        var badChars = /[&<>"'`]/g;
	        var possible = /[&<>"'`]/;
	
	        var escapeChar = function(chr) {
	            return escape[chr] || "&amp;";
	        };
	
	        Handlebars.Utils = {
	            escapeExpression: function(string) {
	                // don't escape SafeStrings, since they're already safe
	                if (string instanceof Handlebars.SafeString) {
	                    return string.toString();
	                } else if (string == null || string === false) {
	                    return "";
	                }
	
	                if(!possible.test(string)) { return string; }
	                return string.replace(badChars, escapeChar);
	            },
	
	            isEmpty: function(value) {
	                if (!value && value !== 0) {
	                    return true;
	                } else if(Object.prototype.toString.call(value) === "[object Array]" && value.length === 0) {
	                    return true;
	                } else {
	                    return false;
	                }
	            }
	        };
	        ;
	    })();
	// lib/handlebars/compiler/compiler.js
	
	    /*jshint eqnull:true*/
	    Handlebars.Compiler = function() {};
	    Handlebars.JavaScriptCompiler = function() {};
	
	    (function(Compiler, JavaScriptCompiler) {
	// the foundHelper register will disambiguate helper lookup from finding a
	// function in a context. This is necessary for mustache compatibility, which
	// requires that context functions in blocks are evaluated by blockHelperMissing,
	// and then proceed as if the resulting value was provided to blockHelperMissing.
	
	        Compiler.prototype = {
	            compiler: Compiler,
	
	            disassemble: function() {
	                var opcodes = this.opcodes, opcode, out = [], params, param;
	
	                for (var i=0, l=opcodes.length; i<l; i++) {
	                    opcode = opcodes[i];
	
	                    if (opcode.opcode === 'DECLARE') {
	                        out.push("DECLARE " + opcode.name + "=" + opcode.value);
	                    } else {
	                        params = [];
	                        for (var j=0; j<opcode.args.length; j++) {
	                            param = opcode.args[j];
	                            if (typeof param === "string") {
	                                param = "\"" + param.replace("\n", "\\n") + "\"";
	                            }
	                            params.push(param);
	                        }
	                        out.push(opcode.opcode + " " + params.join(" "));
	                    }
	                }
	
	                return out.join("\n");
	            },
	            equals: function(other) {
	                var len = this.opcodes.length;
	                if (other.opcodes.length !== len) {
	                    return false;
	                }
	
	                for (var i = 0; i < len; i++) {
	                    var opcode = this.opcodes[i],
	                        otherOpcode = other.opcodes[i];
	                    if (opcode.opcode !== otherOpcode.opcode || opcode.args.length !== otherOpcode.args.length) {
	                        return false;
	                    }
	                    for (var j = 0; j < opcode.args.length; j++) {
	                        if (opcode.args[j] !== otherOpcode.args[j]) {
	                            return false;
	                        }
	                    }
	                }
	
	                len = this.children.length;
	                if (other.children.length !== len) {
	                    return false;
	                }
	                for (i = 0; i < len; i++) {
	                    if (!this.children[i].equals(other.children[i])) {
	                        return false;
	                    }
	                }
	
	                return true;
	            },
	
	            guid: 0,
	
	            compile: function(program, options) {
	                this.children = [];
	                this.depths = {list: []};
	                this.options = options;
	
	                // These changes will propagate to the other compiler components
	                var knownHelpers = this.options.knownHelpers;
	                this.options.knownHelpers = {
	                    'helperMissing': true,
	                    'blockHelperMissing': true,
	                    'each': true,
	                    'if': true,
	                    'unless': true,
	                    'with': true,
	                    'log': true
	                };
	                if (knownHelpers) {
	                    for (var name in knownHelpers) {
	                        this.options.knownHelpers[name] = knownHelpers[name];
	                    }
	                }
	
	                return this.program(program);
	            },
	
	            accept: function(node) {
	                return this[node.type](node);
	            },
	
	            program: function(program) {
	                var statements = program.statements, statement;
	                this.opcodes = [];
	
	                for(var i=0, l=statements.length; i<l; i++) {
	                    statement = statements[i];
	                    this[statement.type](statement);
	                }
	                this.isSimple = l === 1;
	
	                this.depths.list = this.depths.list.sort(function(a, b) {
	                    return a - b;
	                });
	
	                return this;
	            },
	
	            compileProgram: function(program) {
	                var result = new this.compiler().compile(program, this.options);
	                var guid = this.guid++, depth;
	
	                this.usePartial = this.usePartial || result.usePartial;
	
	                this.children[guid] = result;
	
	                for(var i=0, l=result.depths.list.length; i<l; i++) {
	                    depth = result.depths.list[i];
	
	                    if(depth < 2) { continue; }
	                    else { this.addDepth(depth - 1); }
	                }
	
	                return guid;
	            },
	
	            block: function(block) {
	                var mustache = block.mustache,
	                    program = block.program,
	                    inverse = block.inverse;
	
	                if (program) {
	                    program = this.compileProgram(program);
	                }
	
	                if (inverse) {
	                    inverse = this.compileProgram(inverse);
	                }
	
	                var type = this.classifyMustache(mustache);
	
	                if (type === "helper") {
	                    this.helperMustache(mustache, program, inverse);
	                } else if (type === "simple") {
	                    this.simpleMustache(mustache);
	
	                    // now that the simple mustache is resolved, we need to
	                    // evaluate it by executing `blockHelperMissing`
	                    this.opcode('pushProgram', program);
	                    this.opcode('pushProgram', inverse);
	                    this.opcode('emptyHash');
	                    this.opcode('blockValue');
	                } else {
	                    this.ambiguousMustache(mustache, program, inverse);
	
	                    // now that the simple mustache is resolved, we need to
	                    // evaluate it by executing `blockHelperMissing`
	                    this.opcode('pushProgram', program);
	                    this.opcode('pushProgram', inverse);
	                    this.opcode('emptyHash');
	                    this.opcode('ambiguousBlockValue');
	                }
	
	                this.opcode('append');
	            },
	
	            hash: function(hash) {
	                var pairs = hash.pairs, pair, val;
	
	                this.opcode('pushHash');
	
	                for(var i=0, l=pairs.length; i<l; i++) {
	                    pair = pairs[i];
	                    val  = pair[1];
	
	                    if (this.options.stringParams) {
	                        this.opcode('pushStringParam', val.stringModeValue, val.type);
	                    } else {
	                        this.accept(val);
	                    }
	
	                    this.opcode('assignToHash', pair[0]);
	                }
	                this.opcode('popHash');
	            },
	
	            partial: function(partial) {
	                var partialName = partial.partialName;
	                this.usePartial = true;
	
	                if(partial.context) {
	                    this.ID(partial.context);
	                } else {
	                    this.opcode('push', 'depth0');
	                }
	
	                this.opcode('invokePartial', partialName.name);
	                this.opcode('append');
	            },
	
	            content: function(content) {
	                this.opcode('appendContent', content.string);
	            },
	
	            mustache: function(mustache) {
	                var options = this.options;
	                var type = this.classifyMustache(mustache);
	
	                if (type === "simple") {
	                    this.simpleMustache(mustache);
	                } else if (type === "helper") {
	                    this.helperMustache(mustache);
	                } else {
	                    this.ambiguousMustache(mustache);
	                }
	
	                if(mustache.escaped && !options.noEscape) {
	                    this.opcode('appendEscaped');
	                } else {
	                    this.opcode('append');
	                }
	            },
	
	            ambiguousMustache: function(mustache, program, inverse) {
	                var id = mustache.id,
	                    name = id.parts[0],
	                    isBlock = program != null || inverse != null;
	
	                this.opcode('getContext', id.depth);
	
	                this.opcode('pushProgram', program);
	                this.opcode('pushProgram', inverse);
	
	                this.opcode('invokeAmbiguous', name, isBlock);
	            },
	
	            simpleMustache: function(mustache) {
	                var id = mustache.id;
	
	                if (id.type === 'DATA') {
	                    this.DATA(id);
	                } else if (id.parts.length) {
	                    this.ID(id);
	                } else {
	                    // Simplified ID for `this`
	                    this.addDepth(id.depth);
	                    this.opcode('getContext', id.depth);
	                    this.opcode('pushContext');
	                }
	
	                this.opcode('resolvePossibleLambda');
	            },
	
	            helperMustache: function(mustache, program, inverse) {
	                var params = this.setupFullMustacheParams(mustache, program, inverse),
	                    name = mustache.id.parts[0];
	
	                if (this.options.knownHelpers[name]) {
	                    this.opcode('invokeKnownHelper', params.length, name);
	                } else if (this.knownHelpersOnly) {
	                    throw new Error("You specified knownHelpersOnly, but used the unknown helper " + name);
	                } else {
	                    this.opcode('invokeHelper', params.length, name);
	                }
	            },
	
	            ID: function(id) {
	                this.addDepth(id.depth);
	                this.opcode('getContext', id.depth);
	
	                var name = id.parts[0];
	                if (!name) {
	                    this.opcode('pushContext');
	                } else {
	                    this.opcode('lookupOnContext', id.parts[0]);
	                }
	
	                for(var i=1, l=id.parts.length; i<l; i++) {
	                    this.opcode('lookup', id.parts[i]);
	                }
	            },
	
	            DATA: function(data) {
	                this.options.data = true;
	                this.opcode('lookupData', data.id);
	            },
	
	            STRING: function(string) {
	                this.opcode('pushString', string.string);
	            },
	
	            INTEGER: function(integer) {
	                this.opcode('pushLiteral', integer.integer);
	            },
	
	            BOOLEAN: function(bool) {
	                this.opcode('pushLiteral', bool.bool);
	            },
	
	            comment: function() {},
	
	            // HELPERS
	            opcode: function(name) {
	                this.opcodes.push({ opcode: name, args: [].slice.call(arguments, 1) });
	            },
	
	            declare: function(name, value) {
	                this.opcodes.push({ opcode: 'DECLARE', name: name, value: value });
	            },
	
	            addDepth: function(depth) {
	                if(isNaN(depth)) { throw new Error("EWOT"); }
	                if(depth === 0) { return; }
	
	                if(!this.depths[depth]) {
	                    this.depths[depth] = true;
	                    this.depths.list.push(depth);
	                }
	            },
	
	            classifyMustache: function(mustache) {
	                var isHelper   = mustache.isHelper;
	                var isEligible = mustache.eligibleHelper;
	                var options    = this.options;
	
	                // if ambiguous, we can possibly resolve the ambiguity now
	                if (isEligible && !isHelper) {
	                    var name = mustache.id.parts[0];
	
	                    if (options.knownHelpers[name]) {
	                        isHelper = true;
	                    } else if (options.knownHelpersOnly) {
	                        isEligible = false;
	                    }
	                }
	
	                if (isHelper) { return "helper"; }
	                else if (isEligible) { return "ambiguous"; }
	                else { return "simple"; }
	            },
	
	            pushParams: function(params) {
	                var i = params.length, param;
	
	                while(i--) {
	                    param = params[i];
	
	                    if(this.options.stringParams) {
	                        if(param.depth) {
	                            this.addDepth(param.depth);
	                        }
	
	                        this.opcode('getContext', param.depth || 0);
	                        this.opcode('pushStringParam', param.stringModeValue, param.type);
	                    } else {
	                        this[param.type](param);
	                    }
	                }
	            },
	
	            setupMustacheParams: function(mustache) {
	                var params = mustache.params;
	                this.pushParams(params);
	
	                if(mustache.hash) {
	                    this.hash(mustache.hash);
	                } else {
	                    this.opcode('emptyHash');
	                }
	
	                return params;
	            },
	
	            // this will replace setupMustacheParams when we're done
	            setupFullMustacheParams: function(mustache, program, inverse) {
	                var params = mustache.params;
	                this.pushParams(params);
	
	                this.opcode('pushProgram', program);
	                this.opcode('pushProgram', inverse);
	
	                if(mustache.hash) {
	                    this.hash(mustache.hash);
	                } else {
	                    this.opcode('emptyHash');
	                }
	
	                return params;
	            }
	        };
	
	        var Literal = function(value) {
	            this.value = value;
	        };
	
	        JavaScriptCompiler.prototype = {
	            // PUBLIC API: You can override these methods in a subclass to provide
	            // alternative compiled forms for name lookup and buffering semantics
	            nameLookup: function(parent, name /* , type*/) {
	                if (/^[0-9]+$/.test(name)) {
	                    return parent + "[" + name + "]";
	                } else if (JavaScriptCompiler.isValidJavaScriptVariableName(name)) {
	                    return parent + "." + name;
	                }
	                else {
	                    return parent + "['" + name + "']";
	                }
	            },
	
	            appendToBuffer: function(string) {
	                if (this.environment.isSimple) {
	                    return "return " + string + ";";
	                } else {
	                    return {
	                        appendToBuffer: true,
	                        content: string,
	                        toString: function() { return "buffer += " + string + ";"; }
	                    };
	                }
	            },
	
	            initializeBuffer: function() {
	                return this.quotedString("");
	            },
	
	            namespace: "Handlebars",
	            // END PUBLIC API
	
	            compile: function(environment, options, context, asObject) {
	                this.environment = environment;
	                this.options = options || {};
	
	                Handlebars.log(Handlebars.logger.DEBUG, this.environment.disassemble() + "\n\n");
	
	                this.name = this.environment.name;
	                this.isChild = !!context;
	                this.context = context || {
	                    programs: [],
	                    environments: [],
	                    aliases: { }
	                };
	
	                this.preamble();
	
	                this.stackSlot = 0;
	                this.stackVars = [];
	                this.registers = { list: [] };
	                this.compileStack = [];
	                this.inlineStack = [];
	
	                this.compileChildren(environment, options);
	
	                var opcodes = environment.opcodes, opcode;
	
	                this.i = 0;
	
	                for(l=opcodes.length; this.i<l; this.i++) {
	                    opcode = opcodes[this.i];
	
	                    if(opcode.opcode === 'DECLARE') {
	                        this[opcode.name] = opcode.value;
	                    } else {
	                        this[opcode.opcode].apply(this, opcode.args);
	                    }
	                }
	
	                return this.createFunctionContext(asObject);
	            },
	
	            nextOpcode: function() {
	                var opcodes = this.environment.opcodes;
	                return opcodes[this.i + 1];
	            },
	
	            eat: function() {
	                this.i = this.i + 1;
	            },
	
	            preamble: function() {
	                var out = [];
	
	                if (!this.isChild) {
	                    var namespace = this.namespace;
	                    var copies = "helpers = helpers || " + namespace + ".helpers;";
	                    if (this.environment.usePartial) { copies = copies + " partials = partials || " + namespace + ".partials;"; }
	                    if (this.options.data) { copies = copies + " data = data || {};"; }
	                    out.push(copies);
	                } else {
	                    out.push('');
	                }
	
	                if (!this.environment.isSimple) {
	                    out.push(", buffer = " + this.initializeBuffer());
	                } else {
	                    out.push("");
	                }
	
	                // track the last context pushed into place to allow skipping the
	                // getContext opcode when it would be a noop
	                this.lastContext = 0;
	                this.source = out;
	            },
	
	            createFunctionContext: function(asObject) {
	                var locals = this.stackVars.concat(this.registers.list);
	
	                if(locals.length > 0) {
	                    this.source[1] = this.source[1] + ", " + locals.join(", ");
	                }
	
	                // Generate minimizer alias mappings
	                if (!this.isChild) {
	                    for (var alias in this.context.aliases) {
	                        this.source[1] = this.source[1] + ', ' + alias + '=' + this.context.aliases[alias];
	                    }
	                }
	
	                if (this.source[1]) {
	                    this.source[1] = "var " + this.source[1].substring(2) + ";";
	                }
	
	                // Merge children
	                if (!this.isChild) {
	                    this.source[1] += '\n' + this.context.programs.join('\n') + '\n';
	                }
	
	                if (!this.environment.isSimple) {
	                    this.source.push("return buffer;");
	                }
	
	                var params = this.isChild ? ["depth0", "data"] : ["Handlebars", "depth0", "helpers", "partials", "data"];
	
	                for(var i=0, l=this.environment.depths.list.length; i<l; i++) {
	                    params.push("depth" + this.environment.depths.list[i]);
	                }
	
	                // Perform a second pass over the output to merge content when possible
	                var source = this.mergeSource();
	
	                if (!this.isChild) {
	                    var revision = Handlebars.COMPILER_REVISION,
	                        versions = Handlebars.REVISION_CHANGES[revision];
	                    source = "this.compilerInfo = ["+revision+",'"+versions+"'];\n"+source;
	                }
	
	                if (asObject) {
	                    params.push(source);
	
	                    return Function.apply(this, params);
	                } else {
	                    var functionSource = 'function ' + (this.name || '') + '(' + params.join(',') + ') {\n  ' + source + '}';
	                    Handlebars.log(Handlebars.logger.DEBUG, functionSource + "\n\n");
	                    return functionSource;
	                }
	            },
	            mergeSource: function() {
	                // WARN: We are not handling the case where buffer is still populated as the source should
	                // not have buffer append operations as their final action.
	                var source = '',
	                    buffer;
	                for (var i = 0, len = this.source.length; i < len; i++) {
	                    var line = this.source[i];
	                    if (line.appendToBuffer) {
	                        if (buffer) {
	                            buffer = buffer + '\n    + ' + line.content;
	                        } else {
	                            buffer = line.content;
	                        }
	                    } else {
	                        if (buffer) {
	                            source += 'buffer += ' + buffer + ';\n  ';
	                            buffer = undefined;
	                        }
	                        source += line + '\n  ';
	                    }
	                }
	                return source;
	            },
	
	            // [blockValue]
	            //
	            // On stack, before: hash, inverse, program, value
	            // On stack, after: return value of blockHelperMissing
	            //
	            // The purpose of this opcode is to take a block of the form
	            // `{{#foo}}...{{/foo}}`, resolve the value of `foo`, and
	            // replace it on the stack with the result of properly
	            // invoking blockHelperMissing.
	            blockValue: function() {
	                this.context.aliases.blockHelperMissing = 'helpers.blockHelperMissing';
	
	                var params = ["depth0"];
	                this.setupParams(0, params);
	
	                this.replaceStack(function(current) {
	                    params.splice(1, 0, current);
	                    return "blockHelperMissing.call(" + params.join(", ") + ")";
	                });
	            },
	
	            // [ambiguousBlockValue]
	            //
	            // On stack, before: hash, inverse, program, value
	            // Compiler value, before: lastHelper=value of last found helper, if any
	            // On stack, after, if no lastHelper: same as [blockValue]
	            // On stack, after, if lastHelper: value
	            ambiguousBlockValue: function() {
	                this.context.aliases.blockHelperMissing = 'helpers.blockHelperMissing';
	
	                var params = ["depth0"];
	                this.setupParams(0, params);
	
	                var current = this.topStack();
	                params.splice(1, 0, current);
	
	                // Use the options value generated from the invocation
	                params[params.length-1] = 'options';
	
	                this.source.push("if (!" + this.lastHelper + ") { " + current + " = blockHelperMissing.call(" + params.join(", ") + "); }");
	            },
	
	            // [appendContent]
	            //
	            // On stack, before: ...
	            // On stack, after: ...
	            //
	            // Appends the string value of `content` to the current buffer
	            appendContent: function(content) {
	                this.source.push(this.appendToBuffer(this.quotedString(content)));
	            },
	
	            // [append]
	            //
	            // On stack, before: value, ...
	            // On stack, after: ...
	            //
	            // Coerces `value` to a String and appends it to the current buffer.
	            //
	            // If `value` is truthy, or 0, it is coerced into a string and appended
	            // Otherwise, the empty string is appended
	            append: function() {
	                // Force anything that is inlined onto the stack so we don't have duplication
	                // when we examine local
	                this.flushInline();
	                var local = this.popStack();
	                this.source.push("if(" + local + " || " + local + " === 0) { " + this.appendToBuffer(local) + " }");
	                if (this.environment.isSimple) {
	                    this.source.push("else { " + this.appendToBuffer("''") + " }");
	                }
	            },
	
	            // [appendEscaped]
	            //
	            // On stack, before: value, ...
	            // On stack, after: ...
	            //
	            // Escape `value` and append it to the buffer
	            appendEscaped: function() {
	                this.context.aliases.escapeExpression = 'this.escapeExpression';
	
	                this.source.push(this.appendToBuffer("escapeExpression(" + this.popStack() + ")"));
	            },
	
	            // [getContext]
	            //
	            // On stack, before: ...
	            // On stack, after: ...
	            // Compiler value, after: lastContext=depth
	            //
	            // Set the value of the `lastContext` compiler value to the depth
	            getContext: function(depth) {
	                if(this.lastContext !== depth) {
	                    this.lastContext = depth;
	                }
	            },
	
	            // [lookupOnContext]
	            //
	            // On stack, before: ...
	            // On stack, after: currentContext[name], ...
	            //
	            // Looks up the value of `name` on the current context and pushes
	            // it onto the stack.
	            lookupOnContext: function(name) {
	                this.push(this.nameLookup('depth' + this.lastContext, name, 'context'));
	            },
	
	            // [pushContext]
	            //
	            // On stack, before: ...
	            // On stack, after: currentContext, ...
	            //
	            // Pushes the value of the current context onto the stack.
	            pushContext: function() {
	                this.pushStackLiteral('depth' + this.lastContext);
	            },
	
	            // [resolvePossibleLambda]
	            //
	            // On stack, before: value, ...
	            // On stack, after: resolved value, ...
	            //
	            // If the `value` is a lambda, replace it on the stack by
	            // the return value of the lambda
	            resolvePossibleLambda: function() {
	                this.context.aliases.functionType = '"function"';
	
	                this.replaceStack(function(current) {
	                    return "typeof " + current + " === functionType ? " + current + ".apply(depth0) : " + current;
	                });
	            },
	
	            // [lookup]
	            //
	            // On stack, before: value, ...
	            // On stack, after: value[name], ...
	            //
	            // Replace the value on the stack with the result of looking
	            // up `name` on `value`
	            lookup: function(name) {
	                this.replaceStack(function(current) {
	                    return current + " == null || " + current + " === false ? " + current + " : " + this.nameLookup(current, name, 'context');
	                });
	            },
	
	            // [lookupData]
	            //
	            // On stack, before: ...
	            // On stack, after: data[id], ...
	            //
	            // Push the result of looking up `id` on the current data
	            lookupData: function(id) {
	                this.push(this.nameLookup('data', id, 'data'));
	            },
	
	            // [pushStringParam]
	            //
	            // On stack, before: ...
	            // On stack, after: string, currentContext, ...
	            //
	            // This opcode is designed for use in string mode, which
	            // provides the string value of a parameter along with its
	            // depth rather than resolving it immediately.
	            pushStringParam: function(string, type) {
	                this.pushStackLiteral('depth' + this.lastContext);
	
	                this.pushString(type);
	
	                if (typeof string === 'string') {
	                    this.pushString(string);
	                } else {
	                    this.pushStackLiteral(string);
	                }
	            },
	
	            emptyHash: function() {
	                this.pushStackLiteral('{}');
	
	                if (this.options.stringParams) {
	                    this.register('hashTypes', '{}');
	                }
	            },
	            pushHash: function() {
	                this.hash = {values: [], types: []};
	            },
	            popHash: function() {
	                var hash = this.hash;
	                this.hash = undefined;
	
	                if (this.options.stringParams) {
	                    this.register('hashTypes', '{' + hash.types.join(',') + '}');
	                }
	                this.push('{\n    ' + hash.values.join(',\n    ') + '\n  }');
	            },
	
	            // [pushString]
	            //
	            // On stack, before: ...
	            // On stack, after: quotedString(string), ...
	            //
	            // Push a quoted version of `string` onto the stack
	            pushString: function(string) {
	                this.pushStackLiteral(this.quotedString(string));
	            },
	
	            // [push]
	            //
	            // On stack, before: ...
	            // On stack, after: expr, ...
	            //
	            // Push an expression onto the stack
	            push: function(expr) {
	                this.inlineStack.push(expr);
	                return expr;
	            },
	
	            // [pushLiteral]
	            //
	            // On stack, before: ...
	            // On stack, after: value, ...
	            //
	            // Pushes a value onto the stack. This operation prevents
	            // the compiler from creating a temporary variable to hold
	            // it.
	            pushLiteral: function(value) {
	                this.pushStackLiteral(value);
	            },
	
	            // [pushProgram]
	            //
	            // On stack, before: ...
	            // On stack, after: program(guid), ...
	            //
	            // Push a program expression onto the stack. This takes
	            // a compile-time guid and converts it into a runtime-accessible
	            // expression.
	            pushProgram: function(guid) {
	                if (guid != null) {
	                    this.pushStackLiteral(this.programExpression(guid));
	                } else {
	                    this.pushStackLiteral(null);
	                }
	            },
	
	            // [invokeHelper]
	            //
	            // On stack, before: hash, inverse, program, params..., ...
	            // On stack, after: result of helper invocation
	            //
	            // Pops off the helper's parameters, invokes the helper,
	            // and pushes the helper's return value onto the stack.
	            //
	            // If the helper is not found, `helperMissing` is called.
	            invokeHelper: function(paramSize, name) {
	                this.context.aliases.helperMissing = 'helpers.helperMissing';
	
	                var helper = this.lastHelper = this.setupHelper(paramSize, name, true);
	
	                this.push(helper.name);
	                this.replaceStack(function(name) {
	                    return name + ' ? ' + name + '.call(' +
	                        helper.callParams + ") " + ": helperMissing.call(" +
	                        helper.helperMissingParams + ")";
	                });
	            },
	
	            // [invokeKnownHelper]
	            //
	            // On stack, before: hash, inverse, program, params..., ...
	            // On stack, after: result of helper invocation
	            //
	            // This operation is used when the helper is known to exist,
	            // so a `helperMissing` fallback is not required.
	            invokeKnownHelper: function(paramSize, name) {
	                var helper = this.setupHelper(paramSize, name);
	                this.push(helper.name + ".call(" + helper.callParams + ")");
	            },
	
	            // [invokeAmbiguous]
	            //
	            // On stack, before: hash, inverse, program, params..., ...
	            // On stack, after: result of disambiguation
	            //
	            // This operation is used when an expression like `{{foo}}`
	            // is provided, but we don't know at compile-time whether it
	            // is a helper or a path.
	            //
	            // This operation emits more code than the other options,
	            // and can be avoided by passing the `knownHelpers` and
	            // `knownHelpersOnly` flags at compile-time.
	            invokeAmbiguous: function(name, helperCall) {
	                this.context.aliases.functionType = '"function"';
	
	                this.pushStackLiteral('{}');    // Hash value
	                var helper = this.setupHelper(0, name, helperCall);
	
	                var helperName = this.lastHelper = this.nameLookup('helpers', name, 'helper');
	
	                var nonHelper = this.nameLookup('depth' + this.lastContext, name, 'context');
	                var nextStack = this.nextStack();
	
	                this.source.push('if (' + nextStack + ' = ' + helperName + ') { ' + nextStack + ' = ' + nextStack + '.call(' + helper.callParams + '); }');
	                this.source.push('else { ' + nextStack + ' = ' + nonHelper + '; ' + nextStack + ' = typeof ' + nextStack + ' === functionType ? ' + nextStack + '.apply(depth0) : ' + nextStack + '; }');
	            },
	
	            // [invokePartial]
	            //
	            // On stack, before: context, ...
	            // On stack after: result of partial invocation
	            //
	            // This operation pops off a context, invokes a partial with that context,
	            // and pushes the result of the invocation back.
	            invokePartial: function(name) {
	                var params = [this.nameLookup('partials', name, 'partial'), "'" + name + "'", this.popStack(), "helpers", "partials"];
	
	                if (this.options.data) {
	                    params.push("data");
	                }
	
	                this.context.aliases.self = "this";
	                this.push("self.invokePartial(" + params.join(", ") + ")");
	            },
	
	            // [assignToHash]
	            //
	            // On stack, before: value, hash, ...
	            // On stack, after: hash, ...
	            //
	            // Pops a value and hash off the stack, assigns `hash[key] = value`
	            // and pushes the hash back onto the stack.
	            assignToHash: function(key) {
	                var value = this.popStack(),
	                    type;
	
	                if (this.options.stringParams) {
	                    type = this.popStack();
	                    this.popStack();
	                }
	
	                var hash = this.hash;
	                if (type) {
	                    hash.types.push("'" + key + "': " + type);
	                }
	                hash.values.push("'" + key + "': (" + value + ")");
	            },
	
	            // HELPERS
	
	            compiler: JavaScriptCompiler,
	
	            compileChildren: function(environment, options) {
	                var children = environment.children, child, compiler;
	
	                for(var i=0, l=children.length; i<l; i++) {
	                    child = children[i];
	                    compiler = new this.compiler();
	
	                    var index = this.matchExistingProgram(child);
	
	                    if (index == null) {
	                        this.context.programs.push('');     // Placeholder to prevent name conflicts for nested children
	                        index = this.context.programs.length;
	                        child.index = index;
	                        child.name = 'program' + index;
	                        this.context.programs[index] = compiler.compile(child, options, this.context);
	                        this.context.environments[index] = child;
	                    } else {
	                        child.index = index;
	                        child.name = 'program' + index;
	                    }
	                }
	            },
	            matchExistingProgram: function(child) {
	                for (var i = 0, len = this.context.environments.length; i < len; i++) {
	                    var environment = this.context.environments[i];
	                    if (environment && environment.equals(child)) {
	                        return i;
	                    }
	                }
	            },
	
	            programExpression: function(guid) {
	                this.context.aliases.self = "this";
	
	                if(guid == null) {
	                    return "self.noop";
	                }
	
	                var child = this.environment.children[guid],
	                    depths = child.depths.list, depth;
	
	                var programParams = [child.index, child.name, "data"];
	
	                for(var i=0, l = depths.length; i<l; i++) {
	                    depth = depths[i];
	
	                    if(depth === 1) { programParams.push("depth0"); }
	                    else { programParams.push("depth" + (depth - 1)); }
	                }
	
	                if(depths.length === 0) {
	                    return "self.program(" + programParams.join(", ") + ")";
	                } else {
	                    programParams.shift();
	                    return "self.programWithDepth(" + programParams.join(", ") + ")";
	                }
	            },
	
	            register: function(name, val) {
	                this.useRegister(name);
	                this.source.push(name + " = " + val + ";");
	            },
	
	            useRegister: function(name) {
	                if(!this.registers[name]) {
	                    this.registers[name] = true;
	                    this.registers.list.push(name);
	                }
	            },
	
	            pushStackLiteral: function(item) {
	                return this.push(new Literal(item));
	            },
	
	            pushStack: function(item) {
	                this.flushInline();
	
	                var stack = this.incrStack();
	                if (item) {
	                    this.source.push(stack + " = " + item + ";");
	                }
	                this.compileStack.push(stack);
	                return stack;
	            },
	
	            replaceStack: function(callback) {
	                var prefix = '',
	                    inline = this.isInline(),
	                    stack;
	
	                // If we are currently inline then we want to merge the inline statement into the
	                // replacement statement via ','
	                if (inline) {
	                    var top = this.popStack(true);
	
	                    if (top instanceof Literal) {
	                        // Literals do not need to be inlined
	                        stack = top.value;
	                    } else {
	                        // Get or create the current stack name for use by the inline
	                        var name = this.stackSlot ? this.topStackName() : this.incrStack();
	
	                        prefix = '(' + this.push(name) + ' = ' + top + '),';
	                        stack = this.topStack();
	                    }
	                } else {
	                    stack = this.topStack();
	                }
	
	                var item = callback.call(this, stack);
	
	                if (inline) {
	                    if (this.inlineStack.length || this.compileStack.length) {
	                        this.popStack();
	                    }
	                    this.push('(' + prefix + item + ')');
	                } else {
	                    // Prevent modification of the context depth variable. Through replaceStack
	                    if (!/^stack/.test(stack)) {
	                        stack = this.nextStack();
	                    }
	
	                    this.source.push(stack + " = (" + prefix + item + ");");
	                }
	                return stack;
	            },
	
	            nextStack: function() {
	                return this.pushStack();
	            },
	
	            incrStack: function() {
	                this.stackSlot++;
	                if(this.stackSlot > this.stackVars.length) { this.stackVars.push("stack" + this.stackSlot); }
	                return this.topStackName();
	            },
	            topStackName: function() {
	                return "stack" + this.stackSlot;
	            },
	            flushInline: function() {
	                var inlineStack = this.inlineStack;
	                if (inlineStack.length) {
	                    this.inlineStack = [];
	                    for (var i = 0, len = inlineStack.length; i < len; i++) {
	                        var entry = inlineStack[i];
	                        if (entry instanceof Literal) {
	                            this.compileStack.push(entry);
	                        } else {
	                            this.pushStack(entry);
	                        }
	                    }
	                }
	            },
	            isInline: function() {
	                return this.inlineStack.length;
	            },
	
	            popStack: function(wrapped) {
	                var inline = this.isInline(),
	                    item = (inline ? this.inlineStack : this.compileStack).pop();
	
	                if (!wrapped && (item instanceof Literal)) {
	                    return item.value;
	                } else {
	                    if (!inline) {
	                        this.stackSlot--;
	                    }
	                    return item;
	                }
	            },
	
	            topStack: function(wrapped) {
	                var stack = (this.isInline() ? this.inlineStack : this.compileStack),
	                    item = stack[stack.length - 1];
	
	                if (!wrapped && (item instanceof Literal)) {
	                    return item.value;
	                } else {
	                    return item;
	                }
	            },
	
	            quotedString: function(str) {
	                return '"' + str
	                    .replace(/\\/g, '\\\\')
	                    .replace(/"/g, '\\"')
	                    .replace(/\n/g, '\\n')
	                    .replace(/\r/g, '\\r') + '"';
	            },
	
	            setupHelper: function(paramSize, name, missingParams) {
	                var params = [];
	                this.setupParams(paramSize, params, missingParams);
	                var foundHelper = this.nameLookup('helpers', name, 'helper');
	
	                return {
	                    params: params,
	                    name: foundHelper,
	                    callParams: ["depth0"].concat(params).join(", "),
	                    helperMissingParams: missingParams && ["depth0", this.quotedString(name)].concat(params).join(", ")
	                };
	            },
	
	            // the params and contexts arguments are passed in arrays
	            // to fill in
	            setupParams: function(paramSize, params, useRegister) {
	                var options = [], contexts = [], types = [], param, inverse, program;
	
	                options.push("hash:" + this.popStack());
	
	                inverse = this.popStack();
	                program = this.popStack();
	
	                // Avoid setting fn and inverse if neither are set. This allows
	                // helpers to do a check for `if (options.fn)`
	                if (program || inverse) {
	                    if (!program) {
	                        this.context.aliases.self = "this";
	                        program = "self.noop";
	                    }
	
	                    if (!inverse) {
	                        this.context.aliases.self = "this";
	                        inverse = "self.noop";
	                    }
	
	                    options.push("inverse:" + inverse);
	                    options.push("fn:" + program);
	                }
	
	                for(var i=0; i<paramSize; i++) {
	                    param = this.popStack();
	                    params.push(param);
	
	                    if(this.options.stringParams) {
	                        types.push(this.popStack());
	                        contexts.push(this.popStack());
	                    }
	                }
	
	                if (this.options.stringParams) {
	                    options.push("contexts:[" + contexts.join(",") + "]");
	                    options.push("types:[" + types.join(",") + "]");
	                    options.push("hashTypes:hashTypes");
	                }
	
	                if(this.options.data) {
	                    options.push("data:data");
	                }
	
	                options = "{" + options.join(",") + "}";
	                if (useRegister) {
	                    this.register('options', options);
	                    params.push('options');
	                } else {
	                    params.push(options);
	                }
	                return params.join(", ");
	            }
	        };
	
	        var reservedWords = (
	            "break else new var" +
	                " case finally return void" +
	                " catch for switch while" +
	                " continue function this with" +
	                " default if throw" +
	                " delete in try" +
	                " do instanceof typeof" +
	                " abstract enum int short" +
	                " boolean export interface static" +
	                " byte extends long super" +
	                " char final native synchronized" +
	                " class float package throws" +
	                " const goto private transient" +
	                " debugger implements protected volatile" +
	                " double import public let yield"
	            ).split(" ");
	
	        var compilerWords = JavaScriptCompiler.RESERVED_WORDS = {};
	
	        for(var i=0, l=reservedWords.length; i<l; i++) {
	            compilerWords[reservedWords[i]] = true;
	        }
	
	        JavaScriptCompiler.isValidJavaScriptVariableName = function(name) {
	            if(!JavaScriptCompiler.RESERVED_WORDS[name] && /^[a-zA-Z_$][0-9a-zA-Z_$]+$/.test(name)) {
	                return true;
	            }
	            return false;
	        };
	
	        Handlebars.precompile = function(input, options) {
	            if (!input || (typeof input !== 'string' && input.constructor !== Handlebars.AST.ProgramNode)) {
	                throw new Handlebars.Exception("You must pass a string or Handlebars AST to Handlebars.precompile. You passed " + input);
	            }
	
	            options = options || {};
	            if (!('data' in options)) {
	                options.data = true;
	            }
	            var ast = Handlebars.parse(input);
	            var environment = new Compiler().compile(ast, options);
	            return new JavaScriptCompiler().compile(environment, options);
	        };
	
	        Handlebars.compile = function(input, options) {
	            if (!input || (typeof input !== 'string' && input.constructor !== Handlebars.AST.ProgramNode)) {
	                throw new Handlebars.Exception("You must pass a string or Handlebars AST to Handlebars.compile. You passed " + input);
	            }
	
	            options = options || {};
	            if (!('data' in options)) {
	                options.data = true;
	            }
	            var compiled;
	            function compile() {
	                var ast = Handlebars.parse(input);
	                var environment = new Compiler().compile(ast, options);
	                var templateSpec = new JavaScriptCompiler().compile(environment, options, undefined, true);
	                return Handlebars.template(templateSpec);
	            }
	
	            // Template is only compiled on first use and cached after that point.
	            return function(context, options) {
	                if (!compiled) {
	                    compiled = compile();
	                }
	                return compiled.call(this, context, options);
	            };
	        };
	
	        ;
	// lib/handlebars/runtime.js
	
	        Handlebars.VM = {
	            template: function(templateSpec) {
	                // Just add water
	                var container = {
	                    escapeExpression: Handlebars.Utils.escapeExpression,
	                    invokePartial: Handlebars.VM.invokePartial,
	                    programs: [],
	                    program: function(i, fn, data) {
	                        var programWrapper = this.programs[i];
	                        if(data) {
	                            return Handlebars.VM.program(fn, data);
	                        } else if(programWrapper) {
	                            return programWrapper;
	                        } else {
	                            programWrapper = this.programs[i] = Handlebars.VM.program(fn);
	                            return programWrapper;
	                        }
	                    },
	                    programWithDepth: Handlebars.VM.programWithDepth,
	                    noop: Handlebars.VM.noop,
	                    compilerInfo: null
	                };
	
	                return function(context, options) {
	                    options = options || {};
	                    var result = templateSpec.call(container, Handlebars, context, options.helpers, options.partials, options.data);
	
	                    var compilerInfo = container.compilerInfo || [],
	                        compilerRevision = compilerInfo[0] || 1,
	                        currentRevision = Handlebars.COMPILER_REVISION;
	
	                    if (compilerRevision !== currentRevision) {
	                        if (compilerRevision < currentRevision) {
	                            var runtimeVersions = Handlebars.REVISION_CHANGES[currentRevision],
	                                compilerVersions = Handlebars.REVISION_CHANGES[compilerRevision];
	                            throw "Template was precompiled with an older version of Handlebars than the current runtime. "+
	                                "Please update your precompiler to a newer version ("+runtimeVersions+") or downgrade your runtime to an older version ("+compilerVersions+").";
	                        } else {
	                            // Use the embedded version info since the runtime doesn't know about this revision yet
	                            throw "Template was precompiled with a newer version of Handlebars than the current runtime. "+
	                                "Please update your runtime to a newer version ("+compilerInfo[1]+").";
	                        }
	                    }
	
	                    return result;
	                };
	            },
	
	            programWithDepth: function(fn, data, $depth) {
	                var args = Array.prototype.slice.call(arguments, 2);
	
	                return function(context, options) {
	                    options = options || {};
	
	                    return fn.apply(this, [context, options.data || data].concat(args));
	                };
	            },
	            program: function(fn, data) {
	                return function(context, options) {
	                    options = options || {};
	
	                    return fn(context, options.data || data);
	                };
	            },
	            noop: function() { return ""; },
	            invokePartial: function(partial, name, context, helpers, partials, data) {
	                var options = { helpers: helpers, partials: partials, data: data };
	
	                if(partial === undefined) {
	                    throw new Handlebars.Exception("The partial " + name + " could not be found");
	                } else if(partial instanceof Function) {
	                    return partial(context, options);
	                } else if (!Handlebars.compile) {
	                    throw new Handlebars.Exception("The partial " + name + " could not be compiled when running in runtime-only mode");
	                } else {
	                    partials[name] = Handlebars.compile(partial, {data: data !== undefined});
	                    return partials[name](context, options);
	                }
	            }
	        };
	
	        Handlebars.template = Handlebars.VM.template;
	        ;
	// lib/handlebars/browser-suffix.js
	    })(Handlebars.Compiler, Handlebars.JavaScriptCompiler);
	    ;
	
	// AMD Define
	    define('handlebars',[],function(){
	        return Handlebars;
	    });
	
	})();
	/**
	 * @license Handlebars hbs 0.4.0 - Alex Sexton, but Handlebars has it's own licensing junk
	 *
	 * Available via the MIT or new BSD license.
	 * see: http://github.com/jrburke/require-cs for details on the plugin this was based off of
	 */
	
	define('hbs',['module'
	], function (module
	) {
	
	    return {
	                version: '0.5.0',
	        load: function (name, req, onload, config) {
	                    }
	    };
	});
	// todo this won't actually require the properties files you want
	// they have to be loaded in advance by some js, this works okay as an
	// initial version, but at some point the handlebars loader should probably
	// be modified to be able to require()
	
	define('galileo/tile/template/helpers/i18n-namespace',['require','handlebars','underscore','i18n/i18n'],function(require) {
	    var Handlebars = require("handlebars");
	    var _ = require("underscore");
	    var i18nConstructor = require('i18n/i18n');
	
	    function i18nNamespaceHandler(namespace, options) {
	        var args = _.toArray(arguments);
	        options = _.last(args);
	
	        var namespaces = _.initial(args);
	
	        if(this._i18n) {
	            var inherited = _.pluck(this._i18n.getNamespaces(), 'namespace');
	            namespaces = _.uniq(namespaces.concat(inherited));
	        }
	
	        var fullNamespaces = _.map(namespaces, function(namespace) {
	            // as this implies: all i18n assets in templates need to be gotten as dependencies before the template is
	            // rendered, hbs loader does this and therefore these modules will exist, if you do not load beforehand
	            // you should get a nasty error.
	            return require('i18n-load!' + namespace.replace(/\./g, '/'));
	        });
	
	        var copy = _.clone(this);
	
	        copy._i18n = new i18nConstructor(fullNamespaces);
	
	        return options.fn(copy);
	    }
	
	    Handlebars.registerHelper("i18n-namespace", i18nNamespaceHandler);
	
	    return i18nNamespaceHandler;
	});
	
	define('galileo/tile/template/helpers/i18n',['require','handlebars','underscore'],function(require) {
	    var Handlebars = require("handlebars");
	    var _ = require('underscore');
	
	    function i18nHelper(key) {
	        var args = _.initial(arguments);
	        var i18n = this._i18n;
	
	        if(!i18n) {
	            throw new Error('you must supply namespaces to the context using i18n-namespace in the current context');
	        }
	
	        return i18n.apply(i18n, args);
	    }
	
	    Handlebars.registerHelper("i18n", i18nHelper);
	    return i18nHelper;
	});
	define('hbs!galileo/modal/template/force101/content-wearing-force',["handlebars", "galileo/tile/template/helpers/i18n-namespace", "i18n-load!com/fitbit/app/ngd/force101", "galileo/tile/template/helpers/i18n"], function(Handlebars){ 
	   var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
	  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
	helpers = helpers || Handlebars.helpers;
	  var stack1, stack2, options, helperMissing=helpers.helperMissing, self=this;
	
	function program1(depth0,data) {
	  
	  var buffer = "", stack1, stack2, options;
	  buffer += "\n<h3>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_wearing_force_heading", options) : helperMissing.call(depth0, "i18n", "screen_wearing_force_heading", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</h3>\n<p>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_wearing_force_text", options) : helperMissing.call(depth0, "i18n", "screen_wearing_force_text", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</p>\n";
	  return buffer;
	  }
	
	  options = {hash:{},inverse:self.noop,fn:self.program(1, program1, data)};
	  stack2 = ((stack1 = helpers['i18n-namespace']),stack1 ? stack1.call(depth0, "com.fitbit.app.ngd.force101", options) : helperMissing.call(depth0, "i18n-namespace", "com.fitbit.app.ngd.force101", options));
	  if(stack2 || stack2 === 0) { return stack2; }
	  else { return ''; }
	  });
	   Handlebars.registerPartial("galileo_modal_template_force101_content-wearing-force", t);
	   return t;
	});
	define('hbs!galileo/modal/template/force101/content-display-options',["handlebars", "galileo/tile/template/helpers/i18n-namespace", "i18n-load!com/fitbit/app/ngd/force101", "galileo/tile/template/helpers/i18n"], function(Handlebars){ 
	   var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
	  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
	helpers = helpers || Handlebars.helpers;
	  var stack1, stack2, options, helperMissing=helpers.helperMissing, self=this;
	
	function program1(depth0,data) {
	  
	  var buffer = "", stack1, stack2, options;
	  buffer += "\n<h3>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_display_options_heading", options) : helperMissing.call(depth0, "i18n", "screen_display_options_heading", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</h3>\n<p>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_display_options_text", options) : helperMissing.call(depth0, "i18n", "screen_display_options_text", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</p>\n<ul>\n    <li>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_display_options_bullet_1", options) : helperMissing.call(depth0, "i18n", "screen_display_options_bullet_1", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</li>\n    <li>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_display_options_bullet_2", options) : helperMissing.call(depth0, "i18n", "screen_display_options_bullet_2", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</li>\n    <li>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_display_options_bullet_3", options) : helperMissing.call(depth0, "i18n", "screen_display_options_bullet_3", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</li>\n</ul>\n\n<ul class=\"display-options-list\">\n    <li><span>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_display_options_steps", options) : helperMissing.call(depth0, "i18n", "screen_display_options_steps", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</span></li>\n    <li><span>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_display_options_active_minutes", options) : helperMissing.call(depth0, "i18n", "screen_display_options_active_minutes", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</span></li>\n    <li><span>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_display_options_calories", options) : helperMissing.call(depth0, "i18n", "screen_display_options_calories", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</span></li>\n    <li><span>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_display_options_distance", options) : helperMissing.call(depth0, "i18n", "screen_display_options_distance", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</span></li>\n</ul>\n";
	  return buffer;
	  }
	
	  options = {hash:{},inverse:self.noop,fn:self.program(1, program1, data)};
	  stack2 = ((stack1 = helpers['i18n-namespace']),stack1 ? stack1.call(depth0, "com.fitbit.app.ngd.force101", options) : helperMissing.call(depth0, "i18n-namespace", "com.fitbit.app.ngd.force101", options));
	  if(stack2 || stack2 === 0) { return stack2; }
	  else { return ''; }
	  });
	   Handlebars.registerPartial("galileo_modal_template_force101_content-display-options", t);
	   return t;
	});
	define('hbs!galileo/modal/template/force101/content-goals',["handlebars", "galileo/tile/template/helpers/i18n-namespace", "i18n-load!com/fitbit/app/ngd/force101", "galileo/tile/template/helpers/i18n"], function(Handlebars){ 
	   var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
	  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
	helpers = helpers || Handlebars.helpers;
	  var stack1, stack2, options, helperMissing=helpers.helperMissing, self=this;
	
	function program1(depth0,data) {
	  
	  var buffer = "", stack1, stack2, options;
	  buffer += "\n<h3>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_goals_heading", options) : helperMissing.call(depth0, "i18n", "screen_goals_heading", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</h3>\n<p>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_goals_text", options) : helperMissing.call(depth0, "i18n", "screen_goals_text", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</p>\n\n<h4>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_goals_subheading", options) : helperMissing.call(depth0, "i18n", "screen_goals_subheading", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</h4>\n<ul>\n    <li>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_goals_bullet_1", options) : helperMissing.call(depth0, "i18n", "screen_goals_bullet_1", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</li>\n    <li>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_goals_bullet_2", options) : helperMissing.call(depth0, "i18n", "screen_goals_bullet_2", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</li>\n</ul>\n";
	  return buffer;
	  }
	
	  options = {hash:{},inverse:self.noop,fn:self.program(1, program1, data)};
	  stack2 = ((stack1 = helpers['i18n-namespace']),stack1 ? stack1.call(depth0, "com.fitbit.app.ngd.force101", options) : helperMissing.call(depth0, "i18n-namespace", "com.fitbit.app.ngd.force101", options));
	  if(stack2 || stack2 === 0) { return stack2; }
	  else { return ''; }
	  });
	   Handlebars.registerPartial("galileo_modal_template_force101_content-goals", t);
	   return t;
	});
	define('hbs!galileo/modal/template/force101/content-tracking-sleep',["handlebars", "galileo/tile/template/helpers/i18n-namespace", "i18n-load!com/fitbit/app/ngd/force101", "galileo/tile/template/helpers/i18n"], function(Handlebars){ 
	   var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
	  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
	helpers = helpers || Handlebars.helpers;
	  var stack1, stack2, options, helperMissing=helpers.helperMissing, self=this;
	
	function program1(depth0,data) {
	  
	  var buffer = "", stack1, stack2, options;
	  buffer += "\n<h3>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_tracking_sleep_heading", options) : helperMissing.call(depth0, "i18n", "screen_tracking_sleep_heading", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</h3>\n<p>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_tracking_sleep_text", options) : helperMissing.call(depth0, "i18n", "screen_tracking_sleep_text", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</p>\n\n<ul>\n    <li>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_tracking_sleep_bullet_1", options) : helperMissing.call(depth0, "i18n", "screen_tracking_sleep_bullet_1", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</li>\n    <li>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_tracking_sleep_bullet_2", options) : helperMissing.call(depth0, "i18n", "screen_tracking_sleep_bullet_2", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</li>\n    <li>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_tracking_sleep_bullet_3", options) : helperMissing.call(depth0, "i18n", "screen_tracking_sleep_bullet_3", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</li>\n</ul>\n";
	  return buffer;
	  }
	
	  options = {hash:{},inverse:self.noop,fn:self.program(1, program1, data)};
	  stack2 = ((stack1 = helpers['i18n-namespace']),stack1 ? stack1.call(depth0, "com.fitbit.app.ngd.force101", options) : helperMissing.call(depth0, "i18n-namespace", "com.fitbit.app.ngd.force101", options));
	  if(stack2 || stack2 === 0) { return stack2; }
	  else { return ''; }
	  });
	   Handlebars.registerPartial("galileo_modal_template_force101_content-tracking-sleep", t);
	   return t;
	});
	define('hbs!galileo/modal/template/force101/content-silent-alarms',["handlebars", "galileo/tile/template/helpers/i18n-namespace", "i18n-load!com/fitbit/app/ngd/force101", "galileo/tile/template/helpers/i18n"], function(Handlebars){ 
	   var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
	  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
	helpers = helpers || Handlebars.helpers;
	  var stack1, stack2, options, helperMissing=helpers.helperMissing, self=this;
	
	function program1(depth0,data) {
	  
	  var buffer = "", stack1, stack2, options;
	  buffer += "\n<h3>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_silent_alarms_heading", options) : helperMissing.call(depth0, "i18n", "screen_silent_alarms_heading", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</h3>\n<p>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_silent_alarms_text_1", options) : helperMissing.call(depth0, "i18n", "screen_silent_alarms_text_1", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</p>\n<p>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_silent_alarms_text_2", options) : helperMissing.call(depth0, "i18n", "screen_silent_alarms_text_2", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</p>\n<p>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_silent_alarms_text_3", options) : helperMissing.call(depth0, "i18n", "screen_silent_alarms_text_3", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</p>\n";
	  return buffer;
	  }
	
	  options = {hash:{},inverse:self.noop,fn:self.program(1, program1, data)};
	  stack2 = ((stack1 = helpers['i18n-namespace']),stack1 ? stack1.call(depth0, "com.fitbit.app.ngd.force101", options) : helperMissing.call(depth0, "i18n-namespace", "com.fitbit.app.ngd.force101", options));
	  if(stack2 || stack2 === 0) { return stack2; }
	  else { return ''; }
	  });
	   Handlebars.registerPartial("galileo_modal_template_force101_content-silent-alarms", t);
	   return t;
	});
	define('hbs!galileo/modal/template/force101',["handlebars", "galileo/tile/template/helpers/i18n-namespace", "i18n-load!com/fitbit/app/ngd/force101", "galileo/tile/template/helpers/i18n", "i18n-load!com/fitbit/mktg/crosssell"], function(Handlebars){ 
	   var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
	  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
	helpers = helpers || Handlebars.helpers;
	  var buffer = "", stack1, stack2, options, helperMissing=helpers.helperMissing, self=this, functionType="function", escapeExpression=this.escapeExpression;
	
	function program1(depth0,data) {
	  
	  var buffer = "", stack1, stack2, options;
	  buffer += "\n\n<div class=\"force101-modal wearing-force\">\n    <a class=\"close closeBtn\">x</a>\n\n    <div class=\"paddingContainer\">\n        <div class=\"header\">\n            <h2>\n                ";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "force101_heading", options) : helperMissing.call(depth0, "i18n", "force101_heading", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "\n            </h2>\n            ";
	  stack2 = helpers['if'].call(depth0, depth0.isNotAvailable, {hash:{},inverse:self.noop,fn:self.program(2, program2, data)});
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "\n            <ul class=\"nav\">\n                <li class=\"basics\">\n                    <a>\n                        <strong>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "nav_basics", options) : helperMissing.call(depth0, "i18n", "nav_basics", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</strong>\n                    </a>\n                </li>\n                <li class=\"goals\">\n                    <a>\n                        <strong>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "nav_goals", options) : helperMissing.call(depth0, "i18n", "nav_goals", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</strong>\n                    </a>\n                </li>\n                <li class=\"sleep\">\n                    <a>\n                        <strong>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "nav_sleep", options) : helperMissing.call(depth0, "i18n", "nav_sleep", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</strong>\n                    </a>\n                </li>\n            </ul>\n        </div>\n\n        <div class=\"body\">\n\n            <ul class=\"screens\">\n                ";
	  stack2 = helpers.each.call(depth0, depth0.screens, {hash:{},inverse:self.noop,fn:self.program(5, program5, data)});
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "\n            </ul>\n\n        </div>\n    </div>\n\n    <div class=\"navActions\">\n        <ul class=\"actions\">\n            <li>\n                <a rel=\"prev\">&lt; ";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "actions_back", options) : helperMissing.call(depth0, "i18n", "actions_back", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</a>\n            </li>\n            <li>\n                <a rel=\"next\">";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "actions_next", options) : helperMissing.call(depth0, "i18n", "actions_next", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += " &gt;</a>\n            </li>\n            <li>\n                <a class=\"close\" rel=\"done\">";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "actions_done", options) : helperMissing.call(depth0, "i18n", "actions_done", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</a>\n            </li>\n        </ul>\n    </div>\n</div>\n";
	  return buffer;
	  }
	function program2(depth0,data) {
	  
	  var buffer = "", stack1, stack2, options;
	  buffer += "\n            ";
	  options = {hash:{},inverse:self.noop,fn:self.program(3, program3, data)};
	  stack2 = ((stack1 = helpers['i18n-namespace']),stack1 ? stack1.call(depth0, "com.fitbit.mktg.crosssell", options) : helperMissing.call(depth0, "i18n-namespace", "com.fitbit.mktg.crosssell", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "\n            ";
	  return buffer;
	  }
	function program3(depth0,data) {
	  
	  var buffer = "", stack1, stack2, options;
	  buffer += "\n            <div class=\"badge\">";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "status_not_available", options) : helperMissing.call(depth0, "i18n", "status_not_available", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</div>\n            ";
	  return buffer;
	  }
	
	function program5(depth0,data) {
	  
	  var buffer = "", stack1;
	  buffer += "\n                <li class=\"screen ";
	  if (stack1 = helpers.name) { stack1 = stack1.call(depth0, {hash:{}}); }
	  else { stack1 = depth0.name; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
	  buffer += escapeExpression(stack1)
	    + "\" data-screen-name=\"";
	  if (stack1 = helpers.name) { stack1 = stack1.call(depth0, {hash:{}}); }
	  else { stack1 = depth0.name; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
	  buffer += escapeExpression(stack1)
	    + "\">\n                    <div class=\"section\">\n                        ";
	  if (stack1 = helpers.contents) { stack1 = stack1.call(depth0, {hash:{}}); }
	  else { stack1 = depth0.contents; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
	  if(stack1 || stack1 === 0) { buffer += stack1; }
	  buffer += "\n                    </div>\n                </li>\n                ";
	  return buffer;
	  }
	
	  options = {hash:{},inverse:self.noop,fn:self.program(1, program1, data)};
	  stack2 = ((stack1 = helpers['i18n-namespace']),stack1 ? stack1.call(depth0, "com.fitbit.app.ngd.force101", options) : helperMissing.call(depth0, "i18n-namespace", "com.fitbit.app.ngd.force101", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "\n";
	  return buffer;
	  });
	   Handlebars.registerPartial("galileo_modal_template_force101", t);
	   return t;
	});
	define('galileo/modal/force101',['require','hbs!./template/force101/content-wearing-force','hbs!./template/force101/content-display-options','hbs!./template/force101/content-goals','hbs!./template/force101/content-tracking-sleep','hbs!./template/force101/content-silent-alarms','hbs!./template/force101','shared/scripts/modal'],function(require) {
	    var screensContents = [
	        {
	            name: 'wearing-force',
	            contents: require("hbs!./template/force101/content-wearing-force")()
	        },
	        {
	            name: 'display-options',
	            contents: require("hbs!./template/force101/content-display-options")()
	        },
	        {
	            name: 'goals',
	            contents: require("hbs!./template/force101/content-goals")()
	        },
	        {
	            name: 'tracking-sleep',
	            contents: require("hbs!./template/force101/content-tracking-sleep")()
	        },
	        {
	            name: 'silent-alarms',
	            contents: require("hbs!./template/force101/content-silent-alarms")()
	        }
	    ];
	
	    var modalContents = require("hbs!./template/force101");
	
	    var openModal;
	
	    return function() {
	        // If openModal exists, it means Force101 was already opened.
	        if (!openModal) {
	            openModal = require("shared/scripts/modal")(function(close) {
	                var modal = $(modalContents({screens: screensContents, isNotAvailable: ($('body').attr('class').match(/locale-([a-z]{2}_[A-Z]{2})/)[1] === 'zh_TW')}));
	                var screens = modal.find('.screen');
	                var totalScreens = screens.length;
	                var current = 0;
	
	                modal.on('click', '.navActions a:not([rel=done])', function(){
	                    var element = $(this);
	                    var direction = element.attr('rel');
	                    var num = 0;
	
	                    switch(direction){
	                        case 'next':
	                            num += 1;
	                            break;
	                        case 'prev':
	                            num -=1;
	                            break;
	                    }
	
	                    if (num != 0) {
	                        var newCurrent = current + num;
	                        var currentScreen = screens.eq(current);
	                        var newScreen = screens.eq(newCurrent);
	
	                        current = newCurrent;
	
	                        modal.removeClass(currentScreen.data('screen-name'));
	                        modal.addClass(newScreen.data('screen-name'));
	                    }
	                });
	
	                return modal;
	            });
	
	            // When the modal closes, we allow the openModal to be reopened.
	            openModal.onClose(function(){
	                openModal = undefined;
	            });
	        }
	
	        return openModal;
	    }
	});
	
	define('hbs!galileo/modal/template/charge101/content-wearing-charge',["handlebars", "galileo/tile/template/helpers/i18n-namespace", "i18n-load!com/fitbit/app/ngd/charge101", "galileo/tile/template/helpers/i18n"], function(Handlebars){ 
	   var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
	  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
	helpers = helpers || Handlebars.helpers;
	  var stack1, stack2, options, helperMissing=helpers.helperMissing, self=this;
	
	function program1(depth0,data) {
	  
	  var buffer = "", stack1, stack2, options;
	  buffer += "\n<h3>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_wearing_charge_heading", options) : helperMissing.call(depth0, "i18n", "screen_wearing_charge_heading", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += " </h3>\n<p>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_wearing_charge_text", options) : helperMissing.call(depth0, "i18n", "screen_wearing_charge_text", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += " </p>\n";
	  return buffer;
	  }
	
	  options = {hash:{},inverse:self.noop,fn:self.program(1, program1, data)};
	  stack2 = ((stack1 = helpers['i18n-namespace']),stack1 ? stack1.call(depth0, "com.fitbit.app.ngd.charge101", options) : helperMissing.call(depth0, "i18n-namespace", "com.fitbit.app.ngd.charge101", options));
	  if(stack2 || stack2 === 0) { return stack2; }
	  else { return ''; }
	  });
	   Handlebars.registerPartial("galileo_modal_template_charge101_content-wearing-charge", t);
	   return t;
	});
	define('hbs!galileo/modal/template/charge101/content-display-options',["handlebars", "galileo/tile/template/helpers/i18n-namespace", "i18n-load!com/fitbit/app/ngd/charge101", "galileo/tile/template/helpers/i18n"], function(Handlebars){ 
	   var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
	  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
	helpers = helpers || Handlebars.helpers;
	  var stack1, stack2, options, helperMissing=helpers.helperMissing, self=this;
	
	function program1(depth0,data) {
	  
	  var buffer = "", stack1, stack2, options;
	  buffer += "\n<h3>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_display_options_heading", options) : helperMissing.call(depth0, "i18n", "screen_display_options_heading", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += " </h3>\n<p>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_display_options_text", options) : helperMissing.call(depth0, "i18n", "screen_display_options_text", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += " </p>\n<ul>\n    <li>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_display_options_bullet_1", options) : helperMissing.call(depth0, "i18n", "screen_display_options_bullet_1", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += " </li>\n    <li>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_display_options_bullet_2", options) : helperMissing.call(depth0, "i18n", "screen_display_options_bullet_2", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += " </li>\n    <li>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_display_options_bullet_3", options) : helperMissing.call(depth0, "i18n", "screen_display_options_bullet_3", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += " </li>\n</ul>\n\n<ul class=\"display-options-list\">\n    <li>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_display_options_steps", options) : helperMissing.call(depth0, "i18n", "screen_display_options_steps", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += " </li>\n    <li>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_display_options_floors", options) : helperMissing.call(depth0, "i18n", "screen_display_options_floors", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += " </li>\n    <li>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_display_options_calories", options) : helperMissing.call(depth0, "i18n", "screen_display_options_calories", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += " </li>\n    <li>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_display_options_distance", options) : helperMissing.call(depth0, "i18n", "screen_display_options_distance", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += " </li>\n</ul>\n";
	  return buffer;
	  }
	
	  options = {hash:{},inverse:self.noop,fn:self.program(1, program1, data)};
	  stack2 = ((stack1 = helpers['i18n-namespace']),stack1 ? stack1.call(depth0, "com.fitbit.app.ngd.charge101", options) : helperMissing.call(depth0, "i18n-namespace", "com.fitbit.app.ngd.charge101", options));
	  if(stack2 || stack2 === 0) { return stack2; }
	  else { return ''; }
	  });
	   Handlebars.registerPartial("galileo_modal_template_charge101_content-display-options", t);
	   return t;
	});
	define('hbs!galileo/modal/template/charge101/content-goals',["handlebars", "galileo/tile/template/helpers/i18n-namespace", "i18n-load!com/fitbit/app/ngd/charge101", "galileo/tile/template/helpers/i18n"], function(Handlebars){ 
	   var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
	  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
	helpers = helpers || Handlebars.helpers;
	  var stack1, stack2, options, helperMissing=helpers.helperMissing, self=this;
	
	function program1(depth0,data) {
	  
	  var buffer = "", stack1, stack2, options;
	  buffer += "\n<h3>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_goals_heading", options) : helperMissing.call(depth0, "i18n", "screen_goals_heading", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</h3>\n<p>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_goals_text", options) : helperMissing.call(depth0, "i18n", "screen_goals_text", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</p>\n\n<h4>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_goals_subheading", options) : helperMissing.call(depth0, "i18n", "screen_goals_subheading", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</h4>\n<ul>\n    <li>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_goals_bullet_1", options) : helperMissing.call(depth0, "i18n", "screen_goals_bullet_1", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</li>\n    <li>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_goals_bullet_2", options) : helperMissing.call(depth0, "i18n", "screen_goals_bullet_2", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</li>\n</ul>\n";
	  return buffer;
	  }
	
	  options = {hash:{},inverse:self.noop,fn:self.program(1, program1, data)};
	  stack2 = ((stack1 = helpers['i18n-namespace']),stack1 ? stack1.call(depth0, "com.fitbit.app.ngd.charge101", options) : helperMissing.call(depth0, "i18n-namespace", "com.fitbit.app.ngd.charge101", options));
	  if(stack2 || stack2 === 0) { return stack2; }
	  else { return ''; }
	  });
	   Handlebars.registerPartial("galileo_modal_template_charge101_content-goals", t);
	   return t;
	});
	define('hbs!galileo/modal/template/charge101/content-call-notifications',["handlebars", "galileo/tile/template/helpers/i18n-namespace", "i18n-load!com/fitbit/app/ngd/charge101", "galileo/tile/template/helpers/i18n"], function(Handlebars){ 
	   var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
	  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
	helpers = helpers || Handlebars.helpers;
	  var stack1, stack2, options, helperMissing=helpers.helperMissing, self=this;
	
	function program1(depth0,data) {
	  
	  var buffer = "", stack1, stack2, options;
	  buffer += "\n<h3>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_call_notifications_heading", options) : helperMissing.call(depth0, "i18n", "screen_call_notifications_heading", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += " </h3>\n<p>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_call_notifications_text_1", options) : helperMissing.call(depth0, "i18n", "screen_call_notifications_text_1", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += " </p>\n<p>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_call_notifications_text_2", options) : helperMissing.call(depth0, "i18n", "screen_call_notifications_text_2", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += " </p>\n";
	  return buffer;
	  }
	
	  options = {hash:{},inverse:self.noop,fn:self.program(1, program1, data)};
	  stack2 = ((stack1 = helpers['i18n-namespace']),stack1 ? stack1.call(depth0, "com.fitbit.app.ngd.charge101", options) : helperMissing.call(depth0, "i18n-namespace", "com.fitbit.app.ngd.charge101", options));
	  if(stack2 || stack2 === 0) { return stack2; }
	  else { return ''; }
	  });
	   Handlebars.registerPartial("galileo_modal_template_charge101_content-call-notifications", t);
	   return t;
	});
	define('hbs!galileo/modal/template/charge101/content-silent-alarms',["handlebars", "galileo/tile/template/helpers/i18n-namespace", "i18n-load!com/fitbit/app/ngd/charge101", "galileo/tile/template/helpers/i18n"], function(Handlebars){ 
	   var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
	  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
	helpers = helpers || Handlebars.helpers;
	  var stack1, stack2, options, helperMissing=helpers.helperMissing, self=this;
	
	function program1(depth0,data) {
	  
	  var buffer = "", stack1, stack2, options;
	  buffer += "\n<h3>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_silent_alarms_heading", options) : helperMissing.call(depth0, "i18n", "screen_silent_alarms_heading", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</h3>\n<p>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_silent_alarms_text_1", options) : helperMissing.call(depth0, "i18n", "screen_silent_alarms_text_1", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</p>\n<p>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_silent_alarms_text_2", options) : helperMissing.call(depth0, "i18n", "screen_silent_alarms_text_2", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</p>\n<p>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "screen_silent_alarms_text_3", options) : helperMissing.call(depth0, "i18n", "screen_silent_alarms_text_3", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</p>\n";
	  return buffer;
	  }
	
	  options = {hash:{},inverse:self.noop,fn:self.program(1, program1, data)};
	  stack2 = ((stack1 = helpers['i18n-namespace']),stack1 ? stack1.call(depth0, "com.fitbit.app.ngd.charge101", options) : helperMissing.call(depth0, "i18n-namespace", "com.fitbit.app.ngd.charge101", options));
	  if(stack2 || stack2 === 0) { return stack2; }
	  else { return ''; }
	  });
	   Handlebars.registerPartial("galileo_modal_template_charge101_content-silent-alarms", t);
	   return t;
	});
	define('hbs!galileo/modal/template/charge101',["handlebars", "galileo/tile/template/helpers/i18n-namespace", "i18n-load!com/fitbit/app/ngd/charge101", "galileo/tile/template/helpers/i18n", "i18n-load!com/fitbit/mktg/crosssell"], function(Handlebars){ 
	   var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
	  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
	helpers = helpers || Handlebars.helpers;
	  var buffer = "", stack1, stack2, options, helperMissing=helpers.helperMissing, self=this, functionType="function", escapeExpression=this.escapeExpression;
	
	function program1(depth0,data) {
	  
	  var buffer = "", stack1, stack2, options;
	  buffer += "\n\n<div class=\"charge101-modal wearing-charge\">\n    <a class=\"close closeBtn\">x</a>\n\n    <div class=\"paddingContainer\">\n        <div class=\"header\">\n            <h2>\n                ";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "charge101_heading", options) : helperMissing.call(depth0, "i18n", "charge101_heading", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "\n            </h2>\n            ";
	  stack2 = helpers['if'].call(depth0, depth0.isNotAvailable, {hash:{},inverse:self.noop,fn:self.program(2, program2, data)});
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "\n            <ul class=\"nav\">\n                <li class=\"basics\">\n                    <a>\n                        <strong>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "nav_basics", options) : helperMissing.call(depth0, "i18n", "nav_basics", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</strong>\n                    </a>\n                </li>\n                <li class=\"goals\">\n                    <a>\n                        <strong>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "nav_goals", options) : helperMissing.call(depth0, "i18n", "nav_goals", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</strong>\n                    </a>\n                </li>\n                <li class=\"calls\">\n                    <a>\n                        <strong>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "nav_calls", options) : helperMissing.call(depth0, "i18n", "nav_calls", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</strong>\n                    </a>\n                </li>\n                <li class=\"sleep\">\n                    <a>\n                        <strong>";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "nav_sleep", options) : helperMissing.call(depth0, "i18n", "nav_sleep", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</strong>\n                    </a>\n                </li>\n            </ul>\n        </div>\n\n        <div class=\"body\">\n\n            <ul class=\"screens\">\n                ";
	  stack2 = helpers.each.call(depth0, depth0.screens, {hash:{},inverse:self.noop,fn:self.program(5, program5, data)});
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "\n            </ul>\n\n        </div>\n    </div>\n\n    <div class=\"navActions\">\n        <ul class=\"actions\">\n            <li>\n                <a rel=\"prev\">&lt; ";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "actions_back", options) : helperMissing.call(depth0, "i18n", "actions_back", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</a>\n            </li>\n            <li>\n                <a rel=\"next\">";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "actions_next", options) : helperMissing.call(depth0, "i18n", "actions_next", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += " &gt;</a>\n            </li>\n            <li>\n                <a class=\"close\" rel=\"done\">";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "actions_done", options) : helperMissing.call(depth0, "i18n", "actions_done", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</a>\n            </li>\n        </ul>\n    </div>\n</div>\n";
	  return buffer;
	  }
	function program2(depth0,data) {
	  
	  var buffer = "", stack1, stack2, options;
	  buffer += "\n            ";
	  options = {hash:{},inverse:self.noop,fn:self.program(3, program3, data)};
	  stack2 = ((stack1 = helpers['i18n-namespace']),stack1 ? stack1.call(depth0, "com.fitbit.mktg.crosssell", options) : helperMissing.call(depth0, "i18n-namespace", "com.fitbit.mktg.crosssell", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "\n            ";
	  return buffer;
	  }
	function program3(depth0,data) {
	  
	  var buffer = "", stack1, stack2, options;
	  buffer += "\n            <div class=\"badge\">";
	  options = {hash:{}};
	  stack2 = ((stack1 = helpers.i18n),stack1 ? stack1.call(depth0, "status_not_available", options) : helperMissing.call(depth0, "i18n", "status_not_available", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "</div>\n            ";
	  return buffer;
	  }
	
	function program5(depth0,data) {
	  
	  var buffer = "", stack1;
	  buffer += "\n                <li class=\"screen ";
	  if (stack1 = helpers.name) { stack1 = stack1.call(depth0, {hash:{}}); }
	  else { stack1 = depth0.name; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
	  buffer += escapeExpression(stack1)
	    + "\" data-screen-name=\"";
	  if (stack1 = helpers.name) { stack1 = stack1.call(depth0, {hash:{}}); }
	  else { stack1 = depth0.name; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
	  buffer += escapeExpression(stack1)
	    + "\">\n                    <div class=\"section\">\n                        ";
	  if (stack1 = helpers.contents) { stack1 = stack1.call(depth0, {hash:{}}); }
	  else { stack1 = depth0.contents; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
	  if(stack1 || stack1 === 0) { buffer += stack1; }
	  buffer += "\n                    </div>\n                </li>\n                ";
	  return buffer;
	  }
	
	  options = {hash:{},inverse:self.noop,fn:self.program(1, program1, data)};
	  stack2 = ((stack1 = helpers['i18n-namespace']),stack1 ? stack1.call(depth0, "com.fitbit.app.ngd.charge101", options) : helperMissing.call(depth0, "i18n-namespace", "com.fitbit.app.ngd.charge101", options));
	  if(stack2 || stack2 === 0) { buffer += stack2; }
	  buffer += "\n";
	  return buffer;
	  });
	   Handlebars.registerPartial("galileo_modal_template_charge101", t);
	   return t;
	});
	define('galileo/modal/charge101',['require','galileo/builder/util','galileo/builder/text','galileo/widget/tabs','hbs!./template/charge101/content-wearing-charge','hbs!./template/charge101/content-display-options','hbs!./template/charge101/content-goals','hbs!./template/charge101/content-call-notifications','hbs!./template/charge101/content-silent-alarms','hbs!./template/charge101','shared/scripts/modal'],function(require) {
	    var B = require("galileo/builder/util");
	    var Text = require("galileo/builder/text");
	    var Tabs = require("galileo/widget/tabs");
	
	    var screensContents = [
	        {
	            name: 'wearing-charge',
	            contents: require("hbs!./template/charge101/content-wearing-charge")()
	        },
	        {
	            name: 'display-options',
	            contents: require("hbs!./template/charge101/content-display-options")()
	        },
	        {
	            name: 'goals',
	            contents: require("hbs!./template/charge101/content-goals")()
	        },
	        // TODO: Sleep screen in future version
	        // {
	        //     name: 'tracking-sleep',
	        //     contents: require("hbs!./template/charge101/content-tracking-sleep")()
	        // },
	        {
	            name: 'call-notifications',
	            contents: require("hbs!./template/charge101/content-call-notifications")()
	        },
	        {
	            name: 'silent-alarms',
	            contents: require("hbs!./template/charge101/content-silent-alarms")()
	        }
	    ];
	
	    var modalContents = require("hbs!./template/charge101");
	
	    var openModal;
	
	    return function() {
	        // If openModal exists, it means Charge101 was already opened.
	        if (!openModal) {
	            openModal = require("shared/scripts/modal")(function(close) {
	                var modal = $(modalContents({screens: screensContents, isNotAvailable: ($('body').attr('class').match(/locale-([a-z]{2}_[A-Z]{2})/)[1] === 'zh_TW')}));
	                var screens = modal.find('.screen');
	                var totalScreens = screens.length;
	                var current = 0;
	
	                modal.on('click', '.navActions a:not([rel=done])', function(){
	                    var element = $(this);
	                    var direction = element.attr('rel');
	                    var num = 0;
	
	                    switch(direction){
	                        case 'next':
	                            num += 1;
	                            break;
	                        case 'prev':
	                            num -=1;
	                            break;
	                    }
	
	                    if (num != 0) {
	                        var newCurrent = current + num;
	                        var currentScreen = screens.eq(current);
	                        var newScreen = screens.eq(newCurrent);
	
	                        current = newCurrent;
	
	                        modal.removeClass(currentScreen.data('screen-name'));
	                        modal.addClass(newScreen.data('screen-name'));
	                    }
	                });
	
	                return modal;
	            });
	
	            // When the modal closes, we allow the openModal to be reopened.
	            openModal.onClose(function(){
	                openModal = undefined;
	            });
	        }
	
	        return openModal;
	    }
	});
	
	// jshint ignore: start
	define('galileo/modal/device101',['require'],function(require) {
	
	    function initDevice101() {
	        $(".device-101-1-menu-item").after("<br/>");
	
	        $("#fitbit-mobile-device-101").append('<div class="close-button"></div>');
	
	        $(".navigation-button-101").click(function(){ doChangeScreen($(this)); });
	        $(".navigation-button-101.prev-screen").hide();
	
	        $("#fitbit-mobile-device-101 > div.content-area-101:not(.fitbit-mobile-device-101-content)").append("<div class='device-101-left-side'></div><div class='device-101-right-side'></div>");
	        $("#fitbit-mobile-device-101 > div:not(.fitbit-mobile-device-101-content)").each(function() {
	            var _l = $(this).find(".device-101-left-side");
	            $(this).find("img:not('.ic'), p.left-area").appendTo(_l);
	            var _r = $(this).find(".device-101-right-side");
	            $(this).find("p:not(.left-area),h1").appendTo(_r);
	            $(this).find("p.device-101-split").each(function(){
	                var _h = $(this).html();
	                _h = _h.replace("<br/>","</p><p>").replace("<br>","</p><p>");
	                $(this).html(_h);
	            });
	        });
	
	        $('img.lazy').each(function(){
	            var r_src = $(this).attr("data-src");
	            $(this).attr("src", r_src);
	        });
	
	        $("#fitbit-mobile-device-101 .close-button, .fitbit-mobile-device-101-overlay, .navigation-button-101.close-screen").click(function() {
	            $(".fitbit-mobile-device-101-overlay").remove();
	            $("#fitbit-mobile-device-101").remove();
	        });
	
	        $("#fitbit-mobile-device-101 #nav-101").show();
	
	        var cnt = $("#fitbit-mobile-device-101 > div.content-area-101");
	        var cntl = cnt.length;
	        cnt.each(function(i) {
	            if (i !== 0) {
	                if (i == (cntl -1)) {
	                    $(this).addClass("last-item-101");
	                }
	                $(this).hide();
	            } else {
	                $(this).addClass("active-area-101").addClass("first-item-101");
	            }
	            var cl = $(this).hasClass("fitbit-mobile-device-101-content") ? "class='content-table'" : "";
	            var active = (i == 0) ? "active" : "";
	            var href = $(this).attr("id");
	            var el = "<li " + cl + "><a href='#" + href + "' class='pagination-marker-101 " + active + "'></a></li>";
	            $("#nav-101 ul").append(el);
	        });
	
	        $("a.pagination-marker-101, a.device-101-1-menu-item").click(function(ev) {
	            ev.preventDefault();
	            if (!$(this).hasClass("active")) {
	                var _t = $(this).attr("href");
	                $("a.pagination-marker-101").removeClass('active');
	                $("a.pagination-marker-101[href='" + _t + "']").addClass("active");
	
	                $("div.active-area-101").fadeOut().removeClass("active-area-101");
	                $("div" + _t).fadeIn().addClass("active-area-101");
	                reDrawButtons($("div" + _t));
	            }
	            return false;
	        });
	
	        function reDrawButtons(el) {
	            if (el.hasClass("first-item-101")) {
	                $(".navigation-button-101.prev-screen").hide();
	            } else {
	                $(".navigation-button-101.prev-screen").show();
	            }
	            if (el.hasClass("last-item-101")) {
	                $(".navigation-button-101.next-screen").hide();
	                $(".navigation-button-101.close-screen").show();
	            } else {
	                $(".navigation-button-101.next-screen").show();
	                $(".navigation-button-101.close-screen").hide();
	            }
	        }
	
	        function doChangeScreen(el) {
	            var _t = null;
	            if (el.hasClass("prev-screen")) {
	                _t = $("a.pagination-marker-101.active").parent().prev().find("a.pagination-marker-101");
	            } else if (el.hasClass("next-screen")) {
	                _t = $("a.pagination-marker-101.active").parent().next().find("a.pagination-marker-101");
	            }
	            if (_t && _t.length) {
	                var _target = _t.attr("href");
	                $("a.pagination-marker-101.active").removeClass("active");
	                _t.addClass("active");
	                $("div.active-area-101").fadeOut().removeClass("active-area-101");
	                $("div" + _target).fadeIn().addClass("active-area-101");
	                reDrawButtons($("div" + _target));
	            }
	
	        }
	
	        $(".fitbit-mobile-device-101-overlay").show();
	        $("#fitbit-mobile-device-101").show();
	
	    }
	
	    return function(device) {
	        /*** Todo: change URL when url rewrite for new devices will be created ***/
	        // Get locale from document, as the locale defined by the browser may differ
	        var region = 'us';
	        var bodyClass = $('body').attr('class');
	        var matchLocale;
	        if ((matchLocale = bodyClass.match(/locale-\S+_(\S+)/i)) || ((matchLocale = bodyClass.match(/locale-xx(\S+)/i)))) {
	            var langCode = matchLocale[1].toLowerCase();
	            if (langCode === 'gb') {
	                langCode = 'uk';
	            } else if (['ch', 'ca', 'be', 'no', 'se', 'nl'].indexOf(langCode) !== -1) {
	                matchLocale = bodyClass.match(/locale-(\S+)_(\S+)/i);
	                if (matchLocale[1] !== 'en' || langCode === 'ca') {
	                    langCode = matchLocale[1] + '-' + matchLocale[2].toLowerCase();
	                }
	            }
	            if (langCode !== 'en') {
	                region = langCode;
	            }
	        }
	
	        var url = false;
	
	        // If region is not found, then the content will be english by default
	        if (device === 'surge') {
	            url = region + '/surge/surge-101';
	        } else if (device === 'chargehr') {
	            url = region + '/chargehr/chargehr-101';
	        } else if (device === 'blaze') {
	            url = region + '/blaze/blaze-101';
	        } else if (device === 'alta') {
	            url = region + '/alta/alta-101';
	        } else if (device === 'flex2') {
	            url = region + '/flex2/flex2-101';
	        } else if (device === 'charge2') {
	            url = region + '/charge2/charge2-101';
	        } else if (device === 'ionic') {
	            url = region + '/ionic/ionic-101';
	        } else if (device === 'aria2') {
	            url = region + '/aria2/aria2-101';
	        } else if (device === 'altahr') {
	            url = region + '/altahr/altahr-101';
	        }
	        if (url) {
	            $.get('/' + url, function( data ) {
	                if (data) {
	                    $("body").append(data);
	                    initDevice101();
	                }
	            });
	        }
	    }
	});
	
	define('galileo/util/dialog101Loader',[],function () {
	    
	    var started = false, done = false, stack = [];
	
	    var getMultiScripts = function(arr) {
	        var _arr = $.map(arr, function(scr) {
	            return $.getScript( scr );
	        });
	
	        _arr.push($.Deferred(function( deferred ){
	            $( deferred.resolve );
	        }));
	
	        return $.when.apply($, _arr);
	    };
	
	    return function (k) {
	        if (!started) {
	            started = true;
	            stack.push(k);
	            $.get('/lab/galileo/dialog101', function (html) {
	                // The Aria 101 script immediately loads its content,
	                // so we need to make sure that the aria101_labels div
	                // is available in the DOM, before activating the
	                // script.
	                var $html = $(html);
	                var scripts = [];
	                $html.filter('script').each(function () {
	                    if (this.src) {
	                        scripts.push(this.src);
	                        $(this).remove();
	                    }
	                });
	
	
	                var body = $('body');
	                var div =  $('<div>');
	                div.css({position: 'absolute', left: -10000}).append($html).appendTo(body);
	
	                var $template = $('#fb101-template');
	                $template.replaceWith($template.text());
	                
	                getMultiScripts(scripts)
	                .done(function(){
	                    $.each(stack, function (i, f) {
	                        f();
	                    });
	                });
	
	                done = true;
	
	            });
	        } else {
	            if (done) {
	                k();
	            } else {
	                stack.push(k);
	            }
	        }
	    };
	});
	
	define('galileo/util/channel',['require'],function(require) {
	
	    /**
	     * Implements a channel (a multicast listener), capable of optionally sending the last given arguments when a callback is added.
	     */
	    return function(sendLast) {
	        var fns = [], args;
	        return {
	            /**
	             * The collection of callbacks persisted for this channel.
	             */
	            fns: fns,
	            /**
	             * Calls each function in the channel with the given arguments passed in.
	             * @param arguments Calls each function with the given arguments and stores the arguments for use when take is called.
	             */
	            give: function() {
	                args = arguments;
	                for(var i=0; i<fns.length; i++) {
	                    fns[i].apply(this, args);
	                }
	            },
	            /**
	             * Adds the given function to the channel.
	             * If sendLast was true, it will call the fn with the last arguments give() was called with.
	             * @param fn A callback to add to the channel.
	             * @param ctxt An optional context for the callback.
	             * @returns {Function} A function that will remove the given function from the channel.
	             */
	            take: function(fn, ctxt) {
	                fn = ctxt ? function(fnBind){return function() { return fnBind.apply(ctxt,args) }}(fn) : fn;
	                fns.push(fn);
	                if(sendLast && args) 
	                    fn.apply(this, args);
	                return function() {
	                    for(var i=fns.length-1; i>=0; i--) {
	                        if(fns[i] === fn)
	                            fns.splice(i,1);
	                    }
	                }
	            }
	        };
	    };
	});
	
	define('galileo/ajax/ajax',['require','mootools','jquery','galileo/prototype/all','galileo/util/channel','underscore'],function(require) {
	    require('mootools');
	    require('jquery');
	    require('galileo/prototype/all');
	    var channel = require('galileo/util/channel');
	    var _ = require('underscore');
	
	    var preloading = true, queue = [], values = {}, channels = {};
	    window.channelThings = channels;
	    
	
	    function getKey(wrap, method, url, args) {
	        // sort the arguments by key, so that object iteration order doesn't change the memoization
	        var argsArray = Object.keys(args).map(function(k) { return [k, args[k]]; });
	        argsArray.sortBy(Function.takeKey(0));
	        return JSON.encode( [wrap, method, url, argsArray] );
	    }
	
	    /**
	     *
	     * @param post
	     * @param wrap
	     * @param owner
	     * @param method
	     *      Method is used as the HTTP verb if wrap is set to false, and is used as
	     *      the backend service method if wrap is set to true. This means it's only
	     *      used as the HTTP verb for the 'postRaw' and 'getRaw' methods.
	     * @param url
	     * @param args
	     * @param callback
	     * @returns {{update: update}}
	     */
	    function ajax(post, wrap, owner, method, url, args, callback) {
	        var key = getKey(wrap, method, url, args);
	
	        var fullRequest = !owner || typeof global_page_owner === 'undefined' ?  '/ajaxapi' : '/ajaxapi/user/' + global_page_owner.encodedId;
	        var argsWithCsrf = args;
	        // We're checking method here because even though we have a boolean
	        // argument which seems like it dictates whether the call is a POST,
	        // we still pass the supplied 'method' argument into $.ajax.
	        // The argsWithCsrf are only used when 'wrap' is set to false.
	        if (_.isString(method) && method.toLowerCase() === 'post' &&
	            _.isObject(args) && !_.isArray(args)) {
	            argsWithCsrf = _.extend({}, args, { csrfToken: window.fitbitCsrfToken });
	        }
	        var makeRequest = function(){
	            if(wrap) {
	                $.ajax({type: 'POST', url: fullRequest, data: $.param({
	                    request: JSON.stringify({
	                        template: '/ajaxTemplate.jsp', serviceCalls: [{
	                            name: url, args: args, method: method
	                        }]
	                    }),
	                    csrfToken: window.fitbitCsrfToken
	                }), success: function(res) { 
	                    load(wrap, method, url, args, JSON.parse(res));
	                }});
	            } else {
	                $.ajax({type: method, url: url, data: argsWithCsrf, success: load.bind(this, wrap, method, url, args)});
	            }
	        };
	
	        if(post === true) {
	            if(wrap) {
	                $.ajax({type: 'POST', url: fullRequest, data: $.param({
	                    request: JSON.stringify({
	                        template: '/ajaxTemplate.jsp', serviceCalls: [{
	                            name: url, args: args, method: method
	                        }]
	                    }),
	                    csrfToken: window.fitbitCsrfToken
	                }), success: callback
	                });
	            } else {
	                $.ajax({type: method, url: url, data: argsWithCsrf, success: callback});
	            }
	            return;
	        }
	
	        if(callback == undefined) {
	            return {
	                update: function() {
	                    delete values[key];
	                    makeRequest();
	                }
	            }
	        }
	        if(!channels[key]) {
	            channels[key] = channel();
	            
	            if(preloading) {
	                queue.push(function() {
	                    if(!values[key]) {
	                        makeRequest();
	                    }
	                });
	            } else {
	                makeRequest();
	            }
	        }
	
	        if(!channels[key].fns.contains(callback)) {
	            channels[key].take(callback);
	        }
	
	        if(values.hasOwnProperty(key)) { 
	            callback(values[key]);
	            return;
	        }
	    }
	
	    function load(wrap, method, url, args, value) {
	        var key = getKey(wrap, method, url, args);
	        values[key] = value;
	        channels[key] = channels[key] || channel();
	        channels[key].give(value);
	    }
	
	    function preloadFinished() {
	        preloading = false;
	        queue.map(function(fn) { fn(); });
	        delete queue;
	    }
	
	
	    return {
	        getRaw: ajax.bind(this, false, false, false, 'get'),
	        get: ajax.bind(this, false, true, false),
	        getOwner: ajax.bind(this, false, true, true),
	        post: ajax.bind(this, true, true, false),
	        postOwner: ajax.bind(this, true, true, true),
	        postRaw: ajax.bind(this, true, false, false, 'post'),
	        preload: load.bind(this, true),
	        preloadRaw: load.bind(this, false),
	        preloadFinished: preloadFinished
	    };
	});
	
	define('galileo/util/foodGoalLoader',['require','./channel','galileo/ajax/ajax','galileo/util/dateUtil','underscore','jquery'],function(require) {
	    
	
	    var channel = require('./channel');
	    var Ajax = require('galileo/ajax/ajax');
	    var dateUtil = require('galileo/util/dateUtil');
	    var _ = require('underscore');
	    var started = false, done = false, chan = channel();
	    var $ = require('jquery');
	
	    $('body').on('fgmClose', function() {
	        Ajax.get('getWeightTileDataAt', 'activityTileData', {date: dateUtil.ajaxEncode(new Date())}).update();
	    });
	
	    return function(k){
	        if(!started) {
	            started = true;
	            $.get('/lab/galileo/weightDialogs', function(html) {
	                var parts = html.split('<!--ENDSCRIPT-->');
	                var $body = $('body');
	                var $firstPart = $(parts[0]), loadScript;
	
	                var scripts = _.map(_.filter($firstPart, function(t) { return t.nodeName === 'SCRIPT'; }), function(t) { return $(t).attr('src'); });
	
	                $firstPart = $firstPart.not('script');
	                $('<div>').css({position: 'absolute', left: -10000}).html($firstPart).appendTo($body);
	
	                //since the jquery append implementation adds the 'async' attribute to the script tags it loads and as a result can destroy MessageFormat.locale
	                loadScript = function() {
	                    var src = scripts.shift();
	                    $.getScript(src, scripts.length ? loadScript : waitForFitbit);
	                };
	
	                loadScript();
	
	                function waitForFitbit() {
	                    if(window.fitbit && window.fitbit.i18n) {
	                        $('<div>').css({position: 'absolute', left: -10000}).html(parts[1]).appendTo($body);
	                        chan.give();
	                        done = true;
	                    } else {
	                        setTimeout(waitForFitbit, 100);
	                    }
	                }
	            }.bind(this), 'text');
	        }
	
	        if(done) {
	            k();
	        } else {
	            chan.take(k);
	        }
	    };
	});
	
	define('hbs!galileo/modal/template/basicModal',["handlebars"], function(Handlebars){ 
	   var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
	  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
	helpers = helpers || Handlebars.helpers;
	  var buffer = "", stack1, functionType="function";
	
	
	  buffer += "<div class=\"basic-modal\">\n    <a class=\"close\" href=\"#\">\n        <span class=\"close-icon\">X</span>\n    </a>\n    <div class=\"content\">";
	  if (stack1 = helpers.content) { stack1 = stack1.call(depth0, {hash:{}}); }
	  else { stack1 = depth0.content; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
	  if(stack1 || stack1 === 0) { buffer += stack1; }
	  buffer += "</div>\n</div>";
	  return buffer;
	  });
	   Handlebars.registerPartial("galileo_modal_template_basicModal", t);
	   return t;
	});
	define('basicModal',['underscore', 'hbs!galileo/modal/template/basicModal'], function(_, template) {
	    var BasicModal = function(modalContent, modalWidth) {
	        _loadCss('/styles/modal/basicModal.css');
	        this.$el =  $(template({content: modalContent}));
	        this.$el.hide();
	        this.elementId = _.uniqueId("basicModal"); // prefix ID with "basicModal" to avoid invalid html
	        this.$el.attr("id", this.elementId);
	        this.modalWidth = modalWidth;
	        _appendToBody(this.$el);
	    };
	
	    BasicModal.prototype.trigger = function() {
	        var self = this;
	        var $modalEl = $("#"+self.elementId);
	        if(self.modalWidth) {
	            $modalEl.css({width: self.modalWidth});
	        }
	        $modalEl.overlay({
	            top: "20%",
	            target: "#" + self.elementId,
	            load: true,
	            closeOnClick: true,
	            closeOnEsc: true,
	            close: ".close",
	            mask: {
	                color: "#000",
	                opacity: 0.6
	            },
	            onClose: function() {
	                // clean up the elements used in overlay
	                self.$el.remove();
	                $('#exposeMask').fadeOut().remove();
	            }
	        });
	    };
	
	    function _appendToBody($element) {
	        $("body").append($element);
	    }
	
	    function _loadCss(url) {
	        if (document.createStyleSheet)
	        {
	            document.createStyleSheet(url);
	        } else {
	            $('<link rel="stylesheet" type="text/css" href="' + url + '" />').appendTo('head');
	        }
	    }
	
	    return BasicModal;
	});
	
	define('hbs!galileo/modal/template/holidayShipping',["handlebars"], function(Handlebars){ 
	   var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
	  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
	helpers = helpers || Handlebars.helpers;
	  
	
	
	  return "<div class=\"holidayShipping\">\n    <h1 class=\"shippingGuidelines\">Shipping guidelines</h1>\n    <p class=\"heading\">To order and receive products for shipping during the 2013 holiday season, please refer to the following guidelines:</p>\n    <ul>\n        <li>Add any item to your cart to view whether it’s in-stock. In-stock items ship within 24 hours (1 business day) of your order.</li>\n        <li>If an item is back-ordered, please review the cart messaging to determine whether we’ll be able to ship the item in time for your needs.</li>\n        <li>Please select the most appropriate shipping method for your delivery. Please note that orders received after noon PST are not likely to ship on the same day as ordered (they will ship the next business day).</li>\n        <li>Orders to Canadian shipping addresses will take longer to deliver – please review the cart messaging during check-out.</li>\n    </ul>\n</div>";
	  });
	   Handlebars.registerPartial("galileo_modal_template_holidayShipping", t);
	   return t;
	});
	define('hbs!galileo/modal/template/holidayShippingTwoDay',["handlebars"], function(Handlebars){ 
	   var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
	  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
	helpers = helpers || Handlebars.helpers;
	  
	
	
	  return "<div class=\"holidayShipping\">\n    <h1 class=\"shippingGuidelines\">Shipping guidelines</h1>\n    <p class=\"heading\">FREE 2-3 day shipping on all <span class=\"emphasis\">in-stock orders over $50</span> placed between Friday December 13 at 8:00am PST and Tuesday December 17 at 11:59pm PST</p>\n    <ul>\n        <li>You must select 2-3 day shipping in order to guarantee the 2-3 day ship method.</li>\n        <li>Please review each item’s in-stock or back-order delivery messaging in the cart to ensure the item will ship in time for your needs.</li>\n        <li>Please note that in-stock orders received after noon PST are not likely to ship on the same day as ordered (they will ship the next business day).</li>\n        <li>Orders to Canadian shipping addresses will take longer to deliver – please review the cart messaging during check-out.</li>\n    </ul>\n</div>";
	  });
	   Handlebars.registerPartial("galileo_modal_template_holidayShippingTwoDay", t);
	   return t;
	});
	define('hbs!galileo/modal/template/holidayShippingOneDay',["handlebars"], function(Handlebars){ 
	   var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
	  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
	helpers = helpers || Handlebars.helpers;
	  
	
	
	  return "<div class=\"holidayShipping\">\n    <h1 class=\"shippingGuidelines\">Shipping guidelines</h1>\n    <p class=\"heading\">FREE 1-day shipping on all <span class=\"emphasis\">in-stock orders over $50</span> placed between Tuesday December 17 at 11:59pm PST and Friday December 20 at 5:00pm PST</p>\n    <ul>\n        <li>You must select 1-day shipping in order to guarantee the 1-day ship method.</li>\n        <li>Please review each item’s in-stock or back-order delivery messaging in the cart to ensure the item will ship in time for your needs.</li>\n        <li>Please note that in-stock orders received after noon PST are not likely to ship on the same day as ordered (they will ship the next business day).</li>\n        <li>Orders to Canadian shipping addresses will take longer to deliver – please review the cart messaging during check-out.</li>\n    </ul>\n</div>";
	  });
	   Handlebars.registerPartial("galileo_modal_template_holidayShippingOneDay", t);
	   return t;
	});
	define('hbs!galileo/modal/template/holidayShippingTooLate',["handlebars"], function(Handlebars){ 
	   var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
	  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
	helpers = helpers || Handlebars.helpers;
	  
	
	
	  return "<div class=\"holidayShipping\">\n    <h1 class=\"shippingGuidelines\">Shipping guidelines</h1>\n    <p class=\"heading\">Holiday shipping on all orders will NOT deliver before December 24</p>\n    <ul>\n        <li>All in-stock items ship within 24 hours (1 business day) of your order.</li>\n        <li>If an item is back-ordered, please review the cart messaging to determine when the item will be available to ship.</li>\n        <li>Happy Holidays and New Year!</li>\n    </ul>\n    <p class=\"signature\">-Fitbit Team</p>\n</div>";
	  });
	   Handlebars.registerPartial("galileo_modal_template_holidayShippingTooLate", t);
	   return t;
	});
	// jshint ignore: start
	/*
	 * 	Site Header initialization
	 * 	CSS prerequisites:
	 * 		/css/app/common/buttons.css
	 *      /css/app/common/forms.css
	 *      /css/app/common/headerCopernicus.css
	 *      /css/fitbit/app/modules/dropdown.css
	 *		/css/fitbitui/notificationDropdown.css
	 *      /css/fitbitui/peerMessageModal.css
	 *
	 * 	Notes:
	 * 		- This is an AMD-compatible module but it's also backwards compatible with legacy globals when RequireJS isn't available.
	 * 		- This module does not export anything.
	 */
	
	(function () {
	    var $menu = $('.wrapper-header .hdr-menu');
	    var $menuItems = $menu.find('> ul > li');
	    var $productMenu = $menu.find('.hdr-prod');
	
	    // Moved from headerCopernicus.jsp MKTG-1280
	    function isMobileDetected() {
	        return (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile/i).test(navigator.userAgent || navigator.vendor || window.opera);
	    }
	
	    // Only works for mobile nav hamburger
	    $menu.click(function(event){
	        if(event.target === this) {
	            $(this).toggleClass('active');
	        }
	    });
	
	    var hoverTimer;
	    // Shows the navigation dropdown with a slight delay to make it look more animated and simmilar to how the dashboard nav works
	    $menuItems.mouseenter(function(){
	        // Only if() not mobile and bleow 1024: Mobile hamburger not showing
	        if ($(window).width() > 1024) {
	            var hoverItem = $(this);
	            hoverTimer = setTimeout(function(){
	                hoverItem.children('ul').addClass('hoverDelay');
	            },300)
	        }
	    }).mouseleave(function(){
	        if ($(window).width() > 1024) {
	            clearTimeout(hoverTimer);
	            $menuItems.find('> ul').removeClass('hoverDelay');
	        }
	    });
	
	    $menuItems.hover(function(){
	            $(this).addClass('highlight');
	        },
	        function(){
	            $(this).removeClass('highlight');
	        }
	    );
	
	    // Only allow this click for mobile devices and screen sizes below 1025: Mobile hamburger showing
	    $menuItems.click(function(){
	        // This (if) needs to be inside the click so it can be checked on every click not just page load
	        if (isMobileDetected() || $(window).width() < 1025) {
	            $(this).toggleClass('active');
	            $(this).siblings().removeClass('active');
	        }
	    });
	
	    // This removes the active class from the haeder menu item when clicking anything other than a menu item
	    $(document).click(function(e) {
	        var headerMenu = $('.wrapper-header .hdr-menu > ul > li, .wrapper-header .hdr-menu');
	
	        // if the target of the click isn't headerMenu...nor a descendant of headerMenu
	        if (!headerMenu.is(e.target) && headerMenu.has(e.target).length === 0) {
	            headerMenu.removeClass('active');
	        }
	    });
	    // End Moved
	
	    // For the product menu, set total product count and product counts for each category to calculate widths
	    $productMenu.attr('data-prod-total', $menu.find('.hdr-prod-top li').length);
	
	    $productMenu.find('.hdr-prod-top').each(function() {
	        var $this = $(this);
	        $this.attr('data-prod-count', $this.find('li').length);
	    });
	
	    // Establish CommonJS passthrough shim, for non-AMD environments.
	    var define = window.define || function (f) { return f(); };
	
	    define('fitbit-header',['require','jquery','fitbit-widget-dropdown','fitbit-header-notificationDropdown','galileo/util/dateUtil','messages-deviceNames','messages-batteryLevels','galileo/modal/flex101','galileo/modal/force101','galileo/modal/charge101','galileo/modal/device101','galileo/util/dialog101Loader','galileo/util/foodGoalLoader','basicModal','hbs!galileo/modal/template/holidayShipping','hbs!galileo/modal/template/holidayShippingTwoDay','hbs!galileo/modal/template/holidayShippingOneDay','hbs!galileo/modal/template/holidayShippingTooLate'],function(require) {
	
	        var isAMD = (typeof require === "function");
	        var isLayoutBaseLean = document.getElementById("requirejs");
	
	        /*
	         * Imports
	         */
	        var launchFlex101 = null;
	        var launchForce101 = null;
	        var launchCharge101 = null;
	        var launchAria101 = null;
	        var launchOne101 = null;
	        var launchUltra101 = null;
	        var launchZip101 = null;
	        var launchNewDevice101 = null;
	
	        var load101 = null;
	        var foodGoalLoader = null;
	
	        if (isAMD) { // is AMD environment
	            var $ = require("jquery");
	            var DD = require("fitbit-widget-dropdown");
	            require("fitbit-header-notificationDropdown");
	
	        } else {
	            var $ = window.jQuery;
	            var DD = $.isFunction(fitbit.modules.dropdown) && fitbit.modules.dropdown;
	        }
	
	        /*
	         * i18n
	         */
	        if (isAMD && !isLayoutBaseLean) {
	            var _getRelativeDateMessage = require("galileo/util/dateUtil").getRelativeDate;
	            var deviceMessageBundle = require("messages-deviceNames");
	            var batteryMessageBundle = require("messages-batteryLevels");
	            var undefinedMessage = "???";
	            var _getDeviceMessage = function (deviceType, messageType, productName) {
	                return (deviceMessageBundle[deviceType] && deviceMessageBundle[deviceType][messageType])
	                    ? deviceMessageBundle[deviceType][messageType]
	                    : productName;
	            };
	            var _getBatteryMessage = function (level) {
	                return batteryMessageBundle[level]
	                    ? batteryMessageBundle[level]
	                    : undefinedMessage;
	            };
	
	            launchFlex101 = require("galileo/modal/flex101");
	            launchForce101 = require("galileo/modal/force101");
	            launchCharge101 = require("galileo/modal/charge101");
	            launchNewDevice101 = require("galileo/modal/device101");
	
	            load101 = require("galileo/util/dialog101Loader");
	            foodGoalLoader = require("galileo/util/foodGoalLoader");
	
	            var launchDevice101 = function(deviceFn) {
	                return function() {
	                    load101(
	                        function(){ $[deviceFn](); }
	                    );
	                };
	            };
	
	            // Aria 101 requires food goal modal to be loaded
	            launchAria101 = function() {
	                foodGoalLoader(
	                    launchDevice101('aria101')
	                );
	            };
	            launchOne101 = launchDevice101('one101');
	            launchUltra101 = function() {
	                load101(function() {
	                    $("#fb101").fitbit101();
	                });
	            };
	            launchZip101 = launchDevice101('zip101');
	
	        } else {
	            var _getRelativeDateMessage = fitbit.util.getRelativeDate;
	            var ns = "com.fitbit.app.device.message.";
	            var _getDeviceMessage = function (deviceType, messageType, productName) {
	                return fitbit.i18n.getResource(ns + "device_" + messageType + "_" + deviceType);
	            };
	            var _getBatteryMessage = function (level) {
	                return fitbit.i18n.getResource(ns + "battery_" + level);
	            };
	        }
	
	        /*
	         * Immediate execution...
	         */
	
	        var headerWrapper = $(".wrapper-header").first();
	
	        // Prevent duplicate initializations.
	        if (headerWrapper.data("fitbitHeaderInitialized")) return;
	        headerWrapper.data("fitbitHeaderInitialized", true);
	
	        var primaryNav = headerWrapper.find(".wrapper-nav");
	        var isDashboardNav = headerWrapper.hasClass("nav-app"); // Is the "dashboard nav" visible? (default is the "marketing nav")
	        var activeClass = "active";
	        var subNavClass = "subnav";
	        if (isDashboardNav) { // Apply special color scheme when the "dashboard nav" is visible.
	            subNavClass += " subnav-app";
	        }
	
	        // Ensure the entire area of each primary navigation "tab" element is clickable.
	        // Special case: if we're dealing with a click on the "Products" nav tab, do nothing.
	        primaryNav.on("click", ".nav > li", function (ev) {
	            if ($(ev.currentTarget).hasClass("nav-products")) { // is the "Products" nav tab...
	                ev.preventDefault();
	            } else {
	                var url = $(this).find("a").first().attr("href");
	                if (url) {
	                    ev.preventDefault();
	                    location.href = url;
	                }
	            }
	        });
	
	        // Initialize the account settings dropdown immediately. We don't want to wait until the entire DOM is ready.
	        initializeAccountSettingsDropdown();
	
	        $(function () {
	
	            if(launchFlex101 && (/launchFlex101/.test(window.location.hash) || /launchFlex101/.test(window.location.search))) {
	                launchFlex101();
	            } else if (launchForce101 && (/launchForce101/.test(window.location.hash) || /launchForce101/.test(window.location.search))) {
	                launchForce101();
	            } else if (launchCharge101 && (/launchCharge101/.test(window.location.hash) || /launchCharge101/.test(window.location.search))) {
	                launchCharge101();
	            } else if (launchNewDevice101 && (/launchSurge101/.test(window.location.hash) || /launchSurge101/.test(window.location.search))) {
	                launchNewDevice101('surge');
	            } else if (launchNewDevice101 && (/launchChargeHR101/.test(window.location.hash) || /launchChargeHR101/.test(window.location.search))) {
	                launchNewDevice101('chargehr');
	            } else if (launchNewDevice101 && (/launchBlaze101/.test(window.location.hash) || /launchBlaze101/.test(window.location.search))) {
	                launchNewDevice101('blaze');
	            } else if (launchNewDevice101 && (/launchFlex2101/.test(window.location.hash) || /launchFlex2101/.test(window.location.search))) {
	                launchNewDevice101('flex2');
	            } else if (launchNewDevice101 && (/launchAlta101/.test(window.location.hash) || /launchAlta101/.test(window.location.search))) {
	                launchNewDevice101('alta');
	            } else if (launchNewDevice101 && (/launchAltaHR101/.test(window.location.hash) || /launchAltaHR101/.test(window.location.search))) {
	                launchNewDevice101('altahr');
	            } else if (launchNewDevice101 && (/launchCharge2101/.test(window.location.hash) || /launchCharge2101/.test(window.location.search))) {
	                launchNewDevice101('charge2');
	            } else if (launchNewDevice101 && (/launchIonic101/.test(window.location.hash) || /launchIonic101/.test(window.location.search))) {
	                launchNewDevice101('ionic');
	            } else if (launchNewDevice101 && (/launchAria2101/.test(window.location.hash) || /launchAria2101/.test(window.location.search))) {
	                launchNewDevice101('aria2');
	            } else if (launchAria101 && (/launchAria101/.test(window.location.hash) || /launchAria101/.test(window.location.search))) {
	                launchAria101();
	            } else if (launchZip101 && (/launchZip101/.test(window.location.hash) || /launchZip101/.test(window.location.search))) {
	                launchZip101();
	            } else if (launchOne101 && (/launchOne101/.test(window.location.hash) || /launchOne101/.test(window.location.search))) {
	                launchOne101();
	            } else if (launchUltra101 && /referrer=client/.test(window.location.search)) {// if page requests has "referrer=client" then auto-launch
	                launchUltra101();
	            }
	
	
	            // Establish event listeners pertaining to system alerts/messages...
	            var systemAlertsWrapper = $(".wrapper-system-alerts");
	            if (systemAlertsWrapper.length) {
	
	                // A click on an exit icon should dismiss and remove its parent message.
	                var alertSelector = ".system-alert";
	                var systemAlerts = systemAlertsWrapper.find(alertSelector);
	                systemAlerts
	                .find(".exit")
	                // Instead of a delegator, use per-element, one-time event handlers to prevent double-execution via double-clicking.
	                .one("click", function () {
	                    var currentAlert = $(this).closest(alertSelector);
	
	                    // Build the JSON representation of an Alert (com.fitbit.alert.Alert).
	
	                    var alertObject = {
	                        alertType: currentAlert.data("type"),
	                        deviceType: currentAlert.data("device")
	                    };
	
	                    var jsonAlert = JSON.stringify(alertObject);
	
	                    // Notify the back-end that this alert has been closed by the user.
	                    // Even if the ajax request fails, always display visual success to the user (i.e. we don't care about the response status).
	                    var reqParams = {
	                        request: JSON.stringify({
	                            template: "user/dash/alertResponse.json.jsp",  // template to format JSON response
	                            serviceCalls: [{
	                                name: "alert",  // com.fitbit.ajax.service.AlertAjaxService
	                                method: "processAlert",
	                                args: {
	                                    action: "CLOSE",
	                                    alert: jsonAlert
	                                }
	                            }]
	                        }),
	                        csrfToken: window.fitbitCsrfToken
	                    };
	                    $.ajax({
	                        type: 		"post",
	                        url:		"/ajaxapi",
	                        data:		reqParams,
	                        dataType:	"json"
	                    });
	
	                    // Notify subscribers that this alert is about to be destroyed.
	                    currentAlert.trigger("destroy.systemAlert");
	
	                    // Choose the visual hide-effect based on how many alerts are left to be displayed.
	                    // If there are more alerts to show, do a fade-out and show the next alert.
	                    // Otherwise, if this is the last alert, remove the entire alerts container via a different effect.
	                    var hideEffect = (systemAlerts.length > 1) ? "fadeOut" : "slideUp";
	                    currentAlert[hideEffect](function () {
	                        var nextAlert = currentAlert.next(alertSelector);
	
	                        if (nextAlert.length) { // more alerts to be shown...
	                            nextAlert.fadeIn(function () {
	                                currentAlert.remove();
	                                parseAndSaveCookieData(nextAlert);
	                                nextAlert.trigger("impression.systemAlert");
	                            });
	
	                        } else { // final alert
	                            systemAlertsWrapper.slideUp(function () {
	
	                                // Destroy the alerts container entirely
	                                systemAlertsWrapper.remove();
	
	                                // Hackish: Stupid toolbars on various pages don't reset their absolute positions when the document height changes.
	                                // Need to reset their positions manually.
	                                setTimeout(function () {
	                                    $("body").trigger("resetGlobalTimeSelector");
	                                }, 0);
	                            });
	                        }
	                    });
	                });
	
	                // Define private utility for parsing cookie data from a data attribute and writing it to a cookie.
	                var parseAndSaveCookieData = function (systemAlertWrapperElement) {
	                    if (!systemAlertWrapperElement) return;
	                    var cookieData = systemAlertWrapperElement.first().data("cookie");
	                    if (cookieData && !(/^\s*$/).test(cookieData)) {
	                        var cookieExpireDate = new Date();
	                        cookieExpireDate.setTime(cookieExpireDate.getTime() + 2.62974383e9); // 1 month in the future
	                        document.cookie = "system_alert" + "=" + cookieData + "; expires=" + cookieExpireDate.toGMTString() + "; path=/;";
	                    }
	                };
	
	                // If the first alert shown needs a cookie to be set, do that now.
	                var firstAlert = systemAlerts.first();
	                parseAndSaveCookieData(firstAlert);
	
	                /*
	                 * 	Google Analytics for Amazon Review alerts.
	                 */
	
	                // Internal utility for creating/firing GA tracking events.
	                var fireTrackingEvent = function (device) {
	                    if (typeof device !== "string") return;
	                    var trackingData = ["_trackEvent", "GlobalAlertProductReview-" + device];
	                    if (arguments.length > 1) {
	                        trackingData = trackingData.concat(Array.prototype.slice.call(arguments, 1));
	                    }
	                    try {
	                        fitbit.util.deferredTrack(trackingData);
	                    } catch (e) {
	                        if (console) {
	                            console.log("header.js: 'fitbit.util.deferredTrack' is not available");
	                        }
	                    }
	                };
	
	                // Establish listeners for firing Amazon tracking events.
	                systemAlerts
	                .filter(".amazon-review")
	                .one("impression.systemAlert", function () {
	                    var device = $(this).data("device");
	
	                    fireTrackingEvent(device, "Display", "Show");
	
	                })
	                .one("click contextmenu", ".message a", function (ev) {
	                    var device = $(ev.delegateTarget).data("device");
	
	                    fireTrackingEvent(device, "Click", "LinkToAmazon");
	                })
	                .one("destroy.systemAlert", function (ev) {
	                    var device = $(ev.target).data("device");
	
	                    fireTrackingEvent(device, "Click", "CloseForever");
	                });
	
	                // Establish listeners for firing Dash Promo tracking events.
	                systemAlerts
	                .filter(".newDashInvite")
	                .one("impression.systemAlert", function(){
	                    // Mixpanel tracking view of NGD Preview Promo alert
	                });
	
	                // Trigger an impression event immediately. If a handler is attached, it will be fired, otherwise nothing happens.
	                firstAlert.trigger("impression.systemAlert");
	
	            }
	
	            // If the dropdown widget is available...
	            if (DD) {
	                /*
	                 * 	Subnavs for primary navigation.
	                 * 	These menus are shown/hidden via mouseenter/mouseleave events after a brief delay.
	                 */
	                var subNavParents = primaryNav.find(".hasdropdown");
	                subNavParents.each(function (index, el) {
	                    var catalyst = $(el);
	                    var subnav = null;
	                    var hideTimer = null;
	                    var showTimer = null;
	                    var isMouseCursorInsideCatalyst = false;
	                    function clearTimers () {
	                        if (showTimer) {
	                            clearTimeout(showTimer);
	                            showTimer = null;
	                        }
	                        if (hideTimer) {
	                            clearTimeout(hideTimer);
	                            hideTimer = null;
	                        }
	                    }
	
	                    // Helper: hide the subnav after a brief delay.
	                    function hideSubNav() {
	                        isMouseCursorInsideCatalyst = false;
	                        clearTimers();
	                        if (subnav && subnav.isVisible()) {
	                            hideTimer = setTimeout(function () {
	                                if (!subnav.isMouseCursorInsideDropdown && !isMouseCursorInsideCatalyst) {
	                                    subnav.hide();
	                                    catalyst.removeClass(activeClass);
	                                }
	                                clearTimers();
	                            }, 200);
	                        }
	                    }
	
	                    // Helper: show the subnav after a brief delay.
	                    function showSubNav() {
	                        isMouseCursorInsideCatalyst = true;
	                        clearTimers();
	                        if (subnav) {
	                            subnav.cancelHide();
	                            if (!subnav.isVisible()) {
	                                showTimer = setTimeout(function () {
	                                    subnav.show();
	                                    clearTimers();
	                                }, 350);
	                            }
	                        }
	                    }
	
	                    // Initialization...
	                    catalyst
	                    .one("mouseover", function () {
	                        // Instantiate a dropdown module to serve as this nav item's subnav.
	                        subnav = new DD(catalyst, {
	                            className: subNavClass,
	                            catalystActiveClass: activeClass,
	                            hideDelay: 200,
	                            manualShowEnabled: true
	                        });
	
	                        // Populate the subnav with content. Relocate nested list from inside the catalyst to the content area of the dropdown.
	                        subnav.render(catalyst.find(".subnav-content").first());
	
	                        // Show the subnav after a brief delay.
	                        showSubNav();
	                    })
	                    // Always manually handle show/hide of subnav (so we can impose that delay).
	                    .on("mouseenter", showSubNav)
	                    .on("mouseleave", hideSubNav);
	
	                });
	
	            }
	
	            // Allow cart icon to be shown/hidden. Interesting parties can subscribe to a custom event that, when triggered, shows/hides the cart icon from the site header (for the current page view only).
	            // This is really only used by the cart page. Note: If the user visits the cart while it's empty, the functionality will NOT render a cart icon. The cart icon is rendered via the JSTL. This
	            // functionality will only show/hide a cart icon that already exists.
	            var $cartIcon = headerWrapper.find(".nav-item-cart");
	            if ($cartIcon.length) {
	                $(document.body)
	                .on("hideCartIcon.siteHeader", function () { $cartIcon.hide(); })
	                .on("showCartIcon.siteHeader", function () { $cartIcon.show(); });
	            }
	
	        });
	
	        // Initialize the 2013 Holiday Shipping Ribbons
	        !function initializeHolidayRibbons() {
	            var BasicModal = require('basicModal');
	            var holidayShoppingContents = require('hbs!galileo/modal/template/holidayShipping')();
	            var holidayShoppingTwoDayContents = require('hbs!galileo/modal/template/holidayShippingTwoDay')();
	            var holidayShoppingOneDayContents = require('hbs!galileo/modal/template/holidayShippingOneDay')();
	            var holidayShoppingTooLateContents = require('hbs!galileo/modal/template/holidayShippingTooLate')();
	
	            var $holidayShipping = $('.wrapper-header .holiday-banner.shop-holidays');
	            var $holidayShippingTwoDay = $('.wrapper-header .holiday-banner.two-day-shipping');
	            var $holidayShippingOneDay = $('.wrapper-header .holiday-banner.one-day-shipping');
	            var $holidayShippingTooLate = $('.wrapper-header .holiday-banner.too-late-shipping');
	
	            $holidayShipping.click(function() {
	                new BasicModal(holidayShoppingContents, 500).trigger();
	            });
	
	            $holidayShippingTwoDay.click(function() {
	                new BasicModal(holidayShoppingTwoDayContents, 500).trigger();
	            });
	
	            $holidayShippingOneDay.click(function() {
	                new BasicModal(holidayShoppingOneDayContents, 500).trigger();
	            });
	
	            $holidayShippingTooLate.click(function() {
	                new BasicModal(holidayShoppingTooLateContents, 500).trigger();
	            });
	        }();
	
	        /*
	         * 	Initialize account settings subnav...
	         */
	        function initializeAccountSettingsDropdown() {
	            var settingsCatalyst = headerWrapper.find(".account > .nav-item-settings");
	            if (settingsCatalyst.length && DD) {
	                var evNamespace = ".accountSettingsDropdown";
	
	                var settingsSubNav;
	
	                settingsCatalyst
	                // Fetch user's device info asynchronously, to be prepended later to the subnav content area.
	                .one("mouseover" + evNamespace + " mousedown" + evNamespace, function (ev) {
	                    settingsCatalyst
	                    .off(evNamespace)
	                    .addClass("hasdropdown");
	
	
	                    // Fetch device data and adapt it to a more template-friendly format.
	                    // Adapt data received from API call and prepare values to be rendered by a Handlebars template.
	                    $.post("/ajaxapi", {
	                        request: JSON.stringify({
	                            serviceCalls: [
	                                {
	                                name: "device", // com.fitbit.ajax.service.device.TrackerSettingsAjaxService
	                                method: "getOwnerDevices"
	                            }
	                            ],
	                            template: "common/defaultResponse.json.jsp" // template to format JSON response
	                        }),
	                        csrfToken: window.fitbitCsrfToken
	                    }, function (result) {
	
	                        var deviceResponse = result[0];
	
	                        var deviceElems = [];
	
	                        if (deviceResponse.length) {
	                            $.each(deviceResponse, function (index, device) {
	
	                                // No entry or 101s in the dropdown for soft trackers
	                                if(!device.softTracker) {
	                                    if(device.type == 'FLOJO' && launchAria101) {
	                                        $("#header-settings-subnav .aria101").removeClass("invisible");
	                                        $("#header-settings-subnav .aria101 a").off('click').click(function() {
	                                            launchAria101();
	                                            settingsSubNav.hide();
	                                        });
	                                    } else if (device.type == 'FERMION' && launchNewDevice101) {
	                                        $("#header-settings-subnav .flex2101").removeClass("invisible");
	                                        $("#header-settings-subnav .flex2101 a").off('click').click(function() {
	                                            launchNewDevice101('flex2');
	                                            settingsSubNav.hide();
	                                        });
	                                    } else if (device.type == 'ELECTRON' && launchNewDevice101) {
	                                        $("#header-settings-subnav .blaze101").removeClass("invisible");
	                                        $("#header-settings-subnav .blaze101 a").off('click').click(function() {
	                                            launchNewDevice101('blaze');
	                                            settingsSubNav.hide();
	                                        });
	                                    } else if (device.type == 'LEPTON' && launchNewDevice101) {
	                                        $("#header-settings-subnav .alta101").removeClass("invisible");
	                                        $("#header-settings-subnav .alta101 a").off('click').click(function() {
	                                            launchNewDevice101('alta');
	                                            settingsSubNav.hide();
	                                        });
	                                    } else if (device.type == 'LARYON' && launchNewDevice101) {
	                                        $("#header-settings-subnav .charge2101").removeClass("invisible");
	                                        $("#header-settings-subnav .charge2101 a").off('click').click(function () {
	                                            launchNewDevice101('charge2');
	                                            settingsSubNav.hide();
	                                        });
	                                    } else if(device.type == 'PROTON' && launchNewDevice101) {
	                                        $("#header-settings-subnav .surge101").removeClass("invisible");
	                                        $("#header-settings-subnav .surge101 a").off('click').click(function() {
	                                            launchNewDevice101('surge');
	                                            settingsSubNav.hide();
	                                        });
	                                    } else if(device.type == 'GRAVITON' && launchNewDevice101) {
	                                        $("#header-settings-subnav .chargeHR101").removeClass("invisible");
	                                        $("#header-settings-subnav .chargeHR101 a").off('click').click(function() {
	                                            launchNewDevice101('chargehr');
	                                            settingsSubNav.hide();
	                                        });
	                                    } else if(device.type == 'TAU' && launchCharge101) {
	                                        $("#header-settings-subnav .charge101").removeClass("invisible");
	                                        $("#header-settings-subnav .charge101 a").off('click').click(function() {
	                                            launchCharge101();
	                                            settingsSubNav.hide();
	                                        });
	                                    } else if (device.type == 'HIGGS' && launchNewDevice101) {
	                                        $("#header-settings-subnav .ionic101").removeClass("invisible");
	                                        $("#header-settings-subnav .ionic101 a").off('click').click(function() {
	                                            launchNewDevice101('ionic');
	                                            settingsSubNav.hide();
	                                        });
	                                    } else if (device.type == 'FELIX' && launchNewDevice101) {
	                                        $("#header-settings-subnav .aria2101").removeClass("invisible");
	                                        $("#header-settings-subnav .aria2101 a").off('click').click(function() {
	                                            launchNewDevice101('aria2');
	                                            settingsSubNav.hide();
	                                        });
	                                    } else if(device.type == 'QUARK' && launchFlex101) {
	                                        $("#header-settings-subnav .flex101").removeClass("invisible");
	                                        $("#header-settings-subnav .flex101 a").off('click').click(function() {
	                                            launchFlex101();
	                                            settingsSubNav.hide();
	                                        });
	                                    } else if (device.type == 'NEUTRINO' && launchForce101) {
	                                        $("#header-settings-subnav .force101").removeClass("invisible");
	                                        $("#header-settings-subnav .force101 a").off('click').click(function() {
	                                            launchForce101();
	                                            settingsSubNav.hide();
	                                        });
	                                    } else if (device.type == 'HADRON' && launchOne101) {
	                                        $("#header-settings-subnav .one101").removeClass("invisible");
	                                        $("#header-settings-subnav .one101 a").off('click').click(function() {
	                                            launchOne101();
	                                            settingsSubNav.hide();
	                                        });
	                                    } else if (device.type == 'TYCHO' && launchUltra101) {
	                                        $("#header-settings-subnav .ultra101").removeClass("invisible");
	                                        $("#header-settings-subnav .ultra101 a").off('click').click(function() {
	                                            launchUltra101();
	                                            settingsSubNav.hide();
	                                        });
	                                    } else if (device.type == 'GALILEO' && launchZip101) {
	                                        $("#header-settings-subnav .zip101").removeClass("invisible");
	                                        $("#header-settings-subnav .zip101 a").off('click').click(function() {
	                                            launchZip101();
	                                            settingsSubNav.hide();
	                                        });
	                                    } else if (device.type == 'ATOM' && launchNewDevice101) {
	                                        $("#header-settings-subnav .altahr101").removeClass("invisible");
	                                        $("#header-settings-subnav .altahr101 a").off('click').click(function() {
	                                            launchNewDevice101('altahr');
	                                            settingsSubNav.hide();
	                                        });
	                                    }
	                                    deviceElems.push($("<li>").addClass("device-divider").append($("<div>").addClass("hr")));
	                                    var elem = $("<li>").addClass("device").addClass("device-" + device.productName.toLowerCase().replace(' ', ''));
	                                    var settingsLink = $("<a>").addClass("gotoSettings").appendTo(elem);
	                                    device.settingsUrl && settingsLink.attr('href', device.settingsUrl);
	
	                                    var infoDiv = $("<div>").addClass("info").append(
	                                        $("<span>").addClass("type").text(_getDeviceMessage(device.type, "displayName", device.productName)),
	                                        $("<br>"),
	                                        $("<span>").addClass("sync deviceDetail").data('time', device.lastSyncTime)
	                                        .text(device.lastSyncTime > 0 ? _getRelativeDateMessage(device.lastSyncTime) : "")
	                                    ).appendTo(settingsLink);
	
	                                    infoDiv.append($("<div>").addClass("battery")
	                                                   .addClass(device.battery ? device.battery.toLowerCase() : "")
	                                                   .attr('title', device.battery ? _getBatteryMessage(device.battery.toLowerCase()) : ""));
	                                                   deviceElems.push(elem);
	                                }
	                            });
	                        }
	                        deviceElems.push($("<li>").addClass("divider"));
	                        $.each(deviceElems.reverse(), function() { $("#header-settings-subnav").prepend(this); });
	                    }, "json");
	                })
	
	                // Initialize account settings subnav.
	                .one("click", function (ev) {
	                    ev.preventDefault();
	
	                    // Instantiate a dropdown module to serve as this nav item's subnav.
	                    settingsSubNav = new DD(settingsCatalyst, {
	                        anchorPoint: "below right",
	                        className: subNavClass + " subnav-settings",
	                        catalystActiveClass: activeClass,
	                        mouseBoundaryDetectionEnabled: false
	                    });
	
	                    // Populate the subnav with content.
	                    var settingsSubNavContent = $("#header-settings-subnav");
	                    settingsSubNav.render(settingsSubNavContent);
	
	                    // Update relative dates whenever the subnav is shown.
	                    settingsSubNav.subscribe("beforeShow", function () {
	                        settingsSubNavContent
	                        .find(".device .sync")
	                        .each(function (index, el) {
	                            var absoluteTime = parseInt($(el).attr("data-time"));
	                            if(absoluteTime > 0) {
	                                $(el).text(_getRelativeDateMessage(absoluteTime));
	                            }
	                        });
	                    });
	
	                    // Initialize admin-only links for dashboard version switching.
	                    settingsSubNav.subscribe("beforeShow", function () {
	                        var rootEl = settingsSubNav.getRootElement();
	                        $(rootEl).find(".link-dashboard").on("click", function (ev) {
	                            ev.preventDefault();
	
	                            var element = $(this);
	                            var setting = element.data('setting');
	
	                            $.post("/userSettings/dh/save?apiFormat=json",{ "settings['show galileo dashboard']":setting,'csrfToken':window.fitbitCsrfToken }, function () {
	                                window.location = "/";
	                            });
	                        });
	                    }, true);
	
	                    // Manually show the subnav the first time. Subsequent visibility toggling will be handled by the dropdown module itself.
	                    settingsSubNav.show();
	                });
	            }
	        }
	
	        /*
	         * Show merchandise count in cart icon
	         */
	        function getCookie(name) {
	            var cookies = document.cookie.split('; ');
	            for (var i = 0; i < cookies.length; i++) {
	                nameAndValue = cookies[i].split('=');
	                if (nameAndValue[0] == name) {
	                    return unescape(nameAndValue[1]);
	                }
	            }
	            return null;
	        };
	
	        function updateCartIcon() {
	            var count = 0;
	            var cartLink = '/cart';
	            var merchandise = getCookie("cart_merchandise");
	            if (merchandise) {
	                items = merchandise.split('|');
	                for (var i = 1; i < items.length - 1; i++) {
	                    if (items[i][0] == 'p') {
	                        lineItem = items[i].split(':');
	                        if (lineItem) {
	                            count += parseInt(lineItem[lineItem.length - 1]);
	                        }
	                    } else if (items[i][0] == 'c') {
	                        var promoInfo = items[i].split(':');
	                        if (promoInfo && promoInfo[1]) {
	                            cartLink += '/promo/' + promoInfo[1];
	                        }
	                        // point link in cart icon to the right place
	                        $('.cart-indicator').attr('href', function(i, origLink) {
	                            return origLink.replace('/order', cartLink);
	                        });
	                    }
	                }
	            }
	            // add count of items in cart
	            if (count > 0) $('.cart-indicator > span').html(count);
	        };
	
	        $(document).ready(function () {
	            updateCartIcon();
	
	            if (!window.location.pathname.endsWith('/home')) {
	                var $prod = $('.hdr-prod');
	                if ($prod.length) {
	                    $('#wrapper-footer .ftr-bottom').load($prod.data('home') + window.location.search + ' #footer .links-secondary > *');
	
	                    if (localStorage.getItem('cookie-popup') != 'shown') {
	                        var $cookiePopup = $('#cookie-popup');
	
	                        if ($cookiePopup.length) {
	                            $cookiePopup.load(
	                                $prod.data('home') + window.location.search + ' #cookie-popup > *',
	                                function () {
	                                    var $scriptDefiner = $('#cookie-popup .cookie-content');
	
	                                    // Loading Marketing Pages JS
	                                    $.getScript($scriptDefiner.data('system-js')).then(function () {
	                                        $.getScript($scriptDefiner.data('system-config')).then(function () {
	                                            System.import($scriptDefiner.data('cookie-js'));
	                                        });
	                                    });
	                                });
	                        }
	                    }
	                }
	            }
	        });
	    });
	}());
	
	(function($,sr){
	
	  // debouncing function from John Hann
	  // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
	  var debounce = function (func, threshold, execAsap) {
	      var timeout;
	
	      return function debounced () {
	          var obj = this, args = arguments;
	          function delayed () {
	              if (!execAsap)
	                  func.apply(obj, args);
	              timeout = null;
	          };
	
	          if (timeout)
	              clearTimeout(timeout);
	          else if (execAsap)
	              func.apply(obj, args);
	
	          timeout = setTimeout(delayed, threshold || 100);
	      };
	  }
	  // smartresize
	  jQuery.fn[sr] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };
	
	})(jQuery,'smartresize');
	
	$(window).smartresize(function(){
	    // Closes the navigation dropdown when the window is resized
	    if ($(window).width() > 1024) {
	        $('.wrapper-header .hdr-menu > ul > li, .wrapper-header .hdr-menu').removeClass('active hoverDelay');
	    }
	});
	}.call(window));

/***/ }
/******/ ])


/** WEBPACK FOOTER **
 ** fitbit-header.js.12c0246fb77af0c6a4bd6108e7c0ce01.js
 **/